import { jsx as _, jsxs as G, Fragment as ze } from "react/jsx-runtime";
import { twMerge as N, twJoin as Or } from "tailwind-merge";
import { Transition as Ua, Dialog as Kn, Popover as oo, PopoverButton as so, PopoverPanel as lo, Field as nr, Switch as Ol, Label as Gl, FocusTrap as Ll, FocusTrapFeatures as Rl, MenuButton as Fl, Menu as Kl, MenuItems as Hl, MenuItem as Ul, ComboboxButton as rn, Combobox as uo, ComboboxInput as zl, ComboboxOption as co, ComboboxOptions as po, Listbox as nn, ListboxButton as Kt, ListboxOptions as on, ListboxOption as mo } from "@headlessui/react";
import * as he from "react";
import M, { Fragment as pt, createContext as ho, useState as ue, useRef as Ce, useEffect as Pe, forwardRef as Pt, useCallback as za, useMemo as Xa, createElement as jl, Component as Vl, createRef as Yl, useLayoutEffect as Wl } from "react";
import { C as Tt, P as le, a as Zl, D as Jl, b as $l, c as ql, Q as fo, A as go, d as Ql, S as Xl, L as eu, e as au, f as tu, g as _o } from "./payment-method.enum-2Z38aWiY.mjs";
import { HexAlphaColorPicker as ru, HexColorPicker as nu, HexColorInput as iu } from "react-colorful";
import ou, { toast as Gr, Toaster as su } from "react-hot-toast";
import * as lu from "react-dom";
import uu, { findDOMNode as cu } from "react-dom";
var du = /* @__PURE__ */ ((a) => (a.small = "small", a.medium = "medium", a.big = "big", a))(du || {});
function J_({
  opened: a,
  onClose: r,
  children: n,
  title: t,
  size: e = "small",
  isFetching: i,
  afterLeave: o,
  afterEnter: s,
  className: l,
  contentClassName: u,
  isCentered: c,
  dialogClassName: d,
  backdropClassName: p,
  dialogContentClassName: m,
  dialogContentWrapperClassName: f,
  dialogContentWrapper1ClassName: y,
  titleClassName: v,
  closeIconWrapperClassName: P,
  closeIconClassName: k,
  ...w
}) {
  return /* @__PURE__ */ _(Ua.Root, { afterEnter: s, show: a, as: pt, children: /* @__PURE__ */ G(
    Kn,
    {
      className: N("relative z-10", d),
      onClose: i ? () => {
      } : r,
      children: [
        /* @__PURE__ */ _(
          Ua.Child,
          {
            as: pt,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ _(
              "div",
              {
                className: N(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  p
                )
              }
            )
          }
        ),
        /* @__PURE__ */ _(
          "div",
          {
            className: N("fixed inset-0 z-10 overflow-y-auto", f),
            children: /* @__PURE__ */ _(
              "div",
              {
                id: "modal-background",
                className: N(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  y
                ),
                children: /* @__PURE__ */ _(
                  Ua.Child,
                  {
                    as: pt,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: o,
                    children: /* @__PURE__ */ G(
                      Kn.Panel,
                      {
                        className: N(
                          "relative w-full",
                          e === "small" ? "max-w-2xl" : e === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          l
                        ),
                        ...w,
                        children: [
                          /* @__PURE__ */ G(
                            "div",
                            {
                              className: N(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                c ? "justify-center" : "justify-between",
                                m
                              ),
                              children: [
                                /* @__PURE__ */ _("h3", { className: N(c ? "px-6 lg:px-10" : "", v), children: t }),
                                /* @__PURE__ */ _(
                                  "button",
                                  {
                                    className: N(
                                      "focus-ring rounded-full",
                                      c && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      P
                                    ),
                                    disabled: i,
                                    onClick: r,
                                    children: /* @__PURE__ */ _(
                                      Tt,
                                      {
                                        className: N(
                                          "cursor-pointer",
                                          i && "fill-text-secondary pointer-events-none",
                                          k
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ _(
                            "div",
                            {
                              className: N(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                u
                              ),
                              children: n
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const Ht = ({ small: a = !1, type: r = "light", className: n, style: t }) => /* @__PURE__ */ G("div", { role: "status", className: n, style: t, children: [
  /* @__PURE__ */ G(
    "svg",
    {
      "aria-hidden": "true",
      className: `${a ? "h-5 w-5" : "h-8 w-8"} animate-spin ${r === "light" ? "fill-brand-primary text-background-secondary" : "fill-background-secondary text-text-primary"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ _(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ _("span", { className: "sr-only", children: "Loading..." })
] });
function Ye(a) {
  "@babel/helpers - typeof";
  return Ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ye(a);
}
function pu(a, r) {
  if (Ye(a) != "object" || !a) return a;
  var n = a[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(a, r);
    if (Ye(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(a);
}
function yo(a) {
  var r = pu(a, "string");
  return Ye(r) == "symbol" ? r : r + "";
}
function E(a, r, n) {
  return (r = yo(r)) in a ? Object.defineProperty(a, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[r] = n, a;
}
function ir(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function ee(a, r) {
  if (!(a instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function mu(a, r) {
  for (var n = 0; n < r.length; n++) {
    var t = r[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(a, yo(t.key), t);
  }
}
function ae(a, r, n) {
  return r && mu(a.prototype, r), Object.defineProperty(a, "prototype", {
    writable: !1
  }), a;
}
var hu = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, fu = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, gu = function(r) {
  return fu[r];
}, _u = function(r) {
  return r.replace(hu, gu);
};
function Hn(a, r) {
  var n = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(a);
    r && (t = t.filter(function(e) {
      return Object.getOwnPropertyDescriptor(a, e).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function Un(a) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Hn(Object(n), !0).forEach(function(t) {
      E(a, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : Hn(Object(n)).forEach(function(t) {
      Object.defineProperty(a, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return a;
}
var zn = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: _u
};
ho();
function yu() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  zn = Un(Un({}, zn), a);
}
(function() {
  function a() {
    ee(this, a), this.usedNamespaces = {};
  }
  return ae(a, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var t = this;
      n.forEach(function(e) {
        t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), a;
})();
var vu = {
  type: "3rdParty",
  init: function(r) {
    yu(r.options.react);
  }
};
function jn(a, r) {
  (r == null || r > a.length) && (r = a.length);
  for (var n = 0, t = Array(r); n < r; n++) t[n] = a[n];
  return t;
}
function bu(a, r) {
  if (a) {
    if (typeof a == "string") return jn(a, r);
    var n = {}.toString.call(a).slice(8, -1);
    return n === "Object" && a.constructor && (n = a.constructor.name), n === "Map" || n === "Set" ? Array.from(a) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jn(a, r) : void 0;
  }
}
const V = (a) => typeof a == "string", rt = () => {
  let a, r;
  const n = new Promise((t, e) => {
    a = t, r = e;
  });
  return n.resolve = a, n.reject = r, n;
}, Vn = (a) => a == null ? "" : "" + a, Su = (a, r, n) => {
  a.forEach((t) => {
    r[t] && (n[t] = r[t]);
  });
}, ku = /###/g, Yn = (a) => a && a.indexOf("###") > -1 ? a.replace(ku, ".") : a, Wn = (a) => !a || V(a), mt = (a, r, n) => {
  const t = V(r) ? r.split(".") : r;
  let e = 0;
  for (; e < t.length - 1; ) {
    if (Wn(a)) return {};
    const i = Yn(t[e]);
    !a[i] && n && (a[i] = new n()), Object.prototype.hasOwnProperty.call(a, i) ? a = a[i] : a = {}, ++e;
  }
  return Wn(a) ? {} : {
    obj: a,
    k: Yn(t[e])
  };
}, Zn = (a, r, n) => {
  const {
    obj: t,
    k: e
  } = mt(a, r, Object);
  if (t !== void 0 || r.length === 1) {
    t[e] = n;
    return;
  }
  let i = r[r.length - 1], o = r.slice(0, r.length - 1), s = mt(a, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = mt(a, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}, Mu = (a, r, n, t) => {
  const {
    obj: e,
    k: i
  } = mt(a, r, Object);
  e[i] = e[i] || [], e[i].push(n);
}, Ut = (a, r) => {
  const {
    obj: n,
    k: t
  } = mt(a, r);
  if (n)
    return n[t];
}, wu = (a, r, n) => {
  const t = Ut(a, n);
  return t !== void 0 ? t : Ut(r, n);
}, vo = (a, r, n) => {
  for (const t in r)
    t !== "__proto__" && t !== "constructor" && (t in a ? V(a[t]) || a[t] instanceof String || V(r[t]) || r[t] instanceof String ? n && (a[t] = r[t]) : vo(a[t], r[t], n) : a[t] = r[t]);
  return a;
}, Oa = (a) => a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Cu = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Pu = (a) => V(a) ? a.replace(/[&<>"'\/]/g, (r) => Cu[r]) : a;
class Tu {
  constructor(r) {
    this.capacity = r, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(r) {
    const n = this.regExpMap.get(r);
    if (n !== void 0)
      return n;
    const t = new RegExp(r);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(r, t), this.regExpQueue.push(r), t;
  }
}
const Nu = [" ", ",", "?", "!", ";"], Du = new Tu(20), Au = (a, r, n) => {
  r = r || "", n = n || "";
  const t = Nu.filter((o) => r.indexOf(o) < 0 && n.indexOf(o) < 0);
  if (t.length === 0) return !0;
  const e = Du.getRegExp(`(${t.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !e.test(a);
  if (!i) {
    const o = a.indexOf(n);
    o > 0 && !e.test(a.substring(0, o)) && (i = !0);
  }
  return i;
}, Lr = function(a, r) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!a) return;
  if (a[r]) return a[r];
  const t = r.split(n);
  let e = a;
  for (let i = 0; i < t.length; ) {
    if (!e || typeof e != "object")
      return;
    let o, s = "";
    for (let l = i; l < t.length; ++l)
      if (l !== i && (s += n), s += t[l], o = e[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < t.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    e = o;
  }
  return e;
}, zt = (a) => a && a.replace("_", "-"), Iu = {
  type: "logger",
  log(a) {
    this.output("log", a);
  },
  warn(a) {
    this.output("warn", a);
  },
  error(a) {
    this.output("error", a);
  },
  output(a, r) {
    console && console[a] && console[a].apply(console, r);
  }
};
class jt {
  constructor(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(r, n);
  }
  init(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = r || Iu, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var r = arguments.length, n = new Array(r), t = 0; t < r; t++)
      n[t] = arguments[t];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var r = arguments.length, n = new Array(r), t = 0; t < r; t++)
      n[t] = arguments[t];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var r = arguments.length, n = new Array(r), t = 0; t < r; t++)
      n[t] = arguments[t];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var r = arguments.length, n = new Array(r), t = 0; t < r; t++)
      n[t] = arguments[t];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(r, n, t, e) {
    return e && !this.debug ? null : (V(r[0]) && (r[0] = `${t}${this.prefix} ${r[0]}`), this.logger[n](r));
  }
  create(r) {
    return new jt(this.logger, {
      prefix: `${this.prefix}:${r}:`,
      ...this.options
    });
  }
  clone(r) {
    return r = r || this.options, r.prefix = r.prefix || this.prefix, new jt(this.logger, r);
  }
}
var ta = new jt();
class or {
  constructor() {
    this.observers = {};
  }
  on(r, n) {
    return r.split(" ").forEach((t) => {
      this.observers[t] || (this.observers[t] = /* @__PURE__ */ new Map());
      const e = this.observers[t].get(n) || 0;
      this.observers[t].set(n, e + 1);
    }), this;
  }
  off(r, n) {
    if (this.observers[r]) {
      if (!n) {
        delete this.observers[r];
        return;
      }
      this.observers[r].delete(n);
    }
  }
  emit(r) {
    for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), e = 1; e < n; e++)
      t[e - 1] = arguments[e];
    this.observers[r] && Array.from(this.observers[r].entries()).forEach((o) => {
      let [s, l] = o;
      for (let u = 0; u < l; u++)
        s(...t);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [s, l] = o;
      for (let u = 0; u < l; u++)
        s.apply(s, [r, ...t]);
    });
  }
}
class Jn extends or {
  constructor(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = r || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(r) {
    this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
  }
  removeNamespaces(r) {
    const n = this.options.ns.indexOf(r);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(r, n, t) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = e.keySeparator !== void 0 ? e.keySeparator : this.options.keySeparator, o = e.ignoreJSONStructure !== void 0 ? e.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    r.indexOf(".") > -1 ? s = r.split(".") : (s = [r, n], t && (Array.isArray(t) ? s.push(...t) : V(t) && i ? s.push(...t.split(i)) : s.push(t)));
    const l = Ut(this.data, s);
    return !l && !n && !t && r.indexOf(".") > -1 && (r = s[0], n = s[1], t = s.slice(2).join(".")), l || !o || !V(t) ? l : Lr(this.data && this.data[r] && this.data[r][n], t, i);
  }
  addResource(r, n, t, e) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [r, n];
    t && (s = s.concat(o ? t.split(o) : t)), r.indexOf(".") > -1 && (s = r.split("."), e = n, n = s[1]), this.addNamespaces(n), Zn(this.data, s, e), i.silent || this.emit("added", r, n, t, e);
  }
  addResources(r, n, t) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in t)
      (V(t[i]) || Array.isArray(t[i])) && this.addResource(r, n, i, t[i], {
        silent: !0
      });
    e.silent || this.emit("added", r, n, t);
  }
  addResourceBundle(r, n, t, e, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [r, n];
    r.indexOf(".") > -1 && (s = r.split("."), e = t, t = n, n = s[1]), this.addNamespaces(n);
    let l = Ut(this.data, s) || {};
    o.skipCopy || (t = JSON.parse(JSON.stringify(t))), e ? vo(l, t, i) : l = {
      ...l,
      ...t
    }, Zn(this.data, s, l), o.silent || this.emit("added", r, n, t);
  }
  removeResourceBundle(r, n) {
    this.hasResourceBundle(r, n) && delete this.data[r][n], this.removeNamespaces(n), this.emit("removed", r, n);
  }
  hasResourceBundle(r, n) {
    return this.getResource(r, n) !== void 0;
  }
  getResourceBundle(r, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(r, n)
    } : this.getResource(r, n);
  }
  getDataByLanguage(r) {
    return this.data[r];
  }
  hasLanguageSomeTranslations(r) {
    const n = this.getDataByLanguage(r);
    return !!(n && Object.keys(n) || []).find((e) => n[e] && Object.keys(n[e]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var bo = {
  processors: {},
  addPostProcessor(a) {
    this.processors[a.name] = a;
  },
  handle(a, r, n, t, e) {
    return a.forEach((i) => {
      this.processors[i] && (r = this.processors[i].process(r, n, t, e));
    }), r;
  }
};
const $n = {};
class Vt extends or {
  constructor(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Su(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], r, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ta.create("translator");
  }
  changeLanguage(r) {
    r && (this.language = r);
  }
  exists(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (r == null)
      return !1;
    const t = this.resolve(r, n);
    return t && t.res !== void 0;
  }
  extractFromKey(r, n) {
    let t = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    t === void 0 && (t = ":");
    const e = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const o = t && r.indexOf(t) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !Au(r, t, e);
    if (o && !s) {
      const l = r.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: r,
          namespaces: V(i) ? [i] : i
        };
      const u = r.split(t);
      (t !== e || t === e && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), r = u.join(e);
    }
    return {
      key: r,
      namespaces: V(i) ? [i] : i
    };
  }
  translate(r, n, t) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), r == null) return "";
    Array.isArray(r) || (r = [String(r)]);
    const e = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(r[r.length - 1], n), l = s[s.length - 1], u = n.lng || this.language, c = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (c) {
        const C = n.nsSeparator || this.options.nsSeparator;
        return e ? {
          res: `${l}${C}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: u,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${C}${o}`;
      }
      return e ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: u,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : o;
    }
    const d = this.resolve(r, n);
    let p = d && d.res;
    const m = d && d.usedKey || o, f = d && d.exactUsedKey || o, y = Object.prototype.toString.apply(p), v = ["[object Number]", "[object Function]", "[object RegExp]"], P = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, k = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !V(p) && typeof p != "boolean" && typeof p != "number";
    if (k && p && w && v.indexOf(y) < 0 && !(V(P) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const C = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, p, {
          ...n,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return e ? (d.res = C, d.usedParams = this.getUsedParamsDetails(n), d) : C;
      }
      if (i) {
        const C = Array.isArray(p), S = C ? [] : {}, b = C ? f : m;
        for (const T in p)
          if (Object.prototype.hasOwnProperty.call(p, T)) {
            const D = `${b}${i}${T}`;
            S[T] = this.translate(D, {
              ...n,
              joinArrays: !1,
              ns: s
            }), S[T] === D && (S[T] = p[T]);
          }
        p = S;
      }
    } else if (k && V(P) && Array.isArray(p))
      p = p.join(P), p && (p = this.extendTranslation(p, r, n, t));
    else {
      let C = !1, S = !1;
      const b = n.count !== void 0 && !V(n.count), T = Vt.hasDefaultValue(n), D = b ? this.pluralResolver.getSuffix(u, n.count, n) : "", A = n.ordinal && b ? this.pluralResolver.getSuffix(u, n.count, {
        ordinal: !1
      }) : "", I = b && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), K = I && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${D}`] || n[`defaultValue${A}`] || n.defaultValue;
      !this.isValidLookup(p) && T && (C = !0, p = K), this.isValidLookup(p) || (S = !0, p = o);
      const Y = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && S ? void 0 : p, z = T && K !== p && this.options.updateMissing;
      if (S || C || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", u, l, o, z ? K : p), i) {
          const R = this.resolve(o, {
            ...n,
            keySeparator: !1
          });
          R && R.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let H = [];
        const U = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && U && U[0])
          for (let R = 0; R < U.length; R++)
            H.push(U[R]);
        else this.options.saveMissingTo === "all" ? H = this.languageUtils.toResolveHierarchy(n.lng || this.language) : H.push(n.lng || this.language);
        const B = (R, W, j) => {
          const q = T && j !== p ? j : Y;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(R, l, W, q, z, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(R, l, W, q, z, n), this.emit("missingKey", R, l, W, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && b ? H.forEach((R) => {
          const W = this.pluralResolver.getSuffixes(R, n);
          I && n[`defaultValue${this.options.pluralSeparator}zero`] && W.indexOf(`${this.options.pluralSeparator}zero`) < 0 && W.push(`${this.options.pluralSeparator}zero`), W.forEach((j) => {
            B([R], o + j, n[`defaultValue${j}`] || K);
          });
        }) : B(H, o, K));
      }
      p = this.extendTranslation(p, r, n, d, t), S && p === o && this.options.appendNamespaceToMissingKey && (p = `${l}:${o}`), (S || C) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, C ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return e ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(r, n, t, e, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      r = this.i18nFormat.parse(r, {
        ...this.options.interpolation.defaultVariables,
        ...t
      }, t.lng || this.language || e.usedLng, e.usedNS, e.usedKey, {
        resolved: e
      });
    else if (!t.skipInterpolation) {
      t.interpolation && this.interpolator.init({
        ...t,
        interpolation: {
          ...this.options.interpolation,
          ...t.interpolation
        }
      });
      const u = V(r) && (t && t.interpolation && t.interpolation.skipOnVariables !== void 0 ? t.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (u) {
        const p = r.match(this.interpolator.nestingRegexp);
        c = p && p.length;
      }
      let d = t.replace && !V(t.replace) ? t.replace : t;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), r = this.interpolator.interpolate(r, d, t.lng || this.language || e.usedLng, t), u) {
        const p = r.match(this.interpolator.nestingRegexp), m = p && p.length;
        c < m && (t.nest = !1);
      }
      !t.lng && this.options.compatibilityAPI !== "v1" && e && e.res && (t.lng = this.language || e.usedLng), t.nest !== !1 && (r = this.interpolator.nest(r, function() {
        for (var p = arguments.length, m = new Array(p), f = 0; f < p; f++)
          m[f] = arguments[f];
        return i && i[0] === m[0] && !t.context ? (o.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${n[0]}`), null) : o.translate(...m, n);
      }, t)), t.interpolation && this.interpolator.reset();
    }
    const s = t.postProcess || this.options.postProcess, l = V(s) ? [s] : s;
    return r != null && l && l.length && t.applyPostProcessor !== !1 && (r = bo.handle(l, r, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...e,
        usedParams: this.getUsedParamsDetails(t)
      },
      ...t
    } : t, this)), r;
  }
  resolve(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t, e, i, o, s;
    return V(r) && (r = [r]), r.forEach((l) => {
      if (this.isValidLookup(t)) return;
      const u = this.extractFromKey(l, n), c = u.key;
      e = c;
      let d = u.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !V(n.count), m = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), f = n.context !== void 0 && (V(n.context) || typeof n.context == "number") && n.context !== "", y = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((v) => {
        this.isValidLookup(t) || (s = v, !$n[`${y[0]}-${v}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && ($n[`${y[0]}-${v}`] = !0, this.logger.warn(`key "${e}" for languages "${y.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((P) => {
          if (this.isValidLookup(t)) return;
          o = P;
          const k = [c];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(k, c, P, v, n);
          else {
            let C;
            p && (C = this.pluralResolver.getSuffix(P, n.count, n));
            const S = `${this.options.pluralSeparator}zero`, b = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (k.push(c + C), n.ordinal && C.indexOf(b) === 0 && k.push(c + C.replace(b, this.options.pluralSeparator)), m && k.push(c + S)), f) {
              const T = `${c}${this.options.contextSeparator}${n.context}`;
              k.push(T), p && (k.push(T + C), n.ordinal && C.indexOf(b) === 0 && k.push(T + C.replace(b, this.options.pluralSeparator)), m && k.push(T + S));
            }
          }
          let w;
          for (; w = k.pop(); )
            this.isValidLookup(t) || (i = w, t = this.getResource(P, v, w, n));
        }));
      });
    }), {
      res: t,
      usedKey: e,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(r) {
    return r !== void 0 && !(!this.options.returnNull && r === null) && !(!this.options.returnEmptyString && r === "");
  }
  getResource(r, n, t) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(r, n, t, e) : this.resourceStore.getResource(r, n, t, e);
  }
  getUsedParamsDetails() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], t = r.replace && !V(r.replace);
    let e = t ? r.replace : r;
    if (t && typeof r.count < "u" && (e.count = r.count), this.options.interpolation.defaultVariables && (e = {
      ...this.options.interpolation.defaultVariables,
      ...e
    }), !t) {
      e = {
        ...e
      };
      for (const i of n)
        delete e[i];
    }
    return e;
  }
  static hasDefaultValue(r) {
    const n = "defaultValue";
    for (const t in r)
      if (Object.prototype.hasOwnProperty.call(r, t) && n === t.substring(0, n.length) && r[t] !== void 0)
        return !0;
    return !1;
  }
}
const _r = (a) => a.charAt(0).toUpperCase() + a.slice(1);
class qn {
  constructor(r) {
    this.options = r, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ta.create("languageUtils");
  }
  getScriptPartFromCode(r) {
    if (r = zt(r), !r || r.indexOf("-") < 0) return null;
    const n = r.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(r) {
    if (r = zt(r), !r || r.indexOf("-") < 0) return r;
    const n = r.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(r) {
    if (V(r) && r.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let e = Intl.getCanonicalLocales(r)[0];
          if (e && this.options.lowerCaseLng && (e = e.toLowerCase()), e) return e;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let t = r.split("-");
      return this.options.lowerCaseLng ? t = t.map((e) => e.toLowerCase()) : t.length === 2 ? (t[0] = t[0].toLowerCase(), t[1] = t[1].toUpperCase(), n.indexOf(t[1].toLowerCase()) > -1 && (t[1] = _r(t[1].toLowerCase()))) : t.length === 3 && (t[0] = t[0].toLowerCase(), t[1].length === 2 && (t[1] = t[1].toUpperCase()), t[0] !== "sgn" && t[2].length === 2 && (t[2] = t[2].toUpperCase()), n.indexOf(t[1].toLowerCase()) > -1 && (t[1] = _r(t[1].toLowerCase())), n.indexOf(t[2].toLowerCase()) > -1 && (t[2] = _r(t[2].toLowerCase()))), t.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? r.toLowerCase() : r;
  }
  isSupportedCode(r) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (r = this.getLanguagePartFromCode(r)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(r) > -1;
  }
  getBestMatchFromCodes(r) {
    if (!r) return null;
    let n;
    return r.forEach((t) => {
      if (n) return;
      const e = this.formatLanguageCode(t);
      (!this.options.supportedLngs || this.isSupportedCode(e)) && (n = e);
    }), !n && this.options.supportedLngs && r.forEach((t) => {
      if (n) return;
      const e = this.getLanguagePartFromCode(t);
      if (this.isSupportedCode(e)) return n = e;
      n = this.options.supportedLngs.find((i) => {
        if (i === e) return i;
        if (!(i.indexOf("-") < 0 && e.indexOf("-") < 0) && (i.indexOf("-") > 0 && e.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === e || i.indexOf(e) === 0 && e.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(r, n) {
    if (!r) return [];
    if (typeof r == "function" && (r = r(n)), V(r) && (r = [r]), Array.isArray(r)) return r;
    if (!n) return r.default || [];
    let t = r[n];
    return t || (t = r[this.getScriptPartFromCode(n)]), t || (t = r[this.formatLanguageCode(n)]), t || (t = r[this.getLanguagePartFromCode(n)]), t || (t = r.default), t || [];
  }
  toResolveHierarchy(r, n) {
    const t = this.getFallbackCodes(n || this.options.fallbackLng || [], r), e = [], i = (o) => {
      o && (this.isSupportedCode(o) ? e.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return V(r) && (r.indexOf("-") > -1 || r.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(r)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(r)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(r))) : V(r) && i(this.formatLanguageCode(r)), t.forEach((o) => {
      e.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), e;
  }
}
let xu = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Eu = {
  1: (a) => +(a > 1),
  2: (a) => +(a != 1),
  3: (a) => 0,
  4: (a) => a % 10 == 1 && a % 100 != 11 ? 0 : a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20) ? 1 : 2,
  5: (a) => a == 0 ? 0 : a == 1 ? 1 : a == 2 ? 2 : a % 100 >= 3 && a % 100 <= 10 ? 3 : a % 100 >= 11 ? 4 : 5,
  6: (a) => a == 1 ? 0 : a >= 2 && a <= 4 ? 1 : 2,
  7: (a) => a == 1 ? 0 : a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20) ? 1 : 2,
  8: (a) => a == 1 ? 0 : a == 2 ? 1 : a != 8 && a != 11 ? 2 : 3,
  9: (a) => +(a >= 2),
  10: (a) => a == 1 ? 0 : a == 2 ? 1 : a < 7 ? 2 : a < 11 ? 3 : 4,
  11: (a) => a == 1 || a == 11 ? 0 : a == 2 || a == 12 ? 1 : a > 2 && a < 20 ? 2 : 3,
  12: (a) => +(a % 10 != 1 || a % 100 == 11),
  13: (a) => +(a !== 0),
  14: (a) => a == 1 ? 0 : a == 2 ? 1 : a == 3 ? 2 : 3,
  15: (a) => a % 10 == 1 && a % 100 != 11 ? 0 : a % 10 >= 2 && (a % 100 < 10 || a % 100 >= 20) ? 1 : 2,
  16: (a) => a % 10 == 1 && a % 100 != 11 ? 0 : a !== 0 ? 1 : 2,
  17: (a) => a == 1 || a % 10 == 1 && a % 100 != 11 ? 0 : 1,
  18: (a) => a == 0 ? 0 : a == 1 ? 1 : 2,
  19: (a) => a == 1 ? 0 : a == 0 || a % 100 > 1 && a % 100 < 11 ? 1 : a % 100 > 10 && a % 100 < 20 ? 2 : 3,
  20: (a) => a == 1 ? 0 : a == 0 || a % 100 > 0 && a % 100 < 20 ? 1 : 2,
  21: (a) => a % 100 == 1 ? 1 : a % 100 == 2 ? 2 : a % 100 == 3 || a % 100 == 4 ? 3 : 0,
  22: (a) => a == 1 ? 0 : a == 2 ? 1 : (a < 0 || a > 10) && a % 10 == 0 ? 2 : 3
};
const Bu = ["v1", "v2", "v3"], Ou = ["v4"], Qn = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Gu = () => {
  const a = {};
  return xu.forEach((r) => {
    r.lngs.forEach((n) => {
      a[n] = {
        numbers: r.nr,
        plurals: Eu[r.fc]
      };
    });
  }), a;
};
class Lu {
  constructor(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = r, this.options = n, this.logger = ta.create("pluralResolver"), (!this.options.compatibilityJSON || Ou.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Gu(), this.pluralRulesCache = {};
  }
  addRule(r, n) {
    this.rules[r] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const t = zt(r === "dev" ? "en" : r), e = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: t,
        type: e
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(t, {
          type: e
        });
      } catch {
        if (!r.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(r);
        o = this.getRule(l, n);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[r] || this.rules[this.languageUtils.getLanguagePartFromCode(r)];
  }
  needsPlural(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const t = this.getRule(r, n);
    return this.shouldUseIntlApi() ? t && t.resolvedOptions().pluralCategories.length > 1 : t && t.numbers.length > 1;
  }
  getPluralFormsOfKey(r, n) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(r, t).map((e) => `${n}${e}`);
  }
  getSuffixes(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const t = this.getRule(r, n);
    return t ? this.shouldUseIntlApi() ? t.resolvedOptions().pluralCategories.sort((e, i) => Qn[e] - Qn[i]).map((e) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${e}`) : t.numbers.map((e) => this.getSuffix(r, e, n)) : [];
  }
  getSuffix(r, n) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const e = this.getRule(r, t);
    return e ? this.shouldUseIntlApi() ? `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${e.select(n)}` : this.getSuffixRetroCompatible(e, n) : (this.logger.warn(`no plural rule found for: ${r}`), "");
  }
  getSuffixRetroCompatible(r, n) {
    const t = r.noAbs ? r.plurals(n) : r.plurals(Math.abs(n));
    let e = r.numbers[t];
    this.options.simplifyPluralSuffix && r.numbers.length === 2 && r.numbers[0] === 1 && (e === 2 ? e = "plural" : e === 1 && (e = ""));
    const i = () => this.options.prepend && e.toString() ? this.options.prepend + e.toString() : e.toString();
    return this.options.compatibilityJSON === "v1" ? e === 1 ? "" : typeof e == "number" ? `_plural_${e.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && r.numbers.length === 2 && r.numbers[0] === 1 ? i() : this.options.prepend && t.toString() ? this.options.prepend + t.toString() : t.toString();
  }
  shouldUseIntlApi() {
    return !Bu.includes(this.options.compatibilityJSON);
  }
}
const Xn = function(a, r, n) {
  let t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = wu(a, r, n);
  return !i && e && V(n) && (i = Lr(a, n, t), i === void 0 && (i = Lr(r, n, t))), i;
}, yr = (a) => a.replace(/\$/g, "$$$$");
class Ru {
  constructor() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ta.create("interpolator"), this.options = r, this.format = r.interpolation && r.interpolation.format || ((n) => n), this.init(r);
  }
  init() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    r.interpolation || (r.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: t,
      useRawValueToEscape: e,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: u,
      unescapeSuffix: c,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: m,
      nestingSuffix: f,
      nestingSuffixEscaped: y,
      nestingOptionsSeparator: v,
      maxReplaces: P,
      alwaysFormat: k
    } = r.interpolation;
    this.escape = n !== void 0 ? n : Pu, this.escapeValue = t !== void 0 ? t : !0, this.useRawValueToEscape = e !== void 0 ? e : !1, this.prefix = i ? Oa(i) : o || "{{", this.suffix = s ? Oa(s) : l || "}}", this.formatSeparator = u || ",", this.unescapePrefix = c ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : c || "", this.nestingPrefix = p ? Oa(p) : m || Oa("$t("), this.nestingSuffix = f ? Oa(f) : y || Oa(")"), this.nestingOptionsSeparator = v || ",", this.maxReplaces = P || 1e3, this.alwaysFormat = k !== void 0 ? k : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const r = (n, t) => n && n.source === t ? (n.lastIndex = 0, n) : new RegExp(t, "g");
    this.regexp = r(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = r(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = r(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(r, n, t, e) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const P = Xn(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(P, void 0, t, {
          ...e,
          ...n,
          interpolationkey: m
        }) : P;
      }
      const f = m.split(this.formatSeparator), y = f.shift().trim(), v = f.join(this.formatSeparator).trim();
      return this.format(Xn(n, l, y, this.options.keySeparator, this.options.ignoreJSONStructure), v, t, {
        ...e,
        ...n,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const c = e && e.missingInterpolationHandler || this.options.missingInterpolationHandler, d = e && e.interpolation && e.interpolation.skipOnVariables !== void 0 ? e.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => yr(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? yr(this.escape(m)) : yr(m)
    }].forEach((m) => {
      for (s = 0; i = m.regex.exec(r); ) {
        const f = i[1].trim();
        if (o = u(f), o === void 0)
          if (typeof c == "function") {
            const v = c(r, i, e);
            o = V(v) ? v : "";
          } else if (e && Object.prototype.hasOwnProperty.call(e, f))
            o = "";
          else if (d) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${f} for interpolating ${r}`), o = "";
        else !V(o) && !this.useRawValueToEscape && (o = Vn(o));
        const y = m.safeValue(o);
        if (r = r.replace(i[0], y), d ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= i[0].length) : m.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), r;
  }
  nest(r, n) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, e, i, o;
    const s = (l, u) => {
      const c = this.nestingOptionsSeparator;
      if (l.indexOf(c) < 0) return l;
      const d = l.split(new RegExp(`${c}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, o);
      const m = p.match(/'/g), f = p.match(/"/g);
      (m && m.length % 2 === 0 && !f || f.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), u && (o = {
          ...u,
          ...o
        });
      } catch (y) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, y), `${l}${c}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; e = this.nestingRegexp.exec(r); ) {
      let l = [];
      o = {
        ...t
      }, o = o.replace && !V(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let u = !1;
      if (e[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(e[1])) {
        const c = e[1].split(this.formatSeparator).map((d) => d.trim());
        e[1] = c.shift(), l = c, u = !0;
      }
      if (i = n(s.call(this, e[1].trim(), o), o), i && e[0] === r && !V(i)) return i;
      V(i) || (i = Vn(i)), i || (this.logger.warn(`missed to resolve ${e[1]} for nesting ${r}`), i = ""), u && (i = l.reduce((c, d) => this.format(c, d, t.lng, {
        ...t,
        interpolationkey: e[1].trim()
      }), i.trim())), r = r.replace(e[0], i), this.regexp.lastIndex = 0;
    }
    return r;
  }
}
const Fu = (a) => {
  let r = a.toLowerCase().trim();
  const n = {};
  if (a.indexOf("(") > -1) {
    const t = a.split("(");
    r = t[0].toLowerCase().trim();
    const e = t[1].substring(0, t[1].length - 1);
    r === "currency" && e.indexOf(":") < 0 ? n.currency || (n.currency = e.trim()) : r === "relativetime" && e.indexOf(":") < 0 ? n.range || (n.range = e.trim()) : e.split(";").forEach((o) => {
      if (o) {
        const [s, ...l] = o.split(":"), u = l.join(":").trim().replace(/^'+|'+$/g, ""), c = s.trim();
        n[c] || (n[c] = u), u === "false" && (n[c] = !1), u === "true" && (n[c] = !0), isNaN(u) || (n[c] = parseInt(u, 10));
      }
    });
  }
  return {
    formatName: r,
    formatOptions: n
  };
}, Ga = (a) => {
  const r = {};
  return (n, t, e) => {
    let i = e;
    e && e.interpolationkey && e.formatParams && e.formatParams[e.interpolationkey] && e[e.interpolationkey] && (i = {
      ...i,
      [e.interpolationkey]: void 0
    });
    const o = t + JSON.stringify(i);
    let s = r[o];
    return s || (s = a(zt(t), e), r[o] = s), s(n);
  };
};
class Ku {
  constructor() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ta.create("formatter"), this.options = r, this.formats = {
      number: Ga((n, t) => {
        const e = new Intl.NumberFormat(n, {
          ...t
        });
        return (i) => e.format(i);
      }),
      currency: Ga((n, t) => {
        const e = new Intl.NumberFormat(n, {
          ...t,
          style: "currency"
        });
        return (i) => e.format(i);
      }),
      datetime: Ga((n, t) => {
        const e = new Intl.DateTimeFormat(n, {
          ...t
        });
        return (i) => e.format(i);
      }),
      relativetime: Ga((n, t) => {
        const e = new Intl.RelativeTimeFormat(n, {
          ...t
        });
        return (i) => e.format(i, t.range || "day");
      }),
      list: Ga((n, t) => {
        const e = new Intl.ListFormat(n, {
          ...t
        });
        return (i) => e.format(i);
      })
    }, this.init(r);
  }
  init(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(r, n) {
    this.formats[r.toLowerCase().trim()] = n;
  }
  addCached(r, n) {
    this.formats[r.toLowerCase().trim()] = Ga(n);
  }
  format(r, n, t) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((s) => s.indexOf(")") > -1)) {
      const s = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, s)].join(this.formatSeparator);
    }
    return i.reduce((s, l) => {
      const {
        formatName: u,
        formatOptions: c
      } = Fu(l);
      if (this.formats[u]) {
        let d = s;
        try {
          const p = e && e.formatParams && e.formatParams[e.interpolationkey] || {}, m = p.locale || p.lng || e.locale || e.lng || t;
          d = this.formats[u](s, m, {
            ...c,
            ...e,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return s;
    }, r);
  }
}
const Hu = (a, r) => {
  a.pending[r] !== void 0 && (delete a.pending[r], a.pendingCount--);
};
class Uu extends or {
  constructor(r, n, t) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = r, this.store = n, this.services = t, this.languageUtils = t.languageUtils, this.options = e, this.logger = ta.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = e.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = e.maxRetries >= 0 ? e.maxRetries : 5, this.retryTimeout = e.retryTimeout >= 1 ? e.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(t, e.backend, e);
  }
  queueLoad(r, n, t, e) {
    const i = {}, o = {}, s = {}, l = {};
    return r.forEach((u) => {
      let c = !0;
      n.forEach((d) => {
        const p = `${u}|${d}`;
        !t.reload && this.store.hasResourceBundle(u, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, c = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), c || (s[u] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: e
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(r, n, t) {
    const e = r.split("|"), i = e[0], o = e[1];
    n && this.emit("failedLoading", i, o, n), !n && t && this.store.addResourceBundle(i, o, t, void 0, void 0, {
      skipCopy: !0
    }), this.state[r] = n ? -1 : 2, n && t && (this.state[r] = 0);
    const s = {};
    this.queue.forEach((l) => {
      Mu(l.loaded, [i], o), Hu(l, r), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((u) => {
        s[u] || (s[u] = {});
        const c = l.loaded[u];
        c.length && c.forEach((d) => {
          s[u][d] === void 0 && (s[u][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(r, n, t) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!r.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: r,
        ns: n,
        fcName: t,
        tried: e,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (u, c) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (u && c && e < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, r, n, t, e + 1, i * 2, o);
        }, i);
        return;
      }
      o(u, c);
    }, l = this.backend[t].bind(this.backend);
    if (l.length === 2) {
      try {
        const u = l(r, n);
        u && typeof u.then == "function" ? u.then((c) => s(null, c)).catch(s) : s(null, u);
      } catch (u) {
        s(u);
      }
      return;
    }
    return l(r, n, s);
  }
  prepareLoading(r, n) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, e = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), e && e();
    V(r) && (r = this.languageUtils.toResolveHierarchy(r)), V(n) && (n = [n]);
    const i = this.queueLoad(r, n, t, e);
    if (!i.toLoad.length)
      return i.pending.length || e(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(r, n, t) {
    this.prepareLoading(r, n, {}, t);
  }
  reload(r, n, t) {
    this.prepareLoading(r, n, {
      reload: !0
    }, t);
  }
  loadOne(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const t = r.split("|"), e = t[0], i = t[1];
    this.read(e, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${n}loading namespace ${i} for language ${e} failed`, o), !o && s && this.logger.log(`${n}loaded namespace ${i} for language ${e}`, s), this.loaded(r, o, s);
    });
  }
  saveMissing(r, n, t, e, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${t}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(t == null || t === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let c;
            u.length === 5 ? c = u(r, n, t, e, l) : c = u(r, n, t, e), c && typeof c.then == "function" ? c.then((d) => s(null, d)).catch(s) : s(null, c);
          } catch (c) {
            s(c);
          }
        else
          u(r, n, t, e, s, l);
      }
      !r || !r[0] || this.store.addResource(r[0], n, t, e);
    }
  }
}
const ei = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (a) => {
    let r = {};
    if (typeof a[1] == "object" && (r = a[1]), V(a[1]) && (r.defaultValue = a[1]), V(a[2]) && (r.tDescription = a[2]), typeof a[2] == "object" || typeof a[3] == "object") {
      const n = a[3] || a[2];
      Object.keys(n).forEach((t) => {
        r[t] = n[t];
      });
    }
    return r;
  },
  interpolation: {
    escapeValue: !0,
    format: (a) => a,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), ai = (a) => (V(a.ns) && (a.ns = [a.ns]), V(a.fallbackLng) && (a.fallbackLng = [a.fallbackLng]), V(a.fallbackNS) && (a.fallbackNS = [a.fallbackNS]), a.supportedLngs && a.supportedLngs.indexOf("cimode") < 0 && (a.supportedLngs = a.supportedLngs.concat(["cimode"])), a), It = () => {
}, zu = (a) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(a)).forEach((n) => {
    typeof a[n] == "function" && (a[n] = a[n].bind(a));
  });
};
class yt extends or {
  constructor() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ai(r), this.services = {}, this.logger = ta, this.modules = {
      external: []
    }, zu(this), n && !this.isInitialized && !r.isClone) {
      if (!this.options.initImmediate)
        return this.init(r, n), this;
      setTimeout(() => {
        this.init(r, n);
      }, 0);
    }
  }
  init() {
    var r = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (t = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (V(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const e = ei();
    this.options = {
      ...e,
      ...this.options,
      ...ai(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...e.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? ta.init(i(this.modules.logger), this.options) : ta.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : typeof Intl < "u" && (c = Ku);
      const d = new qn(this.options);
      this.store = new Jn(this.options.resources, this.options);
      const p = this.services;
      p.logger = ta, p.resourceStore = this.store, p.languageUtils = d, p.pluralResolver = new Lu(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), c && (!this.options.interpolation.format || this.options.interpolation.format === e.interpolation.format) && (p.formatter = i(c), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new Ru(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new Uu(i(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(m) {
        for (var f = arguments.length, y = new Array(f > 1 ? f - 1 : 0), v = 1; v < f; v++)
          y[v - 1] = arguments[v];
        r.emit(m, ...y);
      }), this.modules.languageDetector && (p.languageDetector = i(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = i(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new Vt(this.services, this.options), this.translator.on("*", function(m) {
        for (var f = arguments.length, y = new Array(f > 1 ? f - 1 : 0), v = 1; v < f; v++)
          y[v - 1] = arguments[v];
        r.emit(m, ...y);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, t || (t = It), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = function() {
        return r.store[c](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = function() {
        return r.store[c](...arguments), r;
      };
    });
    const l = rt(), u = () => {
      const c = (d, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(p), t(d, p);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), l;
  }
  loadResources(r) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : It;
    const e = V(r) ? r : this.language;
    if (typeof r == "function" && (t = r), !this.options.resources || this.options.partialBundledLanguages) {
      if (e && e.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return t();
      const i = [], o = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((u) => {
          u !== "cimode" && i.indexOf(u) < 0 && i.push(u);
        });
      };
      e ? o(e) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((s) => o(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), t(s);
      });
    } else
      t(null);
  }
  reloadResources(r, n, t) {
    const e = rt();
    return typeof r == "function" && (t = r, r = void 0), typeof n == "function" && (t = n, n = void 0), r || (r = this.languages), n || (n = this.options.ns), t || (t = It), this.services.backendConnector.reload(r, n, (i) => {
      e.resolve(), t(i);
    }), e;
  }
  use(r) {
    if (!r) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!r.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return r.type === "backend" && (this.modules.backend = r), (r.type === "logger" || r.log && r.warn && r.error) && (this.modules.logger = r), r.type === "languageDetector" && (this.modules.languageDetector = r), r.type === "i18nFormat" && (this.modules.i18nFormat = r), r.type === "postProcessor" && bo.addPostProcessor(r), r.type === "formatter" && (this.modules.formatter = r), r.type === "3rdParty" && this.modules.external.push(r), this;
  }
  setResolvedLanguage(r) {
    if (!(!r || !this.languages) && !(["cimode", "dev"].indexOf(r) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const t = this.languages[n];
        if (!(["cimode", "dev"].indexOf(t) > -1) && this.store.hasLanguageSomeTranslations(t)) {
          this.resolvedLanguage = t;
          break;
        }
      }
  }
  changeLanguage(r, n) {
    var t = this;
    this.isLanguageChangingTo = r;
    const e = rt();
    this.emit("languageChanging", r);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, u) => {
      u ? (i(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, e.resolve(function() {
        return t.t(...arguments);
      }), n && n(l, function() {
        return t.t(...arguments);
      });
    }, s = (l) => {
      !r && !l && this.services.languageDetector && (l = []);
      const u = V(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      u && (this.language || i(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (c) => {
        o(c, u);
      });
    };
    return !r && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !r && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(r), e;
  }
  getFixedT(r, n, t) {
    var e = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var u = arguments.length, c = new Array(u > 2 ? u - 2 : 0), d = 2; d < u; d++)
          c[d - 2] = arguments[d];
        l = e.options.overloadTranslationOptionHandler([o, s].concat(c));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || t || i.keyPrefix);
      const p = e.options.keySeparator || ".";
      let m;
      return l.keyPrefix && Array.isArray(o) ? m = o.map((f) => `${l.keyPrefix}${p}${f}`) : m = l.keyPrefix ? `${l.keyPrefix}${p}${o}` : o, e.t(m, l);
    };
    return V(r) ? i.lng = r : i.lngs = r, i.ns = n, i.keyPrefix = t, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(r) {
    this.options.defaultNS = r;
  }
  hasLoadedNamespace(r) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const t = n.lng || this.resolvedLanguage || this.languages[0], e = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (t.toLowerCase() === "cimode") return !0;
    const o = (s, l) => {
      const u = this.services.backendConnector.state[`${s}|${l}`];
      return u === -1 || u === 0 || u === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, o);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(t, r) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(t, r) && (!e || o(i, r)));
  }
  loadNamespaces(r, n) {
    const t = rt();
    return this.options.ns ? (V(r) && (r = [r]), r.forEach((e) => {
      this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
    }), this.loadResources((e) => {
      t.resolve(), n && n(e);
    }), t) : (n && n(), Promise.resolve());
  }
  loadLanguages(r, n) {
    const t = rt();
    V(r) && (r = [r]);
    const e = this.options.preload || [], i = r.filter((o) => e.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = e.concat(i), this.loadResources((o) => {
      t.resolve(), n && n(o);
    }), t) : (n && n(), Promise.resolve());
  }
  dir(r) {
    if (r || (r = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !r) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], t = this.services && this.services.languageUtils || new qn(ei());
    return n.indexOf(t.getLanguagePartFromCode(r)) > -1 || r.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new yt(r, n);
  }
  cloneInstance() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : It;
    const t = r.forkResourceStore;
    t && delete r.forkResourceStore;
    const e = {
      ...this.options,
      ...r,
      isClone: !0
    }, i = new yt(e);
    return (r.debug !== void 0 || r.prefix !== void 0) && (i.logger = i.logger.clone(r)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, t && (i.store = new Jn(this.store.data, e), i.services.resourceStore = i.store), i.translator = new Vt(i.services, e), i.translator.on("*", function(s) {
      for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
        u[c - 1] = arguments[c];
      i.emit(s, ...u);
    }), i.init(e, n), i.translator.options = e, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const F = yt.createInstance();
F.createInstance = yt.createInstance;
F.createInstance;
F.dir;
F.init;
F.loadResources;
F.reloadResources;
F.use;
F.changeLanguage;
F.getFixedT;
F.t;
F.exists;
F.setDefaultNamespace;
F.hasLoadedNamespace;
F.loadNamespaces;
F.loadLanguages;
var Q = /* @__PURE__ */ ((a) => (a.FRENCH = "fr", a.ENGLISH = "en", a.SPANISH = "es", a.ITALIAN = "it", a.PORTUGUESE = "pt", a.DEUTSCH = "de", a.DUTCH = "nl", a.RUSSIAN = "ru", a.JAPANESE = "ja", a.ARABIC = "ar", a.TURKISH = "tr", a.CHINESE = "zh", a.SWEDISH = "sv", a.ROMANIAN = "ro", a.CZECH = "cs", a.HUNGARIAN = "hu", a.SLOVAK = "sk", a.DANISH = "da", a.INDONESIAN = "id", a.POLISH = "pl", a.GREEK = "el", a.SERBIAN = "sr", a.NORWEGIAN = "no", a.THAI = "th", a.SLOVENIAN = "sl", a.UKRAINIAN = "uk", a.ALBANIA = "sq", a.HINDI = "hi", a))(Q || {});
const ju = { affiliate_badge: { made_with: "يعمل بواسطة" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات", trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم", trial_period_price: "مجانا", unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}" } } }, contact_slug: { city: "المدينة", company_name: "اسم الشركة", country: "البلد", email: "البريد الإلكتروني", first_name: "الاسم", last_name: "اسم العائلة", neighborhood: "الحي", phone_number: "رقم الهاتف", postal_code: "الرمز البريدي", state_province: "الولاية/المقاطعة", street_address: "عنوان الشارع", street_number: "رقم الشارع", tax_number: "الرقم الضريبي" }, copy_clipboard: "تم النسخ في الحافظة", copy_clipboard_error: "فشل في نسخ النص", date_picker: { all_time: "كل الوقت", apply: "تطبيق", clear: "إزالة", from: "من", last_3_months: "آخر 3 أشهر", last_30_days: "آخر 30 يوم", last_month: "الشهر الفائت", last_pool_period: "فترة التقييم الأخيرة للمجموعة", this_month: "هذا الشهر", time: "الوقت", title_dates: "تواريخ", to: "إلى" }, error: "خطأ", form_select: { empty_list: "يبدو أن هذه القائمة فارغة", select: "حدد" }, including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})", input: { phone_number: "رقم الهاتف", phone_search: "بحث", search: "بحث" }, locale: { albania: "الألبانية", arabic: "العربية", chinese: "الصينية", czech: "التشيكية", danish: "الدانماركية", dutch: "هولندية", english: "إنجليزية", french: "فرنسية", german: "ألمانية", greek: "اليونانية", hindi: "الهندية", hungarian: "الهنغارية", indonesian: "الأندونيسية", italian: "ايطالية", japanese: "اليابانية", norwegian: "النرويجية", polish: "البولندية", portuguese: "البرتغالية", romanian: "الرومانية", russian: "الروسية", serbian: "الصربية", slovak: "السلوفاكية", slovenian: "السلوفينية", spanish: "الإسبانية", swedish: "السويدية", thai: "التايلندية", turkish: "التركية", ukrainian: "الأوكرانية" }, order_summary: "ملخص الطلب", payment: { cash_on_delivery: "الدفع عند الاستلام", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "بطاقات الائتمان (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "بطاقات الائتمان (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "mollie", paypal_connect: "ربط paypal", paypal_edit_organization_name: "تعديل اسم المنظمة", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "بطاقات الإئتمان (Paystack)", price_plan: "عرض", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "بطاقة ائتمان أو خصم", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "بطاقات الائتمان (Xendit)" }, payment_inputs: { card_holder_placeholder: "حامل البطاقة", card_number_placeholder: "رقم البطاقة", cvc_placeholder: "رمز التحقق", date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي", empty_card_holder: "أدخل اسم حامل البطاقة", empty_card_number: "أدخل رقم البطاقة", empty_cvc: "أدخل رمز التحقق", empty_expiry_date: "أدخل تاريخ الانتهاء", expiry_data_placeholder: "الشهر/السنة", invalid_card_number: "رقم البطاقة غير صالح", invalid_cvc: "رمز التحقق غير صالح", invalid_expiry_date: "تاريخ الانتهاء غير صالح", month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12", year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي" }, "Payment-method": "طريقة دفع", price_plan: { interval: { day_0: "{{count}} يوم", day_1: "يوم {{count}}", day_2: "يومين {{count}}", day_3: "{{count}} أيام", day_4: "{{count}} يوم", day_5: "{{count}} يوم", month_0: "{{count}} شهر", month_1: "شهر {{count}}", month_2: "شهرين {{count}}", month_3: "{{count}} أشهر", month_4: "{{count}} شهر", month_5: "{{count}} شهر", week_0: "{{count}} أسبوع", week_1: "أسبوع {{count}}", week_2: "أسبوعين {{count}}", week_3: "{{count}} أسابيع", week_4: "{{count}} أسبوع", week_5: "{{count}} أسبوع", year_0: "{{count}} سنة", year_1: "سنة {{count}}", year_2: "سنتان{{count}}", year_3: "{{count}} سنوات", year_4: "{{count}} سنة", year_5: "{{count}} سنة" }, trial_period: { day_0: "{{count}} يوم", day_1: "يوم {{count}}", day_2: "يومين {{count}}", day_3: "{{count}} أيام", day_4: "{{count}} يوم", day_5: "{{count}} يوم", month_0: "{{count}} شهر", month_1: "شهر{{count}}", month_2: "شهربن {{count}}", month_3: "{{count}} أشهر", month_4: "{{count}} شهر", month_5: "{{count}} شهر", week_0: "{{count}} أسبوع", week_1: "أسبوع {{count}}", week_2: "أسبوعين {{count}}", week_3: "{{count}} أسابيع", week_4: "{{count}} أسبوع", week_5: "{{count}} أسبوع", year_0: "{{count}} سنة", year_1: "سنة {{count}}", year_2: "سنتان {{count}}", year_3: "{{count}} سنوات", year_4: "{{count}} سنة", year_5: "{{count}} سنة" } }, product: "منتج", quantity: "الكمية", "registered-over": "مسجل أكثر من", "required-field": "الحقل مطلوب", shipping: { condition_label: { price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}", price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر", quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر", quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر", weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام", weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر" }, not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.", shipping_method: "طريقة الشحن" }, shipping_fee: "رسوم الشحن", subtotal: "المجموع الفرعي", total: "المجموع", total_amount_with_shipping: "المجموع (شامل الشحن)", total_amount_with_tax: "المجموع (شامل الضرائب)", total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)", vat: "ضريبة المبيعات", vat_percent: "ضريبة المبيعات ({{percent}}%)" }, Vu = {
  public_pages_purchase: ju
}, Yu = { affiliate_badge: { made_with: "Vytvořeno v" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát", trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak", trial_period_price: "Zdarma", unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}" } } }, contact_slug: { city: "Město", company_name: "Název společnosti", country: "Země", email: "E-mail", first_name: "Jméno", last_name: "Příjmení", neighborhood: "Čtvrť", phone_number: "Telefonní číslo", postal_code: "PSČ", state_province: "Stát/Provincie", street_address: "Ulice", street_number: "Číslo ulice", tax_number: "DIČ" }, copy_clipboard: "Zkopírováno do schránky", copy_clipboard_error: "Kopírování textu se nezdařilo", date_picker: { all_time: "Celý čas", apply: "Použít", clear: "Vymazat", from: "Z", last_3_months: "Poslední 3 měsíce", last_30_days: "Posledních 30 dní", last_month: "Minulý měsíc", last_pool_period: "Poslední hodnotící období", this_month: "Tento měsíc", time: "Čas", title_dates: "Data", to: "Do" }, error: "Chyba", form_select: { empty_list: "Vypadá to, že tento seznam je prázdný", select: "Vybrat" }, including_tax: "Včetně DPH {{percent}} % ({{amount}})", input: { phone_number: "Telefonní číslo", phone_search: "Hledat", search: "Hledat" }, locale: { albania: "Albánština", arabic: "Arabština", chinese: "Čínština", czech: "Čeština", danish: "Dánština", dutch: "Holandský", english: "Angličtina", french: "Francouzština", german: "Němčina", greek: "Řečtina", hindi: "Hindi", hungarian: "Maďarský", indonesian: "Indonéština", italian: "Italština", japanese: "Japonština", norwegian: "Norština", polish: "Polština", portuguese: "Portugalština", romanian: "Rumunština", russian: "Ruština", serbian: "Srbština", slovak: "Slovenština", slovenian: "Slovinský", spanish: "Španělština", swedish: "Švédnština", thai: "Thajština", turkish: "Turečtina", ukrainian: "Ukrajinština" }, order_summary: "Shrnutí objednávky", payment: { cash_on_delivery: "Dobírka", dlocal_boleto: "Boleto (místní)", dlocal_card: "Kreditní karty (místní)", dlocal_pix: "Pix (místní)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditní karty (Mercado Pago)", mercadopago_pix: "PIX (Platební trh)", mollie: "Mollie", paypal_connect: "Připojte PayPal", paypal_edit_organization_name: "Upravit název organizace", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditní karty (Paystack)", price_plan: "Plán", razorpay: "Razorpay", secure_and_pay: "Zabezpečte a zaplaťte", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kreditní nebo debetní karta", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditní karty (Xendit)" }, payment_inputs: { card_holder_placeholder: "Držitel karty", card_number_placeholder: "Číslo karty", cvc_placeholder: "CVC", date_out_of_range: "Datum expirace nemůže být v minulosti", empty_card_holder: "Zadejte jméno držitele karty", empty_card_number: "Zadejte číslo karty", empty_cvc: "Zadejte CVC", empty_expiry_date: "Zadejte datum vypršení platnosti", expiry_data_placeholder: "MM/YY", invalid_card_number: "Číslo karty je neplatné", invalid_cvc: "CVC je neplatné", invalid_expiry_date: "Datum expirace je neplatné", month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12", year_out_of_range: "Rok expirace nemůže být v minulosti" }, "Payment-method": "Platební metoda", price_plan: { interval: { day_0: "den", day_1: "{{count}} dnů", day_2: "{{count}} dnů", month_0: "měsíc", month_1: "{{count}} měsíců", month_2: "{{count}} měsíců", week_0: "týden", week_1: "{{count}} týdnů", week_2: "{{count}} týdnů", year_0: "rok", year_1: "{{count}} let", year_2: "{{count}} let" }, trial_period: { day_0: "{{count}} den", day_1: "{{count}} dny", day_2: "{{count}} dní", month_0: "{{count}} měsíc", month_1: "{{count}} měsíců", month_2: "{{count}} měsíců", week_0: "{{count}} týden", week_1: "{{count}} týdnů", week_2: "{{count}} týdnů", year_0: "{{count}} rok", year_1: "{{count}} let", year_2: "{{count}} let" } }, product: "Produkt", quantity: "Množství", "registered-over": "registrovaných přes", "required-field": "Pole je povinné", shipping: { condition_label: { price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}", price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více", quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami", quantity_min: "Pro objednávky obsahující {{min}} nebo více položek", weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g", weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více" }, not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.", shipping_method: "Způsob dopravy" }, shipping_fee: "Poplatek za dopravu", subtotal: "Mezisoučet", total: "Celkem", total_amount_with_shipping: "Celkem (včetně dopravy)", total_amount_with_tax: "Celkem (včetně daně)", total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)", vat: "Daň z prodeje", vat_percent: "Daň z prodeje ({{percent}}%)" }, Wu = {
  public_pages_purchase: Yu
}, Zu = { affiliate_badge: { made_with: "Støttet af" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}" } } }, contact_slug: { city: "By", company_name: "Firmanavn", country: "Land", email: "E-mail", first_name: "Fornavn", last_name: "Efternavn", neighborhood: "Kvarter", phone_number: "Telefonnummer", postal_code: "Postnummer", state_province: "stat/provins", street_address: "Gadeadresse", street_number: "Gadenummer", tax_number: "Skattenummer" }, copy_clipboard: "Kopieret til udklipsholder", copy_clipboard_error: "Teksten kunne ikke kopieres", date_picker: { all_time: "Hele tiden", apply: "Anvende", clear: "Slet", from: "Fra", last_3_months: "Sidste 3 måneder", last_30_days: "Sidste 30 dage", last_month: "Sidste måned", last_pool_period: "Sidste puljeevalueringsperiode", this_month: "Denne måned", time: "Tid", title_dates: "Datoer", to: "Til" }, error: "Fejl", form_select: { empty_list: "Det ser ud til, at denne liste er tom", select: "Vælge" }, including_tax: "Inkluderer {{percent}} % moms ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Søge", search: "Søge" }, locale: { albania: "Albansk", arabic: "Arabisk", chinese: "Kinesisk", czech: "Tjekkisk", danish: "Dansk", dutch: "Hollandsk", english: "Engelsk", french: "Fransk", german: "Tysk", greek: "Græsk", hindi: "Hindi", hungarian: "Ungarsk", indonesian: "Indonesisk", italian: "Italiensk", japanese: "Japansk", norwegian: "Norsk", polish: "Polsk", portuguese: "Portugisisk", romanian: "Rumænsk", russian: "Russisk", serbian: "Serbisk", slovak: "Slovakisk", slovenian: "Slovensk", spanish: "Spansk", swedish: "Svensk", thai: "Thai", turkish: "Tyrkisk", ukrainian: "Ukrainsk" }, order_summary: "Ordreoversigt", payment: { cash_on_delivery: "Kontant ved levering", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditkort (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditkort (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Tilslut PayPal", paypal_edit_organization_name: "Rediger organisationens navn", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditkort (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kredit- eller betalingskort", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditkort (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kortholder", card_number_placeholder: "Kortnummer", cvc_placeholder: "CVC", date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden", empty_card_holder: "Indtast et kortholdernavn", empty_card_number: "Indtast et kortnummer", empty_cvc: "Indtast en CVC", empty_expiry_date: "Indtast en udløbsdato", expiry_data_placeholder: "MM/ÅÅ", invalid_card_number: "Kortnummeret er ugyldigt", invalid_cvc: "CVC er ugyldig", invalid_expiry_date: "Udløbsdatoen er ugyldig", month_out_of_range: "Udløbsmåned skal være mellem 01 og 12", year_out_of_range: "Udløbsåret må ikke ligge i fortiden" }, "Payment-method": "Betalingsmetode", price_plan: { interval: { day: "dag", day_plural: "{{count}} dage", month: "måned", month_plural: "{{count}} måneder", week: "uge", week_plural: "{{count}} uger", year: "år", year_plural: "{{count}} år" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dage", month: "{{count}} måned", month_plural: "{{count}} måneder", week: "{{count}} uge", week_plural: "{{count}} uger", year: "{{count}} år", year_plural: "{{count}} år" } }, product: "Produkt", quantity: "Mængde", "registered-over": "registreret over", "required-field": "Feltet er påkrævet", shipping: { condition_label: { price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}", price_min: "For ordrer prissat til {{min}} {{currency}} eller mere", quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer", quantity_min: "For ordrer indeholdende {{min}} eller flere varer", weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g", weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere" }, not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.", shipping_method: "Forsendelsesmetode" }, shipping_fee: "Forsendelsesgebyr", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (inklusive forsendelse)", total_amount_with_tax: "Total (inkl. skat)", total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)", vat: "Salgsskat", vat_percent: "Moms ({{percent}} %)" }, Ju = {
  public_pages_purchase: Zu
}, $u = { affiliate_badge: { made_with: "Unterstützt von" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal", trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann", trial_period_price: "Kostenlos", unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}" } } }, contact_slug: { city: "Stadt", company_name: "Firmenname", country: "Land", email: "E-Mail", first_name: "Vorname", last_name: "Nachname", neighborhood: "Nachbarschaft", phone_number: "Telefonnummer", postal_code: "Postleitzahl", state_province: "Bundesland/Provinz", street_address: "Straßenadresse", street_number: "Hausnummer", tax_number: "Steuernummer" }, copy_clipboard: "In die Zwischenablage kopiert", copy_clipboard_error: "Text konnte nicht kopiert werden", date_picker: { all_time: "Alle Zeiten", apply: "Anwenden", clear: "Löschen", from: "Von", last_3_months: "Letzte 3 Monate", last_30_days: "Letzte 30 Tage", last_month: "Letzter Monat", last_pool_period: "Letzter Pool-Auswertungszeitraum", this_month: "Dieser Monat", time: "Zeit", title_dates: "Termine", to: "Nach" }, error: "Fehler", form_select: { empty_list: "Es sieht so aus, als wäre diese Liste leer", select: "Auswählen" }, including_tax: "Enthält {{percent}} % MwSt. ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Suchen", search: "Suchen" }, locale: { albania: "Albanisch", arabic: "Arabisch", chinese: "Chinesisch", czech: "Tschechisch", danish: "Dänisch", dutch: "Niederländisch", english: "Englisch", french: "Französisch", german: "Deutsch", greek: "Griechisch", hindi: "Hindi", hungarian: "Ungarisch", indonesian: "Indonesisch", italian: "Italienisch", japanese: "Japanisch", norwegian: "Norwegisch", polish: "Polnisch", portuguese: "Portugiesisch", romanian: "Rumänisch", russian: "Russisch", serbian: "Serbisch", slovak: "Slowakisch", slovenian: "Slowenisch", spanish: "Spanisch", swedish: "Schwedisch", thai: "Thailändisch", turkish: "Türkisch", ukrainian: "Ukrainisch" }, order_summary: "Bestellübersicht", payment: { cash_on_delivery: "Lieferung per Nachnahme", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditkarten (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditkarten (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "PayPal verbinden", paypal_edit_organization_name: "Organisationsnamen bearbeiten", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditkarten (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kredit- oder Debitkarte", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditkarten (Xendit)" }, payment_inputs: { card_holder_placeholder: "Karteninhaber", card_number_placeholder: "Kartennummer", cvc_placeholder: "CVC", date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen", empty_card_holder: "Name des Karteninhabers eingeben", empty_card_number: "Eine Kartennummer eingeben", empty_cvc: "Einen CVC eingeben", empty_expiry_date: "Geben Sie ein Verfallsdatum ein", expiry_data_placeholder: "MM/JJ", invalid_card_number: "Kartennummer ist ungültig", invalid_cvc: "CVC ist ungültig", invalid_expiry_date: "Verfallsdatum ist ungültig", month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen", year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen" }, "Payment-method": "Zahlungsmethode", price_plan: { interval: { day: "Tag", day_plural: "{{count}} Tage", month: "Monat", month_plural: "{{count}} Monate", week: "Woche", week_plural: "{{count}} Wochen", year: "Jahr", year_plural: "{{count}} Jahre" }, trial_period: { day: "{{count}} Tag", day_plural: "{{count}} Tage", month: "{{count}} Monat", month_plural: "{{count}} Monate", week: "{{count}} Woche", week_plural: "{{count}} Wochen", year: "{{count}} Jahr", year_plural: "{{count}} Jahre" } }, product: "Produkt", quantity: "Menge", "registered-over": "registriert über", "required-field": "Das Feld ist erforderlich", shipping: { condition_label: { price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}", price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr", quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln", quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln", weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g", weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr" }, not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.", shipping_method: "Versandmethode" }, shipping_fee: "Versandgebühr", subtotal: "Zwischensumme", total: "Gesamt", total_amount_with_shipping: "Gesamtbetrag (einschließlich Versand)", total_amount_with_tax: "Gesamtbetrag (inkl. Steuern)", total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)", vat: "Mehrwertsteuer", vat_percent: "Umsatzsteuer ({{percent}} %)" }, qu = {
  public_pages_purchase: $u
}, Qu = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές", trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα", trial_period_price: "Δωρεάν", unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}" } } }, contact_slug: { city: "Πόλη", company_name: "Επωνυμία εταιρίας", country: "Χώρα", email: "Email", first_name: "Όνομα", last_name: "Επώνυμο", neighborhood: "Γειτονιά", phone_number: "Τηλέφωνο", postal_code: "Ταχυδρομικός κώδικας", state_province: "Νομός", street_address: "Διεύθυνση", street_number: "Αριθμός οδού", tax_number: "Α.Φ.Μ." }, copy_clipboard: "Επιτυχής αντιγραφή", copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου", date_picker: { all_time: "Συνολικά", apply: "Υποβολή", clear: "Επαναφορά", from: "Από", last_3_months: "Τελευταίοι 3 μήνες", last_30_days: "Τελευταίες 30 ημέρες", last_month: "Προηγούμενος μήνας", last_pool_period: "Τελευταία περίοδος αξιολόγησης email", this_month: "Αυτό το μήνα", time: "Χρόνος", title_dates: "Ημερομηνίες", to: "Προς" }, error: "Σφάλμα", form_select: { empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή", select: "Επιλογή" }, including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})", input: { phone_number: "Τηλέφωνο", phone_search: "Αναζήτηση", search: "Αναζήτηση" }, locale: { albania: "Αλβανικά", arabic: "Αραβικά", chinese: "Κινέζικα", czech: "Τσέχικα", danish: "Δανικά", dutch: "Ολλανδικά", english: "Αγγλικά", french: "Γαλλικά", german: "Γερμανικά", greek: "Ελληνικά", hindi: "Ινδικά", hungarian: "Ουγγρικά", indonesian: "Ινδονησιακά", italian: "Ιταλικά", japanese: "Ιαπωνικά", norwegian: "Νορβηγικά", polish: "Πολωνικά", portuguese: "Πορτογαλικά", romanian: "Ρουμανικά", russian: "Ρωσικά", serbian: "Σερβικά", slovak: "Σλοβάκικα", slovenian: "Σλοβενικά", spanish: "Ισπανικά", swedish: "Σουηδικά", thai: "Ταϊλανδέζικα", turkish: "Τούρκικα", ukrainian: "Ουκρανικά" }, order_summary: "Σύνοψη Παραγγελίας", payment: { cash_on_delivery: "Με αντικαταβολή", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Τραπεζικές κάρτες (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Σύνδεση με PayPal", paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Τραπεζικές κάρτες (Paystack)", price_plan: "Πλάνο", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Πιστωτική ή χρεωστική κάρτα", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Τραπεζικές κάρτες (Xendit)" }, payment_inputs: { card_holder_placeholder: "Κάτοχος κάρτας", card_number_placeholder: "Αριθμός κάρτας", cvc_placeholder: "CVC", date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν", empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας", empty_card_number: "Εισάγετε έναν αριθμό κάρτας", empty_cvc: "Εισάγετε το CVC", empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης", expiry_data_placeholder: "ΜΜ/ΕΕ", invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος", invalid_cvc: "Το CVC είναι μη έγκυρο", invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη", month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12", year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν" }, "Payment-method": "Τρόπος πληρωμής", price_plan: { interval: { day: "ημέρα", day_plural: "{{count}} ημέρες", month: "μήνας", month_plural: "{{count}} μήνες", week: "εβδομάδα", week_plural: "{{count}} εβδομάδες", year: "έτος", year_plural: "{{count}} έτη" }, trial_period: { day: "{{count}} ημέρα", day_plural: "{{count}} ημέρες", month: "{{count}} μήνας", month_plural: "{{count}} μήνες", week: "{{count}} εβδομάδα", week_plural: "{{count}} εβδομάδες", year: "{{count}} έτος", year_plural: "{{count}} έτη" } }, product: "Προϊόν", quantity: "Ποσότητα", "registered-over": "εγγεγραμμένο πάνω από", "required-field": "Το πεδίο είναι υποχρεωτικό", shipping: { condition_label: { price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}", price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}", quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα", quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα", weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g", weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g" }, not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη", shipping_method: "Τρόπος αποστολής" }, shipping_fee: "Χρέωση αποστολής", subtotal: "Μερικό σύνολο", total: "Σύνολο", total_amount_with_shipping: "Σύνολο (συμπεριλαμβανομένων των μεταφορικών)", total_amount_with_tax: "Σύνολο (συμπεριλαμβανομένου φόρου)", total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)", vat: "Φόρος πωλήσεων", vat_percent: "ΦΠΑ ({{percent}}%)" }, Xu = {
  public_pages_purchase: Qu
}, ec = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then", trial_period_price: "Free", unlimited_new: "<bold>{{amount}}</bold> every {{interval}}" } } }, contact_slug: { city: "City", company_name: "Company name", country: "Country", email: "Email", first_name: "First name", last_name: "Last name", neighborhood: "Neighborhood", phone_number: "Phone number", postal_code: "Postal code", state_province: "State/Province", street_address: "Street address", street_number: "Street number", tax_number: "Tax number" }, copy_clipboard: "Copied to clipboard", copy_clipboard_error: "Failed to copy text", date_picker: { all_time: "All time", apply: "Apply", clear: "Clear", from: "From", last_3_months: "Last 3 months", last_30_days: "Last 30 days", last_month: "Last month", last_pool_period: "Last pool evaluation period", this_month: "This month", time: "Time", title_dates: "Dates", to: "To" }, error: "Error", form_select: { empty_list: "It looks like this list is empty", select: "Select" }, including_tax: "Includes {{percent}}% VAT ({{amount}})", input: { phone_number: "Phone number", phone_search: "Search", search: "Search" }, locale: { albania: "Albanian", arabic: "Arabic", chinese: "Chinese", czech: "Czech", danish: "Danish", dutch: "Dutch", english: "English", french: "French", german: "German", greek: "Greek", hindi: "Hindi", hungarian: "Hungarian", indonesian: "Indonesian", italian: "Italiano", japanese: "Japanese", norwegian: "Norwegian", polish: "Polish", portuguese: "Portuguese", romanian: "Romanian", russian: "Russian", serbian: "Serbian", slovak: "Slovak", slovenian: "Slovenian", spanish: "Spanish", swedish: "Swedish", thai: "Thai", turkish: "Turkish", ukrainian: "Ukrainian" }, order_summary: "Order summary", payment: { cash_on_delivery: "Cash on delivery", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Credit cards (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Credit cards (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Connect PayPal", paypal_edit_organization_name: "Edit organization name", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Credit cards (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Credit or debit card", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Credit cards (Xendit)" }, payment_inputs: { card_holder_placeholder: "Card holder", card_number_placeholder: "Card number", cvc_placeholder: "CVC", date_out_of_range: "Expiry date cannot be in the past", empty_card_holder: "Enter a card holder name", empty_card_number: "Enter a card number", empty_cvc: "Enter a CVC", empty_expiry_date: "Enter an expiry date", expiry_data_placeholder: "MM/YY", invalid_card_number: "Card number is invalid", invalid_cvc: "CVC is invalid", invalid_expiry_date: "Expiry date is invalid", month_out_of_range: "Expiry month must be between 01 and 12", year_out_of_range: "Expiry year cannot be in the past" }, "Payment-method": "Payment method", price_plan: { interval: { day: "day", day_plural: "{{count}} days", month: "month", month_plural: "{{count}} months", week: "week", week_plural: "{{count}} weeks", year: "year", year_plural: "{{count}} years" }, trial_period: { day: "{{count}} day", day_plural: "{{count}} days", month: "{{count}} month", month_plural: "{{count}} months", week: "{{count}} week", week_plural: "{{count}} weeks", year: "{{count}} year", year_plural: "{{count}} years" } }, product: "Product", quantity: "Quantity", "registered-over": "registered over", "required-field": "Field is required", shipping: { condition_label: { price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}", price_min: "For orders priced at {{min}} {{currency}} or more", quantity: "For orders containing between {{min}} to {{max}} items", quantity_min: "For orders containing {{min}} or more items", weight: "For orders with a total weight between {{min}}g to {{max}}g", weight_min: "For orders with a total weight of {{min}}g or more" }, not_available: "Oops! It looks like we don't offer shipping to this location yet", shipping_method: "Shipping method" }, shipping_fee: "Shipping fee", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (including Shipping)", total_amount_with_tax: "Total (including tax)", total_amount_with_tax_and_shipping: "Total (including tax and Shipping)", vat: "Sales tax", vat_percent: "Sales tax ({{percent}}%)" }, ac = {
  public_pages_purchase: ec
}, tc = { affiliate_badge: { made_with: "Desarrollado por" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces", trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}" } } }, contact_slug: { city: "Ciudad", company_name: "Nombre de la empresa", country: "País", email: "Correo", first_name: "Nombre", last_name: "Apellido", neighborhood: "Barrio", phone_number: "Número de teléfono", postal_code: "Código postal", state_province: "Estado/Provincia", street_address: "Dirección", street_number: "Dirección", tax_number: "Número de IVA" }, copy_clipboard: "Copiado en el portapapeles", copy_clipboard_error: "Error el copiar el texto", date_picker: { all_time: "Desde siempre", apply: "Aplicar", clear: "Borrar", from: "Desde", last_3_months: "Últimos 3 meses", last_30_days: "Últimos 30 días", last_month: "Último mes", last_pool_period: "Último periodo de evaluación de la pool", this_month: "Este mes", time: "Hola", title_dates: "Fechas", to: "Hasta" }, error: "Error", form_select: { empty_list: "Parece que esta lista está vacía", select: "Seleccionar" }, including_tax: "Incluye el {{percent}}% de IVA ({{amount}})", input: { phone_number: "Teléfono", phone_search: "Buscar", search: "Buscar" }, locale: { albania: "Albanés", arabic: "árabe", chinese: "Chino", czech: "Checo", danish: "Danés", dutch: "Holandés", english: "Inglés", french: "Francés", german: "Alemán", greek: "Griego", hindi: "Hindi", hungarian: "Húngaro", indonesian: "Indonesio", italian: "Italiano", japanese: "Japonés", norwegian: "Noruego", polish: "Polaco", portuguese: "Portugués", romanian: "Rumano", russian: "Ruso", serbian: "Serbio", slovak: "Eslovaco", slovenian: "Esloveno", spanish: "Español", swedish: "Sueco", thai: "Tailandés", turkish: "Turco", ukrainian: "Ucraniano" }, order_summary: "Resumen del pedido", payment: { cash_on_delivery: "Pago contra entrega", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Tarjetas de crédito (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Tarjetas de crédito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Conectar PayPal", paypal_edit_organization_name: "Editar el nombre de la organización", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Tarjetas de crédito (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Tarjeta de crédito o débito", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Tarjetas de crédito (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titular de la tarjeta", card_number_placeholder: "Número de tarjeta", cvc_placeholder: "CVC", date_out_of_range: "La fecha de expiración no puede estar situada en el pasado", empty_card_holder: "Ingresa el nombre del titular de la tarjeta", empty_card_number: "Ingresa un número de tarjeta", empty_cvc: "Ingresa un CVC", empty_expiry_date: "Ingresa la fecha de expiración", expiry_data_placeholder: "MM/AA", invalid_card_number: "El número de tarjeta no es válido", invalid_cvc: "El CVC no es válido", invalid_expiry_date: "La fecha de expiracion no es válida", month_out_of_range: "El mes de expiración debe estar entre 01 y 12", year_out_of_range: "El año de expiración no puede estar situado en el pasado" }, "Payment-method": "Método de pago", price_plan: { interval: { day: "día", day_plural: "{{count}} días", month: "mes", month_plural: "{{count}} meses", week: "semana", week_plural: "{{count}} semanas", year: "año", year_plural: "{{count}} años" }, trial_period: { day: "{{count}} día", day_plural: "{{count}} días", month: "{{count}} mes", month_plural: "{{count}} meses", week: "{{count}} semana", week_plural: "{{count}} semanas", year: "{{count}} año", year_plural: "{{count}} años" } }, product: "Producto", quantity: "Cantidad", "registered-over": "registrado hace más de", "required-field": "El campo es necesario", shipping: { condition_label: { price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}", price_min: "Para pedidos que cuesten {{min}} {{currency}} o más", quantity: "Para pedidos de entre {{min}} y {{max}} artículos", quantity_min: "Para pedidos con {{min}} o más artículos", weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g", weight_min: "Para pedidos con un peso total de {{min}}g o más" }, not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación", shipping_method: "Método de envío" }, shipping_fee: "Tarifa de envío", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (incluyendo envío)", total_amount_with_tax: "Total (IVA incluido)", total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)", vat: "IVA", vat_percent: "IVA ({{percent}}%)" }, rc = {
  public_pages_purchase: tc
}, nc = { affiliate_badge: { made_with: "Développé par" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois", trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis", trial_period_price: "Gratuit", unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}" } } }, contact_slug: { city: "Ville", company_name: "Nom de l'entreprise", country: "Pays", email: "Email", first_name: "Prénom", last_name: "Nom", neighborhood: "Quartier", phone_number: "Numéro de téléphone", postal_code: "Code postal", state_province: "Région", street_address: "Adresse", street_number: "Numéro de rue", tax_number: "Numéro d'identification fiscale" }, copy_clipboard: "Copié dans le presse-papier", copy_clipboard_error: "Échec de la copie du texte", date_picker: { all_time: "Depuis le début", apply: "Appliquer", clear: "Effacer", from: "De", last_3_months: "Les 3 derniers mois", last_30_days: "Les 30 derniers jours", last_month: "Le mois dernier", last_pool_period: "Dernière période d'évaluation du pool", this_month: "Ce mois", time: "Horaire", title_dates: "Dates", to: "À" }, error: "Erreur", form_select: { empty_list: "Cette liste semble vide", select: "Sélectionner" }, including_tax: "Comprend {{percent}} % de TVA ({{amount}})", input: { phone_number: "Numéro de téléphone", phone_search: "Recherche", search: "Recherche" }, locale: { albania: "Albanais", arabic: "Аrabe", chinese: "Chinois", czech: "Tchèque", danish: "Danois", dutch: "Néerlandais", english: "Anglais", french: "Français", german: "Allemand", greek: "Grec", hindi: "Indien", hungarian: "Hongrois", indonesian: "Indonésien", italian: "Italiano", japanese: "Japonais", norwegian: "Norvégien", polish: "Polonais", portuguese: "Portugais", romanian: "Roumain", russian: "Russe", serbian: "Serbe", slovak: "Slovaque", slovenian: "Slovène", spanish: "Espagnol", swedish: "Suédois", thai: "Thaïlandais", turkish: "Turc", ukrainian: "Ukrainien" }, order_summary: "Résumé de la commande", payment: { cash_on_delivery: "Paiement à la livraison", dlocal_boleto: "Billet (Dlocal)", dlocal_card: "Cartes de crédit (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Cartes de crédit (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Connectez-vous à PayPal", paypal_edit_organization_name: "Modifier le nom de l'organisation", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Cartes de crédit (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "BanContact (Stripe)", stripe_card: "Carte de crédit ou de débit", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Cartes de crédit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titulaire de la carte", card_number_placeholder: "Numéro de carte", cvc_placeholder: "CVC", date_out_of_range: "La date d’expiration ne peut pas être dans le passé", empty_card_holder: "Saisir le nom du titulaire de la carte", empty_card_number: "Entrez un numéro de carte", empty_cvc: "Saisissez le code CVC", empty_expiry_date: "Entrez une date d'expiration", expiry_data_placeholder: "MM/AA", invalid_card_number: "Le numéro de carte est invalide", invalid_cvc: "Le code CVC est invalide", invalid_expiry_date: "La date d’expiration est invalide", month_out_of_range: "Le mois d’expiration doit être entre 01 et 12", year_out_of_range: "L'année d'expiration ne peut pas être dans le passé" }, "Payment-method": "Mode de paiement", price_plan: { interval: { day: "jour", day_plural: "{{count}} jours", month: "mois", month_plural: "{{count}} mois", week: "semaine", week_plural: "{{count}} semaines", year: "an", year_plural: "{{count}} ans" }, trial_period: { day: "{{count}} jour", day_plural: "{{count}} jours", month: "{{count}} mois", month_plural: "{{count}} mois", week: "{{count}} semaine", week_plural: "{{count}} semaines", year: "{{count}} an", year_plural: "{{count}} ans" } }, product: "Produit", quantity: "Quantité", "registered-over": "enregistré plus de", "required-field": "Le champ est obligatoire", shipping: { condition_label: { price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}", price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus", quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles", quantity_min: "Pour les commandes contenant {{min}} articles ou plus", weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g", weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus" }, not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit", shipping_method: "Méthode d'expédition" }, shipping_fee: "Frais d'expédition", subtotal: "Sous-total", total: "Total", total_amount_with_shipping: "Total (y compris livraison)", total_amount_with_tax: "Total (TVA incluse)", total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)", vat: "TVA", vat_percent: "TVA ({{percent}}%)" }, ic = {
  public_pages_purchase: nc
}, oc = { affiliate_badge: { made_with: "द्वारा संचालित" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार", trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर", trial_period_price: "मुफ्त", unlimited_new: "{{amount}} हर {{interval}} पर" } } }, contact_slug: { city: "शहर", company_name: "कंपनी का नाम", country: "देश", email: "ईमेल", first_name: "प्रथम नाम", last_name: "अंतिम नाम", neighborhood: "पड़ोस", phone_number: "फ़ोन नंबर", postal_code: "पोस्टल कोड", state_province: "राज्य/प्रान्त", street_address: "सड़क का पता", street_number: "सड़क संख्या", tax_number: "टैक्स नंबर" }, copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया", copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल", date_picker: { all_time: "सभी समय", apply: "लागू करें", clear: "हटाएं", from: "से", last_3_months: "पिछले 3 महीने", last_30_days: "पिछले 30 दिन", last_month: "पिछले महीने", last_pool_period: "पिछले पूल मूल्यांकन अवधि", this_month: "इस महीने", time: "समय", title_dates: "दिनांक", to: "तक" }, error: "एरर", form_select: { empty_list: "लगता है यह लिस्ट खाली है", select: "चूनें" }, including_tax: "शामिल है {{percent}}% VAT ({{amount}})", input: { phone_number: "फोन नंबर", phone_search: "खोजें", search: "खोजें" }, locale: { albania: "अल्बानियन", arabic: "अरबी", chinese: "चीनी", czech: "चेक", danish: "डैनिश", dutch: "डच", english: "अंग्रेज़ी", french: "फ्रेंच", german: "जर्मन", greek: "यूनानी", hindi: "हिंदी ", hungarian: "हंगेरीअन ", indonesian: "इन्डोनेशियाई", italian: "इटैलिनो", japanese: "जापानी", norwegian: "नार्वेजियन", polish: "पोलिश", portuguese: "पुर्तगाली", romanian: "रोमानियाई", russian: "रूसी", serbian: "सर्बियाई", slovak: "स्लोवाक", slovenian: "स्लोवेनियाई", spanish: "स्पैनिश", swedish: "स्वीडिश", thai: "थाई", turkish: "तुर्की", ukrainian: "यूक्रेनी" }, order_summary: "ऑर्डर समरी", payment: { cash_on_delivery: "कैश-ऑन-डिलीवरी", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "क्रेडिट कार्ड्स (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Paypal से जुड़ें", paypal_edit_organization_name: "संगठन का नाम एडिट करें", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "क्रेडिट कार्ड्स (Paystack)", price_plan: "प्लान", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "एप्पल पे", stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)", stripe_card: "क्रेडिट या डेबिट कार्ड", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-सिक्योर" }, xendit_card: "क्रेडिट कार्ड्स (Xendit)" }, payment_inputs: { card_holder_placeholder: "कार्ड धारक", card_number_placeholder: "कार्ड नंबर", cvc_placeholder: "CVC", date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती", empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें", empty_card_number: "कार्ड नंबर दर्ज करें", empty_cvc: "CVC दर्ज करें  ", empty_expiry_date: "समाप्ति तिथि दर्ज करें", expiry_data_placeholder: "MM/YY", invalid_card_number: "कार्ड नंबर अमान्य है ", invalid_cvc: "CVC अमान्य है", invalid_expiry_date: "समाप्ति तिथि अमान्य है", month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ", year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता" }, "Payment-method": "पेमेंट मेथड", price_plan: { interval: { day: "दिन", day_plural: "{{count}} दिन", month: "महीना", month_plural: "{{count}} महीने", week: "सप्ताह", week_plural: "{{count}} सप्ताह", year: "वर्ष", year_plural: "{{count}} वर्ष" }, trial_period: { day: "{{count}} दिन", day_plural: "{{count}} दिन", month: "{{count}} महीना", month_plural: "{{count}} महीने", week: "{{count}} सप्ताह", week_plural: "{{count}} दिन", year: "{{count}} वर्ष", year_plural: "{{count}} वर्ष" } }, product: "प्रोडक्ट", quantity: "क्वान्टिटी", "registered-over": "पंजीकृत किया गया", "required-field": "यह फील्ड भरना अनिवार्य है", shipping: { condition_label: { price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए", price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए", quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए", quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए", weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए", weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए" }, not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ", shipping_method: "शिपिंग मेथड" }, shipping_fee: "शिपिंग शुल्क", subtotal: "सब टोटल ", total: "टोटल", total_amount_with_shipping: "कुल (शिपिंग सहित)", total_amount_with_tax: "कुल (कर सहित)", total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)", vat: "सेल्स टैक्स", vat_percent: "सेल्स टैक्स ({{percent}}%)" }, sc = {
  public_pages_purchase: oc
}, lc = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal", trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}", trial_period_price: "Ingyenes", unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}" } } }, contact_slug: { city: "Város", company_name: "Cégnév", country: "Ország", email: "E-mail", first_name: "Keresztnév", last_name: "Vezetéknév", neighborhood: "Környék", phone_number: "Telefonszám", postal_code: "Irányítószám", state_province: "Állam/Mező", street_address: "Út/utca", street_number: "Házszám", tax_number: "Adószám" }, copy_clipboard: "Másolva a vágólapra", copy_clipboard_error: "A szöveg másolása nem sikerült", date_picker: { all_time: "Minden idő", apply: "Alkalmaz", clear: "Törlés", from: "Tól", last_3_months: "Utolsó 3 hónap", last_30_days: "Utolsó 30 nap", last_month: "Utolsó hónap", last_pool_period: "Utolsó medenceértékelési időszak", this_month: "Ez a hónap", time: "Idő", title_dates: "Dátumok", to: "Ig" }, error: "Hiba", form_select: { empty_list: "Úgy tűnik, hogy ez a lista üres", select: "Kiválasztás" }, including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})", input: { phone_number: "Telefonszám", phone_search: "Keresés", search: "Keresés" }, locale: { albania: "Albán", arabic: "Arab", chinese: "Kínai", czech: "Cseh", danish: "Dán", dutch: "Holland", english: "Angol", french: "Francia", german: "Német", greek: "Görög", hindi: "Dehogy", hungarian: "Magyar", indonesian: "Indonéz", italian: "Olasz", japanese: "Japán", norwegian: "Norvég", polish: "Fényesít", portuguese: "Portugál", romanian: "Román", russian: "Orosz", serbian: "Szerb", slovak: "Szlovák", slovenian: "Szlovén", spanish: "Spanyol", swedish: "Svéd", thai: "Thai", turkish: "Török", ukrainian: "Ukrán" }, order_summary: "Rendelés összegzése", payment: { cash_on_delivery: "Utánvétes fizetés", dlocal_boleto: "Boleto (helyi)", dlocal_card: "Hitelkártyák (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Hitelkártyák (Mercado Pago)", mercadopago_pix: "PIX (fizetési piac)", mollie: "Mollie", paypal_connect: "Csatlakoztassa a PayPal-t", paypal_edit_organization_name: "Szerkessze a szervezet nevét", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Hitelkártyák (Paystack)", price_plan: "Terv", razorpay: "Razorpay", secure_and_pay: "Biztonságos és fizetés", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (csíkos)", stripe_card: "Hitel- vagy betéti kártya", stripe_ideal: "iDeal (csík)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Hitelkártyák (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kártyabirtokos", card_number_placeholder: "Kártyaszám", cvc_placeholder: "CVC", date_out_of_range: "A lejárati dátum nem lehet a múltban", empty_card_holder: "Adja meg a kártyabirtokos nevét", empty_card_number: "Adjon meg egy kártyaszámot", empty_cvc: "Adja meg a CVC-t", empty_expiry_date: "Adjon meg egy lejárati dátumot", expiry_data_placeholder: "HH/YY", invalid_card_number: "A kártyaszám érvénytelen", invalid_cvc: "A CVC érvénytelen", invalid_expiry_date: "A lejárati dátum érvénytelen", month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie", year_out_of_range: "A lejárati év nem lehet a múltban" }, "Payment-method": "Fizetési mód", price_plan: { interval: { day: "nap", day_plural: "{{count}} nap", month: "hónap", month_plural: "{{count}} hónap", week: "hét", week_plural: "{{count}} hét", year: "év", year_plural: "{{count}} év" }, trial_period: { day: "{{count}} nap", day_plural: "{{count}} nap", month: "{{count}} hónap", month_plural: "{{count}} hónap", week: "{{count}} hét", week_plural: "{{count}} hét", year: "{{count}} év", year_plural: "{{count}} év" } }, product: "Termék", quantity: "Mennyiség", "registered-over": "regisztrált több mint", "required-field": "A mező kitöltése kötelező", shipping: { condition_label: { price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez", price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez", quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez", quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez", weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez", weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez" }, not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.", shipping_method: "Szállítási mód" }, shipping_fee: "Szállítási díj", subtotal: "Részösszeg", total: "Összesen", total_amount_with_shipping: "Összesen (beleértve a szállítást)", total_amount_with_tax: "Összesen (beleértve az adót)", total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)", vat: "Áfa", vat_percent: "Áruforgalmi adó ({{percent}}%)" }, uc = {
  public_pages_purchase: lc
}, cc = { affiliate_badge: { made_with: "Ditenagai oleh" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali", trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu", trial_period_price: "Bebas", unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}" } } }, contact_slug: { city: "Kota", company_name: "Nama perusahaan", country: "Negara", email: "Email", first_name: "Nama depan", last_name: "Nama belakang", neighborhood: "Lingkungan", phone_number: "Nomor telepon", postal_code: "Kode pos", state_province: "Negara Bagian/Provinsi", street_address: "Alamat jalan", street_number: "Nomor jalan", tax_number: "Nomor pajak" }, copy_clipboard: "Disalin ke clipboard", copy_clipboard_error: "Gagal menyalin teks", date_picker: { all_time: "Semua waktu", apply: "Terapkan", clear: "Bersihkan", from: "Dari", last_3_months: "3 bulan terakhir", last_30_days: "30 hari terakhir", last_month: "Bulan lalu", last_pool_period: "Periode evaluasi kolam terakhir", this_month: "Bulan ini", time: "Waktu", title_dates: "Tanggal", to: "Ke" }, error: "Kesalahan", form_select: { empty_list: "Sepertinya daftar ini kosong", select: "Pilih" }, including_tax: "Termasuk PPN {{percent}}% ({{amount}})", input: { phone_number: "Nomor telepon", phone_search: "Cari", search: "Cari" }, locale: { albania: "Bahasa Albania", arabic: "Arab", chinese: "Cina", czech: "Ceko", danish: "Orang Denmark", dutch: "Belanda", english: "Bahasa inggris", french: "Perancis", german: "Jerman", greek: "Orang yunani", hindi: "Tidak", hungarian: "Hongaria", indonesian: "Bahasa Indonesia", italian: "Italia", japanese: "Jepang", norwegian: "Norwegia", polish: "Polandia", portuguese: "Portugis", romanian: "Rumania", russian: "Rusia", serbian: "Orang Serbia", slovak: "Orang Slovakia", slovenian: "Slovenia", spanish: "Orang Spanyol", swedish: "Orang Swedia", thai: "Thai", turkish: "Turki", ukrainian: "Orang Ukraina" }, order_summary: "Ringkasan Pesanan", payment: { cash_on_delivery: "Bayar di tempat", dlocal_boleto: "Boleto (Dlokal)", dlocal_card: "Kartu kredit (Dlokal)", dlocal_pix: "Pix (Dlokal)", flutterwave: "Gelombang bergetar", gocardless: "Tanpa kartu", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kartu kredit (Mercado Pago)", mercadopago_pix: "PIX (Pasar Pembayaran)", mollie: "Mollie", paypal_connect: "Hubungkan PayPal", paypal_edit_organization_name: "Edit nama organisasi", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kartu kredit (Paystack)", price_plan: "Rencana", razorpay: "Pembayaran pisau cukur", secure_and_pay: "Amankan dan Bayar", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Garis)", stripe_card: "Kartu kredit atau debit", stripe_ideal: "iDeal (Garis)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kartu kredit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Pemegang kartu", card_number_placeholder: "Nomor kartu", cvc_placeholder: "CVC", date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu", empty_card_holder: "Masukkan nama pemegang kartu", empty_card_number: "Masukkan nomor kartu", empty_cvc: "Masukkan CVC", empty_expiry_date: "Masukkan tanggal kedaluwarsa", expiry_data_placeholder: "MM/YY", invalid_card_number: "Nomor kartu tidak valid", invalid_cvc: "CVC tidak valid", invalid_expiry_date: "Tanggal kedaluwarsa tidak valid", month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12", year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu" }, "Payment-method": "Metode pembayaran", price_plan: { interval: { day: "hari", month: "bulan", week: "pekan", year: "tahun" }, trial_period: { day: "{{count}} hari", month: "{{count}} bulan", week: "{{count}} minggu", year: "{{count}} tahun" } }, product: "Produk", quantity: "Kuantitas", "registered-over": "terdaftar lebih dari", "required-field": "Bidang wajib diisi", shipping: { condition_label: { price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}", price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih", quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item", quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih", weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g", weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih" }, not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.", shipping_method: "Metode Pengiriman" }, shipping_fee: "Biaya pengiriman", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (termasuk pengiriman)", total_amount_with_tax: "Total (termasuk pajak)", total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)", vat: "Pajak penjualan", vat_percent: "Pajak penjualan ({{percent}}%)" }, dc = {
  public_pages_purchase: cc
}, pc = { affiliate_badge: { made_with: "Realizzato da" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi", trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi", trial_period_price: "Gratuito", unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}" } } }, contact_slug: { city: "Città", company_name: "Nome azienda", country: "Paese", email: "Email", first_name: "Nome", last_name: "Cognome", neighborhood: "Quartiere", phone_number: "Numero di telefono", postal_code: "Codice postale", state_province: "Stato/Provincia", street_address: "Indirizzo", street_number: "Numero civico", tax_number: "Partita IVA" }, copy_clipboard: "Copiato negli appunti", copy_clipboard_error: "Impossibile copiare il testo", date_picker: { all_time: "Per tutto il periodo", apply: "Applicare", clear: "Cancella", from: "Da", last_3_months: "Ultimi 3 mesi", last_30_days: "Ultimi 30 giorni", last_month: "Ultimo mese", last_pool_period: "Ultimo periodo di valutazione del pool", this_month: "Questo mese", time: "Ora", title_dates: "Date", to: "A" }, error: "Errore", form_select: { empty_list: "Sembra che questo elenco sia vuoto", select: "Selezionare" }, including_tax: "Include {{percent}}% di IVA ({{amount}})", input: { phone_number: "Numero di telefono", phone_search: "Ricerca", search: "Ricerca" }, locale: { albania: "Albanese", arabic: "Аrabo", chinese: "Cinese", czech: "Ceco", danish: "Danese", dutch: "Olandese", english: "Inglese", french: "Francese", german: "Tedesco", greek: "Greco", hindi: "Hindi", hungarian: "Ungherese", indonesian: "Indonesiano", italian: "Italiano", japanese: "Giapponese", norwegian: "Norvegese", polish: "Polacco", portuguese: "Portoghese", romanian: "Rumeno", russian: "Russo", serbian: "Serbo", slovak: "Slovacco", slovenian: "Sloveno", spanish: "Spagnolo", swedish: "Svedese", thai: "Tailandese", turkish: "Turco", ukrainian: "Ucraino" }, order_summary: "Riepilogo dell'ordine", payment: { cash_on_delivery: "Contanti alla consegna", dlocal_boleto: "Biglietto (Dlocal)", dlocal_card: "Carte di credito (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Biglietto (Mercado Pago)", mercadopago_card: "Carte di credito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Collegare PayPal", paypal_edit_organization_name: "Modifica il nome dell'organizzazione", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Carte di credito (Paystack)", price_plan: "Piano", razorpay: "Razorpay", secure_and_pay: "Sicurezza e pagamento", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Carta di credito o di debito", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Carte di credito (Xendit)" }, payment_inputs: { card_holder_placeholder: "Portacarte", card_number_placeholder: "Numero della carta", cvc_placeholder: "CVC", date_out_of_range: "La data di scadenza non può essere passata", empty_card_holder: "Inserire il nome del titolare della carta", empty_card_number: "Inserire un numero di carta", empty_cvc: "Inserire una CVC", empty_expiry_date: "Inserire una data di scadenza", expiry_data_placeholder: "MM/AA", invalid_card_number: "Il numero della carta non è valido", invalid_cvc: "Il CVC non è valido", invalid_expiry_date: "La data di scadenza non è valida", month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12", year_out_of_range: "L'anno di scadenza non può essere passato" }, "Payment-method": "Metodo di pagamento", price_plan: { interval: { day: "giorno", day_plural: "{{count}} giorni", month: "mese", month_plural: "{{count}} mesi", week: "settimana", week_plural: "{{count}} settimane", year: "anno", year_plural: "{{count}} anni" }, trial_period: { day: "{{count}} giorno", day_plural: "{{count}} giorni", month: "{{count}} mese", month_plural: "{{count}} mesi", week: "{{count}} settimana", week_plural: "{{count}} settimane", year: "{{count}} anni", year_plural: "{{count}} anni" } }, product: "Prodotto", quantity: "Quantità", "registered-over": "registrato oltre", "required-field": "Il campo è obbligatorio", shipping: { condition_label: { price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}", price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più", quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli", quantity_min: "Per ordini contenenti {{min}} articoli o più", weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g", weight_min: "Per ordini con un peso totale di {{min}}g o più" }, not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.", shipping_method: "Metodo di spedizione" }, shipping_fee: "Spese di spedizione", subtotal: "Totale parziale", total: "Totale", total_amount_with_shipping: "Totale (spedizione inclusa)", total_amount_with_tax: "Totale (IVA inclusa)", total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)", vat: "Imposta sulle vendite", vat_percent: "Imposta sulle vendite ({{percent}}%)" }, mc = {
  public_pages_purchase: pc
}, hc = { affiliate_badge: { made_with: "提供元" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回", trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は", trial_period_price: "無料", unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>" } } }, contact_slug: { city: "市区町村", company_name: "法人名", country: "国", email: "Eメール", first_name: "名", last_name: "姓", neighborhood: "地域", phone_number: "電話番号", postal_code: "郵便番号", state_province: "都道府県", street_address: "住所", street_number: "番地", tax_number: "法人番号（税番号）" }, copy_clipboard: "クリップボードにコピーされました", copy_clipboard_error: "テキストのコピーに失敗しました", date_picker: { all_time: "全期間", apply: "適用", clear: "消去", from: "から", last_3_months: "過去3ヶ月", last_30_days: "過去30日", last_month: "先月", last_pool_period: "前回の集計期間", this_month: "今月", time: "時", title_dates: "日", to: "へ" }, error: "エラー", form_select: { empty_list: "このリストが空のようです", select: "選択する" }, including_tax: "消費税 {{percent}}% を含む（{{amount}}）", input: { phone_number: "電話番号", phone_search: "検索", search: "検索" }, locale: { albania: "アルバニア語", arabic: "アラブ", chinese: "中国語", czech: "チェコ語", danish: "デンマーク語", dutch: "オランダ語", english: "英語", french: "フランス語", german: "ドイツ語", greek: "ギリシャ語", hindi: "ヒンズー語", hungarian: "ハンガリー語", indonesian: "インドネシア語", italian: "イタリア語", japanese: "日本語", norwegian: "ノルウェー語", polish: "ポーランド語", portuguese: "ポルトガル語", romanian: "ルーマニア語", russian: "ロシア語", serbian: "セルビア語", slovak: "スロバキア語", slovenian: "スロバニア語", spanish: "スペイン語", swedish: "スウェーデン語", thai: "タイ語", turkish: "トルコ語", ukrainian: "ウクライナ語" }, order_summary: "ご注文内容", payment: { cash_on_delivery: "着払い", dlocal_boleto: "Borelo（Dlocal）", dlocal_card: "クレジットカード（Dlocal）", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave ", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "クレジットカード (Mercado Pago)", mercadopago_pix: "PIX（Mercado Pago）", mollie: "Mollie", paypal_connect: "PayPalに接続", paypal_edit_organization_name: "組織名を編集", paypal_rest: "ペイパル", paypal_soap: "Paypal", paystack_card: "クレジットカード（Paystack）", price_plan: "プラン", razorpay: "Razorpay ", secure_and_pay: "Secure and Pay", stripe_applepay: "Appleペイ", stripe_bancotact: "Bancontact（Stripe）", stripe_card: "クレジットカードまたはデビットカード", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3Dセキュア" }, xendit_card: "クレジットカード（Xendit）" }, payment_inputs: { card_holder_placeholder: "カード所有者", card_number_placeholder: "カード番号", cvc_placeholder: "CVC", date_out_of_range: "有効期限は過去の日付にすることはできません。", empty_card_holder: "カード所有者の名前を入力してください", empty_card_number: "カード番号を入力", empty_cvc: "CVCを入力", empty_expiry_date: "有効期限を入力してください。", expiry_data_placeholder: "月/年", invalid_card_number: "カード番号が無効です", invalid_cvc: "CVCが無効です", invalid_expiry_date: "有効期限が無効です", month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。", year_out_of_range: "有効期限の年は過去にすることはできません。" }, "Payment-method": "支払い方法", price_plan: { interval: { day: `日

{{count}} 日`, month: `ヶ月

{{count}}ヶ月`, week: `週

{{count}}週`, year: `年

{{count}}年` }, trial_period: { day: `{{count}} 日

{{count}} 日`, month: `{{count}}ヶ月

{{count}}ヶ月`, week: `{{count}}週

{{count}}週`, year: `{{count}}年

{{count}}年` } }, product: "商品", quantity: "数量", "registered-over": "登録された", "required-field": "この項目は必須です", shipping: { condition_label: { price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合", price_min: "{{min}} {{currency}}以上の注文の場合", quantity: "{{min}}から{{max}}個の商品を含む注文の場合", quantity_min: "{{min}}個以上の商品を含む注文の場合", weight: "合計重量が {{min}}g から {{max}}g までの注文の場合", weight_min: "合計重量が {{min}}g 以上の注文の場合" }, not_available: "おっと！この地域への配送にはまだ対応していないようです。", shipping_method: "配送方法" }, shipping_fee: "送料", subtotal: "小計", total: "合計", total_amount_with_shipping: "合計（送料込み）", total_amount_with_tax: "合計（税込）", total_amount_with_tax_and_shipping: "合計（消費税・送料込み）", vat: "消費税", vat_percent: "消費税（{{percent}}%）" }, fc = {
  public_pages_purchase: hc
}, gc = { affiliate_badge: { made_with: "Ondersteund door" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer", trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}" } } }, contact_slug: { city: "Plaats", company_name: "Bedrijfsnaam", country: "Land", email: "E-mail", first_name: "Voornaam", last_name: "Achternaam", neighborhood: "Buurt", phone_number: "Telefoonnummer", postal_code: "Postcode", state_province: "Staat/Provincie", street_address: "Straatadres", street_number: "Huisnummer", tax_number: "BTW-nummer" }, copy_clipboard: "Gekopieerd naar klembord", copy_clipboard_error: "Tekst kopiëren mislukt", date_picker: { all_time: "Alle tijden", apply: "Toepassen", clear: "Wissen", from: "Van", last_3_months: "Laatste 3 maanden", last_30_days: "Laatste 30 dagen", last_month: "Afgelopen maand", last_pool_period: "Laatste pool-evaluatieperiode", this_month: "Deze maand", time: "Tijd", title_dates: "Datum", to: "Naar" }, error: "Fout", form_select: { empty_list: "Het lijkt erop dat deze lijst leeg is", select: "Selecteer" }, including_tax: "Inclusief {{percent}}% BTW ({{amount}})", input: { phone_number: "Telefoonnummer", phone_search: "Zoek", search: "Zoek" }, locale: { albania: "Albanees", arabic: "Arabisch", chinese: "Chinees", czech: "Tsjechisch", danish: "Deens", dutch: "Nederlands", english: "Engels", french: "Frans", german: "Duits", greek: "Grieks", hindi: "Hindi", hungarian: "Hongaars", indonesian: "Indonesisch", italian: "Italiaans", japanese: "Japans", norwegian: "Noors", polish: "Pools", portuguese: "Portugees", romanian: "Roemeens", russian: "Russisch", serbian: "Servisch", slovak: "Slowaaks", slovenian: "Sloveens", spanish: "Spaans", swedish: "Zweeds", thai: "Thais", turkish: "Turks", ukrainian: "Oekraïens" }, order_summary: "Besteloverzicht", payment: { cash_on_delivery: "Contant bij levering", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Creditcards (Dlocal)", dlocal_pix: "Pix (Dlokaal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Creditcards (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Verbind PayPal", paypal_edit_organization_name: "Organisatienaam bewerken", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Creditcards (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Beveiligd betalen", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Creditcard of debetkaart", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Creditcards (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kaarthouder", card_number_placeholder: "Kaartnummer", cvc_placeholder: "CVC", date_out_of_range: "Vervaldatum mag niet in het verleden liggen", empty_card_holder: "Voer de naam van de kaarthouder in", empty_card_number: "Voer een kaartnummer in", empty_cvc: "Voer een CVC in", empty_expiry_date: "Voer een vervaldatum in", expiry_data_placeholder: "MM/JJ", invalid_card_number: "Kaartnummer is ongeldig", invalid_cvc: "CVC is ongeldig", invalid_expiry_date: "Vervaldatum is ongeldig", month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen", year_out_of_range: "Vervaljaar mag niet in het verleden liggen" }, "Payment-method": "Betaalmethode", price_plan: { interval: { day: "dag", day_plural: "{{count}} dagen", month: "maand", month_plural: "{{count}} maanden", week: "week", week_plural: "{{count}} weken", year: "jaar", year_plural: "{{count}} jaren" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dagen", month: "{{count}} maand", month_plural: "{{count}} maanden", week: "{{count}} week", week_plural: "{{count}} weken", year: "{{count}} jaar", year_plural: "{{count}} jaren" } }, product: "Product", quantity: "Aantal", "registered-over": "geregistreerd over", "required-field": "Veld is vereist", shipping: { condition_label: { price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}", price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer", quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten", quantity_min: "Voor bestellingen met {{min}} of meer artikelen", weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g", weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer" }, not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden", shipping_method: "Verzendmethode" }, shipping_fee: "Verzendkosten", subtotal: "Subtotaal", total: "Totaal", total_amount_with_shipping: "Totaal (incl. verzending)", total_amount_with_tax: "Totaal (incl. belasting)", total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)", vat: "Verkoopbelasting", vat_percent: "BTW ({{percent}}%)" }, _c = {
  public_pages_purchase: gc
}, yc = { affiliate_badge: { made_with: "Drevet av" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}" } } }, contact_slug: { city: "By", company_name: "Firmanavn", country: "Land", email: "E-post", first_name: "Fornavn", last_name: "Etternavn", neighborhood: "Nabolag", phone_number: "Telefonnummer", postal_code: "Postnummer", state_province: "Stat/Provins", street_address: "Gateadresse", street_number: "Gate nummer", tax_number: "Skattenummer" }, copy_clipboard: "Kopiert til utklippstavlen", copy_clipboard_error: "Kunne ikke kopiere tekst", date_picker: { all_time: "All tid", apply: "Bruk", clear: "Fjern", from: "Fra", last_3_months: "Siste 3 måneder", last_30_days: "Siste 30 dager", last_month: "Siste måned", last_pool_period: "Siste evalueringsperiode for basseng", this_month: "Denne måneden", time: "Tid", title_dates: "Datoer", to: "Til" }, error: "Feil", form_select: { empty_list: "Det ser ut som denne listen er tom", select: "Velg" }, including_tax: "Inkludert {{percent}}% MVA ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Søk", search: "Søk" }, locale: { albania: "Albansk", arabic: "Arabisk", chinese: "Kinesisk", czech: "Tsjekkisk", danish: "Dansk", dutch: "Nederlandsk", english: "Engelsk", french: "Fransk", german: "Tysk", greek: "Gresk", hindi: "Nei", hungarian: "Ungarsk", indonesian: "Indonesisk", italian: "Italiensk", japanese: "Japansk", norwegian: "Norsk", polish: "Pusse", portuguese: "Portugisisk", romanian: "Rumensk", russian: "Russisk", serbian: "Serbisk", slovak: "Slovakisk", slovenian: "Slovensk", spanish: "Spansk", swedish: "Svensk", thai: "Thai", turkish: "Tyrkisk", ukrainian: "Ukrainsk" }, order_summary: "Ordresammendrag", payment: { cash_on_delivery: "Kontantbetaling ved levering", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kredittkort (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterbølge", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kredittkort (Mercado Pago)", mercadopago_pix: "PIX (betalingsmarked)", mollie: "Mollie", paypal_connect: "Koble til PayPal", paypal_edit_organization_name: "Rediger organisasjonsnavn", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kredittkort (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Sikker og betal", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kreditt- eller debetkort", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kredittkort (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kortholder", card_number_placeholder: "Kortnummer", cvc_placeholder: "CVC", date_out_of_range: "Utløpsdato kan ikke være i fortiden", empty_card_holder: "Skriv inn navnet til kortholderen", empty_card_number: "Skriv inn et kortnummer", empty_cvc: "Skriv inn en CVC", empty_expiry_date: "Skriv inn en utløpsdato", expiry_data_placeholder: "MM/ÅÅ", invalid_card_number: "Kortnummeret er ugyldig", invalid_cvc: "CVC er ugyldig", invalid_expiry_date: "Utløpsdato er ugyldig", month_out_of_range: "Utløpsmåned må være mellom 01 og 12", year_out_of_range: "Utløpsår kan ikke være i fortiden" }, "Payment-method": "Betalingsmåte", price_plan: { interval: { day: "dag", day_plural: "{{count}} dager", month: "måned", month_plural: "{{count}} måneder", week: "uke", week_plural: "{{count}} uker", year: "år", year_plural: "{{count}} år" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dager", month: "{{count}} måned", month_plural: "{{count}} måneder", week: "{{count}} uke", week_plural: "{{count}} uker", year: "{{count}} år", year_plural: "{{count}} år" } }, product: "Produkt", quantity: "Mengde", "registered-over": "registrert over", "required-field": "Felt er obligatorisk", shipping: { condition_label: { price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}", price_min: "For bestillinger priset til {{min}} {{currency}} eller mer", quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer", quantity_min: "For bestillinger som inneholder {{min}} eller flere varer", weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g", weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer" }, not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.", shipping_method: "Fraktmetode" }, shipping_fee: "Fraktgebyr", subtotal: "Delsum", total: "Totalt", total_amount_with_shipping: "Totalbeløp (inkludert frakt)", total_amount_with_tax: "Totalbeløp (inkludert skatt)", total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)", vat: "Moms", vat_percent: "Merverdiavgift ({{percent}}%)" }, vc = {
  public_pages_purchase: yc
}, bc = { affiliate_badge: { made_with: "Zasilane przez" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy", trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem", trial_period_price: "Bezpłatny", unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}" } } }, contact_slug: { city: "Miasto", company_name: "Nazwa firmy", country: "Kraj", email: "Email", first_name: "Imię", last_name: "Nazwisko", neighborhood: "Osiedle", phone_number: "Numer telefonu", postal_code: "Kod pocztowy", state_province: "Stan/Województwo", street_address: "Adres", street_number: "Numer ulicy", tax_number: "Numer identyfikacji podatkowej" }, copy_clipboard: "Skopiowano do schowka", copy_clipboard_error: "Nie udało się skopiować tekstu", date_picker: { all_time: "Cały czas", apply: "Zastosuj", clear: "Wyczyść", from: "Z", last_3_months: "Ostatnie 3 miesiące", last_30_days: "Ostatnie 30 dni", last_month: "Ostatni miesiąc", last_pool_period: "Ostatni okres oceny puli", this_month: "Ten miesiąc", time: "Czas", title_dates: "Daty", to: "Do" }, error: "Błąd", form_select: { empty_list: "Wygląda na to, że ta lista jest pusta", select: "Wybierz" }, including_tax: "Zawiera {{percent}}% VAT ({{amount}})", input: { phone_number: "Numer telefonu", phone_search: "Szukaj", search: "Szukaj" }, locale: { albania: "Albański", arabic: "Arabski", chinese: "Chiński", czech: "Czeski", danish: "Duński", dutch: "Holenderski", english: "Angielski", french: "Francuski", german: "Niemiecki", greek: "Grecki", hindi: "Hinduski", hungarian: "Węgierski", indonesian: "Indonezyjski", italian: "Włoski", japanese: "Japoński", norwegian: "Norweski", polish: "Polski", portuguese: "Portugalski", romanian: "Rumuński", russian: "Rosyjski", serbian: "Serbski", slovak: "Słowacki", slovenian: "Słoweński", spanish: "Hiszpański", swedish: "Szwedzki", thai: "Tajski", turkish: "Turecki", ukrainian: "Ukraiński" }, order_summary: "Podsumowanie zamówienia", payment: { cash_on_delivery: "Płatność gotówką przy odbiorze", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Karty kredytowe (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Karty kredytowe (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Połącz PayPala", paypal_edit_organization_name: "Edytuj nazwę organizacji", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Karty kredytowe (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Karta kredytowa lub debetowa", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Karty kredytowe (Xendit)" }, payment_inputs: { card_holder_placeholder: "Właściciel karty", card_number_placeholder: "Numer karty", cvc_placeholder: "CVC", date_out_of_range: "Data ważności nie może być w przeszłości", empty_card_holder: "Wprowadź imię i nazwisko właściciela karty", empty_card_number: "Wprowadź numer karty", empty_cvc: "Wprowadź CVC", empty_expiry_date: "Wprowadź datę ważności", expiry_data_placeholder: "MM/RR", invalid_card_number: "Numer karty jest nieprawidłowy", invalid_cvc: "CVC jest nieprawidłowy", invalid_expiry_date: "Data ważności jest nieprawidłowa", month_out_of_range: "Miesiąc ważności musi być między 01 a 12", year_out_of_range: "Rok ważności nie może być w przeszłości" }, "Payment-method": "Metoda płatności", price_plan: { interval: { day_0: "dzień", day_1: "{{count}} dni", day_2: "{{count}} dni", month_0: "miesiąc", month_1: "{{count}} miesięcy", month_2: "{{count}} miesięcy", week_0: "tydzień", week_1: "{{count}} tygodni", week_2: "{{count}} tygodni", year_0: "rok", year_1: "{{count}} lat", year_2: "{{count}} lat" }, trial_period: { day_0: "{{count}} dzień", day_1: "{{count}} dni", day_2: "{{count}} dni", month_0: "{{count}} miesiąc", month_1: "{{count}} miesięcy", month_2: "{{count}} miesięcy", week_0: "{{count}} tydzień", week_1: "{{count}} tygodni", week_2: "{{count}} tygodni", year_0: "{{count}} rok", year_1: "{{count}} lat", year_2: "{{count}} lat" } }, product: "Produkt", quantity: "Ilość", "registered-over": "zarejestrowano ponad", "required-field": "Pole jest wymagane", shipping: { condition_label: { price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}", price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej", quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów", quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów", weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g", weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej" }, not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.", shipping_method: "Metoda wysyłki" }, shipping_fee: "Opłata za wysyłkę", subtotal: "Suma częściowa", total: "Razem", total_amount_with_shipping: "Razem (z wysyłką)", total_amount_with_tax: "Razem (z podatkiem)", total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)", vat: "Podatek od sprzedaży", vat_percent: "Podatek od sprzedaży ({{percent}}%)" }, Sc = {
  public_pages_purchase: bc
}, kc = { affiliate_badge: { made_with: "Desenvolvido por" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes", trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois", trial_period_price: "Gratuito", unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}" } } }, contact_slug: { city: "Cidade", company_name: "Nome da empresa", country: "País", email: "Email", first_name: "Nome", last_name: "Sobrenome", neighborhood: "Bairro", phone_number: "Número de telefone", postal_code: "Código postal", state_province: "Estado/Província", street_address: "Endereço", street_number: "Número", tax_number: "CNPJ/NIF" }, copy_clipboard: "Copiado para a área de transferência", copy_clipboard_error: "Falha ao copiar o texto", date_picker: { all_time: "Desde o início", apply: "Aplicar", clear: "Limpar", from: "De", last_3_months: "Últimos 3 meses", last_30_days: "Últimos 30 dias", last_month: "Último mês", last_pool_period: "Último período de avaliação do grupo", this_month: "Este mês", time: "Horário", title_dates: "Datas", to: "Até" }, error: "Erro", form_select: { empty_list: "Parece que essa lista está vazia", select: "Selecionar" }, including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})", input: { phone_number: "Número de telefone", phone_search: "Pesquisar", search: "Pesquisar" }, locale: { albania: "Albanês", arabic: "Árabe", chinese: "Chinês", czech: "Tcheco", danish: "Dinamarquês", dutch: "Holandês", english: "Inglês", french: "Francês", german: "Alemão", greek: "Grego", hindi: "Hindi", hungarian: "Húngaro", indonesian: "Indonésio", italian: "Italiano", japanese: "Japonês", norwegian: "Norueguês", polish: "Polonês", portuguese: "Português", romanian: "Romeno", russian: "Russo", serbian: "Sérvio", slovak: "Eslovaco", slovenian: "Esloveno", spanish: "Espanhol", swedish: "Sueco", thai: "Tailandês", turkish: "Turco", ukrainian: "Ucraniano" }, order_summary: "Resumo do pedido", payment: { cash_on_delivery: "Pagamento na entrega", dlocal_boleto: "Boleto bancário (Dlocal)", dlocal_card: "Cartão de crédito (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Cartão de crédito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Conectar PayPal", paypal_edit_organization_name: "Editar o nome da empresa", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Cartão de crédito (Paystack)", price_plan: "Plano", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Cartão de crédito ou débito", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Cartão de crédito (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titular do cartão", card_number_placeholder: "Número do cartão", cvc_placeholder: "CVV", date_out_of_range: "A data de validade não pode estar no passado", empty_card_holder: "Insira o nome do titular do cartão", empty_card_number: "Insira um número de cartão", empty_cvc: "Insira o CVV", empty_expiry_date: "Insira uma data de validade", expiry_data_placeholder: "MM/AA", invalid_card_number: "O número do cartão é inválido", invalid_cvc: "O CVV é inválido", invalid_expiry_date: "A data de validade é inválida", month_out_of_range: "O mês de validade deve estar entre 01 e 12", year_out_of_range: "O ano de validade não pode estar no passado" }, "Payment-method": "Método de pagamento", price_plan: { interval: { day: "dia", day_plural: "{{count}} dias", month: "mês", month_plural: "{{count}} meses", week: "semana", week_plural: "{{count}} semanas", year: "ano", year_plural: "{{count}} anos" }, trial_period: { day: "{{count}} dia", day_plural: "{{count}} dias", month: "{{count}} mês", month_plural: "{{count}} meses", week: "{{count}} semana", week_plural: "{{count}} semanas", year: "{{count}} ano", year_plural: "{{count}} anos" } }, product: "Produto", quantity: "Quantidade", "registered-over": "registrado há mais de", "required-field": "O campo é obrigatório", shipping: { condition_label: { price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}", price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais", quantity: "Para pedidos contendo entre {{min}} e {{max}} itens", quantity_min: "Para pedidos contendo {{min}} ou mais itens", weight: "Para pedidos com peso total entre {{min}}g e {{max}}g", weight_min: "Para pedidos com peso total de {{min}}g ou mais" }, not_available: "Ops! Parece que ainda não oferecemos envio para este local", shipping_method: "Método de envio" }, shipping_fee: "Taxa de envio", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (incluindo envio)", total_amount_with_tax: "Total (incluindo impostos)", total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)", vat: "Imposto", vat_percent: "Imposto ({{percent}}%)" }, Mc = {
  public_pages_purchase: kc
}, wc = { affiliate_badge: { made_with: "Realizat de" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori", trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci", trial_period_price: "Gratuit", unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}" } } }, contact_slug: { city: "Oraș", company_name: "Numele companiei", country: "Țară", email: "Email", first_name: "Prenume", last_name: "Nume de familie", neighborhood: "Cartier", phone_number: "Număr de telefon", postal_code: "Cod poștal", state_province: "Stat/Provincie", street_address: "Adresă", street_number: "Numărul străzii", tax_number: "Număr de identificare fiscală" }, copy_clipboard: "Copiat în clipboard", copy_clipboard_error: "Copierea textului a eșuat", date_picker: { all_time: "Tot timpul", apply: "Aplică", clear: "Șterge", from: "De la", last_3_months: "Ultimele 3 luni", last_30_days: "Ultimele 30 de zile", last_month: "Luna trecută", last_pool_period: "Ultima perioadă de evaluare a grupului", this_month: "Luna aceasta", time: "Timp", title_dates: "Date", to: "Către" }, error: "Eroare", form_select: { empty_list: "Se pare că această listă este goală", select: "Selectați" }, including_tax: "Incluzând TVA de {{percent}}% ({{amount}})", input: { phone_number: "Număr de telefon", phone_search: "Căutare", search: "Caută" }, locale: { albania: "Albanez", arabic: "Arabic", chinese: "Chinez", czech: "Ceh", danish: "Danez", dutch: "Olandeză", english: "Engleză", french: "Limba franceza", german: "Limba germana", greek: "Greacă", hindi: "Nu", hungarian: "Maghiară", indonesian: "Indoneziană", italian: "Italiană", japanese: "Japonez", norwegian: "Norvegian", polish: "Lustrui", portuguese: "Portugheză", romanian: "Română", russian: "Rusă", serbian: "Sârb", slovak: "Slovacă", slovenian: "Slovenă", spanish: "Spaniolă", swedish: "Suedez", thai: "Thailandez", turkish: "Turc", ukrainian: "Ucrainean" }, order_summary: "Rezumatul comenzii", payment: { cash_on_delivery: "Plata la livrare", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Carduri de credit (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Carduri de credit (Mercado Pago)", mercadopago_pix: "PIX (piață de plată)", mollie: "Mollie", paypal_connect: "Conectați PayPal", paypal_edit_organization_name: "Editați numele organizației", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Carduri de credit (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Securizat și plătiți", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (stripe)", stripe_card: "Card de credit sau debit", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Carduri de credit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titularul cardului", card_number_placeholder: "Numărul cardului", cvc_placeholder: "CVC", date_out_of_range: "Data de expirare nu poate fi în trecut", empty_card_holder: "Introduceți un nume al titularului cardului", empty_card_number: "Introduceți un număr de card", empty_cvc: "Introduceți un CVC", empty_expiry_date: "Introduceți o dată de expirare", expiry_data_placeholder: "LL/AA", invalid_card_number: "Numărul cardului este invalid", invalid_cvc: "CVC este invalid", invalid_expiry_date: "Data de expirare este invalidă", month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12", year_out_of_range: "Anul de expirare nu poate fi în trecut" }, "Payment-method": "Modalitate de plată", price_plan: { interval: { day_0: "zi", day_1: "{{count}} zile", day_2: "{{count}} zile", month_0: "lună", month_1: "{{count}} luni", month_2: "{{count}} luni", week_0: "săptămână", week_1: "{{count}} săptămâni", week_2: "{{count}} săptămâni", year_0: "an", year_1: "{{count}} ani", year_2: "{{count}} ani" }, trial_period: { day_0: "{{count}} zi", day_1: "{{count}} zile", day_2: "{{count}} zile", month_0: "{{count}} lună", month_1: "{{count}} luni", month_2: "{{count}} luni", week_0: "{{count}} săptămână", week_1: "{{count}} săptămâni", week_2: "{{count}} săptămâni", year_0: "{{count}} an", year_1: "{{count}} ani", year_2: "{{count}} ani" } }, product: "Produs", quantity: "Cantitate", "registered-over": "înregistrat peste", "required-field": "Câmpul este obligatoriu", shipping: { condition_label: { price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}", price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult", quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole", quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole", weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g", weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult" }, not_available: "Ups! Se pare că nu oferim livrare în această locație încă.", shipping_method: "Metoda de livrare" }, shipping_fee: "Taxa de livrare", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (inclusiv transport)", total_amount_with_tax: "Total (inclusiv taxe)", total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)", vat: "Taxa pe vânzări", vat_percent: "Taxa pe vânzări ({{percent}}%)" }, Cc = {
  public_pages_purchase: wc
}, Pc = { affiliate_badge: { made_with: "Создано с " }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз", trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем", trial_period_price: "Бесплатно", unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}" } } }, contact_slug: { city: "Город", company_name: "Название компании", country: "Страна", email: "Почта", first_name: "Имя", last_name: "Фамилия", neighborhood: "Соседство", phone_number: "Номер телефона", postal_code: "Почтовый индекс", state_province: "Штат/Область", street_address: "Адрес", street_number: "Номер улицы", tax_number: "Налоговый номер" }, copy_clipboard: "Номер карты недействителен", copy_clipboard_error: "Не удалось скопировать текст", date_picker: { all_time: "Все время", apply: "Применить", clear: "Очистить", from: "От", last_3_months: "Последние 3 месяца", last_30_days: "Последние 30 дней", last_month: "Последний месяц", last_pool_period: "Последний период оценки пула", this_month: "В этом месяце", time: "Время", title_dates: "Даты", to: "В" }, error: "Ошибка", form_select: { empty_list: "Похоже, что этот список пуст.", select: "Выбрать" }, including_tax: "Включает {{percent}}% НДС ({{amount}})", input: { phone_number: "Номер телефона", phone_search: "Поиск", search: "Поиск" }, locale: { albania: "Албанский", arabic: "Арабский", chinese: "Китайский", czech: "Чешский", danish: "Датский", dutch: "Голландский", english: "Английский", french: "Французский", german: "Немецкий", greek: "Греческий", hindi: "Хинди", hungarian: "Венгерский", indonesian: "Индонезийский", italian: "Итальянский", japanese: "Японский", norwegian: "Норвежский", polish: "Польский", portuguese: "Португальский", romanian: "Румынский", russian: "Русский", serbian: "Сербский", slovak: "Словацкий", slovenian: "Словенский", spanish: "Испанский", swedish: "Шведский", thai: "Тайский", turkish: "Турецкий", ukrainian: "Украинский" }, order_summary: "Итог заказа", payment: { cash_on_delivery: "Оплата наличными при доставке", dlocal_boleto: "Заготовка (Dlocal)", dlocal_card: "Кредитные карты (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Билет (Платный рынок)", mercadopago_card: "Кредитные карты", mercadopago_pix: "PIX (Платный рынок)", mollie: "Mollie", paypal_connect: "Подключить PayPal", paypal_edit_organization_name: "Изменить название организации", paypal_rest: "PayPal", paypal_soap: "Разрешить платежи PayPal", paystack_card: "Кредитные карты (Paystack)", price_plan: "План", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Разрешить платежи через BanContact", stripe_card: "Кредитная или дебетовая карта", stripe_ideal: "Разрешить платежи через iDeal", xendit: { "3ds": "3D-Secure" }, xendit_card: "Кредитные карты (Xendit)" }, payment_inputs: { card_holder_placeholder: "Держатель карты", card_number_placeholder: "Номер карты", cvc_placeholder: "CVC код", date_out_of_range: "Дата окончания срока действия не может быть в прошлом", empty_card_holder: "Введите имя держателя карты", empty_card_number: "Введите номер карты", empty_cvc: "Введите CVC код", empty_expiry_date: "Введите дату окончания срока действия", expiry_data_placeholder: "М/Г", invalid_card_number: "Номер карты недействителен", invalid_cvc: "CVC код неправильный", invalid_expiry_date: "Срок годности недействителен", month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12", year_out_of_range: "Год окончания срока действия не может быть в прошлом" }, "Payment-method": "Способ оплаты", price_plan: { interval: { day_0: "день", day_1: "{{count}} дней", day_2: "{{count}} дни", month_0: "месяц", month_1: "{{count}} месяцы", month_2: "{{count}} месяца", week_0: "неделя", week_1: "{{count}} недели", week_2: "{{count}} неделями", year_0: "год", year_1: "{{count}} годы", year_2: "{{count}} лет" }, trial_period: { day_0: "день", day_1: "{{count}} дней", day_2: "{{count}} дни", month_0: "месяц", month_1: "{{count}} месяца", month_2: "{{count}} месяцев", week_0: "{{count}} неделя", week_1: "{{count}} недели", week_2: "{{count}} недель", year_0: "год", year_1: "{{count}} года", year_2: "{{count}} лет" } }, product: "Продукт", quantity: "Количество", "registered-over": "зарегистрировано более чем", "required-field": "Поле обязательно для заполнения", shipping: { condition_label: { price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}", price_min: "Для заказов стоимостью {{min}} {{currency}} или более", quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров", quantity_min: "Для заказов, содержащих {{min}} или более товаров", weight: "Для заказов с общим весом от {{min}}g до {{max}}g", weight_min: "Для заказов с общим весом {{min}}g или более" }, not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.", shipping_method: "Способ доставки" }, shipping_fee: "Стоимость доставки", subtotal: "Промежуточный итог", total: "Итого", total_amount_with_shipping: "Общая сумма (с учетом доставки)", total_amount_with_tax: "Общая сумма (с налогом)", total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)", vat: "Налог с продаж", vat_percent: "Налог с продаж ({{percent}}%)" }, Tc = {
  public_pages_purchase: Pc
}, Nc = { affiliate_badge: { made_with: "Poháňané" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát", trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}", trial_period_price: "Zadarmo", unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}" } } }, contact_slug: { city: "Mesto", company_name: "Názov spoločnosti", country: "Krajina", email: "Email", first_name: "Meno", last_name: "Priezvisko", neighborhood: "Štvrť", phone_number: "Telefónne číslo", postal_code: "PSČ", state_province: "Štát/Provincie", street_address: "Ulica", street_number: "Číslo ulice", tax_number: "Daňové číslo" }, copy_clipboard: "Skopírované do schránky", copy_clipboard_error: "Nepodarilo sa skopírovať text", date_picker: { all_time: "Celý čas", apply: "Použiť", clear: "Vymazať", from: "Z", last_3_months: "Posledné 3 mesiace", last_30_days: "Posledných 30 dní", last_month: "Minulý mesiac", last_pool_period: "Posledné hodnotenie bazéna", this_month: "Tento mesiac", time: "Čas", title_dates: "Dátumy", to: "Do" }, error: "Chyba", form_select: { empty_list: "Zdá sa, že tento zoznam je prázdny", select: "Vybrať" }, including_tax: "Vrátane DPH {{percent}}% ({{amount}})", input: { phone_number: "Telefónne číslo", phone_search: "Hľadať", search: "Hľadať" }, locale: { albania: "Albánsky", arabic: "Arabčina", chinese: "čínsky", czech: "český", danish: "Dánčina", dutch: "Holandský", english: "Angličtina", french: "Francúzsky", german: "Nemecký", greek: "Grécky", hindi: "Nie", hungarian: "Maďarský", indonesian: "Indonézsky", italian: "Taliansky", japanese: "Japončina", norwegian: "Nórsky", polish: "Poľský", portuguese: "Portugalčina", romanian: "Rumunský", russian: "Ruský", serbian: "Srbský", slovak: "Slovenský", slovenian: "Slovensky", spanish: "španielčina", swedish: "švédsky", thai: "Thajčina", turkish: "Turecký", ukrainian: "Ukrajinčina" }, order_summary: "Zhrnutie objednávky", payment: { cash_on_delivery: "Platba na dobierku", dlocal_boleto: "Boleto (miestne)", dlocal_card: "Kreditné karty (miestne)", dlocal_pix: "Pix (miestne)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditné karty (Mercado Pago)", mercadopago_pix: "PIX (Platobný trh)", mollie: "Mollie", paypal_connect: "Pripojte PayPal", paypal_edit_organization_name: "Upravte názov organizácie", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditné karty (Paystack)", price_plan: "Plán", razorpay: "Razorpay", secure_and_pay: "Zabezpečiť a zaplatiť", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (pruh)", stripe_card: "Kreditná alebo debetná karta", stripe_ideal: "iDeal (pruh)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditné karty (Xendit)" }, payment_inputs: { card_holder_placeholder: "Držiteľ karty", card_number_placeholder: "Číslo karty", cvc_placeholder: "CVC", date_out_of_range: "Dátum expirácie nemôže byť v minulosti", empty_card_holder: "Zadajte meno držiteľa karty", empty_card_number: "Zadajte číslo karty", empty_cvc: "Zadajte CVC", empty_expiry_date: "Zadajte dátum expirácie", expiry_data_placeholder: "MM/YY", invalid_card_number: "Číslo karty je neplatné", invalid_cvc: "CVC je neplatný", invalid_expiry_date: "Dátum expirácie je neplatný", month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12", year_out_of_range: "Rok expirácie nemôže byť v minulosti" }, "Payment-method": "Spôsob platby", price_plan: { interval: { day_0: "deň", day_1: "{{count}} dní", day_2: "{{count}} dní", month_0: "mesiac", month_1: "{{count}} mesiacov", month_2: "{{count}} mesiacov", week_0: "týždeň", week_1: "{{count}} týždňov", week_2: "{{count}} týždňov", year_0: "rok", year_1: "{{count}} rokov", year_2: "{{count}} rokov" }, trial_period: { day_0: "{{count}} deň", day_1: "{{count}} dní", day_2: "{{count}} dní", month_0: "{{count}} mesiac", month_1: "{{count}} mesiacov", month_2: "{{count}} mesiacov", week_0: "{{count}} týždeň", week_1: "{{count}} týždňov", week_2: "{{count}} týždňov", year_0: "{{count}} rok", year_1: "{{count}} rokov", year_2: "{{count}} rokov" } }, product: "Produkt", quantity: "Množstvo", "registered-over": "registrované viac ako", "required-field": "Pole je povinné", shipping: { condition_label: { price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}", price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac", quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami", quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek", weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g", weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac" }, not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.", shipping_method: "Spôsob dopravy" }, shipping_fee: "Poplatok za dopravu", subtotal: "Medzisúčet", total: "Celkom", total_amount_with_shipping: "Celkom (vrátane dopravy)", total_amount_with_tax: "Celkom (vrátane dane)", total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)", vat: "Daň z predaja", vat_percent: "Daň z predaja ({{percent}}%)" }, Dc = {
  public_pages_purchase: Nc
}, Ac = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat", trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem", trial_period_price: "Brezplačno", unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}" } } }, contact_slug: { city: "Mesto", company_name: "Ime podjetja", country: "Država", email: "E-pošta", first_name: "Ime", last_name: "Priimek", neighborhood: "Soseska", phone_number: "Telefonska številka", postal_code: "Poštna številka", state_province: "Država/Provinca", street_address: "Ulična naslov", street_number: "Številka ulice", tax_number: "Davčna številka" }, copy_clipboard: "Kopirano v odložišče", copy_clipboard_error: "Kopiranje besedila ni uspelo", date_picker: { all_time: "Vse čase", apply: "Uporabi", clear: "Počisti", from: "Iz", last_3_months: "Zadnja 3 meseca", last_30_days: "Zadnjih 30 dni", last_month: "Zadnji mesec", last_pool_period: "Zadnje obdobje ocenjevanja bazena", this_month: "Ta mesec", time: "Čas", title_dates: "Datumi", to: "Do" }, error: "Napaka", form_select: { empty_list: "Zdi se, da je ta seznam prazen", select: "Izberi" }, including_tax: "Vključeno {{percent}}% DDV ({{amount}})", input: { phone_number: "Telefonska številka", phone_search: "Iskanje", search: "Iskanje" }, locale: { albania: "Albanski", arabic: "Arabsko", chinese: "Kitajski", czech: "češki", danish: "Danščina", dutch: "Nizozemščina", english: "Angleščina", french: "Francosko", german: "Nemški", greek: "Grški", hindi: "Ne", hungarian: "Madžarski", indonesian: "Indonezijski", italian: "Italijanski", japanese: "Japonska", norwegian: "Norveški", polish: "Poljski", portuguese: "Portugalščina", romanian: "Romunščina", russian: "Ruski", serbian: "Srbsko", slovak: "Slovaški", slovenian: "Slovenščina", spanish: "španski", swedish: "švedščina", thai: "Tajska", turkish: "Turško", ukrainian: "Ukrajinski" }, order_summary: "Povzetek naročila", payment: { cash_on_delivery: "Gotovino po povzetju", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditne kartice (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditne kartice (Mercado Pago)", mercadopago_pix: "PIX (plačilni trg)", mollie: "Mollie", paypal_connect: "Povežite PayPal", paypal_edit_organization_name: "Uredi ime organizacije", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditne kartice (Paystack)", price_plan: "Načrtujte", razorpay: "Razorpay", secure_and_pay: "Zavarujte in plačajte", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kreditna ali debetna kartica", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditne kartice (Xendit)" }, payment_inputs: { card_holder_placeholder: "Imetnik kartice", card_number_placeholder: "Številka kartice", cvc_placeholder: "CVC", date_out_of_range: "Datum poteka ne more biti v preteklosti", empty_card_holder: "Vnesite ime imetnika kartice", empty_card_number: "Vnesite številko kartice", empty_cvc: "Vnesite CVC", empty_expiry_date: "Vnesite datum poteka", expiry_data_placeholder: "MM/YY", invalid_card_number: "Številka kartice je neveljavna", invalid_cvc: "CVC je neveljaven", invalid_expiry_date: "Datum poteka je neveljaven", month_out_of_range: "Mesec poteka mora biti med 01 in 12", year_out_of_range: "Leto poteka ne more biti v preteklosti" }, "Payment-method": "Način plačila", price_plan: { interval: { day_0: "dan", day_1: "{{count}} dni", day_2: "{{count}} dni", day_3: "{{count}} dni", month_0: "mesec", month_1: "{{count}} mesecev", month_2: "{{count}} mesecev", month_3: "{{count}} mesecev", week_0: "teden", week_1: "{{count}} tednov", week_2: "{{count}} tednov", week_3: "{{count}} tednov", year_0: "leto", year_1: "{{count}} let", year_2: "{{count}} let", year_3: "{{count}} let" }, trial_period: { day_0: "{{count}} dan", day_1: "{{count}} dni", day_2: "{{count}} dni", day_3: "{{count}} dni", month_0: "{{count}} mesec", month_1: "{{count}} mesecev", month_2: "{{count}} mesecev", month_3: "{{count}} mesecev", week_0: "{{count}} teden", week_1: "{{count}} tednov", week_2: "{{count}} tednov", week_3: "{{count}} tednov", year_0: "{{count}} leto", year_1: "{{count}} let", year_2: "{{count}} let", year_3: "{{count}} let" } }, product: "Izdelek", quantity: "Količina", "registered-over": "registrirani več kot", "required-field": "Polje je obvezno", shipping: { condition_label: { price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}", price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več", quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli", quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov", weight: "Za naročila s skupno težo med {{min}}g in {{max}}g", weight_min: "Za naročila s skupno težo {{min}}g ali več" }, not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.", shipping_method: "Način dostave" }, shipping_fee: "Strošek dostave", subtotal: "Medseštevek", total: "Skupaj", total_amount_with_shipping: "Skupaj (vključno s poštnino)", total_amount_with_tax: "Skupaj (vključno z davkom)", total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)", vat: "Davek na prodajo", vat_percent: "Davek na prodajo ({{percent}}%)" }, Ic = {
  public_pages_purchase: Ac
}, xc = { affiliate_badge: { made_with: "E fuqizuar nga" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë", trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj", trial_period_price: "Falas", unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}" } } }, contact_slug: { city: "Qyteti", company_name: "Emri i kompanisë", country: "Shteti", email: "Email", first_name: "Emri i parë", last_name: "Mbiemri", neighborhood: "Lagja", phone_number: "Numri i telefonit", postal_code: "Kodi postar", state_province: "Shteti/Provinca", street_address: "Adresa e rrugës", street_number: "Numri i rrugës", tax_number: "Numri i tatimit" }, copy_clipboard: "Kopjuhet në clipboard", copy_clipboard_error: "Dështoi të kopjohet teksti", date_picker: { all_time: "Të gjitha kohët", apply: "Apliko", clear: "Pastro", from: "Nga", last_3_months: "3 muajt e fundit", last_30_days: "30 ditët e fundit", last_month: "Muaji i kaluar", last_pool_period: "Periudha e fundit e vlerësimit të grupit", this_month: "Ky muaj", time: "Koha", title_dates: "Datat", to: "Në" }, error: "Gabim", form_select: { empty_list: "Duket se kjo listë është bosh", select: "Zgjidhni" }, including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})", input: { phone_number: "Numri i telefonit", phone_search: "Kërko", search: "Kërko" }, locale: { albania: "Shqiptare", arabic: "Arabisht", chinese: "Kineze", czech: "çeke", danish: "Daneze", dutch: "Holandeze", english: "Anglisht", french: "Frëngjisht", german: "Gjermane", greek: "Greke", hindi: "Jo", hungarian: "Hungareze", indonesian: "Indonezisht", italian: "Italisht", japanese: "Japoneze", norwegian: "Norvegjeze", polish: "Polonisht", portuguese: "Portugeze", romanian: "Rumun", russian: "Rusisht", serbian: "Serb", slovak: "Sllovake", slovenian: "Slloven", spanish: "Spanjisht", swedish: "Suedeze", thai: "Thai", turkish: "Turk", ukrainian: "Ukrainase" }, order_summary: "Përmbledhja e Porosisë", payment: { cash_on_delivery: "Para ne dore gjate dorezimit", dlocal_boleto: "Boleto (lokale)", dlocal_card: "Kartat e kreditit (Dlokale)", dlocal_pix: "Pix (vendor)", flutterwave: "Flutterwave", gocardless: "Pa kartë", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kartat e kreditit (Mercado Pago)", mercadopago_pix: "PIX (Tregu i Pagesave)", mollie: "Mollie", paypal_connect: "Lidhni PayPal", paypal_edit_organization_name: "Redakto emrin e organizatës", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kartat e kreditit (Paystack)", price_plan: "Planifikoni", razorpay: "Razorpay", secure_and_pay: "Siguro dhe Paguaj", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (shirit)", stripe_card: "Kartë krediti ose debiti", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kartat e kreditit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Emri i mbajtësit të kartës", card_number_placeholder: "Numri i kartës", cvc_placeholder: "CVC", date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën", empty_card_holder: "Shkruani emrin e mbajtësit të kartës", empty_card_number: "Shkruani një numër kartelash", empty_cvc: "Shkruani një CVC", empty_expiry_date: "Shkruani një datë skadimi", expiry_data_placeholder: "MM/YY", invalid_card_number: "Numri i kartelës është i pavlefshëm", invalid_cvc: "CVC është i pavlefshëm", invalid_expiry_date: "Data e skadencës është e pavlefshme", month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12", year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën" }, "Payment-method": "Mënyra e pagesës", price_plan: { interval: { day: "ditë", day_plural: "{{count}} ditë", month: "muaj", month_plural: "{{count}} muaj", week: "javë", week_plural: "{{count}} javë", year: "vit", year_plural: "{{count}} vjet" }, trial_period: { day: "{{count}} ditë", day_plural: "{{count}} ditë", month: "{{count}} muaj", month_plural: "{{count}} muaj", week: "{{count}} javë", week_plural: "{{count}} javë", year: "{{count}} vit", year_plural: "{{count}} vjet" } }, product: "Produkt", quantity: "Sasia", "registered-over": "regjistruar mbi", "required-field": "Fusha kërkohet", shipping: { condition_label: { price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}", price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë", quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj", quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj", weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g", weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë" }, not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.", shipping_method: "Metoda e Dërgesës" }, shipping_fee: "Tarifa e dërgesës", subtotal: "Nëntotali", total: "Totali", total_amount_with_shipping: "Totali (përfshirë Transportin)", total_amount_with_tax: "Totali (përfshirë taksën)", total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)", vat: "Tatimi mbi shitjet", vat_percent: "Tatimi mbi shitjet ({{percent}}%)" }, Ec = {
  public_pages_purchase: xc
}, Bc = { affiliate_badge: { made_with: "Pokreće" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута", trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда", trial_period_price: "Бесплатно", unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}" } } }, contact_slug: { city: "Grad", company_name: "Naziv kompanije", country: "Zemlja", email: "Email", first_name: "Ime", last_name: "Prezime", neighborhood: "Kraj", phone_number: "Broj telefona", postal_code: "Poštanski broj", state_province: "Država/Provincija", street_address: "Adresa", street_number: "Broj ulice", tax_number: "Poreski broj" }, copy_clipboard: "Kopirano u međuspremnik", copy_clipboard_error: "Kopiranje teksta nije uspelo", date_picker: { all_time: "Sve vreme", apply: "Primeni", clear: "Obriši", from: "Od", last_3_months: "Poslednja 3 meseca", last_30_days: "Poslednjih 30 dana", last_month: "Prošli mesec", last_pool_period: "Poslednji period evaluacije", this_month: "Ovaj mesec", time: "Vreme", title_dates: "Datumi", to: "Do" }, error: "Грешка", form_select: { empty_list: "Izgleda da je ova lista prazna", select: "Izaberi" }, including_tax: "Uključujući {{percent}}% PDV ({{amount}})", input: { phone_number: "Broj telefona", phone_search: "Pretraži", search: "Pretraži" }, locale: { albania: "Албанац", arabic: "арапски", chinese: "кинески", czech: "чешки", danish: "дански", dutch: "холандски", english: "енглески језик", french: "Француски", german: "Немачки", greek: "грчки", hindi: "Јок", hungarian: "мађарски", indonesian: "индонезијски", italian: "Италијан", japanese: "јапански", norwegian: "норвешки", polish: "Пољски", portuguese: "португалски", romanian: "румунски", russian: "Руски", serbian: "Српски", slovak: "словачки", slovenian: "словеначки", spanish: "Шпански", swedish: "Шведски", thai: "тајландски", turkish: "турски", ukrainian: "украјински" }, order_summary: "Pregled narudžbine", payment: { cash_on_delivery: "Плаћање поузећем", dlocal_boleto: "Болето (Длоцал)", dlocal_card: "Кредитне картице (Длоцал)", dlocal_pix: "Пик (Длоцал)", flutterwave: "Флуттерваве", gocardless: "Гоцардлесс", mercadopago_boleto: "Болето (Меркадо Паго)", mercadopago_card: "Кредитне картице (Мерцадо Паго)", mercadopago_pix: "ПИКС (тржиште плаћања)", mollie: "Моллие", paypal_connect: "Повежите ПаиПал", paypal_edit_organization_name: "Измените назив организације", paypal_rest: "ПаиПал", paypal_soap: "ПаиПал", paystack_card: "Кредитне картице (Паистацк)", price_plan: "План", razorpay: "Разорпаи", secure_and_pay: "Осигурајте и платите", stripe_applepay: "Apple Pay", stripe_bancotact: "Банцонтацт (Стрипе)", stripe_card: "Kreditna ili debitna kartica", stripe_ideal: "иДеал (Стрипе)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Кредитне картице (Ксендит)" }, payment_inputs: { card_holder_placeholder: "Ime vlasnika kartice", card_number_placeholder: "Broj kartice", cvc_placeholder: "CVC", date_out_of_range: "Datum isteka ne može biti u prošlosti", empty_card_holder: "Unesite ime vlasnika kartice", empty_card_number: "Unesite broj kartice", empty_cvc: "Unesite CVC", empty_expiry_date: "Unesite datum isteka", expiry_data_placeholder: "MM/YY", invalid_card_number: "Broj kartice je nevažeći", invalid_cvc: "CVC je nevažeći", invalid_expiry_date: "Datum isteka je nevažeći", month_out_of_range: "Mesec isteka mora biti između 01 i 12", year_out_of_range: "Godina isteka ne može biti u prošlosti" }, "Payment-method": "Начин плаћања", price_plan: { interval: { day_0: "дан", day_1: "{{count}} дана", day_2: "{{count}} дана", month_0: "месец", month_1: "{{count}} месеци", month_2: "{{count}} месеци", week_0: "недељу дана", week_1: "{{count}} недеља", week_2: "{{count}} недеља", year_0: "године", year_1: "{{count}} година", year_2: "{{count}} година" }, trial_period: { day_0: "{{count}} дан", day_1: "{{count}} дана", day_2: "{{count}} дана", month_0: "{{count}} месец", month_1: "{{count}} месеци", month_2: "{{count}} месеци", week_0: "{{count}} недеља", week_1: "{{count}} недеља", week_2: "{{count}} недеља", year_0: "{{count}} година", year_1: "{{count}} година", year_2: "{{count}} година" } }, product: "Proizvod", quantity: "Količina", "registered-over": "registrovano više od", "required-field": "Поље је обавезно", shipping: { condition_label: { price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}", price_min: "Za narudžbine od {{min}} {{currency}} ili više", quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki", quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki", weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g", weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više" }, not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.", shipping_method: "Metod isporuke" }, shipping_fee: "Trošak isporuke", subtotal: "Međuzbir", total: "Ukupno", total_amount_with_shipping: "Ukupno (uključujući dostavu)", total_amount_with_tax: "Ukupno (uključujući porez)", total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)", vat: "Porez na promet", vat_percent: "Porez na promet ({{percent}}%)" }, Oc = {
  public_pages_purchase: Bc
}, Gc = { affiliate_badge: { made_with: "Drivs av" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger", trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}" } } }, contact_slug: { city: "Stad", company_name: "Företagsnamn", country: "Land", email: "E-post", first_name: "Förnamn", last_name: "Efternamn", neighborhood: "Grannskap", phone_number: "Telefonnummer", postal_code: "Postnummer", state_province: "Stat/Provins", street_address: "Gatuadress", street_number: "Gatu nummer", tax_number: "Skattenummer" }, copy_clipboard: "Kopierad till urklipp", copy_clipboard_error: "Misslyckades med att kopiera text", date_picker: { all_time: "All tid", apply: "Tillämpa", clear: "Rensa", from: "Från", last_3_months: "Senaste 3 månaderna", last_30_days: "Senaste 30 dagarna", last_month: "Senaste månaden", last_pool_period: "Senaste poolutvärderingsperioden", this_month: "Denna månad", time: "Tid", title_dates: "Datum", to: "Till" }, error: "Fel", form_select: { empty_list: "Det verkar som att denna lista är tom", select: "Välj" }, including_tax: "Inklusive {{percent}}% moms ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Sök", search: "Sök" }, locale: { albania: "Albanska", arabic: "Arabiska", chinese: "Kinesiska", czech: "Tjeckiska", danish: "Danska", dutch: "Holländska", english: "Engelsk", french: "Franska", german: "Tysk", greek: "Grekisk", hindi: "Nej", hungarian: "Ungerska", indonesian: "Indonesiska", italian: "Italienska", japanese: "Japanska", norwegian: "Norska", polish: "Putsa", portuguese: "Portugisiska", romanian: "Rumänska", russian: "Ryska", serbian: "Serbiska", slovak: "Slovakiska", slovenian: "Slovenska", spanish: "Spanska", swedish: "Svenska", thai: "Thai", turkish: "Turkiska", ukrainian: "Ukrainska" }, order_summary: "Orderöversikt", payment: { cash_on_delivery: "Postförskott", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditkort (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Fluttervåg", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditkort (Mercado Pago)", mercadopago_pix: "PIX (betalningsmarknad)", mollie: "Mollie", paypal_connect: "Anslut PayPal", paypal_edit_organization_name: "Redigera organisationens namn", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditkort (Paystack)", price_plan: "Planen", razorpay: "Razorpay", secure_and_pay: "Säkra och betala", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kredit- eller betalkort", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditkort (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kortinnehavare", card_number_placeholder: "Kortnummer", cvc_placeholder: "CVC", date_out_of_range: "Utgångsdatum kan inte vara i det förflutna", empty_card_holder: "Ange ett namn på kortinnehavaren", empty_card_number: "Ange ett kortnummer", empty_cvc: "Ange en CVC", empty_expiry_date: "Ange ett utgångsdatum", expiry_data_placeholder: "MM/ÅÅ", invalid_card_number: "Kortnumret är ogiltigt", invalid_cvc: "CVC är ogiltigt", invalid_expiry_date: "Utgångsdatum är ogiltigt", month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12", year_out_of_range: "Utgångsår kan inte vara i det förflutna" }, "Payment-method": "Betalningsmetod", price_plan: { interval: { day: "dag", day_plural: "{{count}} dagar", month: "månad", month_plural: "{{count}} månader", week: "vecka", week_plural: "{{count}} veckor", year: "år", year_plural: "{{count}} år" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dagar", month: "{{count}} månad", month_plural: "{{count}} månader", week: "{{count}} vecka", week_plural: "{{count}} veckor", year: "{{count}} år", year_plural: "{{count}} år" } }, product: "Produkt", quantity: "Antal", "registered-over": "registrerade över", "required-field": "Fält är obligatoriskt", shipping: { condition_label: { price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}", price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer", quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar", quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar", weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g", weight_min: "För beställningar med en totalvikt av {{min}}g eller mer" }, not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.", shipping_method: "Fraktmetod" }, shipping_fee: "Fraktavgift", subtotal: "Delsumma", total: "Totalt", total_amount_with_shipping: "Totalt (inklusive frakt)", total_amount_with_tax: "Totalt (inklusive moms)", total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)", vat: "Moms", vat_percent: "Moms ({{percent}}%)" }, Lc = {
  public_pages_purchase: Gc
}, Rc = { affiliate_badge: { made_with: "ขับเคลื่อนโดย" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง", trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น", trial_period_price: "ฟรี", unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}" } } }, contact_slug: { city: "เมือง", company_name: "ชื่อบริษัท", country: "ประเทศ", email: "อีเมล", first_name: "ชื่อจริง", last_name: "นามสกุล", neighborhood: "ย่าน", phone_number: "หมายเลขโทรศัพท์", postal_code: "รหัสไปรษณีย์", state_province: "รัฐ/จังหวัด", street_address: "ที่อยู่ถนน", street_number: "หมายเลขถนน", tax_number: "หมายเลขภาษี" }, copy_clipboard: "คัดลอกไปยังคลิปบอร์ด", copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้", date_picker: { all_time: "ทั้งหมด", apply: "สมัคร", clear: "ล้าง", from: "จาก", last_3_months: "3 เดือนที่ผ่านมา", last_30_days: "30 วันที่ผ่านมา", last_month: "เดือนที่แล้ว", last_pool_period: "ช่วงเวลาประเมินผลล่าสุด", this_month: "เดือนนี้", time: "เวลา", title_dates: "วันที่", to: "ถึง" }, error: "ข้อผิดพลาด", form_select: { empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า", select: "เลือก" }, including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})", input: { phone_number: "หมายเลขโทรศัพท์", phone_search: "ค้นหา", search: "ค้นหา" }, locale: { albania: "แอลเบเนีย", arabic: "ภาษาอาหรับ", chinese: "ชาวจีน", czech: "เช็ก", danish: "ภาษาเดนมาร์ก", dutch: "ภาษาดัตช์", english: "ภาษาอังกฤษ", french: "ภาษาฝรั่งเศส", german: "เยอรมัน", greek: "กรีก", hindi: "ไม่", hungarian: "ภาษาฮังการี", indonesian: "ชาวอินโดนีเซีย", italian: "ภาษาอิตาลี", japanese: "ญี่ปุ่น", norwegian: "ภาษานอร์เวย์", polish: "ขัด", portuguese: "โปรตุเกส", romanian: "โรมาเนีย", russian: "ภาษารัสเซีย", serbian: "เซอร์เบีย", slovak: "สโลวัก", slovenian: "ภาษาสโลเวเนีย", spanish: "สเปน", swedish: "ภาษาสวีเดน", thai: "แบบไทย", turkish: "ภาษาตุรกี", ukrainian: "ภาษายูเครน" }, order_summary: "สรุปคำสั่งซื้อ", payment: { cash_on_delivery: "เงินสดในการจัดส่ง", dlocal_boleto: "โบเลโต (Dlocal)", dlocal_card: "บัตรเครดิต (ดีโลคอล)", dlocal_pix: "Pix (Dlocal)", flutterwave: "กระพือปีก", gocardless: "ไร้บัตร", mercadopago_boleto: "โบเลโต (Mercado Pago)", mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)", mercadopago_pix: "PIX (ตลาดการชำระเงิน)", mollie: "มอลลี่", paypal_connect: "เชื่อมต่อเพย์พาล", paypal_edit_organization_name: "แก้ไขชื่อองค์กร", paypal_rest: "เพย์พาล", paypal_soap: "เพย์พาล", paystack_card: "บัตรเครดิต (เพย์สแต็ค)", price_plan: "วางแผน", razorpay: "เรเซอร์เพย์", secure_and_pay: "ปลอดภัยและชำระเงิน", stripe_applepay: "Apple Pay", stripe_bancotact: "แบนคอนแทค (ลายทาง)", stripe_card: "บัตรเครดิตหรือเดบิต", stripe_ideal: "ไอดีล (ลายทาง)", xendit: { "3ds": "3D-Secure" }, xendit_card: "บัตรเครดิต (Xendit)" }, payment_inputs: { card_holder_placeholder: "ชื่อผู้ถือบัตร", card_number_placeholder: "หมายเลขบัตร", cvc_placeholder: "CVC", date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้", empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร", empty_card_number: "กรอกหมายเลขบัตร", empty_cvc: "กรุณาใส่ CVC", empty_expiry_date: "กรอกวันที่หมดอายุ", expiry_data_placeholder: "MM/YY", invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง", invalid_cvc: "CVC ไม่ถูกต้อง", invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง", month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12", year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้" }, "Payment-method": "วิธีการชำระเงิน", price_plan: { interval: { day: "วัน", month: "เดือน", week: "สัปดาห์", year: "ปี" }, trial_period: { day: "{{count}} วัน", month: "{{count}} เดือน", week: "{{count}} สัปดาห์", year: "{{count}} ปี" } }, product: "ผลิตภัณฑ์", quantity: "จำนวน", "registered-over": "ลงทะเบียนมากกว่า", "required-field": "จำเป็นต้องกรอกข้อมูล", shipping: { condition_label: { price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}", price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป", quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ", quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป", weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g", weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป" }, not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้", shipping_method: "วิธีการจัดส่ง" }, shipping_fee: "ค่าจัดส่ง", subtotal: "ยอดรวมย่อย", total: "รวม", total_amount_with_shipping: "รวมค่าส่งแล้ว", total_amount_with_tax: "รวมทั้งภาษีแล้ว", total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)", vat: "ภาษีขาย", vat_percent: "ภาษีขาย ({{percent}}%)" }, Fc = {
  public_pages_purchase: Rc
}, Kc = { affiliate_badge: { made_with: "Tarafından desteklenmektedir" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez", trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra", trial_period_price: "Ücretsiz", unlimited_new: "<bold>{{amount}}</bold> her {{interval}}" } } }, contact_slug: { city: "Şehir", company_name: "Şirket adı", country: "Ülke", email: "E-posta", first_name: "İsim", last_name: "Soyisim", neighborhood: "Mahalle", phone_number: "Telefon numarası", postal_code: "Posta kodu", state_province: "Eyalet/İl", street_address: "Sokak adresi", street_number: "Sokak numarası", tax_number: "Vergi numarası" }, copy_clipboard: "Panoya kopyalandı", copy_clipboard_error: "Metin kopyalanamadı", date_picker: { all_time: "Tüm zamanlar", apply: "Uygula", clear: "Temizle", from: "Tarihinden itibaren", last_3_months: "Son 3 ay", last_30_days: "Son 30 gün", last_month: "Geçen Ay", last_pool_period: "Son havuz değerlendirme dönemi", this_month: "Bu Ay", time: "Zaman", title_dates: "Tarihler", to: "Tarihine kadar" }, error: "Hata", form_select: { empty_list: "Bu liste boş gibi görünüyor", select: "Seçin" }, including_tax: "KDV dahil {{percent}}% ({{amount}})", input: { phone_number: "Telefon numarası", phone_search: "Ara", search: "Ara" }, locale: { albania: "Arnavut", arabic: "Arap", chinese: "Çince", czech: "Çek", danish: "Danimarka", dutch: "Flemenkçe", english: "İngilizce", french: "Fransızca", german: "Almanca", greek: "Yunan", hindi: "Hintçe", hungarian: "Macarca", indonesian: "Endonezya dili", italian: "İtalyan", japanese: "Japonca", norwegian: "Norveççe", polish: "Lehçe", portuguese: "Portekizce", romanian: "Romen", russian: "Rusça", serbian: "Sırpça", slovak: "Slovak", slovenian: "Slovence", spanish: "İspanyol", swedish: "İsveççe", thai: "Tay dili", turkish: "Türkçe", ukrainian: "Ukrayna" }, order_summary: "Sipariş Özeti", payment: { cash_on_delivery: "Kapıda ödeme", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kredi kartları (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Çarpıntı dalgası", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kredi kartları (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "PayPal'ı bağlayın", paypal_edit_organization_name: "Kuruluş adını düzenleyin", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kredi kartları (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Güvenli ve Ödemeli", stripe_applepay: "Apple Pay", stripe_bancotact: "İletişimi yasakla (Stripe)", stripe_card: "Kredi veya banka kartı", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Güvenlik" }, xendit_card: "Kredi kartları (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kart sahibi", card_number_placeholder: "Kart numarası", cvc_placeholder: "CVC", date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz", empty_card_holder: "Bir kart sahibi adı girin", empty_card_number: "Bir kart numarası girin", empty_cvc: "CVC girin", empty_expiry_date: "Bir son kullanma tarihi girin", expiry_data_placeholder: "AA/YY", invalid_card_number: "Kart numarası geçersiz", invalid_cvc: "CVC geçersiz", invalid_expiry_date: "Son kullanma tarihi geçersiz", month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır", year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz" }, "Payment-method": "Ödeme yöntemi", price_plan: { interval: { day: "gün", day_plural: "{{count}} gün", month: "ay", month_plural: "{{count}} ay", week: "hafta", week_plural: "{{count}} hafta", year: "yıl", year_plural: "{{count}} yıl" }, trial_period: { day: "{{count}} gün", day_plural: "{{count}} gün", month: "{{count}} ay", month_plural: "{{count}} ay", week: "{{count}} hafta", week_plural: "{{count}} hafta", year: "{{count}} yıl", year_plural: "{{count}} yıl" } }, product: "Ürün", quantity: "Miktar", "registered-over": "kaydedilen", "required-field": "Alan gereklidir", shipping: { condition_label: { price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için", price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için", quantity: "{{min}} ile {{max}} ürün içeren siparişler için", quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için", weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için", weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için" }, not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.", shipping_method: "Gönderim Yöntemi" }, shipping_fee: "Gönderim ücreti", subtotal: "Ara Toplam", total: "Toplam", total_amount_with_shipping: "Toplam (kargo dahil)", total_amount_with_tax: "Toplam (vergiler dahil)", total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)", vat: "Satış vergisi", vat_percent: "Satış vergisi ({{percent}}%)" }, Hc = {
  public_pages_purchase: Kc
}, Uc = { affiliate_badge: { made_with: "Підтримується" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів", trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ", trial_period_price: "безкоштовно", unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}" } } }, contact_slug: { city: "Місто", company_name: "Назва компанії", country: "Країна", email: "Електронна пошта", first_name: "Ім'я", last_name: "Прізвище", neighborhood: "Район", phone_number: "Номер телефону", postal_code: "Поштовий індекс", state_province: "Штат/Область", street_address: "Вулиця", street_number: "Номер вулиці", tax_number: "Податковий номер" }, copy_clipboard: "Скопійовано в буфер обміну", copy_clipboard_error: "Не вдалося скопіювати текст", date_picker: { all_time: "Весь час", apply: "Застосувати", clear: "Очистити", from: "З", last_3_months: "Останні 3 місяці", last_30_days: "Останні 30 днів", last_month: "Останній місяць", last_pool_period: "Останній період оцінки пулу", this_month: "Цей місяць", time: "Час", title_dates: "Дати", to: "До" }, error: "Помилка", form_select: { empty_list: "Схоже, що цей список порожній", select: "Вибрати" }, including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})", input: { phone_number: "Номер телефону", phone_search: "Пошук", search: "Пошук" }, locale: { albania: "албанець", arabic: "арабська", chinese: "китайський", czech: "чеська", danish: "датська", dutch: "голландська", english: "англійська", french: "французька", german: "Німецький", greek: "грецька", hindi: "ні", hungarian: "угорська", indonesian: "індонезійська", italian: "італійська", japanese: "Японський", norwegian: "норвезька", polish: "польський", portuguese: "португальська", romanian: "румунська", russian: "російський", serbian: "сербська", slovak: "словацький", slovenian: "словенська", spanish: "Іспанська", swedish: "шведська", thai: "тайська", turkish: "турецька", ukrainian: "Українська" }, order_summary: "Підсумок замовлення", payment: { cash_on_delivery: "Накладений платіж", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Кредитні картки (Dlocal)", dlocal_pix: "Пікс (Dlocal)", flutterwave: "Флаттервейв", gocardless: "Gocardless", mercadopago_boleto: "Болето (Меркадо Паго)", mercadopago_card: "Кредитні картки (Mercado Pago)", mercadopago_pix: "PIX (платіжний ринок)", mollie: "Моллі", paypal_connect: "Підключіть PayPal", paypal_edit_organization_name: "Редагувати назву організації", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Кредитні картки (Paystack)", price_plan: "План", razorpay: "Razorpay", secure_and_pay: "Захистіть і заплатите", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Кредитна або дебетова карта", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Кредитні картки (Xendit)" }, payment_inputs: { card_holder_placeholder: "Власник картки", card_number_placeholder: "Номер картки", cvc_placeholder: "CVC", date_out_of_range: "Дата закінчення не може бути в минулому", empty_card_holder: "Введіть ім'я власника картки", empty_card_number: "Введіть номер картки", empty_cvc: "Введіть CVC", empty_expiry_date: "Введіть дату закінчення терміну дії", expiry_data_placeholder: "ММ/РР", invalid_card_number: "Номер картки недійсний", invalid_cvc: "CVC недійсний", invalid_expiry_date: "Дата закінчення недійсна", month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12", year_out_of_range: "Рік закінчення не може бути в минулому" }, "Payment-method": "Спосіб оплати", price_plan: { interval: { day_0: "день", day_1: "{{count}} днів", day_2: "{{count}} днів", month_0: "місяць", month_1: "{{count}} місяців", month_2: "{{count}} місяців", week_0: "тиждень", week_1: "{{count}} тижнів", week_2: "{{count}} тижнів", year_0: "рік", year_1: "{{count}} років", year_2: "{{count}} років" }, trial_period: { day_0: "{{count}} день", day_1: "{{count}} днів", day_2: "{{count}} днів", month_0: "{{count}} місяць", month_1: "{{count}} місяців", month_2: "{{count}} місяців", week_0: "{{count}} тиждень", week_1: "{{count}} тижнів", week_2: "{{count}} тижнів", year_0: "{{count}} рік", year_1: "{{count}} років", year_2: "{{count}} років" } }, product: "Продукт", quantity: "Кількість", "registered-over": "зареєстровано понад", "required-field": "Поле обов'язкове", shipping: { condition_label: { price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}", price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше", quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів", quantity_min: "Для замовлень, що містять {{min}} або більше товарів", weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g", weight_min: "Для замовлень з загальною вагою {{min}}g або більше" }, not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.", shipping_method: "Спосіб доставки" }, shipping_fee: "Вартість доставки", subtotal: "Проміжний підсумок", total: "Всього", total_amount_with_shipping: "Загалом (з урахуванням доставки)", total_amount_with_tax: "Загалом (з урахуванням податку)", total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)", vat: "Податок на продаж", vat_percent: "Податок з продажу ({{percent}}%)" }, zc = {
  public_pages_purchase: Uc
}, jc = { affiliate_badge: { made_with: "技术支持" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次", trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后", trial_period_price: "免费", unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}" } } }, contact_slug: { city: "城市", company_name: "公司名称", country: "国家", email: "电子邮件", first_name: "名字", last_name: "姓氏", neighborhood: "街道邻里", phone_number: "电话号码", postal_code: "邮政编码", state_province: "州/省", street_address: "街道地址", street_number: "街道号码", tax_number: "税号" }, copy_clipboard: "已复制到剪贴板", copy_clipboard_error: "复制文本失败", date_picker: { all_time: "所有的时间", apply: "应用", clear: "清除", from: "从", last_3_months: "过去3个月", last_30_days: "过去30天", last_month: "次月", last_pool_period: "最后一个池评估期", this_month: "这个月", time: "时间", title_dates: "日期", to: "到" }, error: "错误", form_select: { empty_list: "看起来这个列表是空的", select: "选择" }, including_tax: "含{{percent}}%增值税（{{amount}}）", input: { phone_number: "电话号码", phone_search: "搜索", search: "搜索" }, locale: { albania: "阿尔巴尼亚语", arabic: "阿拉伯语", chinese: "中國人", czech: "捷克语", danish: "丹麦语", dutch: "荷兰语", english: "英语", french: "法语", german: "德语", greek: "希腊语", hindi: "印地语", hungarian: "匈牙利语", indonesian: "印度尼西亚语", italian: "意大利语", japanese: "日语", norwegian: "挪威语", polish: "波兰语", portuguese: "葡萄牙语", romanian: "罗马尼亚语", russian: "俄语", serbian: "塞尔维亚语", slovak: "斯洛伐克语", slovenian: "斯洛文尼亚语", spanish: "西班牙语", swedish: "瑞典语", thai: "泰语", turkish: "土耳其语", ukrainian: "乌克兰语" }, order_summary: "订单摘要", payment: { cash_on_delivery: "货到付款", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "信用卡（Dlocal）", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto（Mercado Pago）", mercadopago_card: "信用卡（Mercado Pago）", mercadopago_pix: "PIX（Mercado Pago）", mollie: "Mollie", paypal_connect: "连接 PayPal", paypal_edit_organization_name: "编辑组织名称", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "信用卡（Paystack）", price_plan: "计划", razorpay: "Razorpay", secure_and_pay: "安全与支付", stripe_applepay: "苹果支付", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "信用卡或借记卡", stripe_ideal: "iDeal (Stripe)", xendit: { "3ds": "3D-安全" }, xendit_card: "信用卡 (Xendit)" }, payment_inputs: { card_holder_placeholder: "持卡人", card_number_placeholder: "卡号", cvc_placeholder: "CVC", date_out_of_range: "过期日期不能是过去时间", empty_card_holder: "输入持卡人姓名", empty_card_number: "输入卡号", empty_cvc: "输入CVC", empty_expiry_date: "输入到期日期", expiry_data_placeholder: "月/年", invalid_card_number: "卡号无效", invalid_cvc: "CVC无效", invalid_expiry_date: "过期日期无效", month_out_of_range: "到期月份必须在01到12之间", year_out_of_range: "到期年不能是过去的年份" }, "Payment-method": "付款方式", price_plan: { interval: { day: `天

{{count}} 天`, month: `月

{{count}} 月`, week: `周

{{count}}周`, year: `年

{{count}}年` }, trial_period: { day: `{{count}} 天

{{count}} 天`, month: `{{count}} 月

{{count}} 月`, week: `周

{{count}} 周`, year: `{{count}}年

{{count}}年` } }, product: "产品", quantity: "数量", "registered-over": "注册超过", "required-field": "字段为必填项", shipping: { condition_label: { price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单", price_min: "对于价格在 {{min}} {{currency}} 或以上的订单", quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单", quantity_min: "对于包含 {{min}} 件或更多商品的订单", weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单", weight_min: "对于总重量在 {{min}}g 或以上的订单" }, not_available: "哎呀！看起来我们还不提供该地点的运输服务。", shipping_method: "运输方式" }, shipping_fee: "运费", subtotal: "小计", total: "总计", total_amount_with_shipping: "总计（含运费）", total_amount_with_tax: "总计（含税）", total_amount_with_tax_and_shipping: "总计（包括税费和运费）", vat: "销售税", vat_percent: "销售税 ({{percent}}%)" }, Vc = {
  public_pages_purchase: jc
}, So = ["common"], Yc = So[0], Wc = Object.values(Q), Zc = {
  ar: { common: Vu },
  cs: { common: Wu },
  da: { common: Ju },
  de: { common: qu },
  el: { common: Xu },
  en: { common: ac },
  es: { common: rc },
  fr: { common: ic },
  hi: { common: sc },
  hu: { common: uc },
  id: { common: dc },
  it: { common: mc },
  ja: { common: fc },
  nl: { common: _c },
  no: { common: vc },
  pl: { common: Sc },
  pt: { common: Mc },
  ro: { common: Cc },
  ru: { common: Tc },
  sk: { common: Dc },
  sl: { common: Ic },
  sq: { common: Ec },
  sr: { common: Oc },
  sv: { common: Lc },
  th: { common: Fc },
  tr: { common: Hc },
  uk: { common: zc },
  zh: { common: Vc }
}, Jc = {
  supportedLngs: Wc,
  load: "languageOnly",
  debug: !1,
  defaultNS: Yc,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: So,
  compatibilityJSON: "v3",
  fallbackLng: Q.ENGLISH,
  lng: Q.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Zc
};
F.use(vu).init(Jc);
const $_ = (a) => {
  switch (a) {
    case le.stripe_card:
      return F.t("public_pages_purchase.payment.stripe_card");
    case le.stripe_ideal:
      return F.t("public_pages_purchase.payment.stripe_ideal");
    case le.stripe_bancontact:
      return F.t("public_pages_purchase.payment.stripe_bancotact");
    case le.stripe_applepay:
      return F.t("public_pages_purchase.payment.stripe_applepay");
    case le.dlocal_card:
      return F.t("public_pages_purchase.payment.dlocal_card");
    case le.dlocal_boleto:
      return F.t("public_pages_purchase.payment.dlocal_boleto");
    case le.dlocal_pix:
      return F.t("public_pages_purchase.payment.dlocal_pix");
    case le.paypal_soap:
    case le.paypal_rest:
      return F.t("public_pages_purchase.payment.paypal_soap");
    case le.mercadopago_br_card:
      return F.t("public_pages_purchase.payment.mercadopago_card");
    case le.mercadopago_br_pix:
      return F.t("public_pages_purchase.payment.mercadopago_pix");
    case le.mercadopago_br_boleto:
      return F.t("public_pages_purchase.payment.mercadopago_boleto");
    case le.mercadopago_co_card:
    case le.mercadopago_ar_card:
    case le.mercadopago_mx_card:
    case le.mercadopago_cl_card:
      return F.t("public_pages_purchase.payment.mercadopago_card");
    case le.razorpay:
      return F.t("public_pages_purchase.payment.razorpay");
    case le.flutterwave:
      return F.t("public_pages_purchase.payment.flutterwave");
    case le.mollie:
      return F.t("public_pages_purchase.payment.mollie");
    case le.gocardless:
      return F.t("public_pages_purchase.payment.gocardless");
    case le.cash_on_delivery:
      return F.t("public_pages_purchase.payment.cash_on_delivery");
    case le.xendit_id_card:
    case le.xendit_ph_card:
      return F.t("public_pages_purchase.payment.xendit_card");
    case le.paystack_gh_card:
    case le.paystack_ke_card:
    case le.paystack_ng_card:
    case le.paystack_za_card:
    case le.paystack_eg_card:
    case le.paystack_ci_card:
      return F.t("public_pages_purchase.payment.paystack_card");
    case le.secure_and_pay:
      return F.t("public_pages_purchase.payment.secure_and_pay");
  }
}, va = ({
  description: a,
  descriptionClassName: r,
  error: n,
  errorClassName: t,
  className: e
}) => {
  const i = n ? /* @__PURE__ */ _(
    "p",
    {
      className: N("text-danger [&>a]:text-brand-primary text-sm", t),
      ...typeof n == "string" ? {
        dangerouslySetInnerHTML: { __html: n }
      } : {
        children: n
      }
    }
  ) : null;
  return n || a ? /* @__PURE__ */ G("div", { className: e, children: [
    a ? /* @__PURE__ */ _(
      "span",
      {
        className: N("[&>a]:text-brand-primary text-sm opacity-70", r),
        children: a
      }
    ) : null,
    i
  ] }) : null;
}, q_ = ({
  inputRef: a,
  error: r,
  description: n,
  value: t,
  onChange: e,
  label: i,
  disabled: o,
  isFetching: s,
  labelClassName: l,
  className: u,
  errorClassName: c,
  descriptionClassName: d,
  checkboxIconClassName: p,
  inputClassName: m,
  inputWrapperClassName: f
}) => /* @__PURE__ */ G(
  "label",
  {
    className: N(
      "group flex w-fit items-center gap-3",
      o ? "cursor-default" : "cursor-pointer",
      u
    ),
    "aria-checked": t,
    children: [
      /* @__PURE__ */ G("div", { className: N("relative flex items-center justify-center", f), children: [
        /* @__PURE__ */ _(
          "input",
          {
            ref: a,
            disabled: o,
            checked: t,
            className: N(
              "peer/checkbox main-transition-colors",
              o ? "bg-skeleton-primary/40 border-darkgray/20 checked:bg-text-primary/60 checked:border-text-primary/75 cursor-default" : "border-darkgray bg-background-secondary checked:border-text-primary checked:bg-text-primary",
              s && "animate-pulse",
              "focus-ring h-[20px] w-[20px] cursor-pointer appearance-none rounded-md border",
              m
            ),
            type: "checkbox",
            onChange: (y) => e(y.target.checked)
          }
        ),
        /* @__PURE__ */ _(
          Zl,
          {
            className: N(
              "absolute",
              o ? t ? "fill-background-secondary/70 opacity-100" : "opacity-0" : "fill-background-secondary opacity-100",
              p
            )
          }
        )
      ] }),
      i && /* @__PURE__ */ _(
        "span",
        {
          className: N(
            "main-transition-colors",
            t ? "text-text-primary" : "text-text-primary/50",
            "leading-5",
            l,
            "text-left"
          ),
          children: i
        }
      ),
      /* @__PURE__ */ _(
        va,
        {
          description: n,
          error: r,
          errorClassName: c,
          descriptionClassName: d
        }
      )
    ]
  }
);
function xa({
  wrapperAs: a = "div",
  wrapperProps: r = { className: "flex justify-between gap-2" },
  label: n,
  required: t,
  labelClassName: e,
  labelRightElement: i,
  requiredSignClassName: o
}) {
  return n || t || i ? /* @__PURE__ */ G(a, { ...r, children: [
    (n || t) && /* @__PURE__ */ G("span", { className: N("flex", e), children: [
      n,
      " ",
      t && /* @__PURE__ */ _("i", { className: N("text-danger", o), children: "*" })
    ] }),
    i
  ] }) : null;
}
function ko() {
  const [a, r] = M.useState({
    width: 1200,
    height: 800,
    isWindowSizeSetFromBrowser: !1
  });
  function n() {
    r({
      width: window.innerWidth,
      height: window.innerHeight,
      isWindowSizeSetFromBrowser: !0
    });
  }
  return M.useEffect(() => (r({
    width: window.innerWidth,
    height: window.innerHeight,
    isWindowSizeSetFromBrowser: !0
  }), window.addEventListener("resize", n), () => {
    window.removeEventListener("resize", n);
  }), []), a;
}
const Mo = ({ hoverOpenDelay: a = 100 } = {}) => {
  const [r, n] = ue(!1), t = Ce(null), e = () => {
    t.current !== null && (clearTimeout(t.current), t.current = null);
  }, i = () => {
    e(), n(!0);
  }, o = () => {
    e(), t.current = setTimeout(() => {
      n(!0);
    }, a);
  }, s = () => {
    e(), n(!1);
  }, l = () => {
    e(), t.current = setTimeout(() => {
      n(!1);
    }, 100);
  };
  return Pe(() => () => e(), []), { show: r, open: i, close: s, delayClose: l, delayOpen: o };
}, wo = (a) => {
  var r;
  return a.hasChildNodes() ? ((r = a.childNodes[0]) == null ? void 0 : r.nodeType) === 3 ? a : wo(a.childNodes[0]) : a;
}, $c = (a, r) => {
  const [n, t] = he.useState(void 0), { width: e } = ko();
  return he.useLayoutEffect(() => {
    const { current: i } = a;
    i && (() => {
      const s = wo(i);
      if (!s) return;
      const l = s.scrollWidth > i.clientWidth;
      t(l), r && r(l);
    })();
  }, [r, a, e]), n;
}, Co = Pt(function(a, r) {
  return /* @__PURE__ */ _(
    "button",
    {
      ref: r,
      ...a,
      onClick: (n) => {
        var t;
        n.preventDefault = () => {
        }, (t = a.onClick) == null || t.call(a, n);
      }
    }
  );
}), qc = Pt(function(a, r) {
  return /* @__PURE__ */ _(
    "div",
    {
      ref: r,
      ...a,
      onClick: (n) => {
        var t;
        n.preventDefault = () => {
        }, n.stopPropagation = () => {
        }, (t = a.onClick) == null || t.call(a, n);
      }
    }
  );
}), sn = ({
  mode: a = "hover",
  popoverButtonRef: r,
  label: n,
  position: t = "top",
  anchor: e,
  className: i,
  wrapperClassName: o,
  popoverClassName: s,
  labelClassName: l,
  disabled: u,
  stayOnHover: c,
  children: d,
  hoverOpenDelay: p
}) => {
  const m = Ce(), f = Ce(null), y = $c(m), { width: v } = ko(), { show: P, delayOpen: k, delayClose: w } = Mo({ hoverOpenDelay: p });
  return /* @__PURE__ */ _(oo, { className: N("flex items-center", o), children: ({ open: C }) => {
    const S = u ? !1 : a === "click" || v < 1024 ? C : a === "hover" || a === "overflow" && y ? P : !1;
    return /* @__PURE__ */ G(ze, { children: [
      /* @__PURE__ */ _(
        so,
        {
          ref: (b) => {
            m && (m.current = b), r && (r.current = b);
          },
          as: a === "click" ? Co : qc,
          className: N(
            "relative truncate outline-hidden",
            a === "click" && !u && "cursor-pointer",
            "h-full w-full max-w-fit",
            i
          ),
          disabled: u,
          onMouseEnter: k,
          onMouseLeave: w,
          children: typeof d == "function" ? d(S) : d
        }
      ),
      /* @__PURE__ */ _(
        Ua,
        {
          as: pt,
          show: S,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ _(
            lo,
            {
              ref: f,
              anchor: e ?? t.replace("-", " "),
              className: N(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                s
              ),
              onMouseEnter: c ? k : void 0,
              onMouseLeave: c ? w : void 0,
              children: /* @__PURE__ */ _(
                "div",
                {
                  className: N(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    l
                  ),
                  children: n
                }
              )
            }
          )
        }
      )
    ] });
  } });
}, Q_ = (a) => /* @__PURE__ */ _(sn, { ...a, mode: "click" }), Qc = ({
  switcherElement: a,
  selected: r,
  onChange: n,
  label: t,
  labelClassName: e,
  wrapperClassName: i,
  switcherClassName: o,
  disabled: s
}) => /* @__PURE__ */ G(
  nr,
  {
    className: N(
      "relative flex flex-col gap-2 md:flex-row md:items-center",
      i
    ),
    children: [
      /* @__PURE__ */ _(
        Ol,
        {
          checked: r,
          disabled: s,
          onChange: n,
          onKeyDown: (l) => {
            l.key === "Enter" && !s && (l.preventDefault(), n(!r));
          },
          className: N("focus-ring inline-flex w-fit shrink-0 rounded-sm", o),
          children: a
        }
      ),
      t && /* @__PURE__ */ _(Gl, { className: N("cursor-pointer", e), children: t })
    ]
  }
), X_ = ({
  selected: a,
  onChange: r,
  switcherClassName: n,
  disabled: t,
  ...e
}) => {
  const i = N(
    "main-transition-colors focus-ring relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent",
    a && !t ? "bg-brand-primary" : "bg-fill-primary",
    n
  ), o = /* @__PURE__ */ _(
    "span",
    {
      "aria-hidden": "true",
      className: N(
        "bg-background-secondary pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-lg ring-0 transition-transform duration-200 ease-linear",
        a ? "translate-x-5" : "translate-x-0"
      )
    }
  );
  return /* @__PURE__ */ _(
    Qc,
    {
      switcherElement: o,
      selected: a,
      disabled: t,
      onChange: r,
      switcherClassName: i,
      ...e
    }
  );
}, ey = ({
  color: a,
  labelClassName: r,
  popoverClassName: n,
  popoverButtonClassName: t,
  popoverButtonChildClassName: e,
  hexColorInput: i,
  wrapperClassName: o,
  children: s,
  additionalPopoverChildren: l,
  focusTrapFeatures: u = Rl.None,
  stayWhenUnfocused: c = !1,
  showAlpha: d = !0,
  showOnlyHue: p = !1,
  pickerRef: m,
  error: f,
  description: y,
  anchor: v = "top",
  disabled: P,
  ...k
}) => {
  const [w, C] = ue(!1), S = Ce(null);
  Pe(() => {
    const T = (I) => {
      var K;
      (K = S.current) != null && K.contains(I.target) && C(!0);
    }, D = (I) => {
      S.current && !S.current.contains(I.target) && C(!1);
    }, A = (I) => {
      I.key === "Escape" && C(!1);
    };
    return document.addEventListener("focusin", T), document.addEventListener("touchstart", D, !0), document.addEventListener("mousedown", D, !0), document.addEventListener("keydown", A), () => {
      document.removeEventListener("focusin", T), document.removeEventListener("touchstart", D, !0), document.removeEventListener("mousedown", D, !0), document.removeEventListener("keydown", A);
    };
  }, []), m && (m.current = {
    allowToHideWhenUnfocused: (T) => {
      C(!T);
    }
  });
  const b = d && !p ? ru : nu;
  return /* @__PURE__ */ _(oo, { className: "flex items-center", children: ({ open: T, close: D }) => {
    const A = c && w || T;
    return /* @__PURE__ */ G(ze, { children: [
      /* @__PURE__ */ _(
        so,
        {
          disabled: P,
          as: Co,
          className: N(
            "relative truncate outline-hidden",
            "cursor-pointer",
            "h-full w-full max-w-fit",
            "focus-ring rounded-lg",
            f && "border-danger rounded-xl border-2 p-0.5",
            t
          ),
          children: (s == null ? void 0 : s(A)) ?? /* @__PURE__ */ _(
            "div",
            {
              style: { backgroundColor: a },
              className: N(
                "border-text-secondary/30 h-10 w-10 rounded-lg border",
                e
              )
            }
          )
        }
      ),
      /* @__PURE__ */ _(
        Ua,
        {
          as: pt,
          show: A,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ _(
            lo,
            {
              ref: S,
              anchor: v,
              className: N(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                p ? "pt-4" : "pt-5",
                n
              ),
              children: /* @__PURE__ */ _(Ll, { features: u, children: /* @__PURE__ */ _(
                "div",
                {
                  className: N(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    "max-w-[200px]",
                    r
                  ),
                  children: /* @__PURE__ */ G(
                    "div",
                    {
                      className: N(
                        "flex flex-col gap-3",
                        p && "[&_.react-colorful]:!h-fit [&_div.react-colorful>div:first-child]:hidden [&_div.react-colorful>div:nth-of-type(2)]:!rounded-lg",
                        o
                      ),
                      children: [
                        /* @__PURE__ */ _(b, { color: a, ...k }),
                        !p && /* @__PURE__ */ G("div", { className: "flex", children: [
                          /* @__PURE__ */ _("div", { className: "bg-background-tertiary rounded-l-lg p-2", children: "#" }),
                          /* @__PURE__ */ _(
                            iu,
                            {
                              alpha: !0,
                              className: N(
                                "main-transition-colors border-text-secondary/30 focus:border-brand-primary w-full rounded-r-lg border p-2 outline-hidden",
                                i
                              ),
                              color: a,
                              onChange: k.onChange
                            }
                          )
                        ] }),
                        l == null ? void 0 : l(D),
                        /* @__PURE__ */ _(
                          va,
                          {
                            errorClassName: "text-left",
                            error: f,
                            description: y
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
}, Rr = (a, r) => ({
  ...a ? {
    "data-test-id": `${r}`
  } : {}
});
var ye = /* @__PURE__ */ ((a) => (a.Stripe = "stripe", a.PaypalSoap = "paypal-soap", a.Dlocal = "dlocal", a.MercadoPagoBR = "mercadopago-br", a.MercadoPagoCO = "mercadopago-co", a.MercadoPagoMX = "mercadopago-mx", a.MercadoPagoAR = "mercadopago-ar", a.MercadoPagoCL = "mercadopago-cl", a.Razorpay = "razorpay", a.Flutterwave = "flutterwave", a.Mollie = "mollie", a.Gocardless = "gocardless", a.XenditID = "xendit-id", a.XenditPH = "xendit-ph", a.PaystackGH = "paystack-gh", a.PaystackKE = "paystack-ke", a.PaystackNG = "paystack-ng", a.PaystackZA = "paystack-za", a.PaystackEG = "paystack-eg", a.PaystackCI = "paystack-ci", a.CashOnDelivery = "cash-on-delivery", a.PaypalRest = "paypal-rest", a.SecureAndPay = "secure-and-pay", a))(ye || {});
const ay = (a) => {
  switch (a) {
    case ye.Stripe:
      return "Stripe";
    case ye.PaypalSoap:
    case ye.PaypalRest:
      return "PayPal";
    case ye.Dlocal:
      return "dLocal";
    case ye.MercadoPagoBR:
    case ye.MercadoPagoCO:
    case ye.MercadoPagoMX:
    case ye.MercadoPagoAR:
    case ye.MercadoPagoCL:
      return "Mercado Pago";
    case ye.Razorpay:
      return "Razorpay";
    case ye.Flutterwave:
      return "Flutterwave";
    case ye.Mollie:
      return "Mollie";
    case ye.Gocardless:
      return "GoCardless";
    case ye.XenditID:
    case ye.XenditPH:
      return "Xendit";
    case ye.PaystackGH:
    case ye.PaystackKE:
    case ye.PaystackNG:
    case ye.PaystackZA:
    case ye.PaystackEG:
    case ye.PaystackCI:
      return "Paystack";
    case ye.CashOnDelivery:
      return F.t("public_pages_purchase.payment.cash_on_delivery");
    case ye.SecureAndPay:
      return "Secure and Pay";
  }
};
var Fr = /* @__PURE__ */ ((a) => (a.dateFirst = "d/m/Y", a.monthFirst = "m/d/Y", a))(Fr || {}), ct = /* @__PURE__ */ ((a) => (a.hourMinute = "H:i", a.hourMinuteAmPm = "h:i A", a.hourMinuteSecond = "H:i:s", a.hourMinuteSecondAmPm = "h:i:s A", a))(ct || {}), Da = /* @__PURE__ */ ((a) => (a.ENGLISH = "en", a.FRENCH = "fr", a.SPANISH = "es", a.ITALIAN = "it", a.PORTUGUESE = "pt", a.DEUTSCH = "de", a.DUTCH = "nl", a.RUSSIAN = "ru", a.JAPANESE = "jp", a.ARABIC = "ar", a.TURKISH = "tr", a.CHINESE = "zh", a.SWEDISH = "sv", a.ROMANIAN = "ro", a.CZECH = "cs", a.HUNGARIAN = "hu", a.SLOVAK = "sk", a.DANISH = "dk", a.INDONESIAN = "id", a.POLISH = "pl", a.GREEK = "el", a.SERBIAN = "sr", a.NORWEGIAN = "no", a.THAI = "th", a.SLOVENIAN = "sl", a.UKRAINIAN = "ua", a.ALBANIA = "sq", a.HINDI = "hi", a))(Da || {});
const ty = {
  en: "EN",
  fr: "FR",
  es: "ES",
  it: "IT",
  pt: "PT",
  de: "DE",
  nl: "NL",
  ru: "RU",
  jp: "JP",
  ar: "AR",
  tr: "TR",
  zh: "CH",
  sv: "SV",
  ro: "RO",
  cs: "CS",
  hu: "HU",
  sk: "SK",
  dk: "DK",
  id: "ID",
  pl: "PL",
  el: "EL",
  sr: "SR",
  hi: "HI",
  no: "NO",
  th: "TH",
  sl: "SL",
  ua: "UA",
  sq: "SQ"
}, ry = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  de: "Deutsch",
  nl: "Nederlands",
  ru: "Русский",
  jp: "日本語",
  ar: "عربي",
  tr: "Türkçe",
  zh: "中文(简体)",
  sv: "Svenska",
  ro: "Română",
  cs: "Čeština",
  hu: "Magyar",
  sk: "Slovenský",
  dk: "Dansk",
  id: "Indonesian",
  pl: "Polski",
  el: "Ελληνικά",
  sr: "Srpski",
  hi: "Hindi",
  no: "Norsk",
  th: "ไทย",
  sl: "Slovenski",
  ua: "Український",
  sq: "Shqiptare"
}, Xc = {
  en: "public_pages_purchase.locale.english",
  fr: "public_pages_purchase.locale.french",
  es: "public_pages_purchase.locale.spanish",
  it: "public_pages_purchase.locale.italian",
  pt: "public_pages_purchase.locale.portuguese",
  de: "public_pages_purchase.locale.german",
  nl: "public_pages_purchase.locale.dutch",
  ru: "public_pages_purchase.locale.russian",
  jp: "public_pages_purchase.locale.japanese",
  zh: "public_pages_purchase.locale.chinese",
  tr: "public_pages_purchase.locale.turkish",
  ar: "public_pages_purchase.locale.arabic",
  sv: "public_pages_purchase.locale.swedish",
  ro: "public_pages_purchase.locale.romanian",
  cs: "public_pages_purchase.locale.czech",
  hu: "public_pages_purchase.locale.hungarian",
  sk: "public_pages_purchase.locale.slovak",
  dk: "public_pages_purchase.locale.danish",
  id: "public_pages_purchase.locale.indonesian",
  pl: "public_pages_purchase.locale.polish",
  el: "public_pages_purchase.locale.greek",
  sr: "public_pages_purchase.locale.serbian",
  hi: "public_pages_purchase.locale.hindi",
  no: "public_pages_purchase.locale.norwegian",
  th: "public_pages_purchase.locale.thai",
  sl: "public_pages_purchase.locale.slovenian",
  ua: "public_pages_purchase.locale.ukrainian",
  sq: "public_pages_purchase.locale.albania"
};
function Po(a) {
  const r = Object.keys(Da).find(
    (n) => Da[n] === a
  );
  return r ? Q[r] : Q.ENGLISH;
}
function ny(a) {
  const r = Object.keys(Q).find(
    (n) => Q[n] === a
  );
  return r ? Da[r] : Da.ENGLISH;
}
function iy(a) {
  return F.t(Xc[a]);
}
const ed = ho(null), oy = ({
  children: a,
  locale: r
}) => (Pe(() => {
  if (!F.isInitialized) return;
  const n = Po(r);
  F.language !== n && F.changeLanguage(n);
}, [r]), /* @__PURE__ */ _(ed.Provider, { value: { locale: r }, children: a }));
var ln = /* @__PURE__ */ ((a) => (a.Afghanistan = "AF", a.AlandIslands = "AX", a.Albania = "AL", a.Algeria = "DZ", a.AmericanSamoa = "AS", a.Andorra = "AD", a.Angola = "AO", a.Anguilla = "AI", a.Antarctica = "AQ", a.AntiguaAndBarbuda = "AG", a.Argentina = "AR", a.Armenia = "AM", a.Aruba = "AW", a.Australia = "AU", a.Austria = "AT", a.Azerbaijan = "AZ", a.Bahamas = "BS", a.Bahrain = "BH", a.Bangladesh = "BD", a.Barbados = "BB", a.Belarus = "BY", a.Belgium = "BE", a.Belize = "BZ", a.Benin = "BJ", a.Bermuda = "BM", a.Bhutan = "BT", a.Bolivia = "BO", a.BonaireSintEustatiusSaba = "BQ", a.BosniaAndHerzegovina = "BA", a.Botswana = "BW", a.BouvetIsland = "BV", a.Brazil = "BR", a.BritishIndianOceanTerritory = "IO", a.BruneiDarussalam = "BN", a.Bulgaria = "BG", a.BurkinaFaso = "BF", a.Burundi = "BI", a.Cambodia = "KH", a.Cameroon = "CM", a.Canada = "CA", a.CapeVerde = "CV", a.CaymanIslands = "KY", a.CentralAfricanRepublic = "CF", a.Chad = "TD", a.Chile = "CL", a.China = "CN", a.ChristmasIsland = "CX", a.CocosKeelingIslands = "CC", a.Colombia = "CO", a.Comoros = "KM", a.Congo = "CG", a.CongoDemocraticRepublic = "CD", a.CookIslands = "CK", a.CostaRica = "CR", a.CoteDIvoire = "CI", a.Croatia = "HR", a.Cuba = "CU", a.Curaçao = "CW", a.Cyprus = "CY", a.CzechRepublic = "CZ", a.Denmark = "DK", a.Djibouti = "DJ", a.Dominica = "DM", a.DominicanRepublic = "DO", a.Ecuador = "EC", a.Egypt = "EG", a.ElSalvador = "SV", a.EquatorialGuinea = "GQ", a.Eritrea = "ER", a.Estonia = "EE", a.Ethiopia = "ET", a.FalklandIslands = "FK", a.FaroeIslands = "FO", a.Fiji = "FJ", a.Finland = "FI", a.France = "FR", a.FrenchGuiana = "GF", a.FrenchPolynesia = "PF", a.FrenchSouthernTerritories = "TF", a.Gabon = "GA", a.Gambia = "GM", a.Georgia = "GE", a.Germany = "DE", a.Ghana = "GH", a.Gibraltar = "GI", a.Greece = "GR", a.Greenland = "GL", a.Grenada = "GD", a.Guadeloupe = "GP", a.Guam = "GU", a.Guatemala = "GT", a.Guernsey = "GG", a.Guinea = "GN", a.GuineaBissau = "GW", a.Guyana = "GY", a.Haiti = "HT", a.HeardIslandMcdonaldIslands = "HM", a.HolySeeVaticanCityState = "VA", a.Honduras = "HN", a.HongKong = "HK", a.Hungary = "HU", a.Iceland = "IS", a.India = "IN", a.Indonesia = "ID", a.Iran = "IR", a.Iraq = "IQ", a.Ireland = "IE", a.IsleOfMan = "IM", a.Israel = "IL", a.Italy = "IT", a.Jamaica = "JM", a.Japan = "JP", a.Jersey = "JE", a.Jordan = "JO", a.Kazakhstan = "KZ", a.Kenya = "KE", a.Kiribati = "KI", a.Korea = "KR", a.KoreaDemocraticPeoplesRepublic = "KP", a.Kuwait = "KW", a.Kyrgyzstan = "KG", a.LaoPeoplesDemocraticRepublic = "LA", a.Latvia = "LV", a.Lebanon = "LB", a.Lesotho = "LS", a.Liberia = "LR", a.LibyanArabJamahiriya = "LY", a.Liechtenstein = "LI", a.Lithuania = "LT", a.Luxembourg = "LU", a.Macao = "MO", a.Macedonia = "MK", a.Madagascar = "MG", a.Malawi = "MW", a.Malaysia = "MY", a.Maldives = "MV", a.Mali = "ML", a.Malta = "MT", a.MarshallIslands = "MH", a.Martinique = "MQ", a.Mauritania = "MR", a.Mauritius = "MU", a.Mayotte = "YT", a.Mexico = "MX", a.Micronesia = "FM", a.Moldova = "MD", a.Monaco = "MC", a.Mongolia = "MN", a.Montenegro = "ME", a.Montserrat = "MS", a.Morocco = "MA", a.Mozambique = "MZ", a.Myanmar = "MM", a.Namibia = "NA", a.Nauru = "NR", a.Nepal = "NP", a.Netherlands = "NL", a.NewCaledonia = "NC", a.NewZealand = "NZ", a.Nicaragua = "NI", a.Niger = "NE", a.Nigeria = "NG", a.Niue = "NU", a.NorfolkIsland = "NF", a.NorthernMarianaIslands = "MP", a.Norway = "NO", a.Oman = "OM", a.Pakistan = "PK", a.Palau = "PW", a.PalestinianTerritory = "PS", a.Panama = "PA", a.PapuaNewGuinea = "PG", a.Paraguay = "PY", a.Peru = "PE", a.Philippines = "PH", a.Pitcairn = "PN", a.Poland = "PL", a.Portugal = "PT", a.PuertoRico = "PR", a.Qatar = "QA", a.Reunion = "RE", a.Romania = "RO", a.RussianFederation = "RU", a.Rwanda = "RW", a.SaintBarthelemy = "BL", a.SaintHelena = "SH", a.SaintKittsAndNevis = "KN", a.SaintLucia = "LC", a.SaintMartin = "MF", a.SaintPierreAndMiquelon = "PM", a.SaintVincentAndGrenadines = "VC", a.Samoa = "WS", a.SanMarino = "SM", a.SaoTomeAndPrincipe = "ST", a.SaudiArabia = "SA", a.Senegal = "SN", a.Serbia = "RS", a.Seychelles = "SC", a.SierraLeone = "SL", a.Singapore = "SG", a.SintMaarten = "SX", a.Slovakia = "SK", a.Slovenia = "SI", a.SolomonIslands = "SB", a.Somalia = "SO", a.SouthAfrica = "ZA", a.SouthGeorgiaAndSandwichIsl = "GS", a.SouthSudan = "SS", a.Spain = "ES", a.SriLanka = "LK", a.Sudan = "SD", a.Suriname = "SR", a.SvalbardAndJanMayen = "SJ", a.Swaziland = "SZ", a.Sweden = "SE", a.Switzerland = "CH", a.SyrianArabRepublic = "SY", a.Taiwan = "TW", a.Tajikistan = "TJ", a.Tanzania = "TZ", a.Thailand = "TH", a.TimorLeste = "TL", a.Togo = "TG", a.Tokelau = "TK", a.Tonga = "TO", a.TrinidadAndTobago = "TT", a.Tunisia = "TN", a.Turkey = "TR", a.Turkmenistan = "TM", a.TurksAndCaicosIslands = "TC", a.Tuvalu = "TV", a.Uganda = "UG", a.Ukraine = "UA", a.UnitedArabEmirates = "AE", a.UnitedKingdom = "GB", a.UnitedStates = "US", a.UnitedStatesOutlyingIslands = "UM", a.Uruguay = "UY", a.Uzbekistan = "UZ", a.Vanuatu = "VU", a.Venezuela = "VE", a.Vietnam = "VN", a.VirginIslandsBritish = "VG", a.VirginIslandsUS = "VI", a.WallisAndFutuna = "WF", a.WesternSahara = "EH", a.Yemen = "YE", a.Zambia = "ZM", a.Zimbabwe = "ZW", a))(ln || {}), vr = {};
const ad = /* @__PURE__ */ JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKK","983","ISO 3166-2:XK"]]'), td = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var nt = {}, ti;
function rd() {
  if (ti) return nt;
  ti = 1, nt.remove = i;
  for (var a = [
    {
      base: " ",
      chars: " "
    },
    {
      base: "0",
      chars: "߀"
    },
    {
      base: "A",
      chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
    },
    {
      base: "AA",
      chars: "Ꜳ"
    },
    {
      base: "AE",
      chars: "ÆǼǢ"
    },
    {
      base: "AO",
      chars: "Ꜵ"
    },
    {
      base: "AU",
      chars: "Ꜷ"
    },
    {
      base: "AV",
      chars: "ꜸꜺ"
    },
    {
      base: "AY",
      chars: "Ꜽ"
    },
    {
      base: "B",
      chars: "ⒷＢḂḄḆɃƁ"
    },
    {
      base: "C",
      chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
    },
    {
      base: "D",
      chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
    },
    {
      base: "Dh",
      chars: "Ð"
    },
    {
      base: "DZ",
      chars: "ǱǄ"
    },
    {
      base: "Dz",
      chars: "ǲǅ"
    },
    {
      base: "E",
      chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
    },
    {
      base: "F",
      chars: "ꝼⒻＦḞƑꝻ"
    },
    {
      base: "G",
      chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
    },
    {
      base: "H",
      chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    },
    {
      base: "I",
      chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
    },
    {
      base: "J",
      chars: "ⒿＪĴɈȷ"
    },
    {
      base: "K",
      chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    },
    {
      base: "L",
      chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    },
    {
      base: "LJ",
      chars: "Ǉ"
    },
    {
      base: "Lj",
      chars: "ǈ"
    },
    {
      base: "M",
      chars: "ⓂＭḾṀṂⱮƜϻ"
    },
    {
      base: "N",
      chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
    },
    {
      base: "NJ",
      chars: "Ǌ"
    },
    {
      base: "Nj",
      chars: "ǋ"
    },
    {
      base: "O",
      chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
    },
    {
      base: "OE",
      chars: "Œ"
    },
    {
      base: "OI",
      chars: "Ƣ"
    },
    {
      base: "OO",
      chars: "Ꝏ"
    },
    {
      base: "OU",
      chars: "Ȣ"
    },
    {
      base: "P",
      chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
    },
    {
      base: "Q",
      chars: "ⓆＱꝖꝘɊ"
    },
    {
      base: "R",
      chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    },
    {
      base: "S",
      chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    },
    {
      base: "T",
      chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    },
    {
      base: "Th",
      chars: "Þ"
    },
    {
      base: "TZ",
      chars: "Ꜩ"
    },
    {
      base: "U",
      chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    },
    {
      base: "V",
      chars: "ⓋＶṼṾƲꝞɅ"
    },
    {
      base: "VY",
      chars: "Ꝡ"
    },
    {
      base: "W",
      chars: "ⓌＷẀẂŴẆẄẈⱲ"
    },
    {
      base: "X",
      chars: "ⓍＸẊẌ"
    },
    {
      base: "Y",
      chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
    },
    {
      base: "Z",
      chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    },
    {
      base: "a",
      chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
    },
    {
      base: "aa",
      chars: "ꜳ"
    },
    {
      base: "ae",
      chars: "æǽǣ"
    },
    {
      base: "ao",
      chars: "ꜵ"
    },
    {
      base: "au",
      chars: "ꜷ"
    },
    {
      base: "av",
      chars: "ꜹꜻ"
    },
    {
      base: "ay",
      chars: "ꜽ"
    },
    {
      base: "b",
      chars: "ⓑｂḃḅḇƀƃɓƂ"
    },
    {
      base: "c",
      chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
    },
    {
      base: "d",
      chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
    },
    {
      base: "dh",
      chars: "ð"
    },
    {
      base: "dz",
      chars: "ǳǆ"
    },
    {
      base: "e",
      chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
    },
    {
      base: "f",
      chars: "ⓕｆḟƒ"
    },
    {
      base: "ff",
      chars: "ﬀ"
    },
    {
      base: "fi",
      chars: "ﬁ"
    },
    {
      base: "fl",
      chars: "ﬂ"
    },
    {
      base: "ffi",
      chars: "ﬃ"
    },
    {
      base: "ffl",
      chars: "ﬄ"
    },
    {
      base: "g",
      chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
    },
    {
      base: "h",
      chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    },
    {
      base: "hv",
      chars: "ƕ"
    },
    {
      base: "i",
      chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
    },
    {
      base: "j",
      chars: "ⓙｊĵǰɉ"
    },
    {
      base: "k",
      chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    },
    {
      base: "l",
      chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
    },
    {
      base: "lj",
      chars: "ǉ"
    },
    {
      base: "m",
      chars: "ⓜｍḿṁṃɱɯ"
    },
    {
      base: "n",
      chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
    },
    {
      base: "nj",
      chars: "ǌ"
    },
    {
      base: "o",
      chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
    },
    {
      base: "oe",
      chars: "œ"
    },
    {
      base: "oi",
      chars: "ƣ"
    },
    {
      base: "oo",
      chars: "ꝏ"
    },
    {
      base: "ou",
      chars: "ȣ"
    },
    {
      base: "p",
      chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
    },
    {
      base: "q",
      chars: "ⓠｑɋꝗꝙ"
    },
    {
      base: "r",
      chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    },
    {
      base: "s",
      chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
    },
    {
      base: "ss",
      chars: "ß"
    },
    {
      base: "t",
      chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    },
    {
      base: "th",
      chars: "þ"
    },
    {
      base: "tz",
      chars: "ꜩ"
    },
    {
      base: "u",
      chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    },
    {
      base: "v",
      chars: "ⓥｖṽṿʋꝟʌ"
    },
    {
      base: "vy",
      chars: "ꝡ"
    },
    {
      base: "w",
      chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
    },
    {
      base: "x",
      chars: "ⓧｘẋẍ"
    },
    {
      base: "y",
      chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
    },
    {
      base: "z",
      chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }
  ], r = {}, n = 0; n < a.length; n += 1)
    for (var t = a[n].chars, e = 0; e < t.length; e += 1)
      r[t[e]] = a[n].base;
  function i(o) {
    return o.replace(/[^\u0000-\u007e]/g, function(s) {
      return r[s] || s;
    });
  }
  return nt.replacementList = a, nt.diacriticsMap = r, nt;
}
var ri;
function nd() {
  return ri || (ri = 1, (function(a) {
    const r = ad, n = td, t = rd().remove, e = {}, i = {}, o = {}, s = {}, l = {};
    r.forEach(function(S) {
      const b = S;
      i[b[0]] = b[1], o[b[1]] = b[0], s[b[2]] = b[0], l[b[0]] = b[2];
    });
    function u(S) {
      return ("000" + (S || "")).slice(-3);
    }
    function c(S, b) {
      return Object.prototype.hasOwnProperty.call(S, b);
    }
    function d(S, b) {
      return Object.keys(S).reduce(function(T, D) {
        const A = S[D];
        return T[D] = b(A, D), T;
      }, {});
    }
    function p(S, b) {
      switch (S) {
        case "official":
          return Array.isArray(b) ? b[0] : b;
        case "all":
          return typeof b == "string" ? [b] : b;
        case "alias":
          return Array.isArray(b) ? b[1] || b[0] : b;
        default:
          throw new TypeError(
            "LocaleNameType must be one of these: all, official, alias!"
          );
      }
    }
    a.registerLocale = function(S) {
      if (!S.locale)
        throw new TypeError("Missing localeData.locale");
      if (!S.countries)
        throw new TypeError("Missing localeData.countries");
      e[S.locale] = S.countries;
    };
    function m(S) {
      return o[S];
    }
    a.alpha3ToAlpha2 = m;
    function f(S) {
      return i[S];
    }
    a.alpha2ToAlpha3 = f;
    function y(S) {
      return l[m(S)];
    }
    a.alpha3ToNumeric = y;
    function v(S) {
      return l[S];
    }
    a.alpha2ToNumeric = v;
    function P(S) {
      const b = u(S);
      return f(s[b]);
    }
    a.numericToAlpha3 = P;
    function k(S) {
      const b = u(S);
      return s[b];
    }
    a.numericToAlpha2 = k;
    function w(S) {
      if (typeof S == "string") {
        if (/^[0-9]*$/.test(S))
          return P(S);
        if (S.length === 2)
          return f(S.toUpperCase());
        if (S.length === 3)
          return S.toUpperCase();
      }
      if (typeof S == "number")
        return P(S);
    }
    a.toAlpha3 = w;
    function C(S) {
      if (typeof S == "string") {
        if (/^[0-9]*$/.test(S))
          return k(S);
        if (S.length === 2)
          return S.toUpperCase();
        if (S.length === 3)
          return m(S.toUpperCase());
      }
      if (typeof S == "number")
        return k(S);
    }
    a.toAlpha2 = C, a.getName = function(S, b, T = {}) {
      "select" in T || (T.select = "official");
      try {
        const A = e[b.toLowerCase()][C(S)];
        return p(T.select, A);
      } catch {
        return;
      }
    }, a.getNames = function(S, b = {}) {
      "select" in b || (b.select = "official");
      const T = e[S.toLowerCase()];
      return T === void 0 ? {} : d(T, function(D) {
        return p(b.select, D);
      });
    }, a.getAlpha2Code = function(S, b) {
      const T = (A) => A.toLowerCase(), D = (A, I) => T(A) === T(I);
      try {
        const A = e[b.toLowerCase()];
        for (const I in A)
          if (c(A, I)) {
            if (typeof A[I] == "string" && D(A[I], S))
              return I;
            if (Array.isArray(A[I])) {
              for (const K of A[I])
                if (D(K, S))
                  return I;
            }
          }
        return;
      } catch {
        return;
      }
    }, a.getSimpleAlpha2Code = function(S, b) {
      const T = (A) => t(A.toLowerCase()), D = (A, I) => T(A) === T(I);
      try {
        const A = e[b.toLowerCase()];
        for (const I in A)
          if (c(A, I)) {
            if (typeof A[I] == "string" && D(A[I], S))
              return I;
            if (Array.isArray(A[I])) {
              for (const K of A[I])
                if (D(K, S))
                  return I;
            }
          }
        return;
      } catch {
        return;
      }
    }, a.getAlpha2Codes = function() {
      return i;
    }, a.getAlpha3Code = function(S, b) {
      const T = a.getAlpha2Code(S, b);
      if (T)
        return a.toAlpha3(T);
    }, a.getSimpleAlpha3Code = function(S, b) {
      const T = a.getSimpleAlpha2Code(S, b);
      if (T)
        return a.toAlpha3(T);
    }, a.getAlpha3Codes = function() {
      return o;
    }, a.getNumericCodes = function() {
      return s;
    }, a.langs = function() {
      return Object.keys(e);
    }, a.getSupportedLanguages = function() {
      return n;
    }, a.isValid = function(S) {
      if (!S)
        return !1;
      const b = S.toString().toUpperCase();
      return c(o, b) || c(i, b) || c(s, b);
    };
  })(vr)), vr;
}
var id = nd();
const Kr = /* @__PURE__ */ ir(id), To = "ar", No = { AF: "أفغانستان", AL: "ألبانيا", DZ: "الجزائر", AS: "ساموا الأمريكية", AD: "أندورا", AO: "أنغولا", AI: "أنغويلا", AQ: "القارة القطبية الجنوبية", AG: "أنتيغوا وباربودا", AR: "الأرجنتين", AM: "أرمينيا", AW: "أروبا", AU: "أستراليا", AT: "النمسا", AZ: "أذربيجان", BS: "باهاماس", BH: "البحرين", BD: "بنغلاديش", BB: "باربادوس", BY: "روسيا البيضاء", BE: "بلجيكا", BZ: "بليز", BJ: "بنين", BM: "برمودا", BT: "بوتان", BO: "بوليفيا", BA: "البوسنة والهرسك", BW: "بوتسوانا", BV: "جزيرة بوفيه", BR: "البرازيل", IO: "إقليم المحيط الهندي البريطاني", BN: "بروناي", BG: "بلغاريا", BF: "بوركينا فاسو", BI: "بوروندي", KH: "كمبوديا", CM: "الكاميرون", CA: "كندا", CV: "الرأس الأخضر", KY: "جزر كايمان", CF: "جمهورية أفريقيا الوسطى", TD: "تشاد", CL: "تشيلي", CN: "الصين", CX: "جزيرة عيد الميلاد", CC: "جزر كوكوس", CO: "كولومبيا", KM: "جزر القمر", CG: "جمهورية الكونغو", CD: "جمهورية الكونغو الديمقراطية", CK: "جزر كوك", CR: "كوستاريكا", CI: "ساحل العاج", HR: "كرواتيا", CU: "كوبا", CY: "قبرص", CZ: "جمهورية التشيك", DK: "الدنمارك", DJ: "جيبوتي", DM: "دومينيكا", DO: "جمهورية الدومينيكان", EC: "الإكوادور", EG: "مصر", SV: "السلفادور", GQ: "غينيا الاستوائية", ER: "إريتريا", EE: "إستونيا", ET: "إثيوبيا", FK: "جزر فوكلاند", FO: "جزر فارو", FJ: "فيجي", FI: "فنلندا", FR: "فرنسا", GF: "غويانا الفرنسية", PF: "بولينزيا الفرنسية", TF: "أراض فرنسية جنوبية وأنتارتيكية", GA: "الغابون", GM: "غامبيا", GE: "جورجيا", DE: "ألمانيا", GH: "غانا", GI: "جبل طارق", GR: "اليونان", GL: "جرينلاند", GD: "غرينادا", GP: "غوادلوب", GU: "غوام", GT: "غواتيمالا", GN: "غينيا", GW: "غينيا بيساو", GY: "غيانا", HT: "هايتي", HM: "جزيرة هيرد وجزر ماكدونالد", VA: "الفاتيكان", HN: "هندوراس", HK: "هونغ كونغ", HU: "المجر", IS: "آيسلندا", IN: "الهند", ID: "إندونيسيا", IR: "إيران", IQ: "العراق", IE: "أيرلندا", IL: "إسرائيل", IT: "إيطاليا", JM: "جامايكا", JP: "اليابان", JO: "الأردن", KZ: "كازاخستان", KE: "كينيا", KI: "كيريباتي", KP: "كوريا الشمالية", KR: "كوريا الجنوبية", KW: "الكويت", KG: "قيرغيزستان", LA: "لاوس", LV: "لاتفيا", LB: "لبنان", LS: "ليسوتو", LR: "ليبيريا", LY: "ليبيا", LI: "ليختنشتاين", LT: "ليتوانيا", LU: "لوكسمبورغ", MO: "ماكاو", MK: "مقدونيا الشمالية", MG: "مدغشقر", MW: "مالاوي", MY: "ماليزيا", MV: "جزر المالديف", ML: "مالي", MT: "مالطا", MH: "جزر مارشال", MQ: "مارتينيك", MR: "موريتانيا", MU: "موريشيوس", YT: "مايوت", MX: "المكسيك", FM: "ولايات ميكرونيسيا المتحدة", MD: "مولدوفا", MC: "موناكو", MN: "منغوليا", MS: "مونتسرات", MA: "المغرب", MZ: "موزمبيق", MM: "بورما", NA: "ناميبيا", NR: "ناورو", NP: "نيبال", NL: "هولندا", NC: "كاليدونيا الجديدة", NZ: "نيوزيلندا", NI: "نيكاراغوا", NE: "النيجر", NG: "نيجيريا", NU: "نييوي", NF: "جزيرة نورفولك", MP: "جزر ماريانا الشمالية", NO: "النرويج", OM: "عمان", PK: "باكستان", PW: "بالاو", PS: "فلسطين", PA: "بنما", PG: "بابوا غينيا الجديدة", PY: "باراغواي", PE: "بيرو", PH: "الفلبين", PN: "جزر بيتكيرن", PL: "بولندا", PT: "البرتغال", PR: "بورتوريكو", QA: "قطر", RE: "لا ريونيون", RO: "رومانيا", RU: "روسيا", RW: "رواندا", SH: "سانت هيلينا وأسينشين وتريستان دا كونا", KN: "سانت كيتس ونيفيس", LC: "سانت لوسيا", PM: "سان بيير وميكلون", VC: "سانت فينسنت والغرينادين", WS: "ساموا", SM: "سان مارينو", ST: "ساو تومي وبرينسيب", SA: "السعودية", SN: "السنغال", SC: "سيشل", SL: "سيراليون", SG: "سنغافورة", SK: "سلوفاكيا", SI: "سلوفينيا", SB: "جزر سليمان", SO: "الصومال", ZA: "جنوب أفريقيا", GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية", ES: "إسبانيا", LK: "سريلانكا", SD: "السودان", SR: "سورينام", SJ: "سفالبارد ويان ماين", SZ: "سوازيلاند", SE: "السويد", CH: "سويسرا", SY: "سوريا", TW: "تايوان", TJ: "طاجيكستان", TZ: "تانزانيا", TH: "تايلاند", TL: "تيمور الشرقية", TG: "توغو", TK: "توكيلاو", TO: "تونغا", TT: "ترينيداد وتوباغو", TN: "تونس", TR: "تركيا", TM: "تركمانستان", TC: "جزر توركس وكايكوس", TV: "توفالو", UG: "أوغندا", UA: "أوكرانيا", AE: "الإمارات العربية المتحدة", GB: "المملكة المتحدة", US: "الولايات المتحدة", UM: "جزر الولايات المتحدة", UY: "الأوروغواي", UZ: "أوزبكستان", VU: "فانواتو", VE: "فنزويلا", VN: "فيتنام", VG: "جزر العذراء البريطانية", VI: "جزر العذراء الأمريكية", WF: "والس وفوتونا", EH: "الصحراء الغربية", YE: "اليمن", ZM: "زامبيا", ZW: "زيمبابوي", AX: "جزر أولاند", BQ: "الجزر الكاريبية الهولندية", CW: "كوراساو", GG: "غيرنزي", IM: "جزيرة مان", JE: "جيرزي", ME: "الجبل الأسود", BL: "سان بارتيلمي", MF: "سانت مارتن (الجزء الفرنسي)", RS: "صربيا", SX: "سانت مارتن (الجزء الهولندي)", SS: "جنوب السودان", XK: "كوسوفو" }, od = {
  locale: To,
  countries: No
}, sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: No,
  default: od,
  locale: To
}, Symbol.toStringTag, { value: "Module" })), Do = "cs", Ao = { AF: "Afghánistán", AX: "Ålandy", AL: "Albánie", DZ: "Alžírsko", AS: "Americká Samoa", VI: "Americké Panenské ostrovy", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktida", AG: "Antigua a Barbuda", AR: "Argentina", AM: "Arménie", AW: "Aruba", AU: "Austrálie", AZ: "Ázerbájdžán", BS: "Bahamy", BH: "Bahrajn", BD: "Bangladéš", BB: "Barbados", BE: "Belgie", BZ: "Belize", BY: "Bělorusko", BJ: "Benin", BM: "Bermudy", BT: "Bhútán", BO: "Bolívie", BQ: "Bonaire, Svatý Eustach a Saba", BA: "Bosna a Hercegovina", BW: "Botswana", BV: "Bouvetův ostrov", BR: "Brazílie", IO: "Britské indickooceánské území", VG: "Britské Panenské ostrovy", BN: "Brunej", BG: "Bulharsko", BF: "Burkina Faso", BI: "Burundi", CK: "Cookovy ostrovy", CW: "Curaçao", TD: "Čad", ME: "Černá Hora", CZ: "Česká republika", CN: "Čína", DK: "Dánsko", CD: "Demokratická republika Kongo", DM: "Dominika", DO: "Dominikánská republika", DJ: "Džibutsko", EG: "Egypt", EC: "Ekvádor", ER: "Eritrea", EE: "Estonsko", ET: "Etiopie", FO: "Faerské ostrovy", FK: "Falklandy (Malvíny)", FJ: "Fidži", PH: "Filipíny", FI: "Finsko", FR: "Francie", GF: "Francouzská Guyana", TF: "Francouzská jižní a antarktická území", PF: "Francouzská Polynésie", GA: "Gabon", GM: "Gambie", GH: "Ghana", GI: "Gibraltar", GD: "Grenada", GL: "Grónsko", GE: "Gruzie", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GG: "Guernsey", GY: "Guyana", HT: "Haiti", HM: "Heardův ostrov a McDonaldovy ostrovy", HN: "Honduras", HK: "Hongkong", CL: "Chile", HR: "Chorvatsko", IN: "Indie", ID: "Indonésie", IQ: "Irák", IR: "Írán", IE: "Irsko", IS: "Island", IT: "Itálie", IL: "Izrael", JM: "Jamajka", JP: "Japonsko", YE: "Jemen", JE: "Jersey", ZA: "Jihoafrická republika", GS: "Jižní Georgie a Jižní Sandwichovy ostrovy", KR: "Jižní Korea", SS: "Jižní Súdán", JO: "Jordánsko", KY: "Kajmanské ostrovy", KH: "Kambodža", CM: "Kamerun", CA: "Kanada", CV: "Kapverdy", QA: "Katar", KZ: "Kazachstán", KE: "Keňa", KI: "Kiribati", CC: "Kokosové ostrovy", CO: "Kolumbie", KM: "Komory", CG: "Kongo", CR: "Kostarika", CU: "Kuba", KW: "Kuvajt", CY: "Kypr", KG: "Kyrgyzstán", LA: "Laos", LS: "Lesotho", LB: "Libanon", LR: "Libérie", LY: "Libye", LI: "Lichtenštejnsko", LT: "Litva", LV: "Lotyšsko", LU: "Lucembursko", MO: "Macao", MG: "Madagaskar", HU: "Maďarsko", MY: "Malajsie", MW: "Malawi", MV: "Maledivy", ML: "Mali", MT: "Malta", IM: "Ostrov Man", MA: "Maroko", MH: "Marshallovy ostrovy", MQ: "Martinik", MU: "Mauricius", MR: "Mauritánie", YT: "Mayotte", UM: "Menší odlehlé ostrovy USA", MX: "Mexiko", FM: "Mikronésie", MD: "Moldavsko", MC: "Monako", MN: "Mongolsko", MS: "Montserrat", MZ: "Mosambik", MM: "Myanmar", NA: "Namibie", NR: "Nauru", DE: "Německo", NP: "Nepál", NE: "Niger", NG: "Nigérie", NI: "Nikaragua", NU: "Niue", NL: "Nizozemsko", NF: "Norfolk", NO: "Norsko", NC: "Nová Kaledonie", NZ: "Nový Zéland", OM: "Omán", PK: "Pákistán", PW: "Palau", PS: "Palestinská autonomie", PA: "Panama", PG: "Papua-Nová Guinea", PY: "Paraguay", PE: "Peru", PN: "Pitcairnovy ostrovy", CI: "Pobřeží slonoviny", PL: "Polsko", PR: "Portoriko", PT: "Portugalsko", AT: "Rakousko", RE: "Réunion", GQ: "Rovníková Guinea", RO: "Rumunsko", RU: "Rusko", RW: "Rwanda", GR: "Řecko", PM: "Saint-Pierre a Miquelon", SV: "Salvador", WS: "Samoa", SM: "San Marino", SA: "Saúdská Arábie", SN: "Senegal", KP: "Severní Korea", MK: "Severní Makedonie", MP: "Severní Mariany", SC: "Seychely", SL: "Sierra Leone", SG: "Singapur", SK: "Slovensko", SI: "Slovinsko", SO: "Somálsko", AE: "Spojené arabské emiráty", GB: "Spojené království", US: "Spojené státy americké", RS: "Srbsko", CF: "Středoafrická republika", SD: "Súdán", SR: "Surinam", SH: "Svatá Helena, Ascension a Tristan da Cunha", LC: "Svatá Lucie", BL: "Svatý Bartoloměj", KN: "Svatý Kryštof a Nevis", MF: "Svatý Martin (francouzská část)", SX: "Svatý Martin (nizozemská část)", ST: "Svatý Tomáš a Princův ostrov", VC: "Svatý Vincenc a Grenadiny", SZ: "Svazijsko", SY: "Sýrie", SB: "Šalamounovy ostrovy", ES: "Španělsko", SJ: "Špicberky a Jan Mayen", LK: "Šrí Lanka", SE: "Švédsko", CH: "Švýcarsko", TJ: "Tádžikistán", TZ: "Tanzanie", TH: "Thajsko", TW: "Tchaj-wan", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad a Tobago", TN: "Tunisko", TR: "Turecko", TM: "Turkmenistán", TC: "Turks a Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ukrajina", UY: "Uruguay", UZ: "Uzbekistán", CX: "Vánoční ostrov", VU: "Vanuatu", VA: "Vatikán", VE: "Venezuela", VN: "Vietnam", TL: "Východní Timor", WF: "Wallis a Futuna", ZM: "Zambie", EH: "Západní Sahara", ZW: "Zimbabwe", XK: "Kosovo" }, ld = {
  locale: Do,
  countries: Ao
}, ud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ao,
  default: ld,
  locale: Do
}, Symbol.toStringTag, { value: "Module" })), Io = "da", xo = { AF: "Afghanistan", AL: "Albanien", DZ: "Algeriet", AS: "Amerikansk Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua og Barbuda", AR: "Argentina", AM: "Armenien", AW: "Aruba", AU: "Australien", AT: "Østrig", AZ: "Aserbajdsjan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Hviderusland", BE: "Belgien", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnien-Hercegovina", BW: "Botswana", BV: "Bouvet Island", BR: "Brasilien", IO: "British Indian Ocean Territory", BN: "Brunei Darussalam", BG: "Bulgarien", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodja", CM: "Cameroun", CA: "Canada", CV: "Kap Verde", KY: "Caymanøerne", CF: "Den Centralafrikanske Republik", TD: "Tchad", CL: "Chile", CN: "Kina", CX: "Juløen", CC: "Cocosøerne", CO: "Colombia", KM: "Comorerne", CG: "Congo", CD: "Demokratiske Republik Congo", CK: "Cookøerne", CR: "Costa Rica", CI: "Elfenbenskysten", HR: "Kroatien", CU: "Cuba", CY: "Cypern", CZ: "Tjekkiet", DK: "Danmark", DJ: "Djibouti", DM: "Dominica", DO: "Dominikanske Republik", EC: "Ecuador", EG: "Egypten", SV: "El Salvador", GQ: "Ækvatorialguinea", ER: "Eritrea", EE: "Estland", ET: "Etiopien", FK: "Falklandsøerne", FO: "Færøerne", FJ: "Fiji", FI: "Finland", FR: "Frankrig", GF: "Fransk Guiana", PF: "Fransk Polynesien", TF: "Franske Sydterritorier", GA: "Gabon", GM: "Gambia", GE: "Georgien", DE: "Tyskland", GH: "Ghana", GI: "Gibraltar", GR: "Grækenland", GL: "Grønland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard-øen og McDonald-øerne", VA: "Vatikanstaten", HN: "Honduras", HK: "Hong Kong", HU: "Ungarn", IS: "Island", IN: "Indien", ID: "Indonesien", IR: "Iran", IQ: "Irak", IE: "Irland", IL: "Israel", IT: "Italien", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Nordkorea", KR: "Sydkorea", KW: "Kuwait", KG: "Kirgisistan", LA: "Laos", LV: "Letland", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libyen", LI: "Liechtenstein", LT: "Litauen", LU: "Luxembourg", MO: "Macao", MK: "Nordmakedonien", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldiverne", ML: "Mali", MT: "Malta", MH: "Marshalløerne", MQ: "Martinique", MR: "Mauretanien", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Mikronesien", MD: "Moldova", MC: "Monaco", MN: "Mongoliet", MS: "Montserrat", MA: "Marokko", MZ: "Mozambique", MM: "Myanmar (Burma)", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Holland", NC: "Ny Kaledonien", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk Island", MP: "Nordmarianerne", NO: "Norge", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palæstina", PA: "Panama", PG: "Papua Ny Guinea", PY: "Paraguay", PE: "Peru", PH: "Filippinerne", PN: "Pitcairn", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Rumænien", RU: "Rusland", RW: "Rwanda", SH: "Sankt Helena", KN: "Saint Kitts og Nevis", LC: "Saint Lucia", PM: "Saint-Pierre og Miquelon", VC: "Saint Vincent og Grenadinerne", WS: "Samoa", SM: "San Marino", ST: "São Tomé og Príncipe", SA: "Saudi-Arabien", SN: "Senegal", SC: "Seychellerne", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakiet", SI: "Slovenien", SB: "Salomonøerne", SO: "Somalia", ZA: "Sydafrika", GS: "South Georgia og South Sandwich Islands", ES: "Spanien", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Norge Svalbard og Jan Mayen", SZ: "Eswatini", SE: "Sverige", CH: "Schweiz", SY: "Syrien", TW: "Republikken Kina Taiwan", TJ: "Tadsjikistan", TZ: "Tanzania", TH: "Thailand", TL: "Østtimor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad og Tobago", TN: "Tunesien", TR: "Tyrkiet", TM: "Turkmenistan", TC: "Turks- og Caicosøerne", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", AE: "Forenede Arabiske Emirater", GB: "Storbritannien", US: "USA", UM: "USA's ydre småøer", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Britiske Jomfruøer", VI: "Amerikanske Jomfruøer", WF: "Wallis og Futuna", EH: "Vestsahara", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Ålandsøerne", BQ: "Nederlandske Antiller", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint-Barthélemy", MF: "Saint Martin (fransk side)", RS: "Serbien", SX: "Saint Martin (hollandsk side)", SS: "Sydsudan", XK: "Kosovo" }, cd = {
  locale: Io,
  countries: xo
}, dd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: xo,
  default: cd,
  locale: Io
}, Symbol.toStringTag, { value: "Module" })), Eo = "de", Bo = { AF: "Afghanistan", EG: "Ägypten", AX: "Åland", AL: "Albanien", DZ: "Algerien", AS: "Amerikanisch-Samoa", VI: "Amerikanische Jungferninseln", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua und Barbuda", GQ: "Äquatorialguinea", AR: "Argentinien", AM: "Armenien", AW: "Aruba", AZ: "Aserbaidschan", ET: "Äthiopien", AU: "Australien", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesch", BB: "Barbados", BY: "Belarus", BE: "Belgien", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivien", BQ: "Bonaire", BA: "Bosnien und Herzegowina", BW: "Botswana", BV: "Bouvetinsel", BR: "Brasilien", VG: "Britische Jungferninseln", IO: "Britisches Territorium im Indischen Ozean", BN: "Brunei Darussalam", BG: "Bulgarien", BF: "Burkina Faso", BI: "Burundi", CL: "Chile", CN: "China", CK: "Cookinseln", CR: "Costa Rica", CI: "Elfenbeinküste", CW: "Curaçao", DK: "Dänemark", DE: "Deutschland", DM: "Dominica", DO: "Dominikanische Republik", DJ: "Dschibuti", EC: "Ecuador", SV: "El Salvador", ER: "Eritrea", EE: "Estland", FK: "Falklandinseln", FO: "Färöer", FJ: "Fidschi", FI: "Finnland", FR: "Frankreich", GF: "Französisch-Guayana", PF: "Französisch-Polynesien", TF: "Französische Süd- und Antarktisgebiete", GA: "Gabun", GM: "Gambia", GE: "Georgien", GH: "Ghana", GI: "Gibraltar", GD: "Grenada", GR: "Griechenland", GL: "Grönland", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GG: "Guernsey", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard und McDonaldinseln", HN: "Honduras", HK: ["Hongkong", "Hong Kong"], IN: "Indien", ID: "Indonesien", IM: "Insel Man", IQ: "Irak", IR: "Iran", IE: "Irland", IS: "Island", IL: "Israel", IT: "Italien", JM: "Jamaika", JP: "Japan", YE: "Jemen", JE: "Jersey", JO: "Jordanien", KY: "Kaimaninseln", KH: "Kambodscha", CM: "Kamerun", CA: "Kanada", CV: "Kap Verde", KZ: "Kasachstan", QA: "Katar", KE: "Kenia", KG: "Kirgisistan", KI: "Kiribati", CC: "Kokosinseln", CO: "Kolumbien", KM: "Komoren", CD: "Kongo", KP: "Nordkorea", KR: "Südkorea", HR: "Kroatien", CU: "Kuba", KW: "Kuwait", LA: "Laos", LS: "Lesotho", LV: "Lettland", LB: "Libanon", LR: "Liberia", LY: "Libyen", LI: "Liechtenstein", LT: "Litauen", LU: "Luxemburg", MO: "Macao", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Malediven", ML: "Mali", MT: "Malta", MA: "Marokko", MH: "Marshallinseln", MQ: "Martinique", MR: "Mauretanien", MU: "Mauritius", YT: "Mayotte", MX: "Mexiko", FM: "Mikronesien", MD: "Moldawien", MC: "Monaco", MN: "Mongolei", ME: "Montenegro", MS: "Montserrat", MZ: "Mosambik", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NC: "Neukaledonien", NZ: "Neuseeland", NI: "Nicaragua", NL: "Niederlande", NE: "Niger", NG: "Nigeria", NU: "Niue", MK: "Nordmazedonien", MP: "Nördliche Marianen", NF: "Norfolkinsel", NO: "Norwegen", OM: "Oman", AT: "Österreich", TL: "Osttimor", PK: "Pakistan", PS: "Staat Palästina", PW: "Palau", PA: "Panama", PG: "Papua-Neuguinea", PY: "Paraguay", PE: "Peru", PH: "Philippinen", PN: "Pitcairninseln", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", TW: "Taiwan", CG: "Republik Kongo", RE: "Réunion", RW: "Ruanda", RO: "Rumänien", RU: ["Russische Föderation", "Russland"], BL: "Saint-Barthélemy", MF: "Saint-Martin", SB: "Salomonen", ZM: "Sambia", WS: "Samoa", SM: "San Marino", ST: "São Tomé und Príncipe", SA: "Saudi-Arabien", SE: "Schweden", CH: "Schweiz", SN: "Senegal", RS: "Serbien", SC: "Seychellen", SL: "Sierra Leone", ZW: "Simbabwe", SG: "Singapur", SX: "Sint Maarten", SK: "Slowakei", SI: "Slowenien", SO: "Somalia", ES: "Spanien", LK: "Sri Lanka", SH: "St. Helena", KN: "St. Kitts und Nevis", LC: "St. Lucia", PM: "Saint-Pierre und Miquelon", VC: "St. Vincent und die Grenadinen", ZA: "Südafrika", SD: "Sudan", GS: "Südgeorgien und die Südlichen Sandwichinseln", SS: "Südsudan", SR: "Suriname", SJ: "Svalbard und Jan Mayen", SZ: "Eswatini", SY: "Syrien, Arabische Republik", TJ: "Tadschikistan", TZ: ["Tansania, Vereinigte Republik", "Tansania"], TH: "Thailand", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad und Tobago", TD: "Tschad", CZ: ["Tschechische Republik", "Tschechien"], TN: "Tunesien", TR: "Türkei", TM: "Turkmenistan", TC: "Turks- und Caicosinseln", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", HU: "Ungarn", UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VA: "Vatikanstadt", VE: "Venezuela", AE: "Vereinigte Arabische Emirate", US: ["Vereinigte Staaten von Amerika", "Vereinigte Staaten", "USA"], GB: ["Vereinigtes Königreich", "Großbritannien"], VN: "Vietnam", WF: "Wallis und Futuna", CX: "Weihnachtsinsel", EH: "Westsahara", CF: "Zentralafrikanische Republik", CY: "Zypern", XK: "Kosovo" }, pd = {
  locale: Eo,
  countries: Bo
}, md = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Bo,
  default: pd,
  locale: Eo
}, Symbol.toStringTag, { value: "Module" })), Oo = "el", Go = { AF: "Αφγανιστάν", AL: "Αλβανία", DZ: "Αλγερία", AS: "Αμερικανική Σαμόα", AD: "Ανδόρρα", AO: "Ανγκόλα", AI: "Ανγκουίλα", AQ: "Ανταρκτική", AG: "Αντίγκουα και Μπαρμπούντα", AR: "Αργεντινή", AM: "Αρμενία", AW: "Αρούμπα", AU: "Αυστραλία", AT: "Αυστρία", AZ: "Αζερμπαϊτζάν", BS: "Μπαχάμες", BH: "Μπαχρέιν", BD: "Μπανγκλαντές", BB: "Μπαρμπάντος", BY: "Λευκορωσία", BE: "Βέλγιο", BZ: "Μπελίζ", BJ: "Μπενίν", BM: "Βερμούδες", BT: "Μπουτάν", BO: "Βολιβία", BA: "Βοσνία και Ερζεγοβίνη", BW: "Μποτσουάνα", BV: "Μπουβέ", BR: "Βραζιλία", IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού", BN: "Σουλτανάτο του Μπρουνέι", BG: "Βουλγαρία", BF: "Μπουρκίνα Φάσο", BI: "Μπουρουντί", KH: "Καμπότζη", CM: "Καμερούν", CA: "Καναδάς", CV: ["Δημοκρατία του Πράσινου Ακρωτηρίου", "Πράσινο Ακρωτήριο"], KY: "Κέιμαν Νήσοι", CF: "Κεντροαφρικανική Δημοκρατία", TD: "Τσάντ", CL: "Χιλή", CN: "Κίνα", CX: "Νήσος των Χριστουγέννων", CC: "Νησιά Κόκος", CO: "Κολομβία", KM: "Ένωση των Κομορών", CG: ["Δημοκρατία του Κονγκό", "Κονγκό"], CD: "Λαϊκή Δημοκρατία του Κονγκό", CK: "Νήσοι Κουκ", CR: "Κόστα Ρίκα", CI: "Ακτή Ελεφαντοστού", HR: "Κροατία", CU: "Κούβα", CY: "Κύπρος", CZ: ["Τσεχική Δημοκρατία", "Τσεχία"], DK: "Δανία", DJ: "Τζιμπουτί", DM: ["Κοινοπολιτεία της Δομινίκας", "Ντομίνικα"], DO: "Δομινικανή Δημοκρατία", EC: "Εκουαδόρ", EG: "Αίγυπτος", SV: "Ελ Σαλβαδόρ", GQ: "Ισημερινή-Γουινέα", ER: ["Κράτος της Ερυθραίας", "Ερυθραία"], EE: "Εσθονία", ET: "Αιθιοπία", FK: "Νήσοι Φώκλαντ (Μαλβίνας)", FO: "Νήσοι Φερόες", FJ: "Δημοκρατία των Φίτζι", FI: "Φινλανδία", FR: "Γαλλία", GF: "Γαλλική Γουιάνα", PF: "Γαλλική Πολυνησία", TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη", GA: "Γκαμπόν", GM: "Γκάμπια", GE: "Γεωργία", DE: "Γερμανία", GH: "Γκάνα", GI: "Γιβραλτάρ", GR: "Ελλάδα", GL: "Γροιλανδία", GD: "Γρενάδα", GP: "Γουαδελούπη", GU: "Γκουάμ", GT: "Γουατεμάλα", GN: "Γουινέα", GW: "Γουινέα-Μπισσάου", GY: "Γουιάνα", HT: "Αϊτη", HM: "Νήσοι Χερντ και Μακντόναλντ", VA: ["Κράτος της Πόλης του Βατικανού", "Βατικανό"], HN: "Ονδούρα", HK: "Χονγκ Κόνγκ", HU: "Ουγγαρία", IS: "Ισλανδία", IN: "Ινδία", ID: "Ινδονησία", IR: ["Ισλαμική Δημοκρατία του Ιράν", "Ιράν"], IQ: "Ιράκ", IE: "Ιρλανδία", IL: "Ισραήλ", IT: "Ιταλία", JM: "Τζαμάικα", JP: "Ιαπωνία", JO: "Ιορδανία", KZ: "Καζακστάν", KE: "Κένυα", KI: "Κιριμπάτι", KP: ["Λαοκρατική Δημοκρατία της Κορέας", "Βόρεια Κορέα"], KR: ["Δημοκρατία της Κορέας", "Νότια Κορέα"], KW: "Κουβέιτ", KG: "Κιργιζία", LA: ["Λαϊκή Δημοκρατία του Λάος", "Λάος"], LV: "Λετονία", LB: "Λίβανο", LS: ["Βασίλειο του Λεσότο", "Λεσότο"], LR: "Λιβερία", LY: ["Κράτος της Λιβύης", "Λιβύη"], LI: ["Πριγκιπάτο του Λίχτενσταϊν", "Λίχτενσταϊν"], LT: "Λιθουανία", LU: "Λουξεμβούργο", MO: "Μακάου", MK: ["Δημοκρατία της Βόρειας Μακεδονίας", "Βόρεια Μακεδονία"], MG: "Μαδαγασκάρη", MW: "Μαλάουι", MY: "Μαλαισία", MV: "Μαλβίδες", ML: "Μαλί", MT: "Μάλτα", MH: "Νήσοι Μάρσαλ", MQ: "Μαρτινίκα", MR: "Μαυριτανία", MU: "Μαυρίκιος", YT: "Μαγιότ", MX: "Μεξικό", FM: ["Ομόσπονδες Πολιτείες της Μικρονησίας", "Μικρονησία"], MD: ["Δημοκρατία της Μολδαβίας", "Μολδαβία"], MC: ["Πριγκιπάτο του Μονακό", "Μονακό"], MN: "Μογγολία", MS: "Μοντσερράτ", MA: "Μαρόκο", MZ: "Μοζαμβίκη", MM: "Μιανμάρ", NA: "Ναμίμπια", NR: "Ναουρού", NP: "Νεπάλ", NL: "Ολλανδία", NC: "Νέα Καληδονία", NZ: "Νέα Ζηλανδία", NI: "Νικαράγουα", NE: "Νίγηρας", NG: "Νιγηρία", NU: "Νιούε", NF: "Νησί Νόρφολκ", MP: "Βόρειες Μαριάνες Νήσοι", NO: "Νορβηγία", OM: "Ομάν", PK: "Πακιστάν", PW: "Παλάου", PS: ["Κράτος της Παλαιστίνης", "Παλαιστίνη"], PA: "Παναμάς", PG: "Παπούα Νέα Γουινέα", PY: "Παραγουάη", PE: "Περού", PH: "Φιλιππίνες", PN: "Νήσοι Πίτκαιρν", PL: "Πολωνία", PT: "Πορτογαλία", PR: "Πουέρτο Ρίκο", QA: "Κατάρ", RE: "Ρεϋνιόν", RO: "Ρουμανία", RU: ["Ρωσική Ομοσπονδία", "Ρωσία"], RW: "Ρουάντα", SH: "Νήσος Αγίας Ελένης", KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις", LC: "Αγία Λουκία", PM: "Σαιν Πιερ και Μικελόν", VC: "Άγιος Βικέντιος και Γρεναδίνες", WS: "Σαμόα", SM: "Άγιος Μαρίνος", ST: "Σάο Τομέ και Πρίνσιπε", SA: "Σαουδική Αραβία", SN: "Σενεγάλη", SC: "Σεϋχέλλες", SL: "Σιέρα Λεόνε", SG: "Σιγκαπούρη", SK: "Σλοβακία", SI: "Σλοβενία", SB: "Νήσοι Σολομώντα", SO: "Σομαλία", ZA: "Νότια Αφρική", GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι", ES: "Ισπανία", LK: "Σρι Λάνκα", SD: "Σουδάν", SR: "Σουρινάμ", SJ: "Σβάλμπαρντ και Γιαν Μαγιέν", SZ: "Σουαζιλάνδη", SE: "Σουηδία", CH: "Ελβετία", SY: ["Αραβική Δημοκρατία της Συρίας", "Συρία"], TW: "Δημοκρατία της Κίνας", TJ: "Τατζικιστάν", TZ: ["Ενωμένη Δημοκρατία της Τανζανίας", "Τανζανία"], TH: "Ταϊλάνδη", TL: "Ανατολικό Τιμόρ", TG: "Τογκό", TK: "Τοκελάου", TO: "Τόνγκα", TT: "Τρινιντάντ και Τομπάγκο", TN: "Τυνησία", TR: "Τουρκία", TM: "Τουρκμενιστάν", TC: "Τερκς και Κέικος", TV: "Τουβαλού", UG: "Ουγκάντα", UA: "Ουκρανια", AE: "Ηνωμένα Αραβικά Εμιράτα", GB: "Ηνωμένο Βασίλειο", US: ["Ηνωμένες Πολιτείες Αμερικής", "Αμερική", "ΗΠΑ"], UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών", UY: "Ουρουγουάη", UZ: "Ουζμπεκιστάν", VU: "Βανουάτου", VE: "Βενεζουέλα", VN: "Βιετνάμ", VG: "Βρετανικές Παρθένοι Νήσοι", VI: "Αμερικανικές Παρθένοι Νήσοι", WF: "Ουαλίς και Φουτουνά", EH: "Δυτική Σαχάρα", YE: "Υεμένη", ZM: "Ζάμπια", ZW: "Ζιμπάμπουε", AX: "Νήσοι Ώλαντ", BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα", CW: "Κουρασάο", GG: "Γκουέρνσεϊ", IM: "Νήσος του Μαν", JE: "Βαϊλάτο του Τζέρσεϊ", ME: "Μαυροβούνιο", BL: "Άγιος Βαρθολομαίος", MF: "Άγιος Μαρτίνος (Γαλλία)", RS: "Σερβία", SX: "Άγιος Μαρτίνος (Ολλανδία)", SS: "Νότιο Σουδάν", XK: "Κόσοβο" }, hd = {
  locale: Oo,
  countries: Go
}, fd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Go,
  default: hd,
  locale: Oo
}, Symbol.toStringTag, { value: "Module" })), Lo = "en", Ro = { AF: "Afghanistan", AL: "Albania", DZ: "Algeria", AS: "American Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua and Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaijan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Belarus", BE: "Belgium", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia and Herzegovina", BW: "Botswana", BV: "Bouvet Island", BR: "Brazil", IO: "British Indian Ocean Territory", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodia", CM: "Cameroon", CA: "Canada", CV: "Cape Verde", KY: "Cayman Islands", CF: "Central African Republic", TD: "Chad", CL: "Chile", CN: ["People's Republic of China", "China"], CX: "Christmas Island", CC: "Cocos (Keeling) Islands", CO: "Colombia", KM: "Comoros", CG: ["Republic of the Congo", "Congo"], CD: ["Democratic Republic of the Congo", "Congo"], CK: "Cook Islands", CR: "Costa Rica", CI: ["Cote d'Ivoire", "Côte d'Ivoire", "Ivory Coast"], HR: "Croatia", CU: "Cuba", CY: "Cyprus", CZ: ["Czech Republic", "Czechia"], DK: "Denmark", DJ: "Djibouti", DM: "Dominica", DO: "Dominican Republic", EC: "Ecuador", EG: "Egypt", SV: "El Salvador", GQ: "Equatorial Guinea", ER: "Eritrea", EE: "Estonia", ET: "Ethiopia", FK: "Falkland Islands (Malvinas)", FO: "Faroe Islands", FJ: "Fiji", FI: "Finland", FR: "France", GF: "French Guiana", PF: "French Polynesia", TF: "French Southern Territories", GA: "Gabon", GM: ["Republic of The Gambia", "The Gambia", "Gambia"], GE: "Georgia", DE: "Germany", GH: "Ghana", GI: "Gibraltar", GR: "Greece", GL: "Greenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard Island and McDonald Islands", VA: "Holy See (Vatican City State)", HN: "Honduras", HK: "Hong Kong", HU: "Hungary", IS: "Iceland", IN: "India", ID: "Indonesia", IR: ["Islamic Republic of Iran", "Iran"], IQ: "Iraq", IE: "Ireland", IL: "Israel", IT: "Italy", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "North Korea", KR: ["South Korea", "Korea, Republic of", "Republic of Korea"], KW: "Kuwait", KG: "Kyrgyzstan", LA: "Lao People's Democratic Republic", LV: "Latvia", LB: "Lebanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Lithuania", LU: "Luxembourg", MO: "Macao", MG: "Madagascar", MW: "Malawi", MY: "Malaysia", MV: "Maldives", ML: "Mali", MT: "Malta", MH: "Marshall Islands", MQ: "Martinique", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Micronesia, Federated States of", MD: "Moldova, Republic of", MC: "Monaco", MN: "Mongolia", MS: "Montserrat", MA: "Morocco", MZ: "Mozambique", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"], NC: "New Caledonia", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk Island", MK: ["The Republic of North Macedonia", "North Macedonia"], MP: "Northern Mariana Islands", NO: "Norway", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: ["State of Palestine", "Palestine"], PA: "Panama", PG: "Papua New Guinea", PY: "Paraguay", PE: "Peru", PH: "Philippines", PN: ["Pitcairn", "Pitcairn Islands"], PL: "Poland", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Reunion", RO: "Romania", RU: ["Russian Federation", "Russia"], RW: "Rwanda", SH: "Saint Helena", KN: "Saint Kitts and Nevis", LC: "Saint Lucia", PM: "Saint Pierre and Miquelon", VC: "Saint Vincent and the Grenadines", WS: "Samoa", SM: "San Marino", ST: "Sao Tome and Principe", SA: "Saudi Arabia", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakia", SI: "Slovenia", SB: "Solomon Islands", SO: "Somalia", ZA: "South Africa", GS: "South Georgia and the South Sandwich Islands", ES: "Spain", LK: "Sri Lanka", SD: "Sudan", SR: "Suriname", SJ: "Svalbard and Jan Mayen", SZ: "Eswatini", SE: "Sweden", CH: "Switzerland", SY: "Syrian Arab Republic", TW: ["Taiwan, Province of China", "Taiwan"], TJ: "Tajikistan", TZ: ["United Republic of Tanzania", "Tanzania"], TH: "Thailand", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad and Tobago", TN: "Tunisia", TR: ["Türkiye", "Turkey"], TM: "Turkmenistan", TC: "Turks and Caicos Islands", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", AE: ["United Arab Emirates", "UAE"], GB: ["United Kingdom", "UK", "Great Britain"], US: ["United States of America", "United States", "USA", "U.S.A.", "US", "U.S."], UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Virgin Islands, British", VI: "Virgin Islands, U.S.", WF: "Wallis and Futuna", EH: "Western Sahara", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabwe", AX: ["Åland Islands", "Aland Islands"], BQ: "Bonaire, Sint Eustatius and Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (French part)", RS: "Serbia", SX: "Sint Maarten (Dutch part)", SS: "South Sudan", XK: "Kosovo" }, gd = {
  locale: Lo,
  countries: Ro
}, _d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ro,
  default: gd,
  locale: Lo
}, Symbol.toStringTag, { value: "Module" })), Fo = "es", Ko = { AF: "Afganistán", AL: "Albania", DZ: "Argelia", AS: "Samoa Americana", AD: "Andorra", AO: "Angola", AI: "Anguila", AQ: "Antártida", AG: "Antigua y Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaiyán", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Bielorrusia", BE: "Bélgica", BZ: "Belice", BJ: "Benin", BM: "Bermudas", BT: "Bután", BO: "Bolivia", BA: "Bosnia y Herzegovina", BW: "Botswana", BV: "Isla Bouvet", BR: "Brasil", IO: "Territorio Británico del Océano Índico", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Camboya", CM: "Camerún", CA: "Canadá", CV: "Cabo Verde", KY: "Islas Caimán", CF: "República Centroafricana", TD: "Chad", CL: "Chile", CN: "China", CX: "Isla de Navidad", CC: "Islas Cocos (Keeling)", CO: "Colombia", KM: "Comoras", CG: "Congo", CD: "Congo (República Democrática del)", CK: "Islas Cook", CR: "Costa Rica", CI: "Costa de Marfil", HR: "Croacia", CU: "Cuba", CY: "Chipre", CZ: "República Checa", DK: "Dinamarca", DJ: "Yibuti", DM: "Dominica", DO: "República Dominicana", EC: "Ecuador", EG: "Egipto", SV: "El Salvador", GQ: "Guinea Ecuatorial", ER: "Eritrea", EE: "Estonia", ET: "Etiopía", FK: "Islas Malvinas", FO: "Islas Feroe", FJ: "Fiji", FI: "Finlandia", FR: "Francia", GF: "Guayana Francesa", PF: "Polinesia Francesa", TF: "Tierras Australes Francesas", GA: "Gabón", GM: "Gambia", GE: "Georgia", DE: "Alemania", GH: "Ghana", GI: "Gibraltar", GR: "Grecia", GL: "Groenlandia", GD: "Granada", GP: "Guadalupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea Bissau", GY: "Guyana", HT: "Haití", HM: "Heard e Islas McDonald", VA: "Santa Sede", HN: "Honduras", HK: "Hong Kong", HU: "Hungría", IS: "Islandia", IN: "India", ID: "Indonesia", IR: ["Irán", "República Islámica de Irán"], IQ: "Iraq", IE: "Irlanda", IL: "Israel", IT: "Italia", JM: "Jamaica", JP: "Japón", JO: "Jordania", KZ: "Kazajistán", KE: "Kenia", KI: "Kiribati", KP: "República Popular Democrática de Corea", KR: "República de Corea", KW: "Kuwait", KG: "Kirguistán", LA: "República Democrática Popular de Lao", LV: "Letonia", LB: "Líbano", LS: "Lesoto", LR: "Liberia", LY: "Libia", LI: "Liechtenstein", LT: "Lituania", LU: "Luxemburgo", MO: "Macao", MK: "Macedonia del Norte", MG: "Madagascar", MW: "Malaui", MY: "Malasia", MV: "Maldivas", ML: "Malí", MT: "Malta", MH: "Islas Marshall", MQ: "Martinica", MR: "Mauritania", MU: "Mauricio", YT: "Mayotte", MX: "México", FM: "Micronesia", MD: "Moldavia", MC: "Mónaco", MN: "Mongolia", MS: "Montserrat", MA: "Marruecos", MZ: "Mozambique", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Países Bajos", NC: "Nueva Caledonia", NZ: "Nueva Zelanda", NI: "Nicaragua", NE: "Níger", NG: "Nigeria", NU: "Niue", NF: "Isla Norfolk", MP: "Islas Marianas del Norte", NO: "Noruega", OM: "Omán", PK: "Pakistán", PW: "Palau", PS: "Palestina", PA: "Panamá", PG: "Papua Nueva Guinea", PY: "Paraguay", PE: "Perú", PH: "Filipinas", PN: "Pitcairn", PL: "Polonia", PT: "Portugal", PR: "Puerto Rico", QA: "Catar", RE: "Reunión", RO: "Rumanía", RU: "Rusia", RW: "Ruanda", SH: "Santa Helena, Ascensión y Tristán de Acuña", KN: "Saint Kitts y Nevis", LC: "Santa Lucía", PM: "San Pedro y Miquelón", VC: "San Vicente y las Granadinas", WS: "Samoa", SM: "San Marino", ST: "Santo Tomé y Príncipe", SA: "Arabia Saudita", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leona", SG: "Singapur", SK: "Eslovaquia", SI: "Eslovenia", SB: "Islas Salomón", SO: "Somalia", ZA: "Sudáfrica", GS: "Georgia del Sur y las Islas Sandwich del Sur", ES: "España", LK: "Sri Lanka", SD: "Sudán", SR: "Suriname", SJ: "Svalbard y Jan Mayen", SZ: "Esuatini", SE: "Suecia", CH: "Suiza", SY: "República Árabe Siria", TW: "Taiwán", TJ: "Tayikistán", TZ: "Tanzania", TH: "Tailandia", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad y Tobago", TN: "Túnez", TR: "Turquía", TM: "Turkmenistán", TC: "Islas Turcas y Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ucrania", AE: "Emiratos Árabes Unidos", GB: "Reino Unido", US: "Estados Unidos", UM: "Islas Ultramarinas Menores de los Estados Unidos", UY: "Uruguay", UZ: "Uzbekistán", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Islas Vírgenes británicas", VI: "Islas Vírgenes de los Estados Unidos", WF: "Wallis y Futuna", EH: "Sahara Occidental", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabue", AX: "Islas Åland", BQ: "Bonaire, San Eustaquio y Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isla de Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (francesa)", RS: "Serbia", SX: "Sint Maarten (neerlandesa)", SS: "Sudán del Sur", XK: "Kosovo" }, yd = {
  locale: Fo,
  countries: Ko
}, vd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ko,
  default: yd,
  locale: Fo
}, Symbol.toStringTag, { value: "Module" })), Ho = "fr", Uo = { AF: "Afghanistan", AL: "Albanie", DZ: "Algérie", AS: "Samoa américaines", AD: "Andorre", AO: "Angola", AI: "Anguilla", AQ: "Antarctique", AG: "Antigua-et-Barbuda", AR: "Argentine", AM: "Arménie", AW: "Aruba", AU: "Australie", AT: "Autriche", AZ: "Azerbaïdjan", BS: "Bahamas", BH: "Bahreïn", BD: "Bangladesh", BB: "Barbade", BY: "Biélorussie", BE: "Belgique", BZ: "Belize", BJ: "Bénin", BM: "Bermudes", BT: "Bhoutan", BO: "Bolivie", BA: "Bosnie-Herzégovine", BW: "Botswana", BV: "Île Bouvet", BR: "Brésil", IO: "Océan Indien Britannique", BN: "Brunei Darussalam", BG: "Bulgarie", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodge", CM: "Cameroun", CA: "Canada", CV: "Cap-Vert", KY: "Îles Caïmans", CF: "République Centrafricaine", TD: "Tchad", CL: "Chili", CN: "Chine", CX: "Île Christmas", CC: "Îles Cocos", CO: "Colombie", KM: "Comores", CG: "République du Congo", CD: "République démocratique du Congo", CK: "Îles Cook", CR: "Costa Rica", CI: "Côte-d'Ivoire", HR: "Croatie", CU: "Cuba", CY: "Chypre", CZ: "République Tchèque", DK: "Danemark", DJ: "Djibouti", DM: "Dominique", DO: "République Dominicaine", EC: "Équateur", EG: "Égypte", SV: "El Salvador", GQ: "Guinée équatoriale", ER: "Érythrée", EE: "Estonie", ET: "Éthiopie", FK: "Îles Malouines", FO: "Îles Féroé", FJ: "Fidji", FI: "Finlande", FR: "France", GF: "Guyane française", PF: "Polynésie française", TF: "Terres australes françaises", GA: "Gabon", GM: "Gambie", GE: "Géorgie", DE: "Allemagne", GH: "Ghana", GI: "Gibraltar", GR: "Grèce", GL: "Groenland", GD: "Grenade", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinée", GW: "Guinée-Bissau", GY: "Guyana", HT: "Haïti", HM: "Îles Heard-et-MacDonald", VA: "Saint-Siège (Vatican)", HN: "Honduras", HK: "Hong Kong", HU: "Hongrie", IS: "Islande", IN: "Inde", ID: "Indonésie", IR: "Iran", IQ: "Irak", IE: "Irlande", IL: "Israël", IT: "Italie", JM: "Jamaïque", JP: "Japon", JO: "Jordanie", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Corée du Nord", KR: "Corée du Sud", KW: "Koweït", KG: "Kirghizistan", LA: "Laos", LV: "Lettonie", LB: "Liban", LS: "Lesotho", LR: "Libéria", LY: "Libye", LI: "Liechtenstein", LT: "Lituanie", LU: "Luxembourg", MO: "Macao", MK: "Macédoine du Nord", MG: "Madagascar", MW: "Malawi", MY: "Malaisie", MV: "Maldives", ML: "Mali", MT: "Malte", MH: "Îles Marshall", MQ: "Martinique", MR: "Mauritanie", MU: "Maurice", YT: "Mayotte", MX: "Mexique", FM: "Micronésie", MD: "Moldavie", MC: "Monaco", MN: "Mongolie", MS: "Montserrat", MA: "Maroc", MZ: "Mozambique", MM: "Myanmar", NA: "Namibie", NR: "Nauru", NP: "Népal", NL: "Pays-Bas", NC: "Nouvelle-Calédonie", NZ: "Nouvelle-Zélande", NI: "Nicaragua", NE: "Niger", NG: "Nigéria", NU: "Niué", NF: "Île Norfolk", MP: "Îles Mariannes du Nord", NO: "Norvège", OM: "Oman", PK: "Pakistan", PW: "Palaos", PS: "Palestine", PA: "Panama", PG: "Papouasie-Nouvelle-Guinée", PY: "Paraguay", PE: "Pérou", PH: "Philippines", PN: "Îles Pitcairn", PL: "Pologne", PT: "Portugal", PR: "Porto Rico", QA: "Qatar", RE: "Réunion", RO: "Roumanie", RU: "Russie", RW: "Rwanda", SH: "Sainte-Hélène", KN: "Saint-Christophe-et-Niévès", LC: "Sainte-Lucie", PM: "Saint-Pierre-et-Miquelon", VC: "Saint-Vincent-et-les-Grenadines", WS: "Samoa", SM: "Saint-Marin", ST: "São Tomé-et-Principe", SA: "Arabie Saoudite", SN: "Sénégal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapour", SK: "Slovaquie", SI: "Slovénie", SB: "Îles Salomon", SO: "Somalie", ZA: "Afrique du Sud", GS: "Géorgie du Sud-et-les Îles Sandwich du Sud", ES: "Espagne", LK: "Sri Lanka", SD: "Soudan", SR: "Suriname", SJ: "Svalbard et Île Jan Mayen", SZ: "Royaume d'Eswatini", SE: "Suède", CH: "Suisse", SY: "Syrie", TW: "Taïwan", TJ: "Tadjikistan", TZ: "République unie de Tanzanie", TH: "Thaïlande", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinité-et-Tobago", TN: "Tunisie", TR: "Turquie", TM: "Turkménistan", TC: "Îles Turques-et-Caïques", TV: "Tuvalu", UG: "Ouganda", UA: "Ukraine", AE: "Émirats Arabes Unis", GB: "Royaume-Uni", US: "États-Unis d'Amérique", UM: "Îles mineures éloignées des États-Unis", UY: "Uruguay", UZ: "Ouzbékistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Îles vierges britanniques", VI: "Îles vierges américaines", WF: "Wallis-et-Futuna", EH: "Sahara occidental", YE: "Yémen", ZM: "Zambie", ZW: "Zimbabwe", AX: "Åland", BQ: "Bonaire, Saint-Eustache et Saba", CW: "Curaçao", GG: "Guernesey", IM: "Île de Man", JE: "Jersey", ME: "Monténégro", BL: "Saint-Barthélemy", MF: "Saint-Martin (partie française)", RS: "Serbie", SX: "Saint-Martin (partie néerlandaise)", SS: "Soudan du Sud", XK: "Kosovo" }, bd = {
  locale: Ho,
  countries: Uo
}, Sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Uo,
  default: bd,
  locale: Ho
}, Symbol.toStringTag, { value: "Module" })), zo = "hi", jo = { AD: "अंडोरा", AE: "संयुक्त अरब अमीरात", AF: "अफगानिस्तान", AG: "एंटीगुआ और बारबूडा", AI: "अंग्विला", AL: "अल्बानिया", AM: "अर्मेनिया", AO: "अंगोला", AQ: "अंटार्टिका", AR: "अर्जेंटिना", AS: "अमेरिकान सामोआ", AT: "आस्ट्रिया", AU: "आस्ट्रेलिया", AW: "अरुबा", AX: "ऑलैण्ड द्वीपसमूह", AZ: "अजरबेजान", BA: "बोस्निया हर्जेगोविना", BB: "बार्बाडोस", BD: "बांग्लादेश", BE: "बेल्जियम", BF: "बुर्किना फासो", BG: "बल्गारिया", BH: "बहरीन", BI: "बुरुंडी", BJ: "बानिन", BL: "सेंट_बार्थेलेमी", BM: "बर्मूडा", BN: "ब्रुनेई", BO: "बोलिविया", BQ: "कैरिबियन नीदरलैंड", BR: "ब्राजील", BS: "बहामास", BT: "भूटान", BV: "बाउवेट", BW: "बोत्सवाना", BY: "बेलारुस", BZ: "बेलिजे", CA: "कनाडा", CC: "कोकोस (कीलिंग) द्वीप", CD: "कांगो लोकतान्त्रिक गणराज्य", CF: "सेंट्रल अफ्रीका गणतंत्र", CG: "कांगो", CH: "स्विट्जरलैंड", CI: "आइवरी कोस्ट", CK: "कुक द्वीप", CL: "चिली", CM: "कैमरून", CN: "चीन", CO: "कोलंबिया", CR: "कोस्टा रिका", CU: "क्यूबा", CV: "केप वर्दे", CW: "कुराकाओ", CX: "क्रिसमस द्वीप", CY: "साइप्रस", CZ: "चेक", DE: "जर्मनी", DJ: "जिबॉती", DK: "डैनमार्क", DM: "डोमिनिक", DO: "डोमिनिक गणतंत्र", DZ: "अल्जीरिया", EC: "इक्वाडोर", EE: "एस्तोनिया", EG: "मिस्र", EH: "पश्चिमी सहारा", ER: "एरिट्रेया", ES: "स्पेन", ET: "इथियोपिया", FI: "फिनलैंड", FJ: "फिजी", FK: "फाकलैंड द्वीप समूह (मालविनास)", FM: "माइक्रोनेशिया", FO: "फराओ द्वीप समूह", FR: "फ्रांस", GA: "गैबोन", GB: "ग्रेट ब्रिटेन", GD: "ग्रेनेडा", GE: "जॉर्जिया", GF: "फ्रेंच गुआना", GG: "ग्वेर्नसे", GH: "घाना", GI: "जिब्राल्टर", GL: "ग्रीनलैंड", GM: "गाम्बिया", GN: "गिनी", GP: "ग्वाडेलोप", GQ: "एक्वेटोरियल गिनी", GR: "यूनान", GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह", GT: "ग्वाटेमाला", GU: "ग्वाम", GW: "गिनी-बिसाउ", GY: "गुआना", HK: "हांग कांग", HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह", HN: "होंडुरास", HR: "क्रोएशिया", HT: "हैती", HU: "हंगरी", ID: "इंडोनेशिया", IE: "आयरलैंड", IL: "इजराइल", IM: "आइसल ऑफ मैन", IN: "भारत", IO: "ब्रितानी हिंद महासागरीय क्षेत्र", IQ: "इराक", IR: "ईरान", IS: "आइसलैंड", IT: "इटली", JE: "जर्सी", JM: "जमैका", JO: "जॉर्डन", JP: "जापान", KE: "केन्या", KG: "किर्जिस्तान", KH: "कंबोडिया", KI: "किरिबिती", KM: "कोमोरोस", KN: "सेंट किट्स एंड नेविस", KP: "उत्तर कोरिया", KR: "दक्षिण कोरिया", KW: "कुवैत", KY: "केमैन आइसलैंड्स", KZ: "कज़ाखिस्तान", LA: "लाओस", LB: "लेबनान", LC: "सेंट लुसिया", LI: "लिक्टेनिस्टीन", LK: "श्री लंका", LR: "लाइबेरिया", LS: "लेसोथो", LT: "लिथुआनिया", LU: "लक्जमबर्ग", LV: "लात्विया", LY: "लीबिया", MA: "मोरक्को", MC: "मोनाको", MD: "मोलदोवा", ME: "मोंटेनेग्रो", MF: "सेंट मार्टिन की सामूहिकता", MG: "मैडागास्कर", MH: "मार्शल द्वीपसमूह", MK: "मकदूनिया", ML: "माली", MM: "म्यामांर (बर्मा)", MN: "मंगोलिया", MO: "मकाओ", MP: "उत्तर मैरिना द्वीपसमूह", MQ: "मार्टिनिक", MR: "मॉरितानिया", MS: "मोंटसेराट", MT: "माल्टा", MU: "मारीशस", MV: "मालदीव", MW: "मालावी", MX: "मेक्सिको", MY: "मलयेशिया", MZ: "मोजांबिक", NA: "नामीबिया", NC: "न्यू कैलेडोनिया", NE: "नाइजर", NF: "नोरफॉक द्वीप", NG: "नाइजीरिया", NI: "निकारागुआ", NL: "नीदरलैंड्स", NO: "नॉर्वे", NP: "नेपाल", NR: "नाउरू", NU: "नियू", NZ: "न्यूजीलैंड", OM: "ओमान", PA: "पनामा", PE: "पेरू", PF: "फ्रैंच गुआना", PG: "पापुआ न्यू गिनी", PH: "फिलीपींस", PK: "पाकिस्तान", PL: "पोलैंड", PM: "सेंट पिएरे एंड मिक्वेलॉन", PN: "पिटकैर्न द्वीपसमूह", PR: "पुएर्तो रिको", PS: "फिलिस्तीन राज्य", PT: "पुर्तगाल", PW: "पलाउ", PY: "पराग्वे", QA: "क़तार", RE: "रीयूनियन", RO: "रोमानिया", RS: "सर्बिया", RU: "रूस", RW: "रवांडा", SA: "सऊदी अरब", SB: "सोलोमन द्वीपसमूह", SC: "सेशेल्स", SD: "सूडान", SE: "स्वीडन", SG: "सिंगापुर", SH: "सेंट हेलेना", SI: "स्लोवानिया", SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)", SK: "स्लोवाकिया", SL: "सियारा लिओन", SM: "सैन मारिनो", SN: "सेनेगल", SO: "सोमालिया", SR: "सूरीनाम", SS: "दक्षिण सूडान", ST: "साओ टॉम एंड प्रिंसिपी", SV: "सल्वाडोर", SX: "सिण्ट मार्टेन", SY: "सीरिया", SZ: "स्वाजीलैंड", TC: "तुर्क एंड कैकोस द्वीपसमूह", TD: "चाड", TF: "फ्रांसीसी दक्षिणी क्षेत्र", TG: "टोगो", TH: "थाईलैंड", TJ: "तज़ाकिस्तान", TK: "टोकेलू", TL: "पूर्वी तिमोर", TM: "तुर्कमेनिस्तान", TN: "ट्यूनीशिया", TO: "टोंगा", TR: "तुर्की", TT: "ट्रिनिडाड एंड टोबैगो", TV: "तुवालू", TW: "ताइवान", TZ: "तंजानिया", UA: "उक्रेन", UG: "उगांडा", UM: "यूएस माइनर आउटलाइंग द्वीपसमूह", US: "यूएसए (संयुक्त राज्य अमेरिका)", UY: "उरुग्वे", UZ: "उजबेकिस्तान", VA: "वेटिकन", VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स", VE: "वेनेजुएला", VG: "ब्रितानी वर्जिन द्वीपसमूह", VI: "अमेरिकी वर्जिन द्वीपसमूह", VN: "विएतनाम", VU: "वनातू", WF: "वालीज एंड फुटुना", WS: "पश्चिमी सामोआ", XK: "कोसोवो", YE: "यमन", YT: "मायोते", ZA: "दक्षिण अफ्रीका", ZM: "जाम्बिया", ZW: "जिंबावे" }, kd = {
  locale: zo,
  countries: jo
}, Md = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: jo,
  default: kd,
  locale: zo
}, Symbol.toStringTag, { value: "Module" })), Vo = "hu", Yo = { AF: "Afganisztán", AL: "Albánia", DZ: "Algéria", AS: "Amerikai Szamoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktisz", AG: "Antigua és Barbuda", AR: "Argentína", AM: "Örményország", AW: "Aruba", AU: "Ausztrália", AT: "Ausztria", AZ: "Azerbajdzsán", BS: "Bahama-szigetek", BH: "Bahrein", BD: "Banglades", BB: "Barbados", BY: "Fehéroroszország", BE: "Belgium", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhután", BO: "Bolívia", BA: "Bosznia-Hercegovina", BW: "Botswana", BV: "Bouvet-sziget", BR: "Brazília", IO: "Brit Indiai-óceáni Terület", BN: "Brunei", BG: "Bulgária", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodzsa", CM: "Kamerun", CA: "Kanada", CV: "Zöld-foki Köztársaság", KY: "Kajmán-szigetek", CF: "Közép-afrikai Köztársaság", TD: "Csád", CL: "Chile", CN: "Kína", CX: "Karácsony-sziget", CC: "Kókusz (Keeling)-szigetek", CO: "Kolumbia", KM: "Comore-szigetek", CG: "Kongói Köztársaság", CD: "Kongói Demokratikus Köztársaság", CK: "Cook-szigetek", CR: "Costa Rica", CI: "Elefántcsontpart", HR: "Horvátország", CU: "Kuba", CY: "Ciprus", CZ: "Csehország", DK: "Dánia", DJ: "Dzsibuti", DM: "Dominikai Közösség", DO: "Dominikai Köztársaság", EC: "Ecuador", EG: "Egyiptom", SV: "Salvador", GQ: "Egyenlítői-Guinea", ER: "Eritrea", EE: "Észtország", ET: "Etiópia", FK: "Falkland-szigetek", FO: "Feröer", FJ: "Fidzsi-szigetek", FI: "Finnország", FR: "Franciaország", GF: "Francia Guyana", PF: "Francia Polinézia", TF: "Francia déli területek", GA: "Gabon", GM: "Gambia", GE: "Grúzia", DE: "Németország", GH: "Ghána", GI: "Gibraltár", GR: "Görögország", GL: "Grönland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Bissau-Guinea", GY: "Guyana", HT: "Haiti", HM: "Heard-sziget és McDonald-szigetek", VA: "Vatikán", HN: "Honduras", HK: "Hong Kong", HU: "Magyarország", IS: "Izland", IN: "India", ID: "Indonézia", IR: "Irán", IQ: "Irak", IE: "Írország", IL: "Izrael", IT: "Olaszország", JM: "Jamaica", JP: "Japán", JO: "Jordánia", KZ: "Kazahsztán", KE: "Kenya", KI: "Kiribati", KP: "Észak-Korea", KR: "Dél-Korea", KW: "Kuvait", KG: "Kirgizisztán", LA: "Laosz", LV: "Lettország", LB: "Libanon", LS: "Lesotho", LR: "Libéria", LY: "Líbia", LI: "Liechtenstein", LT: "Litvánia", LU: "Luxemburg", MO: "Makao", MK: "Észak-Macedónia", MG: "Madagaszkár", MW: "Malawi", MY: "Malajzia", MV: "Maldív-szigetek", ML: "Mali", MT: "Málta", MH: "Marshall-szigetek", MQ: "Martinique", MR: "Mauritánia", MU: "Mauritius", YT: "Mayotte", MX: "Mexikó", FM: "Mikronéziai Szövetségi Államok", MD: "Moldova", MC: "Monaco", MN: "Mongólia", MS: "Montserrat", MA: "Marokkó", MZ: "Mozambik", MM: "Mianmar", NA: "Namíbia", NR: "Nauru", NP: "Nepál", NL: "Hollandia", NC: "Új-Kaledónia", NZ: "Új-Zéland", NI: "Nicaragua", NE: "Niger", NG: "Nigéria", NU: "Niue", NF: "Norfolk-sziget", MP: "Északi-Mariana-szigetek", NO: "Norvégia", OM: "Omán", PK: "Pakisztán", PW: "Palau", PS: "Palesztina", PA: "Panama", PG: "Pápua Új-Guinea", PY: "Paraguay", PE: "Peru", PH: "Fülöp-szigetek", PN: "Pitcairn-szigetek", PL: "Lengyelország", PT: "Portugália", PR: "Puerto Rico", QA: "Katar", RE: "Réunion", RO: "Románia", RU: "Oroszország", RW: "Ruanda", SH: "Saint Helena", KN: "Saint Kitts és Nevis", LC: "Saint Lucia", PM: "Saint Pierre and Miquelon", VC: "Saint Vincent és a Grenadine-szigetek", WS: "Szamoa", SM: "San Marino", ST: "São Tomé és Príncipe", SA: "Szaudi-Arábia", SN: "Szenegál", SC: "Seychelle-szigetek", SL: "Sierra Leone", SG: "Szingapúr", SK: "Szlovákia", SI: "Szlovénia", SB: "Salamon-szigetek", SO: "Szomália", ZA: "Dél-Afrika", GS: "Déli-Georgia és Déli-Sandwich-szigetek", ES: "Spanyolország", LK: "Sri Lanka", SD: "Szudán", SR: "Suriname", SJ: "Spitzbergák és Jan Mayen", SZ: "Szváziföld", SE: "Svédország", CH: "Svájc", SY: "Szíria", TW: "Tajvan", TJ: "Tádzsikisztán", TZ: "Tanzánia", TH: "Thaiföld", TL: "Kelet-Timor", TG: "Togo", TK: "Tokelau-szigetek", TO: "Tonga", TT: "Trinidad és Tobago", TN: "Tunézia", TR: "Törökország", TM: "Türkmenisztán", TC: "Turks- és Caicos-szigetek", TV: "Tuvalu", UG: "Uganda", UA: "Ukrajna", AE: "Egyesült Arab Emírségek", GB: "Egyesült Királyság", US: "Amerikai Egyesült Államok", UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai", UY: "Uruguay", UZ: "Üzbegisztán", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Brit Virgin-szigetek", VI: "Amerikai Virgin-szigetek", WF: "Wallis és Futuna", EH: "Nyugat-Szahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Karibi Hollandia", CW: "Curaçao", GG: "Guernsey", IM: "Man-sziget", JE: "Jersey", ME: "Montenegró", BL: "Saint Barthélemy", MF: "Szent Márton-sziget (francia rész)", RS: "Szerbia", SX: "Szent Márton-sziget (holland rész)", SS: "Dél-Szudán", XK: "Koszovó" }, wd = {
  locale: Vo,
  countries: Yo
}, Cd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Yo,
  default: wd,
  locale: Vo
}, Symbol.toStringTag, { value: "Module" })), Wo = "id", Zo = { AF: "Afghanistan", AL: "Albania", DZ: "Algeria", AS: "Samoa Amerika", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua dan Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaijan", BS: "Bahama", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Belarusia", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia dan Herzegovina", BW: "Botswana", BV: "Kepulauan Bouvet", BR: "Brasil", IO: "Teritori Samudra Hindia Britania", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kamboja", CM: "Kamerun", CA: "Kanada", CV: "Tanjung Verde", KY: "Kepulauan Cayman", CF: "Afrika Tengah", TD: "Chad", CL: "Chile", CN: "China", CX: "Pulau Natal", CC: "Kepulauan Cocos (Keeling)", CO: "Kolombia", KM: "Komoro", CG: "Kongo", CD: "Republik Demokratik Kongo", CK: "Kepulauan Cook", CR: "Kosta Rika", CI: "Pantai Gading", HR: "Kroasia", CU: "Kuba", CY: "Siprus", CZ: "Republik Ceko", DK: "Denmark", DJ: "Djibouti", DM: "Dominika", DO: "Republik Dominika", EC: "Ekuador", EG: "Mesir", SV: "El Salvador", GQ: "Guinea Khatulistiwa", ER: "Eritrea", EE: "Estonia", ET: "Ethiopia", FK: "Kepulauan Falkland(Malvinas)", FO: "Kepulauan Faroe", FJ: "Fiji", FI: "Finlandia", FR: "Perancis", GF: "Guyana Perancis", PF: "Polinesia Perancis", TF: "Antartika Perancis", GA: "Gabon", GM: "Gambia", GE: "Georgia", DE: "Jerman", GH: "Ghana", GI: "Gibraltar", GR: "Yunani", GL: "Greenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatamala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Pulau Heard dan Kepulauan McDonald", VA: "Vatikan", HN: "Honduras", HK: "Hong Kong", HU: "Hungaria", IS: "Islandia", IN: "India", ID: "Indonesia", IR: "Iran", IQ: "Irak", IE: "Irlandia", IL: "Israel", IT: "Italia", JM: "Jamaika", JP: "Jepang", JO: "Yordania", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Korea Utara", KR: "Korea Selatan", KW: "Kuwait", KG: "Kyrgyzstan", LA: "Laos", LV: "Latvia", LB: "Lebanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Lithuania", LU: "Luxemburg", MO: "Makau", MK: "Makedonia Utara", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldives", ML: "Mali", MT: "Malta", MH: "Kepulauan Marshall", MQ: "Martinik", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Meksiko", FM: "Federasi Mikronesia", MD: "Moldova", MC: "Monako", MN: "Mongolia", MS: "Montserrat", MA: "Moroko", MZ: "Mozambik", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Belanda", NC: "Kaledonia Baru", NZ: "Selandia Baru", NI: "Nikaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Kepulauan Norfolk", MP: "Kepulauan Mariana Utara", NO: "Norwegia", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestina", PA: "Panama", PG: "Papua Nugini", PY: "Paraguay", PE: "Peru", PH: "Filipina", PN: "Pitcairn", PL: "Polandia", PT: "Portugal", PR: "Puerto Riko", QA: "Qatar", RE: "Reunion", RO: "Rumania", RU: "Rusia", RW: "Rwanda", SH: "Saint Helena", KN: "Saint Kitts dan Nevis", LC: "Saint Lucia", PM: "Saint Pierre dan Miquelon", VC: "Saint Vincent dan the Grenadines", WS: "Samoa", SM: "San Marino", ST: "Sao Tome dan Principe", SA: "Arab Saudi", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapura", SK: "Slovakia", SI: "Slovenia", SB: "Kepulauan Solomon", SO: "Somalia", ZA: "Afrika Selatan", GS: "Georgia Selatan dan Kepulauan Sandwich Selatan", ES: "Spanyol", LK: "Sri Lanka", SD: "Sudan", SR: "Suriname", SJ: "Svalbard dan Jan Mayen", SZ: "Eswatini", SE: "Sweden", CH: "Swiss", SY: "Suriah", TW: "Taiwan", TJ: "Tajikistan", TZ: "Tanzania", TH: "Thailand", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad dan Tobago", TN: "Tunisia", TR: "Turki", TM: "Turkmenistan", TC: "Turks dan Caicos Islands", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "Uni Emirat Arab", GB: "Britania Raya", US: "Amerika Serikat", UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Viet Nam", VG: "Virgin Islands, British", VI: "Virgin Islands, U.S.", WF: "Wallis and Futuna", EH: "Sahara Barat", YE: "Yaman", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland Islands", BQ: "Bonaire, Sint Eustatius and Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (French part)", RS: "Serbia", SX: "Sint Maarten (Dutch part)", SS: "Sudan Selatan", XK: "Kosovo" }, Pd = {
  locale: Wo,
  countries: Zo
}, Td = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Zo,
  default: Pd,
  locale: Wo
}, Symbol.toStringTag, { value: "Module" })), Jo = "it", $o = { AD: "Andorra", AE: "Emirati Arabi Uniti", AF: "Afghanistan", AG: "Antigua e Barbuda", AI: "Anguilla", AL: "Albania", AM: "Armenia", AO: "Angola", AQ: "Antartide", AR: "Argentina", AS: "Samoa Americane", AT: "Austria", AU: "Australia", AW: "Aruba", AX: "Isole Åland", AZ: "Azerbaigian", BA: "Bosnia ed Erzegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgio", BF: "Burkina Faso", BG: "Bulgaria", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Saint-Barthélemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Isole BES", BR: "Brasile", BS: "Bahamas", BT: "Bhutan", BV: "Isola Bouvet", BW: "Botswana", BY: "Bielorussia", BZ: "Belize", CA: "Canada", CC: "Isole Cocos e Keeling", CD: "Repubblica Democratica del Congo", CF: "Repubblica Centrafricana", CG: "Repubblica del Congo", CH: "Svizzera", CI: "Costa d'Avorio", CK: "Isole Cook", CL: "Cile", CM: "Camerun", CN: "Cina", CO: "Colombia", CR: "Costa Rica", CU: "Cuba", CV: "Capo Verde", CW: "Curaçao", CX: "Isola del Natale", CY: "Cipro", CZ: "Repubblica Ceca", DE: "Germania", DJ: "Gibuti", DK: "Danimarca", DM: "Dominica", DO: "Repubblica Dominicana", DZ: "Algeria", EC: "Ecuador", EE: "Estonia", EG: "Egitto", EH: "Sahara Occidentale", ER: "Eritrea", ES: "Spagna", ET: "Etiopia", FI: "Finlandia", FJ: "Figi", FK: "Isole Falkland", FM: "Stati Federati di Micronesia", FO: "Isole Fær Øer", FR: "Francia", GA: "Gabon", GB: "Regno Unito", GD: "Grenada", GE: "Georgia", GF: "Guyana Francese", GG: "Guernsey", GH: "Ghana", GI: "Gibilterra", GL: "Groenlandia", GM: "Gambia", GN: "Guinea", GP: "Guadalupa", GQ: "Guinea Equatoriale", GR: "Grecia", GS: "Georgia del Sud e isole Sandwich meridionali", GT: "Guatemala", GU: "Guam", GW: "Guinea-Bissau", GY: "Guyana", HK: "Hong Kong", HM: "Isole Heard e McDonald", HN: "Honduras", HR: "Croazia", HT: "Haiti", HU: "Ungheria", ID: "Indonesia", IE: "Irlanda", IL: "Israele", IM: "Isola di Man", IN: "India", IO: "Territori Britannici dell'Oceano Indiano", IQ: "Iraq", IR: "Iran", IS: "Islanda", IT: "Italia", JE: "Jersey", JM: "Giamaica", JO: "Giordania", JP: "Giappone", KE: "Kenya", KG: "Kirghizistan", KH: "Cambogia", KI: "Kiribati", KM: "Comore", KN: "Saint Kitts e Nevis", KP: "Corea del Nord", KR: "Corea del Sud", KW: "Kuwait", KY: "Isole Cayman", KZ: "Kazakistan", LA: "Laos", LB: "Libano", LC: "Santa Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Lituania", LU: "Lussemburgo", LV: "Lettonia", LY: "Libia", MA: "Marocco", MC: "Monaco", MD: "Moldavia", ME: "Montenegro", MF: "Saint-Martin", MG: "Madagascar", MH: "Isole Marshall", MK: "Macedonia del Nord", ML: "Mali", MM: "Birmania  Myanmar", MN: "Mongolia", MO: "Macao", MP: "Isole Marianne Settentrionali", MQ: "Martinica", MR: "Mauritania", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldive", MW: "Malawi", MX: "Messico", MY: "Malesia", MZ: "Mozambico", NA: "Namibia", NC: "Nuova Caledonia", NE: "Niger", NF: "Isola Norfolk", NG: "Nigeria", NI: "Nicaragua", NL: "Paesi Bassi", NO: "Norvegia", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nuova Zelanda", OM: "Oman", PA: "Panamá", PE: "Perù", PF: "Polinesia Francese", PG: "Papua Nuova Guinea", PH: "Filippine", PK: "Pakistan", PL: "Polonia", PM: "Saint Pierre e Miquelon", PN: "Isole Pitcairn", PR: "Porto Rico", PS: "Stato di Palestina", PT: "Portogallo", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "Romania", RS: "Serbia", RU: "Russia", RW: "Ruanda", SA: "Arabia Saudita", SB: "Isole Salomone", SC: "Seychelles", SD: "Sudan", SE: "Svezia", SG: "Singapore", SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha", SI: "Slovenia", SJ: "Svalbard e Jan Mayen", SK: "Slovacchia", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Suriname", SS: "Sudan del Sud", ST: "São Tomé e Príncipe", SV: "El Salvador", SX: "Sint Maarten", SY: "Siria", SZ: "Eswatini", TC: "Isole Turks e Caicos", TD: "Ciad", TF: "Territori Francesi del Sud", TG: "Togo", TH: "Thailandia", TJ: "Tagikistan", TK: "Tokelau", TL: "Timor Est", TM: "Turkmenistan", TN: "Tunisia", TO: "Tonga", TR: "Turchia", TT: "Trinidad e Tobago", TV: "Tuvalu", TW: ["Repubblica di Cina", "Taiwan"], TZ: "Tanzania", UA: "Ucraina", UG: "Uganda", UM: "Isole minori esterne degli Stati Uniti", US: "Stati Uniti d'America", UY: "Uruguay", UZ: "Uzbekistan", VA: "Città del Vaticano", VC: "Saint Vincent e Grenadine", VE: "Venezuela", VG: "Isole Vergini Britanniche", VI: "Isole Vergini Americane", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis e Futuna", WS: "Samoa", YE: "Yemen", YT: "Mayotte", ZA: "Sudafrica", ZM: "Zambia", ZW: "Zimbabwe", XK: "Kosovo" }, Nd = {
  locale: Jo,
  countries: $o
}, Dd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: $o,
  default: Nd,
  locale: Jo
}, Symbol.toStringTag, { value: "Module" })), qo = "ja", Qo = { AF: "アフガニスタン", AL: "アルバニア", DZ: "アルジェリア", AS: "アメリカ領サモア", AD: "アンドラ", AO: "アンゴラ", AI: "アンギラ", AQ: "南極", AG: "アンティグア・バーブーダ", AR: "アルゼンチン", AM: "アルメニア", AW: "アルバ", AU: "オーストラリア", AT: "オーストリア", AZ: "アゼルバイジャン", BS: "バハマ", BH: "バーレーン", BD: "バングラデシュ", BB: "バルバドス", BY: "ベラルーシ", BE: "ベルギー", BZ: "ベリーズ", BJ: "ベナン", BM: "バミューダ", BT: "ブータン", BO: "ボリビア多民族国", BA: "ボスニア・ヘルツェゴビナ", BW: "ボツワナ", BV: "ブーベ島", BR: "ブラジル", IO: "イギリス領インド洋地域", BN: "ブルネイ・ダルサラーム", BG: "ブルガリア", BF: "ブルキナファソ", BI: "ブルンジ", KH: "カンボジア", CM: "カメルーン", CA: "カナダ", CV: "カーボベルデ", KY: "ケイマン諸島", CF: "中央アフリカ共和国", TD: "チャド", CL: "チリ", CN: "中華人民共和国", CX: "クリスマス島", CC: "ココス（キーリング）諸島", CO: "コロンビア", KM: "コモロ", CG: "コンゴ共和国", CD: "コンゴ民主共和国", CK: "クック諸島", CR: "コスタリカ", CI: "コートジボワール", HR: "クロアチア", CU: "キューバ", CY: "キプロス", CZ: "チェコ", DK: "デンマーク", DJ: "ジブチ", DM: "ドミニカ国", DO: "ドミニカ共和国", EC: "エクアドル", EG: "エジプト", SV: "エルサルバドル", GQ: "赤道ギニア", ER: "エリトリア", EE: "エストニア", ET: "エチオピア", FK: "フォークランド（マルビナス）諸島", FO: "フェロー諸島", FJ: "フィジー", FI: "フィンランド", FR: "フランス", GF: "フランス領ギアナ", PF: "フランス領ポリネシア", TF: "フランス領南方・南極地域", GA: "ガボン", GM: "ガンビア", GE: "ジョージア", DE: "ドイツ", GH: "ガーナ", GI: "ジブラルタル", GR: "ギリシャ", GL: "グリーンランド", GD: "グレナダ", GP: "グアドループ", GU: "グアム", GT: "グアテマラ", GN: "ギニア", GW: "ギニアビサウ", GY: "ガイアナ", HT: "ハイチ", HM: "ハード島とマクドナルド諸島", VA: "バチカン市国", HN: "ホンジュラス", HK: "香港", HU: "ハンガリー", IS: "アイスランド", IN: "インド", ID: "インドネシア", IR: "イラン・イスラム共和国", IQ: "イラク", IE: "アイルランド", IL: "イスラエル", IT: "イタリア", JM: "ジャマイカ", JP: "日本", JO: "ヨルダン", KZ: "カザフスタン", KE: "ケニア", KI: "キリバス", KP: "朝鮮民主主義人民共和国", KR: "大韓民国", KW: "クウェート", KG: "キルギス", LA: "ラオス人民民主共和国", LV: "ラトビア", LB: "レバノン", LS: "レソト", LR: "リベリア", LY: "リビア", LI: "リヒテンシュタイン", LT: "リトアニア", LU: "ルクセンブルク", MO: "マカオ", MG: "マダガスカル", MW: "マラウイ", MY: "マレーシア", MV: "モルディブ", ML: "マリ", MT: "マルタ", MH: "マーシャル諸島", MQ: "マルティニーク", MR: "モーリタニア", MU: "モーリシャス", YT: "マヨット", MX: "メキシコ", FM: "ミクロネシア連邦", MD: "モルドバ共和国", MC: "モナコ", MN: "モンゴル", MS: "モントセラト", MA: "モロッコ", MZ: "モザンビーク", MM: "ミャンマー", NA: "ナミビア", NR: "ナウル", NP: "ネパール", NL: "オランダ", NC: "ニューカレドニア", NZ: "ニュージーランド", NI: "ニカラグア", NE: "ニジェール", NG: "ナイジェリア", NU: "ニウエ", NF: "ノーフォーク島", MK: "北マケドニア", MP: "北マリアナ諸島", NO: "ノルウェー", OM: "オマーン", PK: "パキスタン", PW: "パラオ", PS: "パレスチナ", PA: "パナマ", PG: "パプアニューギニア", PY: "パラグアイ", PE: "ペルー", PH: "フィリピン", PN: "ピトケアン", PL: "ポーランド", PT: "ポルトガル", PR: "プエルトリコ", QA: "カタール", RE: "レユニオン", RO: "ルーマニア", RU: "ロシア連邦", RW: "ルワンダ", SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ", KN: "セントクリストファー・ネイビス", LC: "セントルシア", PM: "サンピエール島・ミクロン島", VC: "セントビンセントおよびグレナディーン諸島", WS: "サモア", SM: "サンマリノ", ST: "サントメ・プリンシペ", SA: "サウジアラビア", SN: "セネガル", SC: "セーシェル", SL: "シエラレオネ", SG: "シンガポール", SK: "スロバキア", SI: "スロベニア", SB: "ソロモン諸島", SO: "ソマリア", ZA: "南アフリカ", GS: "サウスジョージア・サウスサンドウィッチ諸島", ES: "スペイン", LK: "スリランカ", SD: "スーダン", SR: "スリナム", SJ: "スヴァールバル諸島およびヤンマイエン島", SZ: "スワジランド", SE: "スウェーデン", CH: "スイス", SY: "シリア・アラブ共和国", TW: "台湾", TJ: "タジキスタン", TZ: "タンザニア", TH: "タイ", TL: "東ティモール", TG: "トーゴ", TK: "トケラウ", TO: "トンガ", TT: "トリニダード・トバゴ", TN: "チュニジア", TR: "トルコ", TM: "トルクメニスタン", TC: "タークス・カイコス諸島", TV: "ツバル", UG: "ウガンダ", UA: "ウクライナ", AE: "アラブ首長国連邦", GB: "イギリス", US: "アメリカ合衆国", UM: "合衆国領有小離島", UY: "ウルグアイ", UZ: "ウズベキスタン", VU: "バヌアツ", VE: "ベネズエラ・ボリバル共和国", VN: "ベトナム", VG: "イギリス領ヴァージン諸島", VI: "アメリカ領ヴァージン諸島", WF: "ウォリス・フツナ", EH: "西サハラ", YE: "イエメン", ZM: "ザンビア", ZW: "ジンバブエ", AX: "オーランド諸島", BQ: "ボネール、シント・ユースタティウスおよびサバ", CW: "キュラソー", GG: "ガーンジー", IM: "マン島", JE: "ジャージー", ME: "モンテネグロ", BL: "サン・バルテルミー", MF: "サン・マルタン（フランス領）", RS: "セルビア", SX: "シント・マールテン（オランダ領）", SS: "南スーダン", XK: "コソボ" }, Ad = {
  locale: qo,
  countries: Qo
}, Id = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Qo,
  default: Ad,
  locale: qo
}, Symbol.toStringTag, { value: "Module" })), Xo = "nl", es = { AF: "Afghanistan", AL: "Albanië", DZ: "Algerije", AS: "Amerikaans-Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua en Barbuda", AR: "Argentinië", AM: "Armenië", AW: "Aruba", AU: "Australië", AT: "Oostenrijk", AZ: "Azerbeidzjan", BS: "Bahama's", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Wit-Rusland", BE: ["België", "Koninkrijk België"], BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivië", BA: "Bosnië-Herzegovina", BW: "Botswana", BV: "Bouvet Eiland", BR: "Brazilië", IO: "Brits Indische oceaan", BN: "Brunei Darussalam", BG: "Bulgarije", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodja", CM: "Kameroen", CA: "Canada", CV: "Kaapverdië", KY: "Kaaimaneilanden", CF: "Centraal-Afrikaanse Republiek", TD: "Tsjaad", CL: "Chili", CN: "China", CX: "Christmaseiland", CC: "Cocoseilanden", CO: "Colombia", KM: "Comoren", CG: "Congo, Volksrepubliek", CD: "Congo, Democratische Republiek", CK: "Cookeilanden", CR: "Costa Rica", CI: "Ivoorkust", HR: "Kroatië", CU: "Cuba", CY: "Cyprus", CZ: "Tsjechië", DK: "Denemarken", DJ: "Djibouti", DM: "Dominica", DO: "Dominicaanse Republiek", EC: "Ecuador", EG: "Egypte", SV: "El Salvador", GQ: "Equatoriaal-Guinea", ER: "Eritrea", EE: "Estland", ET: "Ethiopië", FK: "Falklandeilanden", FO: "Faeröer", FJ: "Fiji", FI: "Finland", FR: "Frankrijk", GF: "Frans-Guyana", PF: "Frans-Polynesië", TF: "Franse Zuidelijke Gebieden", GA: "Gabon", GM: "Gambia", GE: "Georgië", DE: "Duitsland", GH: "Ghana", GI: "Gibraltar", GR: "Griekenland", GL: "Groenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinee-Bissau", GY: "Guyana", HT: "Haïti", HM: "Heard en McDonaldeilanden", VA: "Heilige Stoel", HN: "Honduras", HK: "Hong Kong", HU: "Hongarije", IS: "IJsland", IN: "India", ID: "Indonesië", IR: "Iran", IQ: "Irak", IE: "Ierland", IL: "Israël", IT: "Italië", JM: "Jamaica", JP: "Japan", JO: "Jordanië", KZ: "Kazachstan", KE: "Kenia", KI: "Kiribati", KP: "Noord-Korea", KR: "Zuid-Korea", KW: "Koeweit", KG: "Kirgizstan", LA: "Laos", LV: "Letland", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libië", LI: "Liechtenstein", LT: "Litouwen", LU: "Luxemburg", MO: "Macao", MG: "Madagaskar", MW: "Malawi", MY: "Maleisië", MV: ["Maldiven", "Malediven"], ML: "Mali", MT: "Malta", MH: "Marshalleilanden", MQ: "Martinique", MR: "Mauritanië", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Micronesië, Federale Staten", MD: "Moldavië", MC: "Monaco", MN: "Mongolië", MS: "Montserrat", MA: "Marokko", MZ: "Mozambique", MM: "Myanmar", NA: "Namibië", NR: "Nauru", NP: "Nepal", NL: ["Nederland", "Koninkrijk der Nederlanden"], NC: "Nieuw-Caledonië", NZ: "Nieuw-Zeeland", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk", MP: "Noordelijke Marianen", MK: "Noord-Macedonië", NO: "Noorwegen", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestina", PA: "Panama", PG: "Papoea-Nieuw-Guinea", PY: "Paraguay", PE: "Peru", PH: "Filipijnen", PN: "Pitcairn", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Roemenië", RU: "Rusland", RW: "Rwanda", SH: "Sint-Helena", KN: "Saint Kitts en Nevis", LC: "Saint Lucia", PM: "Saint-Pierre en Miquelon", VC: "Saint Vincent en de Grenadines", WS: "Samoa", SM: "San Marino", ST: "São Tomé en Principe", SA: "Saudi-Arabië", SN: "Senegal", SC: "Seychellen", SL: "Sierra Leone", SG: "Singapore", SK: "Slowakije", SI: "Slovenië", SB: "Salomonseilanden", SO: "Somalië", ZA: "Zuid-Afrika", GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden", ES: "Spanje", LK: "Sri Lanka", SD: "Soedan", SR: "Suriname", SJ: "Spitsbergen en Jan Mayen", SZ: "Ngwane, Koninkrijk Eswatini", SE: "Zweden", CH: "Zwitserland", SY: "Syrië", TW: "Taiwan", TJ: "Tadzjikistan", TZ: ["Tanzania", "Tanzania, Verenigde Republiek"], TH: "Thailand", TL: "Timor Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad en Tobago", TN: "Tunesië", TR: "Turkije", TM: "Turkmenistan", TC: "Turks- en Caicoseilanden", TV: "Tuvalu", UG: "Oeganda", UA: "Oekraïne", AE: "Verenigde Arabische Emiraten", GB: ["Groot-Brittannië", "Verenigd Koninkrijk"], US: ["Verenigde Staten van Amerika", "Verenigde Staten"], UM: "Ver afgelegen eilandjes van de Verenigde Staten", UY: "Uruguay", UZ: "Oezbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Maagdeneilanden, Britse", VI: "Maagdeneilanden, Amerikaanse", WF: "Wallis en Futuna", EH: "Westelijke Sahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Bonaire, Sint Eustatius en Saba", CW: "Curaçao", GG: "Guernsey", IM: "Man Eiland", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: ["Sint-Maarten (Frans deel)", "Sint-Maarten (Franse Antillen)", "Collectiviteit van Sint-Maarten"], RS: "Servië", SX: ["Sint Maarten", "Sint-Maarten", "Sint Maarten (Nederlands deel)", "Land Sint Maarten"], SS: "Zuid-Soedan", XK: "Kosovo" }, xd = {
  locale: Xo,
  countries: es
}, Ed = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: es,
  default: xd,
  locale: Xo
}, Symbol.toStringTag, { value: "Module" })), as = "no", ts = { AF: "Afghanistan", AL: "Albania", DZ: "Algerie", AS: "Amerikansk Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua og Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Østerrike", AZ: "Aserbajdsjan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Hviterussland", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia-Hercegovina", BW: "Botswana", BV: "Bouvetøya", BR: "Brasil", IO: "Det britiske territoriet i Indiahavet", BN: "Brunei", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodsja", CM: "Kamerun", CA: "Canada", CV: "Kapp Verde", KY: "Caymanøyene", CF: "Den sentralafrikanske republikk", TD: "Tsjad", CL: "Chile", CN: "Kina", CX: "Christmasøya", CC: "Kokosøyene", CO: "Colombia", KM: "Komorene", CG: "Kongo-Brazzaville", CD: "Kongo", CK: "Cookøyene", CR: "Costa Rica", CI: "Elfenbenskysten", HR: "Kroatia", CU: "Cuba", CY: "Kypros", CZ: "Tsjekkia", DK: "Danmark", DJ: "Djibouti", DM: "Dominica", DO: "Den dominikanske republikk", EC: "Ecuador", EG: "Egypt", SV: "El Salvador", GQ: "Ekvatorial-Guinea", ER: "Eritrea", EE: "Estland", ET: "Etiopia", FK: "Falklandsøyene", FO: "Færøyene", FJ: "Fiji", FI: "Finland", FR: "Frankrike", GF: "Fransk Guyana", PF: "Fransk Polynesia", TF: "De franske sørterritorier", GA: "Gabon", GM: "Gambia", GE: "Georgia", DE: "Tyskland", GH: "Ghana", GI: "Gibraltar", GR: "Hellas", GL: "Grønland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard- og McDonaldøyene", VA: "Vatikanstaten", HN: "Honduras", HK: "Hongkong SAR Kina", HU: "Ungarn", IS: "Island", IN: "India", ID: "Indonesia", IR: "Iran", IQ: "Irak", IE: "Irland", IL: "Israel", IT: "Italia", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kasakhstan", KE: "Kenya", KI: "Kiribati", KP: "Nord-Korea", KR: "Sør-Korea", KW: "Kuwait", KG: "Kirgisistan", LA: "Laos", LV: "Latvia", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Litauen", LU: "Luxemburg", MO: "Macao SAR Kina", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldivene", ML: "Mali", MT: "Malta", MH: "Marshalløyene", MQ: "Martinique", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Mikronesiaføderasjonen", MD: "Moldova", MC: "Monaco", MN: "Mongolia", MS: "Montserrat", MA: "Marokko", MZ: "Mosambik", MM: "Myanmar (Burma)", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Nederland", NC: "Ny-Caledonia", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolkøya", MK: "Nord-Makedonia", MP: "Nord-Marianene", NO: "Norge", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Det palestinske området", PA: "Panama", PG: "Papua Ny-Guinea", PY: "Paraguay", PE: "Peru", PH: "Filippinene", PN: "Pitcairnøyene", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Romania", RU: "Russland", RW: "Rwanda", SH: "St. Helena", KN: "Saint Kitts og Nevis", LC: "St. Lucia", PM: "Saint-Pierre-et-Miquelon", VC: "St. Vincent og Grenadinene", WS: "Samoa", SM: "San Marino", ST: "São Tomé og Príncipe", SA: "Saudi-Arabia", SN: "Senegal", SC: "Seychellene", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakia", SI: "Slovenia", SB: "Salomonøyene", SO: "Somalia", ZA: "Sør-Afrika", GS: "Sør-Georgia og Sør-Sandwichøyene", ES: "Spania", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Svalbard og Jan Mayen", SZ: "Eswatini", SE: "Sverige", CH: "Sveits", SY: "Syria", TW: "Taiwan", TJ: "Tadsjikistan", TZ: "Tanzania", TH: "Thailand", TL: "Øst-Timor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad og Tobago", TN: "Tunisia", TR: "Tyrkia", TM: "Turkmenistan", TC: "Turks- og Caicosøyene", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "De forente arabiske emirater", GB: "Storbritannia", US: "USA", UM: "USAs ytre øyer", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "De britiske jomfruøyene", VI: "De amerikanske jomfruøyene", WF: "Wallis og Futuna", EH: "Vest-Sahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Karibisk Nederland", CW: "Curaçao", GG: "Guernsey", IM: "Man", JE: "Jersey", ME: "Montenegro", BL: "Saint-Barthélemy", MF: "Saint-Martin", RS: "Serbia", SX: "Sint Maarten", SS: "Sør-Sudan", XK: "Kosovo" }, Bd = {
  locale: as,
  countries: ts
}, Od = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ts,
  default: Bd,
  locale: as
}, Symbol.toStringTag, { value: "Module" })), rs = "pl", ns = { AF: "Afganistan", AL: "Albania", DZ: "Algieria", AS: "Samoa Amerykańskie", AD: "Andora", AO: "Angola", AI: "Anguilla", AQ: "Antarktyka", AG: "Antigua i Barbuda", AR: "Argentyna", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbejdżan", BS: "Bahamy", BH: "Bahrajn", BD: "Bangladesz", BB: "Barbados", BY: "Białoruś", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermudy", BT: "Bhutan", BO: "Boliwia", BA: "Bośnia i Hercegowina", BW: "Botswana", BV: "Wyspa Bouveta", BR: "Brazylia", IO: "Brytyjskie Terytorium Oceanu Indyjskiego", BN: "Brunei", BG: "Bułgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodża", CM: "Kamerun", CA: "Kanada", CV: "Republika Zielonego Przylądka", KY: "Kajmany", CF: "Republika Środkowoafrykańska", TD: "Czad", CL: "Chile", CN: "Chiny", CX: "Wyspa Bożego Narodzenia", CC: "Wyspy Kokosowe", CO: "Kolumbia", KM: "Komory", CG: "Kongo", CD: "Demokratyczna Republika Konga", CK: "Wyspy Cooka", CR: "Kostaryka", CI: "Wybrzeże Kości Słoniowej", HR: "Chorwacja", CU: "Kuba", CY: "Cypr", CZ: "Czechy", DK: "Dania", DJ: "Dżibuti", DM: "Dominika", DO: "Dominikana", EC: "Ekwador", EG: "Egipt", SV: "Salwador", GQ: "Gwinea Równikowa", ER: "Erytrea", EE: "Estonia", ET: "Etiopia", FK: "Falklandy", FO: "Wyspy Owcze", FJ: "Fidżi", FI: "Finlandia", FR: "Francja", GF: "Gujana Francuska", PF: "Polinezja Francuska", TF: "Francuskie Terytoria Południowe i Antarktyczne", GA: "Gabon", GM: "Gambia", GE: "Gruzja", DE: "Niemcy", GH: "Ghana", GI: "Gibraltar", GR: "Grecja", GL: "Grenlandia", GD: "Grenada", GP: "Gwadelupa", GU: "Guam", GT: "Gwatemala", GN: "Gwinea", GW: "Gwinea Bissau", GY: "Gujana", HT: "Haiti", HM: "Wyspy Heard i McDonalda", VA: "Watykan", HN: "Honduras", HK: "Hongkong", HU: "Węgry", IS: "Islandia", IN: "Indie", ID: "Indonezja", IR: "Iran", IQ: "Irak", IE: "Irlandia", IL: "Izrael", IT: "Włochy", JM: "Jamajka", JP: "Japonia", JO: "Jordania", KZ: "Kazachstan", KE: "Kenia", KI: "Kiribati", KP: "Korea Północna", KR: "Korea Południowa", KW: "Kuwejt", KG: "Kirgistan", LA: "Laos", LV: "Łotwa", LB: "Liban", LS: "Lesotho", LR: "Liberia", LY: "Libia", LI: "Liechtenstein", LT: "Litwa", LU: "Luksemburg", MO: "Makau", MK: "Macedonia Północna", MG: "Madagaskar", MW: "Malawi", MY: "Malezja", MV: "Malediwy", ML: "Mali", MT: "Malta", MH: "Wyspy Marshalla", MQ: "Martynika", MR: "Mauretania", MU: "Mauritius", YT: "Majotta", MX: "Meksyk", FM: "Mikronezja", MD: "Mołdawia", MC: "Monako", MN: "Mongolia", MS: "Montserrat", MA: "Maroko", MZ: "Mozambik", MM: "Mjanma", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Holandia", NC: "Nowa Kaledonia", NZ: "Nowa Zelandia", NI: "Nikaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk", MP: "Mariany Północne", NO: "Norwegia", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestyna", PA: "Panama", PG: "Papua-Nowa Gwinea", PY: "Paragwaj", PE: "Peru", PH: "Filipiny", PN: "Pitcairn", PL: "Polska", PT: "Portugalia", PR: "Portoryko", QA: "Katar", RE: "Reunion", RO: "Rumunia", RU: "Rosja", RW: "Rwanda", SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha", KN: "Saint Kitts i Nevis", LC: "Saint Lucia", PM: "Saint-Pierre i Miquelon", VC: "Saint Vincent i Grenadyny", WS: "Samoa", SM: "San Marino", ST: "Wyspy Świętego Tomasza i Książęca", SA: "Arabia Saudyjska", SN: "Senegal", SC: "Seszele", SL: "Sierra Leone", SG: "Singapur", SK: "Słowacja", SI: "Słowenia", SB: "Wyspy Salomona", SO: "Somalia", ZA: "Południowa Afryka", GS: "Georgia Południowa i Sandwich Południowy", ES: "Hiszpania", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Svalbard i Jan Mayen", SZ: "Eswatini", SE: "Szwecja", CH: "Szwajcaria", SY: "Syria", TW: "Tajwan", TJ: "Tadżykistan", TZ: "Tanzania", TH: "Tajlandia", TL: "Timor Wschodni", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trynidad i Tobago", TN: "Tunezja", TR: "Turcja", TM: "Turkmenistan", TC: "Turks i Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "Zjednoczone Emiraty Arabskie", GB: "Wielka Brytania", US: "Stany Zjednoczone", UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych", UY: "Urugwaj", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Wenezuela", VN: "Wietnam", VG: "Brytyjskie Wyspy Dziewicze", VI: "Wyspy Dziewicze Stanów Zjednoczonych", WF: "Wallis i Futuna", EH: "Sahara Zachodnia", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Wyspy Alandzkie", BQ: "Bonaire, Sint Eustatius i Saba", CW: "Curaçao", GG: "Guernsey", IM: "Wyspa Man", JE: "Jersey", ME: "Czarnogóra", BL: "Saint-Barthélemy", MF: "Saint-Martin", RS: "Serbia", SX: "Sint Maarten", SS: "Sudan Południowy", XK: "Kosowo" }, Gd = {
  locale: rs,
  countries: ns
}, Ld = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ns,
  default: Gd,
  locale: rs
}, Symbol.toStringTag, { value: "Module" })), is = "pt", os = { AF: "Afeganistão", ZA: "África do Sul", AL: "Albânia", DE: "Alemanha", AD: "Andorra", AO: "Angola", AI: "Anguila", AQ: "Antártida", AG: "Antígua e Barbuda", SA: "Arábia Saudita", DZ: "Argélia", AR: "Argentina", AM: "Arménia", AW: "Aruba", AU: "Austrália", AT: "Áustria", AZ: "Azerbaijão", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BE: "Bélgica", BZ: "Belize", BJ: "Benim", BM: "Bermudas", BY: "Bielorrússia", BO: "Bolívia", BA: "Bósnia-Herzegovina", BW: "Botsuana", BR: "Brasil", BN: "Brunei", BG: "Bulgária", BF: "Burkina Faso", BI: "Burundi", BT: "Butão", CV: "Cabo Verde", KH: "Camboja", CA: "Canadá", QA: "Qatar", KZ: "Cazaquistão", TD: "Chade", CL: "Chile", CN: "China", CY: "Chipre", VA: "Santa Sé", SG: "Singapura", CO: "Colômbia", KM: "Comores", CG: "República Democrática do Congo", CD: "República Popular do Congo", KP: "Coreia do Norte", KR: "Coreia do Sul", CI: "Costa do Marfim", CR: "Costa Rica", HR: "Croácia", CU: "Cuba", CW: "Curaçao", DK: "Dinamarca", DJ: "Djibouti", DM: "Dominica", EG: "Egito", SV: "El Salvador", AE: "Emirados Árabes Unidos", EC: "Equador", ER: "Eritreia", SK: "Eslováquia", SI: "Eslovénia", ES: "Espanha", US: ["Estados Unidos", "Estados Unidos da América"], EE: "Estónia", ET: "Etiópia", FJ: "Fiji", PH: "Filipinas", FI: "Finlândia", FR: "França", GA: "Gabão", GM: "Gâmbia", GH: "Gana", GE: "Geórgia", GS: "Geórgia do Sul e Ilhas Sandwich do Sul", GI: "Gibraltar", GD: "Granada", GR: "Grécia", GL: "Gronelândia", GP: "Guadalupe", GU: "Guam", GT: "Guatemala", GG: "Guernsey", GY: "Guiana", GF: "Guiana Francesa", GN: "Guiné", GW: "Guiné-Bissau", GQ: "Guiné Equatorial", HT: "Haiti", NL: "Países Baixos", HN: "Honduras", HK: "Hong Kong", HU: "Hungria", YE: "Iémen", BV: "Ilha Bouvet", CX: "Ilha de Natal", IM: "Ilha de Man", NF: "Ilha Norfolk", AX: "Ilhas Åland", KY: "Ilhas Caimão", CC: "Ilhas Cocos (Keeling)", CK: "Ilhas Cook", UM: "Ilhas Distantes dos EUA", HM: "Ilha Heard e Ilhas McDonald", FO: "Ilhas Faroé", FK: "Ilhas Malvinas", MP: "Ilhas Marianas do Norte", MH: "Ilhas Marshall", PN: "Ilhas Pitcairn", SB: "Ilhas Salomão", TC: "Ilhas Turcas e Caicos", VG: "Ilhas Virgens Britânicas", VI: "Ilhas Virgens Americanas", IN: "Índia", ID: "Indonésia", IR: "Irão", IQ: "Iraque", IE: "Irlanda", IS: "Islândia", IL: "Israel", IT: "Itália", JM: "Jamaica", JP: "Japão", JE: "Jersey", JO: "Jordânia", KW: "Koweit", LA: "Laos", LS: "Lesoto", LV: "Letónia", LB: "Líbano", LR: "Libéria", LY: "Líbia", LI: "Liechtenstein", LT: "Lituânia", LU: "Luxemburgo", MO: "Macau", MK: "Macedónia do Norte", MG: "Madagáscar", MY: "Malásia", MW: "Maláui", MV: "Maldivas", ML: "Mali", MT: "Malta", MA: "Marrocos", MQ: "Martinica", MU: "Maurícia", MR: "Mauritânia", YT: "Mayotte", MX: "México", MM: "Mianmar (Birmânia)", FM: "Micronésia", MZ: "Moçambique", MD: "Moldávia", MC: "Mónaco", MN: "Mongólia", ME: "Montenegro", MS: "Monserrate", NA: "Namíbia", NR: "Nauru", NP: "Nepal", NI: "Nicarágua", NE: "Níger", NG: "Nigéria", NU: "Niue", NO: "Noruega", NC: "Nova Caledónia", NZ: "Nova Zelândia", OM: "Omã", BQ: "Países Baixos Caribenhos", PW: "Palau", PA: "Panamá", PG: "Papua-Nova Guiné", PK: "Paquistão", PY: "Paraguai", PE: "Peru", PF: "Polinésia Francesa", PL: "Polónia", PR: "Porto Rico", PT: "Portugal", KE: "Quénia", KG: "Quirguistão", KI: "Quiribati", GB: "Reino Unido", CF: "República Centro-Africana", DO: "República Dominicana", CM: "Camarões", CZ: "Chéquia", RE: "Reunião", RO: "Roménia", RW: "Ruanda", RU: "Rússia", EH: "Saara Ocidental", PM: "Saint Pierre e Miquelon", WS: "Samoa", AS: "Samoa Americana", SM: "San Marino", SH: "Santa Helena", LC: "Santa Lúcia", BL: "São Bartolomeu", KN: "São Cristóvão e Neves", MF: "São Martinho", ST: "São Tomé e Príncipe", VC: "São Vicente e Granadinas", SN: "Senegal", SL: "Serra Leoa", RS: "Sérvia", SC: "Seychelles", SX: "São Martinho", SY: "Síria", SO: "Somália", LK: "Sri Lanka", SZ: "Essuatíni", SD: "Sudão", SS: "Sudão do Sul", SE: "Suécia", CH: "Suíça", SR: "Suriname", SJ: "Svalbard e Jan Mayen", TH: "Tailândia", TW: "Taiwan", TJ: "Tajiquistão", TZ: "Tanzânia", IO: "Território Britânico do Oceano Índico", TF: "Terras Austrais e Antárticas Francesas", PS: "Territórios palestinos", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trindade e Tobago", TN: "Tunísia", TM: "Turquemenistão", TR: "Turquia", TV: "Tuvalu", UA: "Ucrânia", UG: "Uganda", UY: "Uruguai", UZ: "Uzbequistão", VU: "Vanuatu", VE: "Venezuela", VN: "Vietname", WF: "Wallis e Futuna", ZM: "Zâmbia", ZW: "Zimbábue", XK: "Kosovo" }, Rd = {
  locale: is,
  countries: os
}, Fd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: os,
  default: Rd,
  locale: is
}, Symbol.toStringTag, { value: "Module" })), ss = "ro", ls = { AD: "Andorra", AE: "Emiratele Arabe Unite", AF: "Afganistan", AG: "Antigua și Barbuda", AI: "Anguilla", AL: "Albania", AM: "Armenia", AO: "Angola", AQ: "Antarctica", AR: "Argentina", AS: "Samoa Americană", AT: "Austria", AU: "Australia", AW: "Aruba", AX: "Insulele Åland", AZ: "Azerbaidjan", BA: "Bosnia și Herțegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgia", BF: "Burkina Faso", BG: "Bulgaria", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Sfântul Bartolomeu", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Insulele Caraibe Olandeze", BR: "Brazilia", BS: "Bahamas", BT: "Bhutan", BV: "Insula Bouvet", BW: "Botswana", BY: "Belarus", BZ: "Belize", CA: "Canada", CC: "Insulele Cocos (Keeling)", CD: "Congo - Kinshasa", CF: "Republica Centrafricană", CG: "Congo - Brazzaville", CH: "Elveția", CI: "Côte d’Ivoire", CK: "Insulele Cook", CL: "Chile", CM: "Camerun", CN: "China", CO: "Columbia", CR: "Costa Rica", CU: "Cuba", CV: "Capul Verde", CW: "Curaçao", CX: "Insula Christmas", CY: "Cipru", CZ: "Cehia", DE: "Germania", DJ: "Djibouti", DK: "Danemarca", DM: "Dominica", DO: "Republica Dominicană", DZ: "Algeria", EC: "Ecuador", EE: "Estonia", EG: "Egipt", EH: "Sahara Occidentală", ER: "Eritreea", ES: "Spania", ET: "Etiopia", FI: "Finlanda", FJ: "Fiji", FK: "Insulele Falkland", FM: "Micronezia", FO: "Insulele Feroe", FR: "Franța", GA: "Gabon", GB: "Regatul Unit", GD: "Grenada", GE: "Georgia", GF: "Guyana Franceză", GG: "Guernsey", GH: "Ghana", GI: "Gibraltar", GL: "Groenlanda", GM: "Gambia", GN: "Guineea", GP: "Guadelupa", GQ: "Guineea Ecuatorială", GR: "Grecia", GS: "Georgia de Sud și Insulele Sandwich de Sud", GT: "Guatemala", GU: "Guam", GW: "Guineea-Bissau", GY: "Guyana", HK: "R.A.S. Hong Kong a Chinei", HM: "Insula Heard și Insulele McDonald", HN: "Honduras", HR: "Croația", HT: "Haiti", HU: "Ungaria", ID: "Indonezia", IE: "Irlanda", IL: "Israel", IM: "Insula Man", IN: "India", IO: "Teritoriul Britanic din Oceanul Indian", IQ: "Irak", IR: "Iran", IS: "Islanda", IT: "Italia", JE: "Jersey", JM: "Jamaica", JO: "Iordania", JP: "Japonia", KE: "Kenya", KG: "Kârgâzstan", KH: "Cambodgia", KI: "Kiribati", KM: "Comore", KN: "Saint Kitts și Nevis", KP: "Coreea de Nord", KR: "Coreea de Sud", KW: "Kuweit", KY: "Insulele Cayman", KZ: "Kazahstan", LA: "Laos", LB: "Liban", LC: "Sfânta Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Lituania", LU: "Luxemburg", LV: "Letonia", LY: "Libia", MA: "Maroc", MC: "Monaco", MD: "Republica Moldova", ME: "Muntenegru", MF: "Sfântul Martin", MG: "Madagascar", MH: "Insulele Marshall", MK: "Macedonia de Nord", ML: "Mali", MM: "Myanmar", MN: "Mongolia", MO: "R.A.S. Macao a Chinei", MP: "Insulele Mariane de Nord", MQ: "Martinica", MR: "Mauritania", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldive", MW: "Malawi", MX: "Mexic", MY: "Malaysia", MZ: "Mozambic", NA: "Namibia", NC: "Noua Caledonie", NE: "Niger", NF: "Insula Norfolk", NG: "Nigeria", NI: "Nicaragua", NL: "Țările de Jos", NO: "Norvegia", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Noua Zeelandă", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Polinezia Franceză", PG: "Papua-Noua Guinee", PH: "Filipine", PK: "Pakistan", PL: "Polonia", PM: "Saint-Pierre și Miquelon", PN: "Insulele Pitcairn", PR: "Puerto Rico", PS: "Teritoriile Palestiniene", PT: "Portugalia", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "România", RS: "Serbia", RU: "Rusia", RW: "Rwanda", SA: "Arabia Saudită", SB: "Insulele Solomon", SC: "Seychelles", SD: "Sudan", SE: "Suedia", SG: "Singapore", SH: "Sfânta Elena", SI: "Slovenia", SJ: "Svalbard și Jan Mayen", SK: "Slovacia", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Suriname", SS: "Sudanul de Sud", ST: "Sao Tomé și Príncipe", SV: "El Salvador", SX: "Sint-Maarten", SY: "Siria", SZ: "Eswatini", TC: "Insulele Turks și Caicos", TD: "Ciad", TF: "Teritoriile Australe și Antarctice Franceze", TG: "Togo", TH: "Thailanda", TJ: "Tadjikistan", TK: "Tokelau", TL: "Timorul de Est", TM: "Turkmenistan", TN: "Tunisia", TO: "Tonga", TR: "Turcia", TT: "Trinidad și Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzania", UA: "Ucraina", UG: "Uganda", UM: "Insulele Îndepărtate ale S.U.A.", US: "Statele Unite ale Americii", UY: "Uruguay", UZ: "Uzbekistan", VA: "Statul Cetății Vaticanului", VC: "Saint Vincent și Grenadinele", VE: "Venezuela", VG: "Insulele Virgine Britanice", VI: "Insulele Virgine Americane", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis și Futuna", WS: "Samoa", XK: "Kosovo", YE: "Yemen", YT: "Mayotte", ZA: "Africa de Sud", ZM: "Zambia", ZW: "Zimbabwe" }, Kd = {
  locale: ss,
  countries: ls
}, Hd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ls,
  default: Kd,
  locale: ss
}, Symbol.toStringTag, { value: "Module" })), us = "ru", cs = { AU: "Австралия", AT: "Австрия", AZ: "Азербайджан", AX: "Аландские острова", AL: "Албания", DZ: "Алжир", VI: "Виргинские Острова (США)", AS: "Американское Самоа", AI: "Ангилья", AO: "Ангола", AD: "Андорра", AQ: "Антарктида", AG: "Антигуа и Барбуда", AR: "Аргентина", AM: "Армения", AW: "Аруба", AF: "Афганистан", BS: "Багамы", BD: "Бангладеш", BB: "Барбадос", BH: "Бахрейн", BZ: "Белиз", BY: "Беларусь", BE: "Бельгия", BJ: "Бенин", BM: "Бермуды", BG: "Болгария", BO: "Боливия", BQ: "Бонэйр, Синт-Эстатиус и Саба", BA: "Босния и Герцеговина", BW: "Ботсвана", BR: "Бразилия", IO: "Британская территория в Индийском океане", VG: "Виргинские Острова (Великобритания)", BN: "Бруней", BF: "Буркина-Фасо", BI: "Бурунди", BT: "Бутан", VU: "Вануату", VA: "Ватикан", GB: "Великобритания", HU: "Венгрия", VE: "Венесуэла", UM: "Внешние малые острова (США)", TL: "Восточный Тимор", VN: "Вьетнам", GA: "Габон", HT: "Гаити", GY: "Гайана", GM: "Гамбия", GH: "Гана", GP: "Гваделупа", GT: "Гватемала", GF: "Гвиана", GN: "Гвинея", GW: "Гвинея-Бисау", DE: "Германия", GG: "Гернси", GI: "Гибралтар", HN: "Гондурас", HK: "Гонконг", GD: "Гренада", GL: "Гренландия", GR: "Греция", GE: "Грузия", GU: "Гуам", DK: "Дания", JE: "Джерси", DJ: "Джибути", DM: "Доминика", DO: "Доминиканская Республика", CD: "Демократическая Республика Конго", EG: "Египет", ZM: "Замбия", EH: "САДР", ZW: "Зимбабве", IL: "Израиль", IN: "Индия", ID: "Индонезия", JO: "Иордания", IQ: "Ирак", IR: "Иран", IE: "Ирландия", IS: "Исландия", ES: "Испания", IT: "Италия", YE: "Йемен", CV: "Кабо-Верде", KZ: "Казахстан", KY: "Острова Кайман", KH: "Камбоджа", CM: "Камерун", CA: "Канада", QA: "Катар", KE: "Кения", CY: "Кипр", KG: "Киргизия", KI: "Кирибати", TW: ["Тайвань", "Китайская Республика"], KP: "КНДР (Корейская Народно-Демократическая Республика)", CN: "КНР (Китайская Народная Республика)", CC: "Кокосовые острова", CO: "Колумбия", KM: "Коморы", CR: "Коста-Рика", CI: "Кот-д’Ивуар", CU: "Куба", KW: "Кувейт", CW: "Кюрасао", LA: "Лаос", LV: "Латвия", LS: "Лесото", LR: "Либерия", LB: "Ливан", LY: "Ливия", LT: "Литва", LI: "Лихтенштейн", LU: "Люксембург", MU: "Маврикий", MR: "Мавритания", MG: "Мадагаскар", YT: "Майотта", MO: "Макао", MW: "Малави", MY: "Малайзия", ML: "Мали", MV: "Мальдивы", MT: "Мальта", MA: "Марокко", MQ: "Мартиника", MH: "Маршалловы Острова", MX: "Мексика", FM: "Микронезия", MZ: "Мозамбик", MD: "Молдавия", MC: "Монако", MN: "Монголия", MS: "Монтсеррат", MM: "Мьянма", NA: "Намибия", NR: "Науру", NP: "Непал", NE: "Нигер", NG: "Нигерия", NL: "Нидерланды", NI: "Никарагуа", NU: "Ниуэ", NZ: "Новая Зеландия", NC: "Новая Каледония", NO: "Норвегия", AE: "ОАЭ", OM: "Оман", BV: "Остров Буве", IM: "Остров Мэн", CK: "Острова Кука", NF: "Остров Норфолк", CX: "Остров Рождества", PN: "Острова Питкэрн", SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья", PK: "Пакистан", PW: "Палау", PS: "Государство Палестина", PA: "Панама", PG: "Папуа — Новая Гвинея", PY: "Парагвай", PE: "Перу", PL: "Польша", PT: "Португалия", PR: "Пуэрто-Рико", CG: "Республика Конго", KR: "Республика Корея", RE: "Реюньон", RU: ["Российская Федерация", "Россия"], RW: "Руанда", RO: "Румыния", SV: "Сальвадор", WS: "Самоа", SM: "Сан-Марино", ST: "Сан-Томе и Принсипи", SA: "Саудовская Аравия", SZ: "Эсватини", MK: "Северная Македония", MP: "Северные Марианские Острова", SC: "Сейшельские Острова", BL: "Сен-Бартелеми", MF: "Сен-Мартен", PM: "Сен-Пьер и Микелон", SN: "Сенегал", VC: "Сент-Винсент и Гренадины", KN: "Сент-Китс и Невис", LC: "Сент-Люсия", RS: "Сербия", SG: "Сингапур", SX: "Синт-Мартен", SY: "Сирия", SK: "Словакия", SI: "Словения", SB: "Соломоновы Острова", SO: "Сомали", SD: "Судан", SR: "Суринам", US: "США", SL: "Сьерра-Леоне", TJ: "Таджикистан", TH: "Таиланд", TZ: "Танзания", TC: "Теркс и Кайкос", TG: "Того", TK: "Токелау", TO: "Тонга", TT: "Тринидад и Тобаго", TV: "Тувалу", TN: "Тунис", TM: "Туркмения", TR: "Турция", UG: "Уганда", UZ: "Узбекистан", UA: "Украина", WF: "Уоллис и Футуна", UY: "Уругвай", FO: "Фареры", FJ: "Фиджи", PH: "Филиппины", FI: "Финляндия", FK: "Фолклендские острова", FR: "Франция", PF: "Французская Полинезия", TF: "Французские Южные и Антарктические Территории", HM: "Херд и Макдональд", HR: "Хорватия", CF: "ЦАР", TD: "Чад", ME: "Черногория", CZ: "Чехия", CL: "Чили", CH: "Швейцария", SE: "Швеция", SJ: "Шпицберген и Ян-Майен", LK: "Шри-Ланка", EC: "Эквадор", GQ: "Экваториальная Гвинея", ER: "Эритрея", EE: "Эстония", ET: "Эфиопия", ZA: "ЮАР", GS: "Южная Георгия и Южные Сандвичевы Острова", SS: "Южный Судан", JM: "Ямайка", JP: "Япония", XK: "Косово" }, Ud = {
  locale: us,
  countries: cs
}, zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: cs,
  default: Ud,
  locale: us
}, Symbol.toStringTag, { value: "Module" })), ds = "sk", ps = { AD: "Andorra", AE: "Spojené arabské emiráty", AF: "Afganistan", AG: "Antigua a Barbuda", AI: "Anguilla", AL: "Albánsko", AM: "Arménsko", AO: "Angola", AQ: "Antarktída", AR: "Argentína", AS: "Americká Samoa", AT: "Rakúsko", AU: "Austrália", AW: "Aruba", AX: "Alandy", AZ: "Azerbajdžan", BA: "Bosna a Hercegovina", BB: "Barbados", BD: "Bangladéš", BE: "Belgicko", BF: "Burkina Faso", BG: "Bulharsko", BH: "Bahrajn", BI: "Burundi", BJ: "Benin", BL: "Svätý Bartolomej", BM: "Bermudy", BN: "Brunej", BO: "Bolívia", BQ: "Karibské Holandsko", BR: "Brazília", BS: "Bahamy", BT: "Bhután", BV: "Bouvetov ostrov", BW: "Botswana", BY: "Bielorusko", BZ: "Belize", CA: "Kanada", CC: "Kokosové ostrovy", CD: "Konžská demokratická republika", CF: "Stredoafrická republika", CG: "Konžská republika", CH: "Švajčiarsko", CI: "Pobrežie Slonoviny", CK: "Cookove ostrovy", CL: "Čile", CM: "Kamerun", CN: "Čína", CO: "Kolumbia", CR: "Kostarika", CU: "Kuba", CV: "Kapverdy", CW: "Curaçao", CX: "Vianočný ostrov", CY: "Cyprus", CZ: "Česko", DE: "Nemecko", DJ: "Džibutsko", DK: "Dánsko", DM: "Dominika", DO: "Dominikánska republika", DZ: "Alžírsko", EC: "Ekvádor", EE: "Estónsko", EG: "Egypt", EH: "Západná Sahara", ER: "Eritrea", ES: "Španielsko", ET: "Etiópia", FI: "Fínsko", FJ: "Fidži", FK: "Falklandy", FM: "Mikronézia", FO: "Faerské ostrovy", FR: "Francúzsko", GA: "Gabon", GB: "Spojené kráľovstvo", GD: "Grenada", GE: "Gruzínsko", GF: "Francúzska Guayana", GG: "Guernsey", GH: "Ghana", GI: "Gibraltár", GL: "Grónsko", GM: "Gambia", GN: "Guinea", GP: "Guadeloupe", GQ: "Rovníková Guinea", GR: "Grécko", GS: "Južná Georgia a Južné Sandwichove ostrovy", GT: "Guatemala", GU: "Guam", GW: "Guinea-Bissau", GY: "Guayana", HK: "Hongkong – OAO Číny", HM: "Heardov ostrov a Macdonaldove ostrovy", HN: "Honduras", HR: "Chorvátsko", HT: "Haiti", HU: "Maďarsko", ID: "Indonézia", IE: "Írsko", IL: "Izrael", IM: "Ostrov Man", IN: "India", IO: "Britské indickooceánske územie", IQ: "Irak", IR: "Irán", IS: "Island", IT: "Taliansko", JE: "Jersey", JM: "Jamajka", JO: "Jordánsko", JP: "Japonsko", KE: "Keňa", KG: "Kirgizsko", KH: "Kambodža", KI: "Kiribati", KM: "Komory", KN: "Svätý Krištof a Nevis", KP: "Severná Kórea", KR: "Južná Kórea", KW: "Kuvajt", KY: "Kajmanie ostrovy", KZ: "Kazachstan", LA: "Laos", LB: "Libanon", LC: "Svätá Lucia", LI: "Lichtenštajnsko", LK: "Srí Lanka", LR: "Libéria", LS: "Lesotho", LT: "Litva", LU: "Luxembursko", LV: "Lotyšsko", LY: "Líbya", MA: "Maroko", MC: "Monako", MD: "Moldavsko", ME: "Čierna Hora", MF: "Svätý Martin (fr.)", MG: "Madagaskar", MH: "Marshallove ostrovy", MK: "Severné Macedónsko", ML: "Mali", MM: "Mjanmarsko", MN: "Mongolsko", MO: "Macao – OAO Číny", MP: "Severné Mariány", MQ: "Martinik", MR: "Mauritánia", MS: "Montserrat", MT: "Malta", MU: "Maurícius", MV: "Maldivy", MW: "Malawi", MX: "Mexiko", MY: "Malajzia", MZ: "Mozambik", NA: "Namíbia", NC: "Nová Kaledónia", NE: "Niger", NF: "Norfolk", NG: "Nigéria", NI: "Nikaragua", NL: "Holandsko", NO: "Nórsko", NP: "Nepál", NR: "Nauru", NU: "Niue", NZ: "Nový Zéland", OM: "Omán", PA: "Panama", PE: "Peru", PF: "Francúzska Polynézia", PG: "Papua Nová Guinea", PH: "Filipíny", PK: "Pakistan", PL: "Poľsko", PM: "Saint Pierre a Miquelon", PN: "Pitcairnove ostrovy", PR: "Portoriko", PS: "Palestínske územia", PT: "Portugalsko", PW: "Palau", PY: "Paraguaj", QA: "Katar", RE: "Réunion", RO: "Rumunsko", RS: "Srbsko", RU: "Rusko", RW: "Rwanda", SA: "Saudská Arábia", SB: "Šalamúnove ostrovy", SC: "Seychely", SD: "Sudán", SE: "Švédsko", SG: "Singapur", SH: "Svätá Helena", SI: "Slovinsko", SJ: "Svalbard a Jan Mayen", SK: "Slovensko", SL: "Sierra Leone", SM: "San Maríno", SN: "Senegal", SO: "Somálsko", SR: "Surinam", SS: "Južný Sudán", ST: "Svätý Tomáš a Princov ostrov", SV: "Salvádor", SX: "Svätý Martin (hol.)", SY: "Sýria", SZ: "Svazijsko", TC: "Turks a Caicos", TD: "Čad", TF: "Francúzske južné a antarktické územia", TG: "Togo", TH: "Thajsko", TJ: "Tadžikistan", TK: "Tokelau", TL: "Východný Timor", TM: "Turkménsko", TN: "Tunisko", TO: "Tonga", TR: "Turecko", TT: "Trinidad a Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzánia", UA: "Ukrajina", UG: "Uganda", UM: "Menšie odľahlé ostrovy USA", US: "Spojené štáty", UY: "Uruguaj", UZ: "Uzbekistan", VA: "Vatikán", VC: "Svätý Vincent a Grenadíny", VE: "Venezuela", VG: "Britské Panenské ostrovy", VI: "Americké Panenské ostrovy", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis a Futuna", WS: "Samoa", XK: "Kosovo", YE: "Jemen", YT: "Mayotte", ZA: "Južná Afrika", ZM: "Zambia", ZW: "Zimbabwe" }, jd = {
  locale: ds,
  countries: ps
}, Vd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ps,
  default: jd,
  locale: ds
}, Symbol.toStringTag, { value: "Module" })), ms = "sl", hs = { AD: "Andora", AE: "Združeni arabski emirati", AF: "Afganistan", AG: "Antigva in Barbuda", AI: "Angvila", AL: "Albanija", AM: "Armenija", AO: "Angola", AQ: "Antarktika", AR: "Argentina", AS: "Ameriška Samoa", AT: "Avstrija", AU: "Avstralija", AW: "Aruba", AX: "Ålandski otoki", AZ: "Azerbajdžan", BA: "Bosna in Hercegovina", BB: "Barbados", BD: "Bangladeš", BE: "Belgija", BF: "Burkina Faso", BG: "Bolgarija", BH: "Bahrajn", BI: "Burundi", BJ: "Benin", BL: "Saint Barthélemy", BM: "Bermudi", BN: "Brunej", BO: "Bolivija", BQ: "Nizozemski Karibi", BR: "Brazilija", BS: "Bahami", BT: "Butan", BV: "Bouvetov otok", BW: "Bocvana", BY: "Belorusija", BZ: "Belize", CA: "Kanada", CC: "Kokosovi otoki", CD: "Demokratična republika Kongo", CF: "Centralnoafriška republika", CG: "Kongo - Brazzaville", CH: "Švica", CI: "Slonokoščena obala", CK: "Cookovi otoki", CL: "Čile", CM: "Kamerun", CN: "Kitajska", CO: "Kolumbija", CR: "Kostarika", CU: "Kuba", CV: "Zelenortski otoki", CW: "Curaçao", CX: "Božični otok", CY: "Ciper", CZ: "Češka", DE: "Nemčija", DJ: "Džibuti", DK: "Danska", DM: "Dominika", DO: "Dominikanska republika", DZ: "Alžirija", EC: "Ekvador", EE: "Estonija", EG: "Egipt", EH: "Zahodna Sahara", ER: "Eritreja", ES: "Španija", ET: "Etiopija", FI: "Finska", FJ: "Fidži", FK: "Falklandski otoki", FM: "Mikronezija", FO: "Ferski otoki", FR: "Francija", GA: "Gabon", GB: "Združeno kraljestvo", GD: "Grenada", GE: "Gruzija", GF: "Francoska Gvajana", GG: "Guernsey", GH: "Gana", GI: "Gibraltar", GL: "Grenlandija", GM: "Gambija", GN: "Gvineja", GP: "Gvadalupe", GQ: "Ekvatorialna Gvineja", GR: "Grčija", GS: "Južna Georgia in Južni Sandwichevi otoki", GT: "Gvatemala", GU: "Guam", GW: "Gvineja Bissau", GY: "Gvajana", HK: "Hongkong", HM: "Heardov otok in McDonaldovi otoki", HN: "Honduras", HR: "Hrvaška", HT: "Haiti", HU: "Madžarska", ID: "Indonezija", IE: "Irska", IL: "Izrael", IM: "Otok Man", IN: "Indija", IO: "Britansko ozemlje v Indijskem oceanu", IQ: "Irak", IR: "Iran", IS: "Islandija", IT: "Italija", JE: "Jersey", JM: "Jamajka", JO: "Jordanija", JP: "Japonska", KE: "Kenija", KG: "Kirgizistan", KH: "Kambodža", KI: "Kiribati", KM: "Komori", KN: "Saint Kitts in Nevis", KP: "Severna Koreja", KR: "Južna Koreja", KW: "Kuvajt", KY: "Kajmanski otoki", KZ: "Kazahstan", LA: "Laos", LB: "Libanon", LC: "Saint Lucia", LI: "Lihtenštajn", LK: "Šrilanka", LR: "Liberija", LS: "Lesoto", LT: "Litva", LU: "Luksemburg", LV: "Latvija", LY: "Libija", MA: "Maroko", MC: "Monako", MD: "Moldavija", ME: "Črna gora", MF: "Saint Martin", MG: "Madagaskar", MH: "Marshallovi otoki", MK: "Severna Makedonija", ML: "Mali", MM: "Mjanmar (Burma)", MN: "Mongolija", MO: "Macao", MP: "Severni Marianski otoki", MQ: "Martinik", MR: "Mavretanija", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldivi", MW: "Malavi", MX: "Mehika", MY: "Malezija", MZ: "Mozambik", NA: "Namibija", NC: "Nova Kaledonija", NE: "Niger", NF: "Norfolški otok", NG: "Nigerija", NI: "Nikaragva", NL: "Nizozemska", NO: "Norveška", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nova Zelandija", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Francoska Polinezija", PG: "Papua Nova Gvineja", PH: "Filipini", PK: "Pakistan", PL: "Poljska", PM: "Saint Pierre in Miquelon", PN: "Pitcairn", PR: "Portoriko", PS: "Palestinsko ozemlje", PT: "Portugalska", PW: "Palau", PY: "Paragvaj", QA: "Katar", RE: "Reunion", RO: "Romunija", RS: "Srbija", RU: "Rusija", RW: "Ruanda", SA: "Saudova Arabija", SB: "Salomonovi otoki", SC: "Sejšeli", SD: "Sudan", SE: "Švedska", SG: "Singapur", SH: "Sveta Helena", SI: "Slovenija", SJ: "Svalbard in Jan Mayen", SK: "Slovaška", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalija", SR: "Surinam", SS: "Južni Sudan", ST: "Sao Tome in Principe", SV: "Salvador", SX: "Sint Maarten", SY: "Sirija", SZ: "Svazi", TC: "Otoki Turks in Caicos", TD: "Čad", TF: "Francosko južno ozemlje", TG: "Togo", TH: "Tajska", TJ: "Tadžikistan", TK: "Tokelau", TL: "Timor-Leste", TM: "Turkmenistan", TN: "Tunizija", TO: "Tonga", TR: "Turčija", TT: "Trinidad in Tobago", TV: "Tuvalu", TW: "Tajvan", TZ: "Tanzanija", UA: "Ukrajina", UG: "Uganda", UM: "Stranski zunanji otoki Združenih držav", US: "Združene države Amerike", UY: "Urugvaj", UZ: "Uzbekistan", VA: "Vatikan", VC: "Saint Vincent in Grenadine", VE: "Venezuela", VG: "Britanski Deviški otoki", VI: "Ameriški Deviški otoki", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis in Futuna", WS: "Samoa", XK: "Kosovo", YE: "Jemen", YT: "Mayotte", ZA: "Južnoafriška republika", ZM: "Zambija", ZW: "Zimbabve" }, Yd = {
  locale: ms,
  countries: hs
}, Wd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: hs,
  default: Yd,
  locale: ms
}, Symbol.toStringTag, { value: "Module" })), fs = "sq", gs = { AF: "Afganistan", AL: "Shqipëri", DZ: "Algjeri", AS: "Samoa Amerikane", AD: "Andorrë", AO: "Angolë", AI: "Anguilë", AQ: "Antarktidë", AG: "Antigua & Barbuda", AR: "Argjentinë", AM: "Armeni", AW: "Arubë", AU: "Australi", AT: "Austri", AZ: "Azerbajxhan", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Bjellorusi", BE: "Belgjikë", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Butan", BO: "Bolivi", BA: "Bosnjë & Hercegovinë", BW: "Botsvanë", BV: "Ishulli Buve", BR: "Brazil", IO: "Territori Britanik i Oqeanit Indian", BN: "Brunej", BG: "Bullgari", BF: "Burkina Faso", BI: "Burund", KH: "Kamboxhia", CM: "Kamerun", CA: "Kanada", CV: "Kepi i Gjelbër", KY: "Ishujt Kajman", CF: "Republika Afrikano-Qendrore", TD: "Çad", CL: "Kili", CN: "Kinë", CX: "Ishulli i Krishtlindjes", CC: "Ishujt Kokos (Kiling)", CO: "Kolumbi", KM: "Komore", CG: "Kongo-Brazavil", CD: "Kongo-Kinshasa", CK: "Ishulli Kuk", CR: "Kosta Rikë", CI: "Bregu i Fildishtë", HR: "Kroaci", CU: "Kubë", CY: "Qipro", CZ: "Republika Çeke", DK: "Danimarkë", DJ: "Xhibut", DM: "Dominikë", DO: "Republika Dominikane", EC: "Ekuador", EG: "Egjipt", SV: "El Salvador", GQ: "Guineja Ekuatoriale", ER: "Eritre", EE: "Estoni", ET: "Etiopi", FK: "Ishujt Folkland", FO: "Ishujt Faroe", FJ: "Fixhi", FI: "Finlandë", FR: "Francë", GF: "Guajana Frënge", PF: "Polinezia Frënge", TF: "Territoret Frënge Jugore", GA: "Gabon", GM: "Gambia", GE: "Gjeorgji", DE: "Gjermani", GH: "Gana", GI: "Gjibraltar", GR: "Greqi", GL: "Groenlandë", GD: "Grenadë", GP: "Guadalup", GU: "Guam", GT: "Guatemalë", GN: "Guine", GW: "Guinea-Bisau", GY: "Guajanë", HT: "Haiti", HM: "Ishujt Hërd & Mekdonald", VA: "Vatikan", HN: "Honduras", HK: "RVA i Hong Kongut Kinë", HU: "Hungari", IS: "Islandë", IN: "Indi", ID: "Indonezi", IR: "Iran", IQ: "Irak", IE: "Irlandë", IL: "Izrael", IT: "Itali", JM: "Xhamajkë", JP: "Japoni", JO: "Jordani", KZ: "Kazakistan", KE: "Kenia", KI: "Kiribati", KP: "Koreja e Veriut", KR: "Koreja e Jugut", KW: "Kuvajt", KG: "Kirgizstan", LA: "Laos", LV: "Letoni", LB: "Liban", LS: "Lesoto", LR: "Liberi", LY: "Libi", LI: "Lihtenshtein", LT: "Lituani", LU: "Luksemburg", MO: "RVA i Makaos Kinë", MG: "Madagaskar", MW: "Malavi", MY: "Malajzi", MV: "Maldive", ML: "Mali", MT: "Maltë", MH: "Ishujt Marshall", MQ: "Martinikë", MR: "Mauritani", MU: "Mauritius", YT: "Majote", MX: "Meksikë", FM: "Mikronezi", MD: "Moldavi", MC: "Monako", MN: "Mongoli", MS: "Montserat", MA: "Marok", MZ: "Mozambik", MM: "Mianmar (Burma)", NA: "Namibi", NR: "Nauru", NP: "Nepal", NL: "Holandë", NC: "Kaledonia e Re", NZ: "Zelandë e Re", NI: "Nikaragua", NE: "Niger", NG: "Nigeri", NU: "Niue", NF: "Ishujt Norfolk", MK: "Maqedoni", MP: "Ishujt Veriorë Mariana", NO: "Norvegji", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Territoret Palestineze", PA: "Panama", PG: "Papua Guineja e Re", PY: "Paraguai", PE: "Peru", PH: "Filipine", PN: "Ishujt Pitkern", PL: "Poloni", PT: "Portugali", PR: "Porto Riko", QA: "Katar", RE: "Reunion", RO: "Rumani", RU: "Rusi", RW: "Ruandë", SH: "Shën Helena", KN: "Shën Kits e Nevis", LC: "Shën Luçia", PM: "Shën Pier dhe Mikëlon", VC: "Shën Vinsent & Grenadinet", WS: "Samoa", SM: "San Marino", ST: "Sao Tome & Prinsipe", SA: "Arabi Saudite", SN: "Senegal", SC: "Sejshelle", SL: "Sierra Leone", SG: "Singapor", SK: "Sllovaki", SI: "Slloveni", SB: "Ishujt Solomon", SO: "Somali", ZA: "Afrikë e Jugut", GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut", ES: "Spanjë", LK: "Sri Lankë", SD: "Sudan", SR: "Surinam", SJ: "Svalbard & Zhan Majen", SZ: "Svaziland", SE: "Suedi", CH: "Zvicër", SY: "Siri", TW: "Tajvan", TJ: "Taxhikistan", TZ: "Tanzani", TH: "Tajlandë", TL: "Timori Lindor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad & Tobago", TN: "Tunizi", TR: "Turqi", TM: "Turkmenistan", TC: "Ishujt Turk & Kaikos", TV: "Tuvalu", UG: "Ugandë", UA: "Ukrainë", AE: "Emiratet e Bashkuara Arabe", GB: "Mbretëria e Bashkuar", US: "Shtetet e Bashkuara të Amerikës", UM: "Ishujt e Përtejmë SHBA-së", UY: "Uruguai", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuelë", VN: "Vietnam", VG: "Ishujt e Virgjër Britanikë", VI: "Ishujt e Virgjër Amerikanë", WF: "Uollis e Futuna", EH: "Sahara Perëndimore", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabve", AX: "Ishujt Aland", BQ: "Karaibet Holandeze", CW: "Kurasao", GG: "Gërnsi", IM: "Ishulli i Robit", JE: "Xhërsi", ME: "Mali i Zi", BL: "Shën Bartolomeo", MF: "Shën Martin", RS: "Serbi", SX: "Shën Martin", SS: "Sudan i Jugut", XK: "Kosovë" }, Zd = {
  locale: fs,
  countries: gs
}, Jd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: gs,
  default: Zd,
  locale: fs
}, Symbol.toStringTag, { value: "Module" })), _s = "sr", ys = { AD: "Андора", AE: "Уједињени Арапски Емирати", AF: "Авганистан", AG: "Антигва и Барбуда", AI: "Ангвила", AL: "Албанија", AM: "Јерменија", AO: "Ангола", AQ: "Антарктик", AR: "Аргентина", AS: "Америчка Самоа", AT: "Аустрија", AU: "Аустралија", AW: "Аруба", AX: "Оландска Острва", AZ: "Азербејџан", BA: "Босна и Херцеговина", BB: "Барбадос", BD: "Бангладеш", BE: "Белгија", BF: "Буркина Фасо", BG: "Бугарска", BH: "Бахреин", BI: "Бурунди", BJ: "Бенин", BL: "Сен Бартелеми", BM: "Бермуда", BN: "Брунеј", BO: "Боливија", BQ: "Карипска Холандија", BR: "Бразил", BS: "Бахами", BT: "Бутан", BV: "Острво Буве", BW: "Боцвана", BY: "Белорусија", BZ: "Белизе", CA: "Канада", CC: "Кокосова (Килингова) Острва", CD: "Конго - Киншаса", CF: "Централноафричка Република", CG: "Конго - Бразавил", CH: "Швајцарска", CI: "Обала Слоноваче", CK: "Кукова Острва", CL: "Чиле", CM: "Камерун", CN: "Кина", CO: "Колумбија", CR: "Костарика", CU: "Куба", CV: "Зеленортска Острва", CW: "Курасао", CX: "Божићно Острво", CY: "Кипар", CZ: "Чешка", DE: "Немачка", DJ: "Џибути", DK: "Данска", DM: "Доминика", DO: "Доминиканска Република", DZ: "Алжир", EC: "Еквадор", EE: "Естонија", EG: "Египат", EH: "Западна Сахара", ER: "Еритреја", ES: "Шпанија", ET: "Етиопија", FI: "Финска", FJ: "Фиџи", FK: "Фокландска Острва", FM: "Микронезија", FO: "Фарска Острва", FR: "Француска", GA: "Габон", GB: "Уједињено Краљевство", GD: "Гренада", GE: "Грузија", GF: "Француска Гвајана", GG: "Гернзи", GH: "Гана", GI: "Гибралтар", GL: "Гренланд", GM: "Гамбија", GN: "Гвинеја", GP: "Гваделуп", GQ: "Екваторијална Гвинеја", GR: "Грчка", GS: "Јужна Џорџија и Јужна Сендвичка Острва", GT: "Гватемала", GU: "Гуам", GW: "Гвинеја-Бисао", GY: "Гвајана", HK: "САР Хонгконг (Кина)", HM: "Острво Херд и Мекдоналдова острва", HN: "Хондурас", HR: "Хрватска", HT: "Хаити", HU: "Мађарска", ID: "Индонезија", IE: "Ирска", IL: "Израел", IM: "Острво Ман", IN: "Индија", IO: "Британска територија Индијског океана", IQ: "Ирак", IR: "Иран", IS: "Исланд", IT: "Италија", JE: "Џерзи", JM: "Јамајка", JO: "Јордан", JP: "Јапан", KE: "Кенија", KG: "Киргистан", KH: "Камбоџа", KI: "Кирибати", KM: "Коморска Острва", KN: "Сент Китс и Невис", KP: "Северна Кореја", KR: "Јужна Кореја", KW: "Кувајт", KY: "Кајманска Острва", KZ: "Казахстан", LA: "Лаос", LB: "Либан", LC: "Света Луција", LI: "Лихтенштајн", LK: "Шри Ланка", LR: "Либерија", LS: "Лесото", LT: "Литванија", LU: "Луксембург", LV: "Летонија", LY: "Либија", MA: "Мароко", MC: "Монако", MD: "Молдавија", ME: "Црна Гора", MF: "Свети Мартин (Француска)", MG: "Мадагаскар", MH: "Маршалска Острва", MK: "Северна Македонија", ML: "Мали", MM: "Мијанмар (Бурма)", MN: "Монголија", MO: "САР Макао (Кина)", MP: "Северна Маријанска Острва", MQ: "Мартиник", MR: "Мауританија", MS: "Монсерат", MT: "Малта", MU: "Маурицијус", MV: "Малдиви", MW: "Малави", MX: "Мексико", MY: "Малезија", MZ: "Мозамбик", NA: "Намибија", NC: "Нова Каледонија", NE: "Нигер", NF: "Острво Норфок", NG: "Нигерија", NI: "Никарагва", NL: "Холандија", NO: "Норвешка", NP: "Непал", NR: "Науру", NU: "Ниуе", NZ: "Нови Зеланд", OM: "Оман", PA: "Панама", PE: "Перу", PF: "Француска Полинезија", PG: "Папуа Нова Гвинеја", PH: "Филипини", PK: "Пакистан", PL: "Пољска", PM: "Сен Пјер и Микелон", PN: "Питкерн", PR: "Порторико", PS: "Палестинске територије", PT: "Португалија", PW: "Палау", PY: "Парагвај", QA: "Катар", RE: "Реинион", RO: "Румунија", RS: "Србија", RU: "Русија", RW: "Руанда", SA: "Саудијска Арабија", SB: "Соломонска Острва", SC: "Сејшели", SD: "Судан", SE: "Шведска", SG: "Сингапур", SH: "Света Јелена", SI: "Словенија", SJ: "Свалбард и Јан Мајен", SK: "Словачка", SL: "Сијера Леоне", SM: "Сан Марино", SN: "Сенегал", SO: "Сомалија", SR: "Суринам", SS: "Јужни Судан", ST: "Сао Томе и Принципе", SV: "Салвадор", SX: "Свети Мартин (Холандија)", SY: "Сирија", SZ: "Свазиленд", TC: "Острва Туркс и Каикос", TD: "Чад", TF: "Француске Јужне Територије", TG: "Того", TH: "Тајланд", TJ: "Таџикистан", TK: "Токелау", TL: "Источни Тимор", TM: "Туркменистан", TN: "Тунис", TO: "Тонга", TR: "Турска", TT: "Тринидад и Тобаго", TV: "Тувалу", TW: "Тајван", TZ: "Танзанија", UA: "Украјина", UG: "Уганда", UM: "Удаљена острва САД", US: "Сједињене Државе", UY: "Уругвај", UZ: "Узбекистан", VA: "Ватикан", VC: "Сент Винсент и Гренадини", VE: "Венецуела", VG: "Британска Девичанска Острва", VI: "Америчка Девичанска Острва", VN: "Вијетнам", VU: "Вануату", WF: "Валис и Футуна", WS: "Самоа", XK: "Косово", YE: "Јемен", YT: "Мајот", ZA: "Јужноафричка Република", ZM: "Замбија", ZW: "Зимбабве" }, $d = {
  locale: _s,
  countries: ys
}, qd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ys,
  default: $d,
  locale: _s
}, Symbol.toStringTag, { value: "Module" })), vs = "sv", bs = { AD: "Andorra", AE: "Förenade Arabemiraten", AF: "Afghanistan", AG: "Antigua och Barbuda", AI: "Anguilla", AL: "Albanien", AM: "Armenien", AO: "Angola", AQ: "Antarktis", AR: "Argentina", AS: "Amerikanska Samoa", AT: "Österrike", AU: "Australien", AW: "Aruba", AX: "Åland", AZ: "Azerbajdzjan", BA: "Bosnien och Hercegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgien", BF: "Burkina Faso", BG: "Bulgarien", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Saint-Barthélemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Bonaire, Saint Eustatius och Saba", BR: "Brasilien", BS: "Bahamas", BT: "Bhutan", BV: "Bouvetön", BW: "Botswana", BY: "Belarus", BZ: "Belize", CA: "Kanada", CC: "Kokosöarna", CD: "Demokratiska republiken Kongo", CF: "Centralafrikanska republiken", CG: "Kongo-Brazzaville", CH: "Schweiz", CI: "Elfenbenskusten", CK: "Cooköarna", CL: "Chile", CM: "Kamerun", CN: "Kina", CO: "Colombia", CR: "Costa Rica", CU: "Kuba", CV: "Kap Verde", CW: "Curacao", CX: "Julön", CY: "Cypern", CZ: "Tjeckien", DE: "Tyskland", DJ: "Djibouti", DK: "Danmark", DM: "Dominica", DO: "Dominikanska republiken", DZ: "Algeriet", EC: "Ecuador", EE: "Estland", EG: "Egypten", EH: "Västsahara", ER: "Eritrea", ES: "Spanien", ET: "Etiopien", FI: "Finland", FJ: "Fiji", FK: "Falklandsöarna", FM: "Mikronesiska federationen", FO: "Färöarna", FR: "Frankrike", GA: "Gabon", GB: "Storbritannien", GD: "Grenada", GE: "Georgien", GF: "Franska Guyana", GG: "Guernsey", GH: "Ghana", GI: "Gibraltar", GL: "Grönland", GM: "Gambia", GN: "Guinea", GP: "Guadeloupe", GQ: "Ekvatorialguinea", GR: "Grekland", GS: "Sydgeorgien och Sydsandwichöarna", GT: "Guatemala", GU: "Guam", GW: "Guinea Bissau", GY: "Guyana", HK: "Hongkong", HM: "Heard- och McDonaldsöarna", HN: "Honduras", HR: "Kroatien", HT: "Haiti", HU: "Ungern", ID: "Indonesien", IE: "Irland", IL: "Israel", IM: "Isle of Man", IN: "Indien", IO: "Brittiska territoriet i Indiska Oceanen", IQ: "Irak", IR: "Iran", IS: "Island", IT: "Italien", JE: "Jersey", JM: "Jamaica", JO: "Jordanien", JP: "Japan", KE: "Kenya", KG: "Kirgizistan", KH: "Kambodja", KI: "Kiribati", KM: "Komorerna", KN: "Saint Kitts och Nevis", KP: "Nordkorea", KR: "Sydkorea", KW: "Kuwait", KY: "Caymanöarna", KZ: "Kazakstan", LA: "Laos", LB: "Libanon", LC: "Saint Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Litauen", LU: "Luxemburg", LV: "Lettland", LY: "Libyen", MA: "Marocko", MC: "Monaco", MD: "Moldavien", ME: "Montenegro", MF: "Saint Martin (franska delen)", MG: "Madagaskar", MH: "Marshallöarna", MK: "Nordmakedonien", ML: "Mali", MM: "Burma", MN: "Mongoliet", MO: "Macau", MP: "Nordmarianerna", MQ: "Martinique", MR: "Mauretanien", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldiverna", MW: "Malawi", MX: "Mexiko", MY: "Malaysia", MZ: "Moçambique", NA: "Namibia", NC: "Nya Kaledonien", NE: "Niger", NF: "Norfolkön", NG: "Nigeria", NI: "Nicaragua", NL: "Nederländerna", NO: "Norge", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nya Zeeland", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Franska Polynesien", PG: "Papua Nya Guinea", PH: "Filippinerna", PK: "Pakistan", PL: "Polen", PM: "Saint-Pierre och Miquelon", PN: "Pitcairnöarna", PR: "Puerto Rico", PS: "Palestinska territoriet, ockuperade", PT: "Portugal", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "Rumänien", RS: "Serbien", RU: "Ryssland", RW: "Rwanda", SA: "Saudiarabien", SB: "Salomonöarna", SC: "Seychellerna", SD: "Sudan", SE: "Sverige", SG: "Singapore", SH: "Sankta Helena", SI: "Slovenien", SJ: "Svalbard och Jan Mayen", SK: "Slovakien", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Surinam", SS: "Sydsudan", ST: "São Tomé och Príncipe", SV: "El Salvador", SX: "Sint Maarten (nederländska delen)", SY: "Syrien", SZ: "Eswatini", TC: "Turks- och Caicosöarna", TD: "Tchad", TF: "Franska södra territorierna", TG: "Togo", TH: "Thailand", TJ: "Tadzjikistan", TK: "Tokelauöarna", TL: "Östtimor", TM: "Turkmenistan", TN: "Tunisien", TO: "Tonga", TR: "Turkiet", TT: "Trinidad och Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzania", UA: "Ukraina", UG: "Uganda", UM: "USA:s yttre öar", US: "USA", UY: "Uruguay", UZ: "Uzbekistan", VA: "Vatikanstaten", VC: "Saint Vincent och Grenadinerna", VE: "Venezuela", VG: "Brittiska Jungfruöarna", VI: "Amerikanska Jungfruöarna", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis- och Futunaöarna", WS: "Samoa", YE: "Jemen", YT: "Mayotte", ZA: "Sydafrika", ZM: "Zambia", ZW: "Zimbabwe", XK: "Kosovo" }, Qd = {
  locale: vs,
  countries: bs
}, Xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: bs,
  default: Qd,
  locale: vs
}, Symbol.toStringTag, { value: "Module" })), Ss = "th", ks = { BD: "บังกลาเทศ", BE: "เบลเยียม", BF: "บูร์กินาฟาโซ", BG: "บัลแกเรีย", BA: "บอสเนียและเฮอร์เซโกวีนา", BB: "บาร์เบโดส", WF: "วาลลิสและฟุตูนา", BL: "เซนต์บาร์เธเลมี", BM: "เบอร์มิวดา", BN: "บรูไน", BO: "โบลิเวีย", BH: "บาห์เรน", BI: "บุรุนดี", BJ: "เบนิน", BT: "ภูฏาน", JM: "จาเมกา", BV: "เกาะบูเวต", BW: "บอตสวานา", WS: "ซามัว", BR: "บราซิล", BS: "บาฮามาส", JE: "เจอร์ซีย์", BY: "เบลารุส", BZ: "เบลีซ", RU: "รัสเซีย", RW: "รวันดา", RS: "เซอร์เบีย", TL: "ติมอร์ตะวันออก", RE: "เรอูนียง", TM: "เติร์กเมนิสถาน", TJ: "ทาจิกิสถาน", RO: "โรมาเนีย", TK: "โตเกเลา", GW: "กินี-บิสเซา", GU: "กวม", GT: "กัวเตมาลา", GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช", GR: "กรีซ", GQ: "อิเควทอเรียลกินี", GP: "กวาเดอลูป", JP: "ญี่ปุ่น", GY: "กายอานา", GG: "เกิร์นซีย์", GF: "เฟรนช์เกียนา", GE: "จอร์เจีย", GD: "เกรเนดา", GB: "สหราชอาณาจักร", GA: "กาบอง", SV: "เอลซัลวาดอร์", GN: "กินี", GM: "แกมเบีย", GL: "กรีนแลนด์", GI: "ยิบรอลตาร์", GH: "กานา", OM: "โอมาน", TN: "ตูนิเซีย", JO: "จอร์แดน", HR: "โครเอเชีย", HT: "เฮติ", HU: "ฮังการี", HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน", HN: "ฮอนดูรัส", HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์", VE: "เวเนซุเอลา", PR: "เปอร์โตริโก", PS: "ปาเลสไตน์", PW: "ปาเลา", PT: "โปรตุเกส", SJ: "สฟาลบาร์และยานไมเอน", PY: "ปารากวัย", IQ: "อิรัก", PA: "ปานามา", PF: "เฟรนช์โปลินีเซีย", PG: "ปาปัวนิวกินี", PE: "เปรู", PK: "ปากีสถาน", PH: "ฟิลิปปินส์", PN: "พิตแคร์น", PL: "โปแลนด์", PM: "แซงปีแยร์และมีเกอลง", ZM: "แซมเบีย", EH: "ซาฮาราตะวันตก", EE: "เอสโตเนีย", EG: "อียิปต์", ZA: "แอฟริกาใต้", EC: "เอกวาดอร์", IT: "อิตาลี", VN: "เวียดนาม", SB: "หมู่เกาะโซโลมอน", ET: "เอธิโอเปีย", SO: "โซมาเลีย", ZW: "ซิมบับเว", SA: "ซาอุดีอาระเบีย", ES: "สเปน", ER: "เอริเทรีย", ME: "มอนเตเนโกร", MD: "มอลโดวา", MG: "มาดากัสการ์", MF: "เซนต์มาติน", MA: "โมร็อกโก", MC: "โมนาโก", UZ: "อุซเบกิสถาน", MM: "เมียนม่าร์ [พม่า]", ML: "มาลี", MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน", MN: "มองโกเลีย", MH: "หมู่เกาะมาร์แชลล์", MK: "มาซิโดเนีย", MU: "มอริเชียส", MT: "มอลตา", MW: "มาลาวี", MV: "มัลดีฟส์", MQ: "มาร์ตินีก", MP: "หมู่เกาะนอร์เทิร์นมาเรียนา", MS: "มอนต์เซอร์รัต", MR: "มอริเตเนีย", IM: "เกาะแมน", UG: "ยูกันดา", TZ: "แทนซาเนีย", MY: "มาเลเซีย", MX: "เม็กซิโก", IL: "อิสราเอล", FR: "ฝรั่งเศส", IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี", SH: "เซนต์เฮเลนา", FI: "ฟินแลนด์", FJ: "ฟิจิ", FK: "หมู่เกาะฟอล์กแลนด์", FM: "ไมโครนีเซีย", FO: "หมู่เกาะแฟโร", NI: "นิการากัว", NL: "เนเธอร์แลนด์", NO: "นอร์เวย์", NA: "นามิเบีย", VU: "วานูอาตู", NC: "นิวแคลิโดเนีย", NE: "ไนเจอร์", NF: "เกาะนอร์ฟอล์ก", NG: "ไนจีเรีย", NZ: "นิวซีแลนด์", NP: "เนปาล", NR: "นาอูรู", NU: "นีอูเอ", CK: "หมู่เกาะคุก", CI: "ไอวอรี่โคสต์", CH: "สวิตเซอร์แลนด์", CO: "โคลอมเบีย", CN: "จีน", CM: "แคเมอรูน", CL: "ชิลี", CC: "หมู่เกาะโคโคส", CA: "แคนาดา", CG: "คองโก-บราซซาวิล", CF: "สาธารณรัฐแอฟริกากลาง", CD: "คองโก-กินชาซา", CZ: "สาธารณรัฐเช็ก", CY: "ไซปรัส", CX: "เกาะคริสต์มาส", CR: "คอสตาริกา", CV: "เคปเวิร์ด", CU: "คิวบา", SZ: "สวาซิแลนด์", SY: "ซีเรีย", KG: "คีร์กีซสถาน", KE: "เคนยา", SR: "ซูรินาเม", KI: "คิริบาส", KH: "กัมพูชา", KN: "เซนต์คิตส์และเนวิส", KM: "คอโมโรส", ST: "เซาตูเมและปรินซิปี", SK: "สโลวะเกีย", KR: "เกาหลีใต้", SI: "สโลวีเนีย", KP: "เกาหลีเหนือ", KW: "คูเวต", SN: "เซเนกัล", SM: "ซานมารีโน", SL: "เซียร์ราลีโอน", SC: "เซเชลส์", KZ: "คาซัคสถาน", KY: "หมู่เกาะเคย์แมน", SG: "สิงคโปร์", SE: "สวีเดน", SD: "ซูดาน", DO: "สาธารณรัฐโดมินิกัน", DM: "โดมินิกา", DJ: "จิบูตี", DK: "เดนมาร์ก", VG: "หมู่เกาะบริติชเวอร์จิน", DE: "เยอรมนี", YE: "เยเมน", DZ: "แอลจีเรีย", US: "สหรัฐอเมริกา", UY: "อุรุกวัย", YT: "มายอต", UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง", LB: "เลบานอน", LC: "เซนต์ลูเซีย", LA: "ลาว", TV: "ตูวาลู", TW: "ไต้หวัน", TT: "ตรินิแดดและโตเบโก", TR: "ตุรกี", LK: "ศรีลังกา", LI: "ลิกเตนสไตน์", LV: "ลัตเวีย", TO: "ตองกา", LT: "ลิทัวเนีย", LU: "ลักเซมเบิร์ก", LR: "ไลบีเรีย", LS: "เลโซโท", TH: "ไทย", TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์", TG: "โตโก", TD: "ชาด", TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส", LY: "ลิเบีย", VA: "วาติกัน", VC: "เซนต์วินเซนต์และเกรนาดีนส์", AE: "สหรัฐอาหรับเอมิเรตส์", AD: "อันดอร์รา", AG: "แอนติกาและบาร์บูดา", AF: "อัฟกานิสถาน", AI: "แองกวิลลา", VI: "หมู่เกาะยูเอสเวอร์จิน", IS: "ไอซ์แลนด์", IR: "อิหร่าน", AM: "อาร์เมเนีย", AL: "แอลเบเนีย", AO: "แองโกลา", AQ: "แอนตาร์กติกา", AS: "อเมริกันซามัว", AR: "อาร์เจนตินา", AU: "ออสเตรเลีย", AT: "ออสเตรีย", AW: "อารูบา", IN: "อินเดีย", AX: "หมู่เกาะโอลันด์", AZ: "อาเซอร์ไบจาน", IE: "ไอร์แลนด์", ID: "อินโดนีเซีย", UA: "ยูเครน", QA: "กาตาร์", MZ: "โมซัมบิก", BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา", CW: "คูราเซา", SX: "Sint Maarten (ส่วนดัตช์)", SS: "ซูดานใต้", XK: "โคโซโว" }, ep = {
  locale: Ss,
  countries: ks
}, ap = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ks,
  default: ep,
  locale: Ss
}, Symbol.toStringTag, { value: "Module" })), Ms = "tr", ws = { AD: "Andorra", AE: "Birleşik Arap Emirlikleri", AF: "Afganistan", AG: "Antigua ve Barbuda", AI: "Anguilla", AL: "Arnavutluk", AM: "Ermenistan", AO: "Angola", AQ: "Antarktika", AR: "Arjantin", AS: "Amerikan Samoası", AT: "Avusturya", AU: "Avustralya", AW: "Aruba", AX: "Åland Adaları", AZ: "Azerbaycan", BA: "Bosna Hersek", BB: "Barbados", BD: "Bangladeş", BE: "Belçika", BF: "Burkina Faso", BG: "Bulgaristan", BH: "Bahreyn", BI: "Burundi", BJ: "Benin", BL: "Saint Barthelemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivya", BQ: "Karayip Hollanda", BR: "Brezilya", BS: "Bahamalar", BT: "Butan", BV: "Bouvet Adası", BW: "Botsvana", BY: "Beyaz Rusya", BZ: "Belize", CA: "Kanada", CC: "Cocos (Keeling) Adaları", CD: "Kongo - Kinşasa", CF: "Orta Afrika Cumhuriyeti", CG: "Kongo - Brazavil", CH: "İsviçre", CI: "Fildişi Sahili", CK: "Cook Adaları", CL: "Şili", CM: "Kamerun", CN: "Çin", CO: "Kolombiya", CR: "Kosta Rika", CU: "Küba", CV: "Cape Verde", CW: "Curaçao", CX: "Christmas Adası", CY: "Güney Kıbrıs Rum Kesimi", CZ: "Çek Cumhuriyeti", DE: "Almanya", DJ: "Cibuti", DK: "Danimarka", DM: "Dominika", DO: "Dominik Cumhuriyeti", DZ: "Cezayir", EC: "Ekvador", EE: "Estonya", EG: "Mısır", EH: "Batı Sahara", ER: "Eritre", ES: "İspanya", ET: "Etiyopya", FI: "Finlandiya", FJ: "Fiji", FK: "Falkland Adaları", FM: "Mikronezya", FO: "Faroe Adaları", FR: "Fransa", GA: "Gabon", GB: "Birleşik Krallık", GD: "Grenada", GE: "Gürcistan", GF: "Fransız Guyanası", GG: "Guernsey", GH: "Gana", GI: "Cebelitarık", GL: "Grönland", GM: "Gambiya", GN: "Gine", GP: "Guadalupe", GQ: "Ekvator Ginesi", GR: "Yunanistan", GS: "Güney Georgia ve Güney Sandwich Adaları", GT: "Guatemala", GU: "Guam", GW: "Gine-Bissau", GY: "Guyana", HK: "Çin Hong Kong ÖYB", HM: "Heard Adası ve McDonald Adaları", HN: "Honduras", HR: "Hırvatistan", HT: "Haiti", HU: "Macaristan", ID: "Endonezya", IE: "İrlanda", IL: "İsrail", IM: "Man Adası", IN: "Hindistan", IO: "Britanya Hint Okyanusu Toprakları", IQ: "Irak", IR: "İran", IS: "İzlanda", IT: "İtalya", JE: "Jersey", JM: "Jamaika", JO: "Ürdün", JP: "Japonya", KE: "Kenya", KG: "Kırgızistan", KH: "Kamboçya", KI: "Kiribati", KM: "Komorlar", KN: "Saint Kitts ve Nevis", KP: "Kuzey Kore", KR: "Güney Kore", KW: "Kuveyt", KY: "Cayman Adaları", KZ: "Kazakistan", LA: "Laos", LB: "Lübnan", LC: "Saint Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberya", LS: "Lesoto", LT: "Litvanya", LU: "Lüksemburg", LV: "Letonya", LY: "Libya", MA: "Fas", MC: "Monako", MD: "Moldova", ME: "Karadağ", MF: "Saint Martin", MG: "Madagaskar", MH: "Marshall Adaları", MK: "Kuzey Makedonya", ML: "Mali", MM: "Myanmar (Burma)", MN: "Moğolistan", MO: "Çin Makao ÖYB", MP: "Kuzey Mariana Adaları", MQ: "Martinik", MR: "Moritanya", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldivler", MW: "Malavi", MX: "Meksika", MY: "Malezya", MZ: "Mozambik", NA: "Namibya", NC: "Yeni Kaledonya", NE: "Nijer", NF: "Norfolk Adası", NG: "Nijerya", NI: "Nikaragua", NL: "Hollanda", NO: "Norveç", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Yeni Zelanda", OM: "Umman", PA: "Panama", PE: "Peru", PF: "Fransız Polinezyası", PG: "Papua Yeni Gine", PH: "Filipinler", PK: "Pakistan", PL: "Polonya", PM: "Saint Pierre ve Miquelon", PN: "Pitcairn Adaları", PR: "Porto Riko", PS: "Filistin Bölgeleri", PT: "Portekiz", PW: "Palau", PY: "Paraguay", QA: "Katar", RE: "Réunion", RO: "Romanya", RS: "Sırbistan", RU: "Rusya", RW: "Ruanda", SA: "Suudi Arabistan", SB: "Solomon Adaları", SC: "Seyşeller", SD: "Sudan", SE: "İsveç", SG: "Singapur", SH: "Saint Helena", SI: "Slovenya", SJ: "Svalbard ve Jan Mayen Adaları", SK: "Slovakya", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somali", SR: "Surinam", SS: "Güney Sudan", ST: "São Tomé ve Príncipe", SV: "El Salvador", SX: "Sint Maarten", SY: "Suriye", SZ: "Svaziland", TC: "Turks ve Caicos Adaları", TD: "Çad", TF: "Fransız Güney Toprakları", TG: "Togo", TH: "Tayland", TJ: "Tacikistan", TK: "Tokelau", TL: "Timor-Leste", TM: "Türkmenistan", TN: "Tunus", TO: "Tonga", TR: "Türkiye", TT: "Trinidad ve Tobago", TV: "Tuvalu", TW: "Tayvan", TZ: "Tanzanya", UA: "Ukrayna", UG: "Uganda", UM: "ABD Uzak Adaları", US: ["ABD", "A.B.D.", "Amerika Birleşik Devletleri", "Birleşik Devletler", "Amerika"], UY: "Uruguay", UZ: "Özbekistan", VA: "Vatikan", VC: "Saint Vincent ve Grenadinler", VE: "Venezuela", VG: "Britanya Virjin Adaları", VI: "ABD Virjin Adaları", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis ve Futuna Adaları", WS: "Samoa", YE: "Yemen", YT: "Mayotte", ZA: "Güney Afrika", ZM: "Zambiya", ZW: "Zimbabve", XK: "Kosova" }, tp = {
  locale: Ms,
  countries: ws
}, rp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ws,
  default: tp,
  locale: Ms
}, Symbol.toStringTag, { value: "Module" })), Cs = "uk", Ps = { AU: "Австралія", AT: "Австрія", AZ: "Азербайджан", AX: "Аландські Острови", AL: "Албанія", DZ: "Алжир", AS: "Американське Самоа", AI: "Ангілья", AO: "Ангола", AD: "Андорра", AQ: "Антарктика", AG: "Антигуа і Барбуда", MO: "Макао", AR: "Аргентина", AM: "Вірменія", AW: "Аруба", AF: "Афганістан", BS: "Багамські Острови", BD: "Бангладеш", BB: "Барбадос", BH: "Бахрейн", BZ: "Беліз", BE: "Бельгія", BJ: "Бенін", BM: "Бермудські Острови", BY: "Білорусь", BG: "Болгарія", BO: "Болівія", BA: "Боснія і Герцеговина", BW: "Ботсвана", BR: "Бразилія", IO: "Британська Територія в Індійському Океані", VG: "Британські Віргінські Острови", BN: "Бруней-Даруссалам", BF: "Буркіна-Фасо", BI: "Бурунді", BT: "Бутан", VU: "Вануату", VA: "Ватикан", GB: "Великобританія", VE: "Венесуела", VI: "Віргінські Острови (США)", WF: "Волліс і Футуна", VN: "В'єтнам", UM: "Зовнішні Віддалені Острови (США)", GA: "Габон", HT: "Гаїті", GY: "Гаяна", GM: "Гамбія", GH: "Гана", GP: "Гваделупа", GT: "Гватемала", GF: "Гвіана", GN: "Гвінея", GW: "Гвінея-Бісау", GG: "Гернсі", GI: "Гібралтар", HN: "Гондурас", HK: "Гонконг", GD: "Гренада", GR: "Греція", GE: "Грузія", GU: "Гуам", GL: "Гренландія", DK: "Данія", JE: "Джерсі", DJ: "Джибуті", DM: "Домініка", DO: "Домініканська Республіка", CD: "Демократична Республіка Конго", EC: "Еквадор", GQ: "Екваторіальна Гвінея", ER: "Еритрея", EE: "Естонія", ET: "Ефіопія", EG: "Єгипет", YE: "Ємен", ZM: "Замбія", ZW: "Зімбабве", IL: "Ізраїль", IN: "Індія", ID: "Індонезія", IQ: "Ірак", IR: "Іран", IE: "Ірландія", IS: "Ісландія", ES: "Іспанія", IT: "Італія", JO: "Йорданія", CV: "Кабо-Верде", KZ: "Казахстан", KY: "Кайманові Острови", KH: "Камбоджа", CM: "Камерун", CA: "Канада", BQ: "Карибські Нідерланди", QA: "Катар", KE: "Кенія", CY: "Кіпр", KI: "Кірибаті", KG: "Киргизстан", TW: "Тайвань, Провінція Китаю", KP: "Корейська Народно-Демократична Республіка", CN: "Китай", CC: "Кокосові Острови", CO: "Колумбія", KM: "Комори", XK: "Косово", CR: "Коста-Рика", CI: "Кот-Д'Івуар", CU: "Куба", KW: "Кувейт", CW: "Кюрасао", LA: "Лаос", LV: "Латвія", LS: "Лесото", LR: "Ліберія", LB: "Ліван", LY: "Лівія", LT: "Литва", LI: "Ліхтенштейн", LU: "Люксембург", MU: "Маврикій", MR: "Мавританія", MG: "Мадагаскар", YT: "Майотта", MW: "Малаві", MY: "Малайзія", ML: "Малі", MV: "Мальдіви", MT: "Мальта", MA: "Марокко", MQ: "Мартиніка", MH: "Маршаллові Острови", MX: "Мексика", FM: "Мікронезія", MZ: "Мозамбік", MD: "Молдова", MC: "Монако", MN: "Монголія", MS: "Монтсеррат", MM: "М'янма", NA: "Намібія", NR: "Науру", NP: "Непал", NE: "Нігер", NG: "Нігерія", NL: "Нідерланди", NI: "Нікарагуа", DE: "Німеччина", NU: "Ніуе", NZ: "Нова Зеландія", NC: "Нова Каледонія", NO: "Норвегія", AE: "Об'єднані Арабські Емірати", OM: "Оман", BV: "Острів Буве", HM: "Острів Герд і Острови Макдоналд", IM: "Острів Мен", NF: "Острів Норфолк", CX: "Острів Різдва", CK: "Острови Кука", SH: "Острів Святої Єлени", TC: "Острови Теркс і Кайкос", PK: "Пакистан", PW: "Палау", PS: "Палестина", PA: "Панама", PG: "Папуа-Нова Гвінея", ZA: "Південна Африка", PY: "Парагвай", PE: "Перу", GS: "Південна Джорджія та Південні Сандвічеві Острови", KR: "Республіка Корея", SS: "Південний Судан", MK: "Північна Македонія", MP: "Північні Маріанські Острови", PN: "Піткерн", PL: "Польща", PT: "Португалія", PR: "Пуерто-Рико", CG: "Конго", RE: "Реюньйон", RU: "Росія", RW: "Руанда", RO: "Румунія", EH: "Західна Сахара", SV: "Сальвадор", WS: "Самоа", SM: "Сан-Марино", ST: "Сан-Томе і Принсіпі", SA: "Саудівська Аравія", SZ: "Есватіні", SJ: "Острови Шпіцберген та Ян-Маєн", SC: "Сейшельські Острови", BL: "Сен-Бартелемі", MF: "Сен-Мартен", PM: "Сен-П'єр і Мікелон", SN: "Сенегал", VC: "Сент-Вінсент і Гренадіни", KN: "Сент-Кітс і Невіс", LC: "Сент-Люсія", RS: "Сербія", SG: "Сингапур", SX: "Сінт-Мартен", SY: "Сирія", SK: "Словаччина", SI: "Словенія", SB: "Соломонові Острови", SO: "Сомалі", SD: "Судан", SR: "Суринам", TL: "Тимор-Лешті", US: "США", SL: "Сьєрра-Леоне", TJ: "Таджикистан", TH: "Таїланд", TZ: "Танзанія", TG: "Того", TK: "Токелау", TO: "Тонга", TT: "Тринідад і Тобаго", TV: "Тувалу", TN: "Туніс", TM: "Туркменистан", TR: "Туреччина", UG: "Уганда", HU: "Угорщина", UZ: "Узбекистан", UA: "Україна", UY: "Уругвай", FO: "Фарерські Острови", FJ: "Фіджі", PH: "Філіппіни", FI: "Фінляндія", FK: "Фолклендські Острови", FR: "Франція", PF: "Французька Полінезія", TF: "Французькі Південні і Антарктичні Території", HR: "Хорватія", CF: "Центральноафриканська Республіка", TD: "Чад", ME: "Чорногорія", CZ: "Чехія", CL: "Чилі", CH: "Швейцарія", SE: "Швеція", LK: "Шри-Ланка", JM: "Ямайка", JP: "Японія" }, np = {
  locale: Cs,
  countries: Ps
}, ip = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ps,
  default: np,
  locale: Cs
}, Symbol.toStringTag, { value: "Module" })), Ts = "zh", Ns = { AD: "安道尔", AE: "阿联酋", AF: "阿富汗", AG: "安提瓜和巴布达", AI: "安圭拉", AL: "阿尔巴尼亚", AM: "亚美尼亚", AO: "安哥拉", AQ: "南极洲", AR: "阿根廷", AS: "美属萨摩亚", AT: "奥地利", AU: "澳大利亚", AW: "阿鲁巴", AX: "奥兰", AZ: "阿塞拜疆", BA: "波黑", BB: "巴巴多斯", BD: "孟加拉国", BE: "比利时", BF: "布基纳法索", BG: "保加利亚", BH: "巴林", BI: "布隆迪", BJ: "贝宁", BL: "圣巴泰勒米", BM: "百慕大", BN: "文莱", BO: "玻利维亚", BQ: "荷兰加勒比区", BR: "巴西", BS: "巴哈马", BT: "不丹", BV: "布韦岛", BW: "博茨瓦纳", BY: "白俄罗斯", BZ: "伯利兹", CA: "加拿大", CC: "科科斯（基林）群岛", CD: "刚果（金）", CF: "中非", CG: "刚果（布）", CH: "瑞士", CI: "科特迪瓦", CK: "库克群岛", CL: "智利", CM: "喀麦隆", CN: "中国", CO: "哥伦比亚", CR: "哥斯达黎加", CU: "古巴", CV: "佛得角", CW: "库拉索", CX: "圣诞岛", CY: "塞浦路斯", CZ: "捷克", DE: "德国", DJ: "吉布提", DK: "丹麦", DM: "多米尼克", DO: "多米尼加", DZ: "阿尔及利亚", EC: "厄瓜多尔", EE: "爱沙尼亚", EG: "埃及", EH: "阿拉伯撒哈拉民主共和国", ER: "厄立特里亚", ES: "西班牙", ET: "埃塞俄比亚", FI: "芬兰", FJ: "斐济", FK: "福克兰群岛", FM: "密克罗尼西亚联邦", FO: "法罗群岛", FR: "法国", GA: "加蓬", GB: "英国", GD: "格林纳达", GE: "格鲁吉亚", GF: "法属圭亚那", GG: "根西", GH: "加纳", GI: "直布罗陀", GL: "格陵兰", GM: "冈比亚", GN: "几内亚", GP: "瓜德罗普", GQ: "赤道几内亚", GR: "希腊", GS: "南乔治亚和南桑威奇群岛", GT: "危地马拉", GU: "关岛", GW: "几内亚比绍", GY: "圭亚那", HK: "香港", HM: "赫德岛和麦克唐纳群岛", HN: "洪都拉斯", HR: "克罗地亚", HT: "海地", HU: "匈牙利", ID: "印尼", IE: "爱尔兰", IL: "以色列", IM: "马恩岛", IN: "印度", IO: "英属印度洋领地", IQ: "伊拉克", IR: "伊朗", IS: "冰岛", IT: "意大利", JE: "泽西", JM: "牙买加", JO: "约旦", JP: "日本", KE: "肯尼亚", KG: "吉尔吉斯斯坦", KH: "柬埔寨", KI: "基里巴斯", KM: "科摩罗", KN: "圣基茨和尼维斯", KP: "朝鲜", KR: "韩国", KW: "科威特", KY: "开曼群岛", KZ: "哈萨克斯坦", LA: "老挝", LB: "黎巴嫩", LC: "圣卢西亚", LI: "列支敦士登", LK: "斯里兰卡", LR: "利比里亚", LS: "莱索托", LT: "立陶宛", LU: "卢森堡", LV: "拉脱维亚", LY: "利比亚", MA: "摩洛哥", MC: "摩纳哥", MD: "摩尔多瓦", ME: "黑山", MF: "法属圣马丁", MG: "马达加斯加", MH: "马绍尔群岛", MK: "北马其顿", ML: "马里", MM: "缅甸", MN: "蒙古", MO: "澳门", MP: "北马里亚纳群岛", MQ: "马提尼克", MR: "毛里塔尼亚", MS: "蒙特塞拉特", MT: "马耳他", MU: "毛里求斯", MV: "马尔代夫", MW: "马拉维", MX: "墨西哥", MY: "马来西亚", MZ: "莫桑比克", NA: "纳米比亚", NC: "新喀里多尼亚", NE: "尼日尔", NF: "诺福克岛", NG: "尼日利亚", NI: "尼加拉瓜", NL: "荷兰", NO: "挪威", NP: "尼泊尔", NR: "瑙鲁", NU: "纽埃", NZ: "新西兰", OM: "阿曼", PA: "巴拿马", PE: "秘鲁", PF: "法属波利尼西亚", PG: "巴布亚新几内亚", PH: "菲律宾", PK: "巴基斯坦", PL: "波兰", PM: "圣皮埃尔和密克隆", PN: "皮特凯恩群岛", PR: "波多黎各", PS: "巴勒斯坦", PT: "葡萄牙", PW: "帕劳", PY: "巴拉圭", QA: "卡塔尔", RE: "留尼汪", RO: "罗马尼亚", RS: "塞尔维亚", RU: "俄罗斯", RW: "卢旺达", SA: "沙特阿拉伯", SB: "所罗门群岛", SC: "塞舌尔", SD: "苏丹", SE: "瑞典", SG: "新加坡", SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚", SI: "斯洛文尼亚", SJ: "斯瓦尔巴和扬马延", SK: "斯洛伐克", SL: "塞拉利昂", SM: "圣马力诺", SN: "塞内加尔", SO: "索马里", SR: "苏里南", SS: "南苏丹", ST: "圣多美和普林西比", SV: "萨尔瓦多", SX: "荷属圣马丁", SY: "叙利亚", SZ: "斯威士兰", TC: "特克斯和凯科斯群岛", TD: "乍得", TF: "法属南部领地", TG: "多哥", TH: "泰国", TJ: "塔吉克斯坦", TK: "托克劳", TL: "东帝汶", TM: "土库曼斯坦", TN: "突尼斯", TO: "汤加", TR: "土耳其", TT: "特立尼达和多巴哥", TV: "图瓦卢", TW: "中国台湾省", TZ: "坦桑尼亚", UA: "乌克兰", UG: "乌干达", UM: "美国本土外小岛屿", US: "美国", UY: "乌拉圭", UZ: "乌兹别克斯坦", VA: "梵蒂冈", VC: "圣文森特和格林纳丁斯", VE: "委内瑞拉", VG: "英属维尔京群岛", VI: "美属维尔京群岛", VN: "越南", VU: "瓦努阿图", WF: "瓦利斯和富图纳", WS: "萨摩亚", XK: "科索沃", YE: "也门", YT: "马约特", ZA: "南非", ZM: "赞比亚", ZW: "津巴布韦" }, op = {
  locale: Ts,
  countries: Ns
}, sp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ns,
  default: op,
  locale: Ts
}, Symbol.toStringTag, { value: "Module" })), lp = {
  ar: sd,
  cs: ud,
  da: dd,
  de: md,
  el: fd,
  en: _d,
  es: vd,
  fr: Sd,
  hi: Md,
  hu: Cd,
  id: Td,
  it: Dd,
  ja: Id,
  nl: Ed,
  no: Od,
  pl: Ld,
  pt: Fd,
  ro: Hd,
  ru: zd,
  sk: Vd,
  sl: Wd,
  sq: Jd,
  sr: qd,
  sv: Xd,
  th: ap,
  tr: rp,
  uk: ip,
  zh: sp
};
Object.values(lp).forEach((a) => {
  Kr.registerLocale(a.default);
});
const Ds = (a, r) => {
  const n = Po(r);
  switch (a) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case ln.Taiwan:
      return Kr.getName(a, n, { select: "alias" });
    default:
      return Kr.getName(a, n, { select: "official" });
  }
}, sy = (a = Da.ENGLISH) => Object.values(ln).map((r) => ({
  id: r,
  caption: Ds(r, a) ?? ""
})), ly = (a, r = Da.ENGLISH) => Ds(a, r) ?? "";
var Le = /* @__PURE__ */ ((a) => (a.Email = "email", a.FirstName = "first_name", a.Surname = "surname", a.Country = "country", a.City = "city", a.Neighborhood = "neighborhood", a.StreetAddress = "street_address", a.StreetNumber = "street_number", a.Postcode = "postcode", a.PhoneNumber = "phone_number", a.CompanyName = "company_name", a.TaxNumber = "tax_number", a.State = "state", a))(Le || {});
const up = {
  [Le.Email]: "public_pages_purchase.contact_slug.email",
  [Le.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [Le.Surname]: "public_pages_purchase.contact_slug.last_name",
  [Le.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [Le.Country]: "public_pages_purchase.contact_slug.country",
  [Le.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [Le.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [Le.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [Le.City]: "public_pages_purchase.contact_slug.city",
  [Le.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [Le.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [Le.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [Le.State]: "public_pages_purchase.contact_slug.state_province"
}, cp = (a) => F.t(up[a]), uy = (a) => {
  const { slug: r, fieldName: n } = a;
  return Object.values(Le).includes(r) ? cp(r) : n;
};
var dp = /* @__PURE__ */ ((a) => (a.ARGENTINE_PESO = "ars", a.AUSTRALIAN_DOLLAR = "aud", a.BULGARIAN_LEV = "bgn", a.BRAZILIAN_REAL = "brl", a.CANADIAN_DOLLAR = "cad", a.CENTRAL_AFRICAN_FRANC = "xaf", a.CHILEAN_PESO = "clp", a.CHINESE_YUAN = "cny", a.COLOMBIAN_PESO = "cop", a.CZECH_CROWN = "czk", a.DANISH_KRONE = "dkk", a.EGYPTIAN_POUND = "egp", a.EURO = "eur", a.GHANAIAN_CEDI = "ghs", a.GUINEAN_FRANC = "gnf", a.HONG_KONG_DOLLAR = "hkd", a.HUNGARIAN_FORINT = "huf", a.ICELANDIC_KRONA = "isk", a.INDIAN_RUPEE = "inr", a.INDONESIAN_RUPIAH = "idr", a.ISRAELI_NEW_SHEKEL = "ils", a.JAPANESE_YEN = "jpy", a.KENYAN_SHILLING = "kes", a.MALAWIAN_KWACHA = "mwk", a.MALAYSIAN_RINGGIT = "myr", a.MEXICAN_PESO = "mxn", a.MOROCCAN_DIRHAM = "mad", a.NEW_ZEALAND_DOLLAR = "nzd", a.NIGERIAN_NAIRA = "ngn", a.NORWEGIAN_KRONE = "nok", a.PHILIPPINE_PESO = "php", a.POLISH_ZLOTY = "pln", a.POUND_STERLING = "gbp", a.ROMANIA_LEI = "ron", a.RUSSIAN_RUBLE = "rub", a.RWANDAN_FRANC = "rwf", a.SAO_TOME_AND_PRINCIPE_DOBRA = "std", a.SAUDI_RIYAL = "sar", a.SIERRA_LEONEAN_LEONE = "sll", a.SINGAPORE_DOLLAR = "sgd", a.SOUTH_AFRICAN_RAND = "zar", a.SRI_LANKAN_RUPEE = "lkr", a.SWEDISH_KRONA = "sek", a.SWISS_FRANC = "chf", a.TANZANIAN_SHILLING = "tzs", a.THAI_BAHT = "thb", a.TURKISH_LIRA = "try", a.UGANDAN_SHILLING = "ugx", a.US_DOLLAR = "usd", a.UNITED_ARAB_EMIRATES_DIRHAM = "aed", a.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", a.ZAMBIAN_KWACHA = "zmw", a.SERBIAN_DINAR = "rsd", a.UKRAINIAN_HRYVNIA = "uah", a.ALBANIAN_LEK = "all", a.VIETNAM_DONG = "vnd", a.PERUVIAN_SOL = "pen", a))(dp || {});
const br = (a, r) => new Date(
  new Intl.DateTimeFormat(Q.ENGLISH, {
    timeZone: r,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).format(a)
), Se = (a, r) => a ? a instanceof Date ? br(a, r) : a.match(/([-+]\d+:?\d+)$/) ? br(new Date(a), r) : new Date(a) : br(/* @__PURE__ */ new Date(), r), Ma = (a) => {
  const r = function(n) {
    return (n < 10 ? "0" : "") + n;
  };
  return a.getFullYear() + "-" + r(a.getMonth() + 1) + "-" + r(a.getDate()) + "T" + r(a.getHours()) + ":" + r(a.getMinutes()) + ":" + r(a.getSeconds());
}, pp = (a) => {
  switch (a) {
    case Fr.dateFirst:
      return "en-GB";
    case Fr.monthFirst:
      return "en-US";
    default:
      return;
  }
}, ni = (a, r) => (typeof a == "string" ? new Date(a) : a).toLocaleString(pp(r == null ? void 0 : r.dateFormat), {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: r == null ? void 0 : r.timeZone
}), cy = (a, r) => {
  if (!r && !a) return "";
  const e = new Intl.DateTimeFormat(a, {
    timeZone: r,
    timeZoneName: "shortOffset"
  }).formatToParts(/* @__PURE__ */ new Date()).find((i) => i.type === "timeZoneName");
  if (e)
    return e.value.replace("GMT", "UTC");
}, Ot = (a, r) => Se(a, r);
async function mp(a, r) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(a), r && Gr.success(r);
  } catch {
    Gr.error(F.t("public_pages_purchase.copy_clipboard_error"));
  }
}
const dy = (a) => Number(a), py = (a) => Number(a), my = (a) => a / 100, hy = (a) => Number(a) * 100, hp = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", fp = "flex items-center justify-center gap-2", gp = (a) => "href" in a, _p = ({
  as: a = "a",
  href: r,
  isFetching: n,
  className: t,
  children: e,
  buttonTextClassName: i,
  ...o
}) => o["aria-disabled"] || n ? /* @__PURE__ */ _("button", { className: t, disabled: !!o["aria-disabled"], children: /* @__PURE__ */ _(Hr, { buttonTextClassName: i, isFetching: n, children: e }) }) : /* @__PURE__ */ _(a, { className: t, href: r, ...o, children: /* @__PURE__ */ _(Hr, { buttonTextClassName: i, isFetching: n, children: e }) }), Hr = ({
  children: a,
  isFetching: r,
  buttonTextClassName: n
}) => /* @__PURE__ */ _(
  "div",
  {
    className: N(
      "flex items-center justify-center gap-2 truncate",
      r && "opacity-0",
      n
    ),
    children: a
  }
), Ea = ({
  width: a = "small",
  isFetching: r,
  backgroundColor: n,
  color: t,
  hoverColor: e,
  hoverBackgroundColor: i,
  borderColor: o,
  hoverBorderColor: s,
  loaderType: l,
  testAttributePostfix: u,
  className: c,
  buttonTextClassName: d,
  loaderClassName: p,
  as: m,
  ...f
}) => {
  const y = f, v = N(
    Or(
      hp,
      fp,
      n,
      t,
      e,
      i,
      a === "small" ? "px-4" : "px-10",
      o && `border ${o}`,
      s,
      r && "pointer-events-none select-none"
    ),
    c
  ), P = N(
    Or("absolute", r ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    p
  );
  if (gp(y)) {
    const { "aria-disabled": k, ...w } = y;
    return /* @__PURE__ */ _(
      _p,
      {
        as: m,
        isFetching: r,
        "aria-disabled": k || r,
        className: N(v, k && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...Rr(!!u, `${u}`),
        children: /* @__PURE__ */ G(ze, { children: [
          /* @__PURE__ */ _(Ht, { small: !0, type: l, className: P }),
          y.children
        ] })
      }
    );
  } else {
    const { disabled: k, ...w } = y;
    return /* @__PURE__ */ G(
      "button",
      {
        disabled: r || k,
        className: N(v, k && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...Rr(!!u, `${u}`),
        children: [
          /* @__PURE__ */ _(Ht, { small: !0, type: l, className: P }),
          /* @__PURE__ */ _(Hr, { buttonTextClassName: d, isFetching: r, children: y.children })
        ]
      }
    );
  }
}, fy = (a) => /* @__PURE__ */ _(
  Ea,
  {
    color: "text-text-primary/50",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary",
    ...a
  }
);
var ja = /* @__PURE__ */ ((a) => (a.danger = "danger", a.blue = "blue", a))(ja || {});
const yp = (a) => {
  switch (a) {
    case ja.danger:
      return "hover:text-danger";
    case ja.blue:
      return "hover:text-brand-primary";
    default:
      return "text-brand-primary";
  }
}, vp = (a) => {
  switch (a) {
    case ja.danger:
      return "hover:border-danger";
    case ja.blue:
      return "hover:border-brand-primary";
    default:
      return "border-brand-primary";
  }
}, gy = ({
  neutralType: a = ja.blue,
  ...r
}) => /* @__PURE__ */ _(
  Ea,
  {
    color: "text-text-primary",
    hoverColor: yp(a),
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-background-secondary",
    borderColor: "border-text-secondary/30",
    hoverBorderColor: vp(a),
    ...r
  }
), _y = (a) => /* @__PURE__ */ _(
  Ea,
  {
    color: "text-text-primary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-transparent",
    hoverBackgroundColor: "hover:bg-text-primary",
    borderColor: "border-text-primary",
    loaderType: "dark",
    ...a
  }
), yy = (a) => /* @__PURE__ */ _(
  Ea,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-green",
    hoverBackgroundColor: "hover:bg-green",
    ...a
  }
), ii = ({ selected: a, ...r }) => /* @__PURE__ */ _(
  Ea,
  {
    color: a ? "text-brand-primary" : "text-text-primary",
    hoverColor: a ? "hover:text-brand-primary" : "hover:text-text-primary",
    backgroundColor: a ? "bg-brand-primary/10" : "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary/10",
    borderColor: a ? "border-brand-primary" : "border-text-secondary/30",
    hoverBorderColor: "border-brand-primary",
    type: "button",
    ...r
  }
), As = (a) => /* @__PURE__ */ _(
  Ea,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-brand-primary",
    hoverBackgroundColor: "hover:bg-brand-primary-hover",
    ...a
  }
), Is = (a) => /* @__PURE__ */ _(
  Ea,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-danger",
    hoverBackgroundColor: "hover:bg-danger",
    ...a
  }
);
function bp({
  active: a,
  isFetching: r,
  iconClassName: n,
  menuButtonClassName: t,
  dataTestAttributes: e,
  children: i,
  ...o
}) {
  return /* @__PURE__ */ _(
    Fl,
    {
      disabled: r,
      className: N(
        !i && "hover:bg-brand-primary focus-ring group h-[30px] rounded-lg px-3 py-1 transition-colors lg:h-[20px]",
        !i && (a ? "bg-brand-primary" : "bg-background-primary"),
        r && "pointer-events-none animate-pulse",
        t
      ),
      ...e,
      ...o,
      children: typeof i == "function" ? (s) => i({ ...s, active: a }) : i ?? /* @__PURE__ */ _(
        Jl,
        {
          className: N(
            "group-hover:fill-background-secondary",
            a && "fill-background-secondary",
            n
          )
        }
      )
    }
  );
}
const vy = ({
  menuItems: a,
  anchor: r = {
    to: "left start",
    gap: 4,
    padding: 4
  },
  menuItemsClassName: n,
  toggleOnHover: t = !0,
  ...e
}) => {
  const { show: i, close: o, delayOpen: s, delayClose: l } = Mo();
  return /* @__PURE__ */ _(Kl, { children: ({ open: u, close: c }) => /* @__PURE__ */ G(ze, { children: [
    /* @__PURE__ */ _(
      bp,
      {
        ...e,
        active: t && i || u,
        onMouseEnter: s,
        onMouseLeave: l
      }
    ),
    /* @__PURE__ */ _(
      Ua,
      {
        show: t && i || u,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        children: /* @__PURE__ */ _(
          Hl,
          {
            onClick: () => {
              c(), o();
            },
            static: !0,
            anchor: r,
            className: N(
              "bg-background-secondary border-background-tertiary overflow-hidden rounded-lg border shadow-lg focus:outline-hidden",
              n
            ),
            portal: !0,
            onMouseEnter: s,
            onMouseLeave: l,
            children: a
          }
        )
      }
    )
  ] }) });
}, Sp = "group aria-pressed:text-brand-primary hover:text-brand-primary flex items-center gap-2 w-full px-4 py-3 lg:py-2 text-left text-sm transition-colors border-b border-background-tertiary last:border-0", by = ({
  dataTestAttributes: a,
  onClick: r,
  label: n,
  buttonClassName: t,
  labelClassName: e,
  children: i,
  ...o
}) => /* @__PURE__ */ _(Ul, { ...o, children: i || (({ focus: s }) => /* @__PURE__ */ _(
  "button",
  {
    onClick: r,
    "aria-pressed": s,
    type: "button",
    className: N(
      Sp,
      o.disabled && "hover:text-text-secondary text-text-secondary cursor-not-allowed",
      t
    ),
    ...a,
    children: /* @__PURE__ */ _("span", { className: e, children: n })
  }
)) }, "action-settings"), kp = (a) => {
  switch (a) {
    case "success":
      return "border-green";
    case "error":
      return "border-danger";
    default:
      return "border-brand-primary";
  }
}, Mp = (a) => {
  switch (a) {
    case "success":
      return "hover:fill-green group-focus-visible:fill-green";
    case "error":
      return "hover:fill-danger group-focus-visible:fill-danger";
    default:
      return "hover:fill-brand-primary group-focus-visible:fill-brand-primary";
  }
}, xs = ({
  t: a,
  afterClose: r,
  className: n,
  titleClassName: t,
  buttonClassName: e,
  hideCloseButton: i
}) => {
  const o = Ce(null), s = kp(a.type), l = Mp(a.type);
  return /* @__PURE__ */ G(
    "div",
    {
      className: N(
        "bg-background-secondary text-text-tertiary flex max-w-[350px] items-center gap-2.5 rounded-lg border px-2.5 py-2 shadow-lg",
        a.visible ? "animate-toast-enter" : "animate-toast-leave",
        s,
        n
      ),
      "data-test-id": `toast-${a.type}`,
      children: [
        a.icon,
        /* @__PURE__ */ _("div", { className: N("break-words", t), children: a.message }),
        !i && /* @__PURE__ */ _(
          "button",
          {
            ref: o,
            className: N("group h-fit outline-hidden", e),
            onClick: () => {
              ou.dismiss(a.id), r && r();
            },
            children: /* @__PURE__ */ _(
              Tt,
              {
                className: N("fill-fill-primary main-transition-colors", l)
              }
            )
          }
        )
      ]
    }
  );
}, Sy = ({
  className: a,
  titleClassName: r,
  buttonClassName: n,
  afterClose: t
}) => /* @__PURE__ */ _(
  su,
  {
    position: "top-center",
    containerStyle: {
      top: 80,
      right: 20
    },
    containerClassName: "[&_a]:primary-link",
    toastOptions: {
      success: {
        icon: /* @__PURE__ */ _(ql, { className: "fill-green h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      },
      error: {
        icon: /* @__PURE__ */ _($l, { className: "fill-danger h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      }
    },
    children: (e) => /* @__PURE__ */ _(
      xs,
      {
        t: e,
        className: a,
        titleClassName: r,
        buttonClassName: n,
        afterClose: t
      }
    )
  }
), ky = ({
  className: a,
  titleClassName: r,
  buttonClassName: n
} = {}) => ({ infoToast: za(
  (e, i, o, s) => Gr.custom(
    (l) => /* @__PURE__ */ _(
      xs,
      {
        t: { ...l, message: e },
        className: a,
        titleClassName: r,
        buttonClassName: n,
        afterClose: o,
        hideCloseButton: s
      }
    ),
    {
      duration: 6e5,
      icon: /* @__PURE__ */ _(fo, { className: "fill-brand-primary h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
      ...i
    }
  ),
  []
) }), My = ({
  options: a,
  selected: r,
  onChange: n,
  disabled: t,
  error: e,
  label: i,
  required: o,
  className: s,
  labelClassName: l,
  optionsWrapperClassName: u,
  optionWrapperClassName: c,
  selectedOptionWrapperClassName: d,
  optionClassName: p,
  inputClassName: m
}) => /* @__PURE__ */ G("div", { className: N("flex flex-col gap-1", s), children: [
  /* @__PURE__ */ _(xa, { label: i, labelClassName: l, required: o }),
  /* @__PURE__ */ _("ul", { className: N("flex items-center gap-5", u), children: a ? a.map((f) => /* @__PURE__ */ _(
    sn,
    {
      label: f.tooltipLabel ?? "",
      disabled: !f.showTooltip,
      children: /* @__PURE__ */ _(
        "li",
        {
          className: N(
            c,
            f.id === r && d
          ),
          children: /* @__PURE__ */ G(
            "label",
            {
              className: N(
                "r relative flex w-fit items-center gap-2",
                !t && "cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ _(
                  "input",
                  {
                    className: N(
                      "border-2 outline-hidden",
                      t ? "border-fill-primary/70" : "border-fill-primary",
                      "h-[20px] w-[20px] rounded-full",
                      f.id === r ? "bg-background-secondary" : "bg-transparent",
                      "main-transition-colors focus-ring shrink-0 appearance-none",
                      m
                    ),
                    disabled: t || f.disabled,
                    checked: f.id === r,
                    value: f.caption,
                    onChange: () => n(f.id),
                    type: "radio"
                  }
                ),
                /* @__PURE__ */ _(
                  "svg",
                  {
                    width: 20,
                    height: 20,
                    className: N(
                      "main-transition-colors absolute",
                      f.id === r ? "fill-green" : "fill-transparent",
                      t && "opacity-70"
                    ),
                    children: /* @__PURE__ */ _(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ G("div", { className: "flex items-center gap-3", children: [
                  f.caption && /* @__PURE__ */ _(
                    "span",
                    {
                      className: N(
                        "main-transition-colors",
                        f.id === r ? "text-text-primary" : "text-text-primary/50",
                        t && "opacity-70",
                        p,
                        "text-left"
                      ),
                      children: f.caption
                    }
                  ),
                  f.additionalInfo
                ] })
              ]
            }
          )
        }
      )
    },
    f.id
  )) : /* @__PURE__ */ G(ze, { children: [
    /* @__PURE__ */ _(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ _(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ _(va, { error: e })
] });
function un({
  arrowButtonClassName: a,
  open: r,
  isDisabled: n,
  As: t = rn
}) {
  return /* @__PURE__ */ _(
    t,
    {
      as: "div",
      role: "button",
      className: N(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        a
      ),
      disabled: n,
      children: /* @__PURE__ */ _(
        go,
        {
          className: N("stroke-text-primary main-transition", r && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function cn({ onClick: a, closeButtonClassName: r, isDisabled: n }) {
  return /* @__PURE__ */ _(
    "button",
    {
      type: "button",
      className: N(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        r
      ),
      onClick: a,
      disabled: n,
      children: /* @__PURE__ */ _(Tt, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
function wp({
  children: a,
  selectedData: r,
  virtual: n,
  disabled: t,
  onClose: e,
  onChange: i
}) {
  return /* @__PURE__ */ _(
    uo,
    {
      immediate: !0,
      multiple: !0,
      value: r,
      virtual: n,
      onChange: (o) => i((o == null ? void 0 : o.filter((s) => s.id !== void 0).map((s) => s.id)) ?? []),
      disabled: t,
      onClose: e,
      children: ({ open: o }) => a(o)
    }
  );
}
function Cp({
  children: a,
  selectedData: r,
  virtual: n,
  disabled: t,
  onClose: e,
  onChange: i
}) {
  return /* @__PURE__ */ _(
    uo,
    {
      immediate: !0,
      value: r,
      virtual: n,
      onChange: (o) => {
        o !== null && i(o == null ? void 0 : o.id);
      },
      disabled: t,
      onClose: e,
      children: ({ open: o }) => a(o)
    }
  );
}
const Es = "text-[16px] sm:text-sm", dn = "px-4 py-2.5";
function Bs({
  isDisabled: a,
  open: r,
  hasError: n,
  className: t,
  placeholder: e,
  selectedCaption: i,
  isPreFetching: o,
  onFocus: s,
  onChange: l,
  inputRef: u,
  dataTest: c
}) {
  return /* @__PURE__ */ _(
    zl,
    {
      ref: u,
      className: N(
        "w-full truncate",
        Es,
        "flex items-center justify-between",
        dn,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        a ? "bg-skeleton-primary/20" : "bg-background-secondary",
        r ? "border-brand-primary" : n ? "border-danger" : "border-text-secondary/30",
        o && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        t
      ),
      onChange: (d) => l == null ? void 0 : l(d.target.value),
      onKeyDown: (d) => d.stopPropagation(),
      onFocus: s,
      displayValue: i ? () => i : void 0,
      placeholder: e ?? F.t("public_pages_purchase.form_select.select"),
      ...c
    }
  );
}
function pn({ loaderWrapperClassName: a, loaderClassName: r }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: N(
        "flex h-full items-center justify-center",
        "scale-75",
        a
      ),
      children: /* @__PURE__ */ _(Ht, { className: N(r) })
    }
  );
}
const mn = ({
  item: a,
  optionClassName: r,
  optionIconWrapperClassName: n,
  optionRef: t,
  as: e
}) => {
  const i = (a == null ? void 0 : a.customCaption) ?? (a == null ? void 0 : a.caption), o = ({ disabled: l, selected: u }) => N(
    "bg-background-secondary text-text-primary",
    dn,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    u && "bg-brand-primary text-background-secondary",
    l && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    r,
    a == null ? void 0 : a.className
  ), s = ({ selected: l }) => /* @__PURE__ */ G(ze, { children: [
    i,
    /* @__PURE__ */ G("div", { className: N("flex items-center gap-3", n), children: [
      l && /* @__PURE__ */ _(
        Ql,
        {
          className: Or(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      a == null ? void 0 : a.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ _(
    e,
    {
      disabled: a == null ? void 0 : a.disabled,
      ref: t,
      value: a,
      className: o,
      "data-test-id": a == null ? void 0 : a.dataTestAttribute,
      children: s
    },
    a == null ? void 0 : a.id
  );
}, sr = Pt(
  ({ children: a, style: r, optionsClassName: n, as: t, optionsProps: e }, i) => /* @__PURE__ */ _(
    t,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: i,
      style: r,
      className: N(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "data-[closed]:opacity-0 transition duration-200 ease-out empty:invisible",
        "customScroll",
        Es,
        n
      ),
      ...e,
      children: a
    }
  )
);
sr.displayName = "ListOptionsWrapper";
const oi = 240, Os = () => ({
  id: void 0,
  caption: F.t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
}), hn = (a, r) => {
  let n = 0;
  return a && (a.querySelectorAll('[role="option"]').forEach((e) => {
    n += e.getBoundingClientRect().height;
  }), n = r ? Math.min(n, oi) || oi : 42), n;
};
function Gs({
  optionsClassName: a,
  data: r,
  loaderWrapperClassName: n,
  loaderClassName: t,
  asOptions: e,
  asOption: i,
  ...o
}) {
  const [s, l] = ue(null), u = hn(s, r);
  return /* @__PURE__ */ _(
    sr,
    {
      as: e,
      ref: l,
      optionsClassName: a,
      style: { height: u },
      children: ({ option: c }) => r ? mn({ ...o, as: i, item: c }) : /* @__PURE__ */ _(
        pn,
        {
          loaderWrapperClassName: n,
          loaderClassName: t
        }
      )
    }
  );
}
const Ls = (a, r) => (r == null ? void 0 : r.find((n) => n.id === a)) ?? null, Rs = (a) => {
  const [r, n] = ue(""), [t, e] = ue(a);
  return Pe(() => {
    const i = r === "" ? a : (a == null ? void 0 : a.filter(
      (o) => o.caption.toLowerCase().replace(/\s+/g, "").includes(r.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    e(() => i);
  }, [a, r]), { filteredData: t, setFilteredData: e, query: r, setQuery: n };
}, Fs = (a = []) => ({
  options: a.length > 0 ? a : [Os()],
  disabled: (r) => (r == null ? void 0 : r.disabled) ?? !1
});
function wy({
  label: a,
  data: r,
  staticData: n,
  onChange: t,
  labelClassName: e,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: u,
  description: c,
  className: d,
  containerClassName: p,
  closeButtonClassName: m,
  arrowButtonClassName: f,
  fieldClassName: y,
  disabled: v,
  withoutCloseIcon: P,
  onOpen: k,
  onClose: w,
  dataTest: C,
  wrapperProps: S,
  loaderClassName: b,
  loaderWrapperClassName: T,
  inputWrapperClassName: D,
  inputRef: A,
  statusIcon: I,
  statusIconClassName: K,
  ...Z
}) {
  const [Y, z] = ue(!1);
  Pe(() => {
    Y && k && (k(), z(!1));
  }, [Y]);
  const H = Ls(i, r ?? n) ?? null, { filteredData: U, setQuery: B } = Rs(r), R = i !== void 0, q = v || o || R && (!r && !n), te = R && !P && !q;
  return /* @__PURE__ */ G("div", { className: N("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ _(
      Cp,
      {
        selectedData: H,
        virtual: Fs(U),
        onChange: t,
        disabled: q,
        onClose: () => {
          B(""), w == null || w();
        },
        children: (pe) => /* @__PURE__ */ G(ze, { children: [
          /* @__PURE__ */ G(nr, { className: N("relative flex flex-col gap-1", y), children: [
            /* @__PURE__ */ _(
              xa,
              {
                wrapperAs: "label",
                wrapperProps: S,
                label: a,
                required: u,
                labelClassName: N("text-sm font-medium", e)
              }
            ),
            /* @__PURE__ */ G(rn, { as: "button", className: N("relative", D), children: [
              /* @__PURE__ */ _(
                Bs,
                {
                  dataTest: C,
                  inputRef: A,
                  isDisabled: q,
                  hasError: !!l,
                  open: pe,
                  className: d,
                  placeholder: s,
                  selectedCaption: (H == null ? void 0 : H.caption) ?? "",
                  isPreFetching: o,
                  onFocus: () => z(!0),
                  onChange: (me) => {
                    z(!0), B(me);
                  }
                }
              ),
              I ? /* @__PURE__ */ _(
                "div",
                {
                  className: N(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    K
                  ),
                  children: I
                }
              ) : /* @__PURE__ */ _(
                un,
                {
                  isDisabled: q,
                  arrowButtonClassName: N(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    f
                  ),
                  open: pe
                }
              )
            ] }),
            te && /* @__PURE__ */ _(
              cn,
              {
                isDisabled: q,
                closeButtonClassName: N(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  m
                ),
                onClick: () => t(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ _(
            Gs,
            {
              asOptions: po,
              asOption: co,
              data: U,
              ...Z
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ _(va, { error: l, description: c })
  ] });
}
function Cy({
  data: a,
  staticData: r,
  onChange: n,
  value: t,
  isPreFetching: e,
  placeholder: i,
  required: o,
  description: s,
  className: l,
  closeButtonClassName: u,
  arrowButtonClassName: c,
  fieldClassName: d,
  disabled: p,
  withoutCloseIcon: m,
  onOpen: f,
  onClose: y,
  dataTest: v,
  wrapperProps: P,
  loaderClassName: k,
  loaderWrapperClassName: w,
  captionClassName: C,
  inputRef: S,
  optionsClassName: b,
  ...T
}) {
  const [D, A] = ue(!1);
  Pe(() => {
    D && f && (f(), A(!1));
  }, [D]);
  const I = Ls(t, a ?? r) ?? null, K = t !== void 0, z = p || e || K && (!a && !r), H = K && !m && !z, U = Xa(() => {
    if (a)
      return a.length > 0 ? a : [Os()];
  }, [a]), [B, R] = ue(null), W = hn(B, a);
  return /* @__PURE__ */ _(
    nn,
    {
      value: I,
      onChange: (j) => {
        j !== null && n(j == null ? void 0 : j.id);
      },
      disabled: z,
      children: ({ open: j }) => /* @__PURE__ */ G(ze, { children: [
        /* @__PURE__ */ G(nr, { className: N("relative flex w-fit flex-col gap-1", d), children: [
          /* @__PURE__ */ G(
            Kt,
            {
              className: N(
                "inline-grid w-fit",
                "pr-6",
                H && "pr-10",
                "focus-ring rounded-md outline-hidden",
                l
              ),
              children: [
                /* @__PURE__ */ _(
                  "span",
                  {
                    className: N(
                      "text-start truncate underline decoration-dashed",
                      C
                    ),
                    children: (I == null ? void 0 : I.caption) ?? i ?? F.t("public_pages_purchase.form_select.select")
                  }
                ),
                /* @__PURE__ */ _(
                  un,
                  {
                    As: Kt,
                    isDisabled: z,
                    arrowButtonClassName: N(
                      "absolute bottom-0 right-0",
                      "h-6 w-4",
                      c
                    ),
                    open: j
                  }
                )
              ]
            }
          ),
          H && /* @__PURE__ */ _(
            cn,
            {
              isDisabled: z,
              closeButtonClassName: N(
                "absolute bottom-0 right-5 ",
                "h-6 w-4",
                u
              ),
              onClick: () => n(void 0)
            }
          )
        ] }),
        /* @__PURE__ */ _(
          sr,
          {
            ref: R,
            style: { height: W },
            as: on,
            optionsClassName: N("h-fit w-fit outline-hidden", b),
            children: U ? U.map(
              (q) => mn({
                item: q,
                as: mo,
                optionClassName: T == null ? void 0 : T.optionClassName,
                optionIconWrapperClassName: T == null ? void 0 : T.optionIconWrapperClassName
              })
            ) : /* @__PURE__ */ _(
              pn,
              {
                loaderWrapperClassName: N("p-2", w),
                loaderClassName: k
              }
            )
          }
        )
      ] })
    }
  );
}
function Py({
  label: a,
  data: r,
  staticData: n,
  onChange: t,
  labelClassName: e,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: u,
  description: c,
  className: d,
  containerClassName: p,
  closeButtonClassName: m,
  arrowButtonClassName: f,
  fieldClassName: y,
  disabled: v,
  withoutCloseIcon: P,
  onOpen: k,
  onClose: w,
  dataTest: C,
  wrapperProps: S,
  loaderClassName: b,
  loaderWrapperClassName: T,
  hideSelectedValues: D,
  inputWrapperClassName: A,
  inputRef: I,
  ...K
}) {
  const [Z, Y] = ue(!1);
  Pe(() => {
    Z && k && (k(), Y(!1));
  }, [Z]);
  const z = Xa(
    () => {
      var te;
      return ((te = r ?? n) == null ? void 0 : te.filter((pe) => i == null ? void 0 : i.includes(pe.id))) ?? [];
    },
    [r, n, i]
  ), { filteredData: H, setQuery: U } = Rs(r), B = i.length > 0, j = v || o || B && (!r && !n), q = B && !P && !j;
  return /* @__PURE__ */ G("div", { className: N("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ _(
      wp,
      {
        selectedData: z,
        virtual: Fs(H),
        onChange: t,
        disabled: j,
        onClose: () => {
          U(""), w == null || w();
        },
        children: (te) => /* @__PURE__ */ G(ze, { children: [
          /* @__PURE__ */ G(nr, { className: N("flex flex-col gap-1", y), children: [
            /* @__PURE__ */ _(
              xa,
              {
                wrapperAs: "label",
                wrapperProps: S,
                label: a,
                required: u,
                labelClassName: N("text-sm font-medium", e)
              }
            ),
            /* @__PURE__ */ G(rn, { as: "div", className: N("relative", A), children: [
              /* @__PURE__ */ _(
                Bs,
                {
                  dataTest: C,
                  inputRef: I,
                  isDisabled: j,
                  hasError: !!l,
                  open: te,
                  className: d,
                  placeholder: s,
                  isPreFetching: o,
                  selectedCaption: D ? "" : z.map((pe) => pe.caption).join(", "),
                  onFocus: () => Y(!0),
                  onChange: (pe) => {
                    Y(!0), U(pe);
                  }
                }
              ),
              /* @__PURE__ */ _(
                un,
                {
                  isDisabled: j,
                  arrowButtonClassName: N(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    f
                  ),
                  open: te
                }
              )
            ] }),
            q && /* @__PURE__ */ _(
              cn,
              {
                isDisabled: j,
                closeButtonClassName: N(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  m
                ),
                onClick: () => t([])
              }
            )
          ] }),
          /* @__PURE__ */ _(
            Gs,
            {
              asOptions: po,
              asOption: co,
              data: H,
              ...K
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ _(va, { error: l, description: c })
  ] });
}
function Ty({
  value: a,
  onChange: r,
  children: n,
  optionsClassName: t,
  data: e,
  loaderClassName: i,
  loaderWrapperClassName: o,
  optionClassName: s,
  optionIconWrapperClassName: l,
  disabled: u,
  buttonClassName: c,
  optionsProps: d
}) {
  const p = e == null ? void 0 : e.find((v) => v.id === a), [m, f] = ue(null), y = hn(m, e);
  return /* @__PURE__ */ _(nn, { disabled: u, value: p, onChange: (v) => r(v == null ? void 0 : v.id), children: ({ open: v }) => /* @__PURE__ */ G(ze, { children: [
    /* @__PURE__ */ _(
      Kt,
      {
        className: N(
          "ring-brand-primary outline-hidden focus-visible:ring-2",
          c
        ),
        children: n(v)
      }
    ),
    /* @__PURE__ */ _(
      sr,
      {
        ref: f,
        style: { height: y },
        as: on,
        optionsClassName: N("h-fit outline-hidden", t),
        optionsProps: d,
        children: e ? e.map(
          (P) => mn({
            item: P,
            as: mo,
            optionClassName: s,
            optionIconWrapperClassName: l
          })
        ) : /* @__PURE__ */ _(
          pn,
          {
            loaderWrapperClassName: o,
            loaderClassName: i
          }
        )
      }
    )
  ] }) });
}
function Ny({ amount: a, className: r }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: N(
        "text-background-secondary bg-green flex min-h-6 min-w-6 items-center justify-center rounded-full p-1 text-xs",
        r
      ),
      children: a
    }
  );
}
const Dy = ({
  children: a,
  className: r,
  color: n = "blue",
  showHint: t = !0,
  ...e
}) => /* @__PURE__ */ G("div", { className: N("flex items-center gap-0.5", r), children: [
  a,
  t && /* @__PURE__ */ _(
    sn,
    {
      mode: "click",
      ...e,
      className: N("focus-ring rounded-full"),
      popoverClassName: N("!max-w-[200px] sm:!max-w-[350px]", e.popoverClassName),
      wrapperClassName: "m-1",
      children: (i) => /* @__PURE__ */ _(
        fo,
        {
          className: N(
            `group-focus-visible:fill-${n} h-[16px] w-[16px]`,
            i ? `fill-${n}` : "fill-fill-primary"
          )
        }
      )
    }
  )
] });
var Sr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var si;
function Pp() {
  return si || (si = 1, (function(a) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var i = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (i = e(i, t(s)));
        }
        return i;
      }
      function t(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var o = "";
        for (var s in i)
          r.call(i, s) && i[s] && (o = e(o, s));
        return o;
      }
      function e(i, o) {
        return o ? i ? i + " " + o : i + o : i;
      }
      a.exports ? (n.default = n, a.exports = n) : window.classNames = n;
    })();
  })(Sr)), Sr.exports;
}
var Tp = Pp();
const Ie = /* @__PURE__ */ ir(Tp);
function x(a, r) {
  if (r.length < a)
    throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + r.length + " present");
}
function lr(a) {
  return x(1, arguments), a instanceof Date || Ye(a) === "object" && Object.prototype.toString.call(a) === "[object Date]";
}
function O(a) {
  x(1, arguments);
  var r = Object.prototype.toString.call(a);
  return a instanceof Date || Ye(a) === "object" && r === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || r === "[object Number]" ? new Date(a) : ((typeof a == "string" || r === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function vt(a) {
  if (x(1, arguments), !lr(a) && typeof a != "number")
    return !1;
  var r = O(a);
  return !isNaN(Number(r));
}
function J(a) {
  if (a === null || a === !0 || a === !1)
    return NaN;
  var r = Number(a);
  return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
}
function fn(a, r) {
  x(2, arguments);
  var n = O(a).getTime(), t = J(r);
  return new Date(n + t);
}
function Ks(a, r) {
  x(2, arguments);
  var n = J(r);
  return fn(a, -n);
}
var Np = 864e5;
function Dp(a) {
  x(1, arguments);
  var r = O(a), n = r.getTime();
  r.setUTCMonth(0, 1), r.setUTCHours(0, 0, 0, 0);
  var t = r.getTime(), e = n - t;
  return Math.floor(e / Np) + 1;
}
function Va(a) {
  x(1, arguments);
  var r = 1, n = O(a), t = n.getUTCDay(), e = (t < r ? 7 : 0) + t - r;
  return n.setUTCDate(n.getUTCDate() - e), n.setUTCHours(0, 0, 0, 0), n;
}
function Hs(a) {
  x(1, arguments);
  var r = O(a), n = r.getUTCFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(n + 1, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var e = Va(t), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Va(i);
  return r.getTime() >= e.getTime() ? n + 1 : r.getTime() >= o.getTime() ? n : n - 1;
}
function Ap(a) {
  x(1, arguments);
  var r = Hs(a), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var t = Va(n);
  return t;
}
var Ip = 6048e5;
function Us(a) {
  x(1, arguments);
  var r = O(a), n = Va(r).getTime() - Ap(r).getTime();
  return Math.round(n / Ip) + 1;
}
var xp = {};
function Ba() {
  return xp;
}
function Aa(a, r) {
  var n, t, e, i, o, s, l, u;
  x(1, arguments);
  var c = Ba(), d = J((n = (t = (e = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : c.weekStartsOn) !== null && t !== void 0 ? t : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = O(a), m = p.getUTCDay(), f = (m < d ? 7 : 0) + m - d;
  return p.setUTCDate(p.getUTCDate() - f), p.setUTCHours(0, 0, 0, 0), p;
}
function gn(a, r) {
  var n, t, e, i, o, s, l, u;
  x(1, arguments);
  var c = O(a), d = c.getUTCFullYear(), p = Ba(), m = J((n = (t = (e = (i = r == null ? void 0 : r.firstWeekContainsDate) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : p.firstWeekContainsDate) !== null && t !== void 0 ? t : (l = p.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(d + 1, 0, m), f.setUTCHours(0, 0, 0, 0);
  var y = Aa(f, r), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(d, 0, m), v.setUTCHours(0, 0, 0, 0);
  var P = Aa(v, r);
  return c.getTime() >= y.getTime() ? d + 1 : c.getTime() >= P.getTime() ? d : d - 1;
}
function Ep(a, r) {
  var n, t, e, i, o, s, l, u;
  x(1, arguments);
  var c = Ba(), d = J((n = (t = (e = (i = r == null ? void 0 : r.firstWeekContainsDate) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : c.firstWeekContainsDate) !== null && t !== void 0 ? t : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = gn(a, r), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(p, 0, d), m.setUTCHours(0, 0, 0, 0);
  var f = Aa(m, r);
  return f;
}
var Bp = 6048e5;
function zs(a, r) {
  x(1, arguments);
  var n = O(a), t = Aa(n, r).getTime() - Ep(n, r).getTime();
  return Math.round(t / Bp) + 1;
}
function de(a, r) {
  for (var n = a < 0 ? "-" : "", t = Math.abs(a).toString(); t.length < r; )
    t = "0" + t;
  return n + t;
}
var ma = {
  // Year
  y: function(r, n) {
    var t = r.getUTCFullYear(), e = t > 0 ? t : 1 - t;
    return de(n === "yy" ? e % 100 : e, n.length);
  },
  // Month
  M: function(r, n) {
    var t = r.getUTCMonth();
    return n === "M" ? String(t + 1) : de(t + 1, 2);
  },
  // Day of the month
  d: function(r, n) {
    return de(r.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(r, n) {
    var t = r.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(r, n) {
    return de(r.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(r, n) {
    return de(r.getUTCHours(), n.length);
  },
  // Minute
  m: function(r, n) {
    return de(r.getUTCMinutes(), n.length);
  },
  // Second
  s: function(r, n) {
    return de(r.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(r, n) {
    var t = n.length, e = r.getUTCMilliseconds(), i = Math.floor(e * Math.pow(10, t - 3));
    return de(i, n.length);
  }
}, La = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Op = {
  // Era
  G: function(r, n, t) {
    var e = r.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(e, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return t.era(e, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(e, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(r, n, t) {
    if (n === "yo") {
      var e = r.getUTCFullYear(), i = e > 0 ? e : 1 - e;
      return t.ordinalNumber(i, {
        unit: "year"
      });
    }
    return ma.y(r, n);
  },
  // Local week-numbering year
  Y: function(r, n, t, e) {
    var i = gn(r, e), o = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var s = o % 100;
      return de(s, 2);
    }
    return n === "Yo" ? t.ordinalNumber(o, {
      unit: "year"
    }) : de(o, n.length);
  },
  // ISO week-numbering year
  R: function(r, n) {
    var t = Hs(r);
    return de(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, n) {
    var t = r.getUTCFullYear();
    return de(t, n.length);
  },
  // Quarter
  Q: function(r, n, t) {
    var e = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(e);
      // 01, 02, 03, 04
      case "QQ":
        return de(e, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(e, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, n, t) {
    var e = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(e);
      // 01, 02, 03, 04
      case "qq":
        return de(e, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(e, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, n, t) {
    var e = r.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return ma.M(r, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(e + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(r, n, t) {
    var e = r.getUTCMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(e + 1);
      // 01, 02, ..., 12
      case "LL":
        return de(e + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(e + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(e, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(r, n, t, e) {
    var i = zs(r, e);
    return n === "wo" ? t.ordinalNumber(i, {
      unit: "week"
    }) : de(i, n.length);
  },
  // ISO week of year
  I: function(r, n, t) {
    var e = Us(r);
    return n === "Io" ? t.ordinalNumber(e, {
      unit: "week"
    }) : de(e, n.length);
  },
  // Day of the month
  d: function(r, n, t) {
    return n === "do" ? t.ordinalNumber(r.getUTCDate(), {
      unit: "date"
    }) : ma.d(r, n);
  },
  // Day of year
  D: function(r, n, t) {
    var e = Dp(r);
    return n === "Do" ? t.ordinalNumber(e, {
      unit: "dayOfYear"
    }) : de(e, n.length);
  },
  // Day of week
  E: function(r, n, t) {
    var e = r.getUTCDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(e, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, n, t, e) {
    var i = r.getUTCDay(), o = (i - e.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return de(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, n, t, e) {
    var i = r.getUTCDay(), o = (i - e.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return de(o, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, n, t) {
    var e = r.getUTCDay(), i = e === 0 ? 7 : e;
    switch (n) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return de(i, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(i, {
          unit: "day"
        });
      // Tue
      case "iii":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(e, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, n, t) {
    var e = r.getUTCHours(), i = e / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, n, t) {
    var e = r.getUTCHours(), i;
    switch (e === 12 ? i = La.noon : e === 0 ? i = La.midnight : i = e / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, n, t) {
    var e = r.getUTCHours(), i;
    switch (e >= 17 ? i = La.evening : e >= 12 ? i = La.afternoon : e >= 4 ? i = La.morning : i = La.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, n, t) {
    if (n === "ho") {
      var e = r.getUTCHours() % 12;
      return e === 0 && (e = 12), t.ordinalNumber(e, {
        unit: "hour"
      });
    }
    return ma.h(r, n);
  },
  // Hour [0-23]
  H: function(r, n, t) {
    return n === "Ho" ? t.ordinalNumber(r.getUTCHours(), {
      unit: "hour"
    }) : ma.H(r, n);
  },
  // Hour [0-11]
  K: function(r, n, t) {
    var e = r.getUTCHours() % 12;
    return n === "Ko" ? t.ordinalNumber(e, {
      unit: "hour"
    }) : de(e, n.length);
  },
  // Hour [1-24]
  k: function(r, n, t) {
    var e = r.getUTCHours();
    return e === 0 && (e = 24), n === "ko" ? t.ordinalNumber(e, {
      unit: "hour"
    }) : de(e, n.length);
  },
  // Minute
  m: function(r, n, t) {
    return n === "mo" ? t.ordinalNumber(r.getUTCMinutes(), {
      unit: "minute"
    }) : ma.m(r, n);
  },
  // Second
  s: function(r, n, t) {
    return n === "so" ? t.ordinalNumber(r.getUTCSeconds(), {
      unit: "second"
    }) : ma.s(r, n);
  },
  // Fraction of second
  S: function(r, n) {
    return ma.S(r, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return ui(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ka(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ka(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return ui(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ka(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ka(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + li(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ka(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + li(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ka(o, ":");
    }
  },
  // Seconds timestamp
  t: function(r, n, t, e) {
    var i = e._originalDate || r, o = Math.floor(i.getTime() / 1e3);
    return de(o, n.length);
  },
  // Milliseconds timestamp
  T: function(r, n, t, e) {
    var i = e._originalDate || r, o = i.getTime();
    return de(o, n.length);
  }
};
function li(a, r) {
  var n = a > 0 ? "-" : "+", t = Math.abs(a), e = Math.floor(t / 60), i = t % 60;
  if (i === 0)
    return n + String(e);
  var o = r;
  return n + String(e) + o + de(i, 2);
}
function ui(a, r) {
  if (a % 60 === 0) {
    var n = a > 0 ? "-" : "+";
    return n + de(Math.abs(a) / 60, 2);
  }
  return ka(a, r);
}
function ka(a, r) {
  var n = r || "", t = a > 0 ? "-" : "+", e = Math.abs(a), i = de(Math.floor(e / 60), 2), o = de(e % 60, 2);
  return t + i + n + o;
}
var ci = function(r, n) {
  switch (r) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, js = function(r, n) {
  switch (r) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Gp = function(r, n) {
  var t = r.match(/(P+)(p+)?/) || [], e = t[1], i = t[2];
  if (!i)
    return ci(r, n);
  var o;
  switch (e) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", ci(e, n)).replace("{{time}}", js(i, n));
}, Ur = {
  p: js,
  P: Gp
};
function Yt(a) {
  var r = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
  return r.setUTCFullYear(a.getFullYear()), a.getTime() - r.getTime();
}
var Lp = ["D", "DD"], Rp = ["YY", "YYYY"];
function Vs(a) {
  return Lp.indexOf(a) !== -1;
}
function Ys(a) {
  return Rp.indexOf(a) !== -1;
}
function Wt(a, r, n) {
  if (a === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(r, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(r, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(r, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(r, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Fp = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Kp = function(r, n, t) {
  var e, i = Fp[r];
  return typeof i == "string" ? e = i : n === 1 ? e = i.one : e = i.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + e : e + " ago" : e;
};
function kr(a) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = r.width ? String(r.width) : a.defaultWidth, t = a.formats[n] || a.formats[a.defaultWidth];
    return t;
  };
}
var Hp = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Up = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, zp = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, jp = {
  date: kr({
    formats: Hp,
    defaultWidth: "full"
  }),
  time: kr({
    formats: Up,
    defaultWidth: "full"
  }),
  dateTime: kr({
    formats: zp,
    defaultWidth: "full"
  })
}, Vp = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Yp = function(r, n, t, e) {
  return Vp[r];
};
function it(a) {
  return function(r, n) {
    var t = n != null && n.context ? String(n.context) : "standalone", e;
    if (t === "formatting" && a.formattingValues) {
      var i = a.defaultFormattingWidth || a.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      e = a.formattingValues[o] || a.formattingValues[i];
    } else {
      var s = a.defaultWidth, l = n != null && n.width ? String(n.width) : a.defaultWidth;
      e = a.values[l] || a.values[s];
    }
    var u = a.argumentCallback ? a.argumentCallback(r) : r;
    return e[u];
  };
}
var Wp = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Zp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Jp = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, $p = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, qp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Qp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Xp = function(r, n) {
  var t = Number(r), e = t % 100;
  if (e > 20 || e < 10)
    switch (e % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, em = {
  ordinalNumber: Xp,
  era: it({
    values: Wp,
    defaultWidth: "wide"
  }),
  quarter: it({
    values: Zp,
    defaultWidth: "wide",
    argumentCallback: function(r) {
      return r - 1;
    }
  }),
  month: it({
    values: Jp,
    defaultWidth: "wide"
  }),
  day: it({
    values: $p,
    defaultWidth: "wide"
  }),
  dayPeriod: it({
    values: qp,
    defaultWidth: "wide",
    formattingValues: Qp,
    defaultFormattingWidth: "wide"
  })
};
function ot(a) {
  return function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.width, e = t && a.matchPatterns[t] || a.matchPatterns[a.defaultMatchWidth], i = r.match(e);
    if (!i)
      return null;
    var o = i[0], s = t && a.parsePatterns[t] || a.parsePatterns[a.defaultParseWidth], l = Array.isArray(s) ? tm(s, function(d) {
      return d.test(o);
    }) : am(s, function(d) {
      return d.test(o);
    }), u;
    u = a.valueCallback ? a.valueCallback(l) : l, u = n.valueCallback ? n.valueCallback(u) : u;
    var c = r.slice(o.length);
    return {
      value: u,
      rest: c
    };
  };
}
function am(a, r) {
  for (var n in a)
    if (a.hasOwnProperty(n) && r(a[n]))
      return n;
}
function tm(a, r) {
  for (var n = 0; n < a.length; n++)
    if (r(a[n]))
      return n;
}
function rm(a) {
  return function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.match(a.matchPattern);
    if (!t) return null;
    var e = t[0], i = r.match(a.parsePattern);
    if (!i) return null;
    var o = a.valueCallback ? a.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = r.slice(e.length);
    return {
      value: o,
      rest: s
    };
  };
}
var nm = /^(\d+)(th|st|nd|rd)?/i, im = /\d+/i, om = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, sm = {
  any: [/^b/i, /^(a|c)/i]
}, lm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, um = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, dm = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, pm = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, mm = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, hm = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, fm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, gm = {
  ordinalNumber: rm({
    matchPattern: nm,
    parsePattern: im,
    valueCallback: function(r) {
      return parseInt(r, 10);
    }
  }),
  era: ot({
    matchPatterns: om,
    defaultMatchWidth: "wide",
    parsePatterns: sm,
    defaultParseWidth: "any"
  }),
  quarter: ot({
    matchPatterns: lm,
    defaultMatchWidth: "wide",
    parsePatterns: um,
    defaultParseWidth: "any",
    valueCallback: function(r) {
      return r + 1;
    }
  }),
  month: ot({
    matchPatterns: cm,
    defaultMatchWidth: "wide",
    parsePatterns: dm,
    defaultParseWidth: "any"
  }),
  day: ot({
    matchPatterns: pm,
    defaultMatchWidth: "wide",
    parsePatterns: mm,
    defaultParseWidth: "any"
  }),
  dayPeriod: ot({
    matchPatterns: hm,
    defaultMatchWidth: "any",
    parsePatterns: fm,
    defaultParseWidth: "any"
  })
}, et = {
  code: "en-US",
  formatDistance: Kp,
  formatLong: jp,
  formatRelative: Yp,
  localize: em,
  match: gm,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, _m = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ym = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vm = /^'([^]*?)'?$/, bm = /''/g, Sm = /[a-zA-Z]/;
function di(a, r, n) {
  var t, e, i, o, s, l, u, c, d, p, m, f, y, v, P, k, w, C;
  x(2, arguments);
  var S = String(r), b = Ba(), T = (t = (e = n == null ? void 0 : n.locale) !== null && e !== void 0 ? e : b.locale) !== null && t !== void 0 ? t : et, D = J((i = (o = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (u = n.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : b.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = b.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var A = J((m = (f = (y = (v = n == null ? void 0 : n.weekStartsOn) !== null && v !== void 0 ? v : n == null || (P = n.locale) === null || P === void 0 || (k = P.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && y !== void 0 ? y : b.weekStartsOn) !== null && f !== void 0 ? f : (w = b.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(A >= 0 && A <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!T.localize)
    throw new RangeError("locale must contain localize property");
  if (!T.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var I = O(a);
  if (!vt(I))
    throw new RangeError("Invalid time value");
  var K = Yt(I), Z = Ks(I, K), Y = {
    firstWeekContainsDate: D,
    weekStartsOn: A,
    locale: T,
    _originalDate: I
  }, z = S.match(ym).map(function(H) {
    var U = H[0];
    if (U === "p" || U === "P") {
      var B = Ur[U];
      return B(H, T.formatLong);
    }
    return H;
  }).join("").match(_m).map(function(H) {
    if (H === "''")
      return "'";
    var U = H[0];
    if (U === "'")
      return km(H);
    var B = Op[U];
    if (B)
      return !(n != null && n.useAdditionalWeekYearTokens) && Ys(H) && Wt(H, r, String(a)), !(n != null && n.useAdditionalDayOfYearTokens) && Vs(H) && Wt(H, r, String(a)), B(Z, H, T.localize, Y);
    if (U.match(Sm))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + U + "`");
    return H;
  }).join("");
  return z;
}
function km(a) {
  var r = a.match(vm);
  return r ? r[1].replace(bm, "'") : a;
}
var Mm = 6e4;
function zr(a, r) {
  x(2, arguments);
  var n = J(r);
  return fn(a, n * Mm);
}
var wm = 36e5;
function Cm(a, r) {
  x(2, arguments);
  var n = J(r);
  return fn(a, n * wm);
}
function at(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r);
  return isNaN(t) ? /* @__PURE__ */ new Date(NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Zt(a, r) {
  x(2, arguments);
  var n = J(r), t = n * 7;
  return at(a, t);
}
function qe(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r);
  if (isNaN(t))
    return /* @__PURE__ */ new Date(NaN);
  if (!t)
    return n;
  var e = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + t + 1, 0);
  var o = i.getDate();
  return e >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), e), n);
}
function Ws(a, r) {
  x(2, arguments);
  var n = J(r), t = n * 3;
  return qe(a, t);
}
function Ya(a, r) {
  x(2, arguments);
  var n = J(r);
  return qe(a, n * 12);
}
function Pm(a, r) {
  x(2, arguments);
  var n = J(r);
  return at(a, -n);
}
function pi(a, r) {
  x(2, arguments);
  var n = J(r);
  return Zt(a, -n);
}
function Wa(a, r) {
  x(2, arguments);
  var n = J(r);
  return qe(a, -n);
}
function Tm(a, r) {
  x(2, arguments);
  var n = J(r);
  return Ws(a, -n);
}
function bt(a, r) {
  x(2, arguments);
  var n = J(r);
  return Ya(a, -n);
}
function mi(a) {
  x(1, arguments);
  var r = O(a), n = r.getSeconds();
  return n;
}
function ra(a) {
  x(1, arguments);
  var r = O(a), n = r.getMinutes();
  return n;
}
function na(a) {
  x(1, arguments);
  var r = O(a), n = r.getHours();
  return n;
}
function Nm(a) {
  x(1, arguments);
  var r = O(a), n = r.getDay();
  return n;
}
function hi(a) {
  x(1, arguments);
  var r = O(a), n = r.getDate();
  return n;
}
function Zs(a, r) {
  var n, t, e, i, o, s, l, u;
  x(1, arguments);
  var c = Ba(), d = J((n = (t = (e = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : c.weekStartsOn) !== null && t !== void 0 ? t : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = O(a), m = p.getDay(), f = (m < d ? 7 : 0) + m - d;
  return p.setDate(p.getDate() - f), p.setHours(0, 0, 0, 0), p;
}
function Jt(a) {
  return x(1, arguments), Zs(a, {
    weekStartsOn: 1
  });
}
function Dm(a) {
  x(1, arguments);
  var r = O(a), n = r.getFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setFullYear(n + 1, 0, 4), t.setHours(0, 0, 0, 0);
  var e = Jt(t), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var o = Jt(i);
  return r.getTime() >= e.getTime() ? n + 1 : r.getTime() >= o.getTime() ? n : n - 1;
}
function Am(a) {
  x(1, arguments);
  var r = Dm(a), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0);
  var t = Jt(n);
  return t;
}
var Im = 6048e5;
function xm(a) {
  x(1, arguments);
  var r = O(a), n = Jt(r).getTime() - Am(r).getTime();
  return Math.round(n / Im) + 1;
}
function Be(a) {
  x(1, arguments);
  var r = O(a), n = r.getMonth();
  return n;
}
function Fa(a) {
  x(1, arguments);
  var r = O(a), n = Math.floor(r.getMonth() / 3) + 1;
  return n;
}
function $(a) {
  return x(1, arguments), O(a).getFullYear();
}
function jr(a) {
  x(1, arguments);
  var r = O(a), n = r.getTime();
  return n;
}
function Em(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r);
  return n.setSeconds(t), n;
}
function Gt(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r);
  return n.setMinutes(t), n;
}
function Lt(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r);
  return n.setHours(t), n;
}
function Bm(a) {
  x(1, arguments);
  var r = O(a), n = r.getFullYear(), t = r.getMonth(), e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(n, t + 1, 0), e.setHours(0, 0, 0, 0), e.getDate();
}
function Re(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r), e = n.getFullYear(), i = n.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(e, t, 15), o.setHours(0, 0, 0, 0);
  var s = Bm(o);
  return n.setMonth(t, Math.min(i, s)), n;
}
function Ra(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r), e = Math.floor(n.getMonth() / 3) + 1, i = t - e;
  return Re(n, n.getMonth() + i * 3);
}
function da(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(t), n);
}
function fi(a) {
  x(1, arguments);
  var r;
  if (a && typeof a.forEach == "function")
    r = a;
  else if (Ye(a) === "object" && a !== null)
    r = Array.prototype.slice.call(a);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return r.forEach(function(t) {
    var e = O(t);
    (n === void 0 || n > e || isNaN(e.getDate())) && (n = e);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function gi(a) {
  x(1, arguments);
  var r;
  if (a && typeof a.forEach == "function")
    r = a;
  else if (Ye(a) === "object" && a !== null)
    r = Array.prototype.slice.call(a);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return r.forEach(function(t) {
    var e = O(t);
    (n === void 0 || n < e || isNaN(Number(e))) && (n = e);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function ia(a) {
  x(1, arguments);
  var r = O(a);
  return r.setHours(0, 0, 0, 0), r;
}
var Om = 864e5;
function St(a, r) {
  x(2, arguments);
  var n = ia(a), t = ia(r), e = n.getTime() - Yt(n), i = t.getTime() - Yt(t);
  return Math.round((e - i) / Om);
}
function $t(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r), e = n.getFullYear() - t.getFullYear(), i = n.getMonth() - t.getMonth();
  return e * 12 + i;
}
function qt(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r);
  return n.getFullYear() - t.getFullYear();
}
function Js(a) {
  x(1, arguments);
  var r = O(a);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function Vr(a) {
  x(1, arguments);
  var r = O(a), n = r.getMonth(), t = n - n % 3;
  return r.setMonth(t, 1), r.setHours(0, 0, 0, 0), r;
}
function $s(a) {
  x(1, arguments);
  var r = O(a), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(r.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Yr(a) {
  x(1, arguments);
  var r = O(a);
  return r.setHours(23, 59, 59, 999), r;
}
function Gm(a) {
  x(1, arguments);
  var r = O(a), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function Lm(a) {
  x(1, arguments);
  var r = O(a), n = r.getFullYear();
  return r.setFullYear(n + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function Rm(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r);
  return n.getTime() === t.getTime();
}
function Fm(a, r) {
  x(2, arguments);
  var n = ia(a), t = ia(r);
  return n.getTime() === t.getTime();
}
function Km(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r);
  return n.getFullYear() === t.getFullYear() && n.getMonth() === t.getMonth();
}
function Hm(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r);
  return n.getFullYear() === t.getFullYear();
}
function Um(a, r) {
  x(2, arguments);
  var n = Vr(a), t = Vr(r);
  return n.getTime() === t.getTime();
}
function ya(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r);
  return n.getTime() > t.getTime();
}
function fa(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r);
  return n.getTime() < t.getTime();
}
function kt(a, r) {
  x(2, arguments);
  var n = O(a).getTime(), t = O(r.start).getTime(), e = O(r.end).getTime();
  if (!(t <= e))
    throw new RangeError("Invalid interval");
  return n >= t && n <= e;
}
function _i(a, r) {
  var n = typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (!n) {
    if (Array.isArray(a) || (n = bu(a)) || r) {
      n && (a = n);
      var t = 0, e = function() {
      };
      return {
        s: e,
        n: function() {
          return t >= a.length ? {
            done: !0
          } : {
            done: !1,
            value: a[t++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: e
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(a);
    },
    n: function() {
      var u = n.next();
      return o = u.done, u;
    },
    e: function(u) {
      s = !0, i = u;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function zm(a, r) {
  if (a == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && (a[n] = r[n]);
  return a;
}
function L(a) {
  if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function Wr(a, r) {
  return Wr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, t) {
    return n.__proto__ = t, n;
  }, Wr(a, r);
}
function ne(a, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(a, "prototype", {
    writable: !1
  }), r && Wr(a, r);
}
function Qt(a) {
  return Qt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qt(a);
}
function qs() {
  try {
    var a = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qs = function() {
    return !!a;
  })();
}
function jm(a, r) {
  if (r && (Ye(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return L(a);
}
function ie(a) {
  var r = qs();
  return function() {
    var n, t = Qt(a);
    if (r) {
      var e = Qt(this).constructor;
      n = Reflect.construct(t, arguments, e);
    } else n = t.apply(this, arguments);
    return jm(this, n);
  };
}
var Vm = 10, Qs = /* @__PURE__ */ (function() {
  function a() {
    ee(this, a), E(this, "priority", void 0), E(this, "subPriority", 0);
  }
  return ae(a, [{
    key: "validate",
    value: function(n, t) {
      return !0;
    }
  }]), a;
})(), Ym = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n(t, e, i, o, s) {
    var l;
    return ee(this, n), l = r.call(this), l.value = t, l.validateValue = e, l.setValue = i, l.priority = o, s && (l.subPriority = s), l;
  }
  return ae(n, [{
    key: "validate",
    value: function(e, i) {
      return this.validateValue(e, this.value, i);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return this.setValue(e, i, this.value, o);
    }
  }]), n;
})(Qs), Wm = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", Vm), E(L(t), "subPriority", -1), t;
  }
  return ae(n, [{
    key: "set",
    value: function(e, i) {
      if (i.timestampIsSet)
        return e;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), o.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), o;
    }
  }]), n;
})(Qs), se = /* @__PURE__ */ (function() {
  function a() {
    ee(this, a), E(this, "incompatibleTokens", void 0), E(this, "priority", void 0), E(this, "subPriority", void 0);
  }
  return ae(a, [{
    key: "run",
    value: function(n, t, e, i) {
      var o = this.parse(n, t, e, i);
      return o ? {
        setter: new Ym(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, t, e) {
      return !0;
    }
  }]), a;
})(), Zm = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 140), E(L(t), "incompatibleTokens", ["R", "u", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return o.era(e, {
            width: "abbreviated"
          }) || o.era(e, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return o.era(e, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return o.era(e, {
            width: "wide"
          }) || o.era(e, {
            width: "abbreviated"
          }) || o.era(e, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.era = o, e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), _n = 6e4, yn = 36e5, Jm = 1e3, Me = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ea = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function we(a, r) {
  return a && {
    value: r(a.value),
    rest: a.rest
  };
}
function be(a, r) {
  var n = r.match(a);
  return n ? {
    value: parseInt(n[0], 10),
    rest: r.slice(n[0].length)
  } : null;
}
function aa(a, r) {
  var n = r.match(a);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  var t = n[1] === "+" ? 1 : -1, e = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: t * (e * yn + i * _n + o * Jm),
    rest: r.slice(n[0].length)
  };
}
function Xs(a) {
  return be(Me.anyDigitsSigned, a);
}
function ke(a, r) {
  switch (a) {
    case 1:
      return be(Me.singleDigit, r);
    case 2:
      return be(Me.twoDigits, r);
    case 3:
      return be(Me.threeDigits, r);
    case 4:
      return be(Me.fourDigits, r);
    default:
      return be(new RegExp("^\\d{1," + a + "}"), r);
  }
}
function Xt(a, r) {
  switch (a) {
    case 1:
      return be(Me.singleDigitSigned, r);
    case 2:
      return be(Me.twoDigitsSigned, r);
    case 3:
      return be(Me.threeDigitsSigned, r);
    case 4:
      return be(Me.fourDigitsSigned, r);
    default:
      return be(new RegExp("^-?\\d{1," + a + "}"), r);
  }
}
function vn(a) {
  switch (a) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function el(a, r) {
  var n = r > 0, t = n ? r : 1 - r, e;
  if (t <= 50)
    e = a || 100;
  else {
    var i = t + 50, o = Math.floor(i / 100) * 100, s = a >= i % 100;
    e = a + o - (s ? 100 : 0);
  }
  return n ? e : 1 - e;
}
function al(a) {
  return a % 400 === 0 || a % 4 === 0 && a % 100 !== 0;
}
var $m = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 130), E(L(t), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return we(ke(4, e), s);
        case "yo":
          return we(o.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return we(ke(i.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = el(o.year, s);
        return e.setUTCFullYear(l, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }
      var u = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return e.setUTCFullYear(u, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), qm = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 130), E(L(t), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return we(ke(4, e), s);
        case "Yo":
          return we(o.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return we(ke(i.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      var l = gn(e, s);
      if (o.isTwoDigitYear) {
        var u = el(o.year, l);
        return e.setUTCFullYear(u, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Aa(e, s);
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return e.setUTCFullYear(c, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Aa(e, s);
    }
  }]), n;
})(se), Qm = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 130), E(L(t), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      return Xt(i === "R" ? 4 : i.length, e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), Va(s);
    }
  }]), n;
})(se), Xm = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 130), E(L(t), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      return Xt(i === "u" ? 4 : i.length, e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), eh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 120), E(L(t), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return ke(i.length, e);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return o.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return o.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return o.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth((o - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), ah = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 120), E(L(t), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return ke(i.length, e);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return o.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return o.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return o.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth((o - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), th = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), E(L(t), "priority", 110), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(u) {
        return u - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "M":
          return we(be(Me.month, e), s);
        // 01, 02, ..., 12
        case "MM":
          return we(ke(2, e), s);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return we(o.ordinalNumber(e, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "MMM":
          return o.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(e, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return o.month(e, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return o.month(e, {
            width: "wide",
            context: "formatting"
          }) || o.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(o, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), rh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 110), E(L(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(u) {
        return u - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "L":
          return we(be(Me.month, e), s);
        // 01, 02, ..., 12
        case "LL":
          return we(ke(2, e), s);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return we(o.ordinalNumber(e, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "LLL":
          return o.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(e, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return o.month(e, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return o.month(e, {
            width: "wide",
            context: "standalone"
          }) || o.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(o, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se);
function nh(a, r, n) {
  x(2, arguments);
  var t = O(a), e = J(r), i = zs(t, n) - e;
  return t.setUTCDate(t.getUTCDate() - i * 7), t;
}
var ih = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 100), E(L(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "w":
          return be(Me.week, e);
        case "wo":
          return o.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return Aa(nh(e, o, s), s);
    }
  }]), n;
})(se);
function oh(a, r) {
  x(2, arguments);
  var n = O(a), t = J(r), e = Us(n) - t;
  return n.setUTCDate(n.getUTCDate() - e * 7), n;
}
var sh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 100), E(L(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "I":
          return be(Me.week, e);
        case "Io":
          return o.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return Va(oh(e, o));
    }
  }]), n;
})(se), lh = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], uh = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ch = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 90), E(L(t), "subPriority", 1), E(L(t), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "d":
          return be(Me.date, e);
        case "do":
          return o.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      var o = e.getUTCFullYear(), s = al(o), l = e.getUTCMonth();
      return s ? i >= 1 && i <= uh[l] : i >= 1 && i <= lh[l];
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCDate(o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), dh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 90), E(L(t), "subpriority", 1), E(L(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return be(Me.dayOfYear, e);
        case "Do":
          return o.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      var o = e.getUTCFullYear(), s = al(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(0, o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se);
function bn(a, r, n) {
  var t, e, i, o, s, l, u, c;
  x(2, arguments);
  var d = Ba(), p = J((t = (e = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && e !== void 0 ? e : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = O(a), f = J(r), y = m.getUTCDay(), v = f % 7, P = (v + 7) % 7, k = (P < p ? 7 : 0) + f - y;
  return m.setUTCDate(m.getUTCDate() + k), m;
}
var ph = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 90), E(L(t), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = bn(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), mh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 90), E(L(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o, s) {
      var l = function(c) {
        var d = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        // 3
        case "e":
        case "ee":
          return we(ke(i.length, e), l);
        // 3rd
        case "eo":
          return we(o.ordinalNumber(e, {
            unit: "day"
          }), l);
        // Tue
        case "eee":
          return o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = bn(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), hh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 90), E(L(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o, s) {
      var l = function(c) {
        var d = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        // 3
        case "c":
        case "cc":
          return we(ke(i.length, e), l);
        // 3rd
        case "co":
          return we(o.ordinalNumber(e, {
            unit: "day"
          }), l);
        // Tue
        case "ccc":
          return o.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return o.day(e, {
            width: "wide",
            context: "standalone"
          }) || o.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = bn(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se);
function fh(a, r) {
  x(2, arguments);
  var n = J(r);
  n % 7 === 0 && (n = n - 7);
  var t = 1, e = O(a), i = e.getUTCDay(), o = n % 7, s = (o + 7) % 7, l = (s < t ? 7 : 0) + n - i;
  return e.setUTCDate(e.getUTCDate() + l), e;
}
var gh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 90), E(L(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (i) {
        // 2
        case "i":
        case "ii":
          return ke(i.length, e);
        // 2nd
        case "io":
          return o.ordinalNumber(e, {
            unit: "day"
          });
        // Tue
        case "iii":
          return we(o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        // T
        case "iiiii":
          return we(o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tu
        case "iiiiii":
          return we(o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tuesday
        case "iiii":
        default:
          return we(o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e = fh(e, o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), n;
})(se), _h = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 80), E(L(t), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(vn(o), 0, 0, 0), e;
    }
  }]), n;
})(se), yh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 80), E(L(t), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(vn(o), 0, 0, 0), e;
    }
  }]), n;
})(se), vh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 80), E(L(t), "incompatibleTokens", ["a", "b", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(vn(o), 0, 0, 0), e;
    }
  }]), n;
})(se), bh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 70), E(L(t), "incompatibleTokens", ["H", "K", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "h":
          return be(Me.hour12h, e);
        case "ho":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCHours() >= 12;
      return s && o < 12 ? e.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), n;
})(se), Sh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 70), E(L(t), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "H":
          return be(Me.hour23h, e);
        case "Ho":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), n;
})(se), kh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 70), E(L(t), "incompatibleTokens", ["h", "H", "k", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "K":
          return be(Me.hour11h, e);
        case "Ko":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCHours() >= 12;
      return s && o < 12 ? e.setUTCHours(o + 12, 0, 0, 0) : e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), n;
})(se), Mh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 70), E(L(t), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "k":
          return be(Me.hour24h, e);
        case "ko":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return e.setUTCHours(s, 0, 0, 0), e;
    }
  }]), n;
})(se), wh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 60), E(L(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "m":
          return be(Me.minute, e);
        case "mo":
          return o.ordinalNumber(e, {
            unit: "minute"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMinutes(o, 0, 0), e;
    }
  }]), n;
})(se), Ch = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 50), E(L(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "s":
          return be(Me.second, e);
        case "so":
          return o.ordinalNumber(e, {
            unit: "second"
          });
        default:
          return ke(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCSeconds(o, 0), e;
    }
  }]), n;
})(se), Ph = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 30), E(L(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return we(ke(i.length, e), o);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMilliseconds(o), e;
    }
  }]), n;
})(se), Th = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 10), E(L(t), "incompatibleTokens", ["t", "T", "x"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      switch (i) {
        case "X":
          return aa(ea.basicOptionalMinutes, e);
        case "XX":
          return aa(ea.basic, e);
        case "XXXX":
          return aa(ea.basicOptionalSeconds, e);
        case "XXXXX":
          return aa(ea.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return aa(ea.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.timestampIsSet ? e : new Date(e.getTime() - o);
    }
  }]), n;
})(se), Nh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 10), E(L(t), "incompatibleTokens", ["t", "T", "X"]), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e, i) {
      switch (i) {
        case "x":
          return aa(ea.basicOptionalMinutes, e);
        case "xx":
          return aa(ea.basic, e);
        case "xxxx":
          return aa(ea.basicOptionalSeconds, e);
        case "xxxxx":
          return aa(ea.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return aa(ea.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.timestampIsSet ? e : new Date(e.getTime() - o);
    }
  }]), n;
})(se), Dh = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 40), E(L(t), "incompatibleTokens", "*"), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e) {
      return Xs(e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
})(se), Ah = /* @__PURE__ */ (function(a) {
  ne(n, a);
  var r = ie(n);
  function n() {
    var t;
    ee(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = r.call.apply(r, [this].concat(i)), E(L(t), "priority", 20), E(L(t), "incompatibleTokens", "*"), t;
  }
  return ae(n, [{
    key: "parse",
    value: function(e) {
      return Xs(e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
})(se), Ih = {
  G: new Zm(),
  y: new $m(),
  Y: new qm(),
  R: new Qm(),
  u: new Xm(),
  Q: new eh(),
  q: new ah(),
  M: new th(),
  L: new rh(),
  w: new ih(),
  I: new sh(),
  d: new ch(),
  D: new dh(),
  E: new ph(),
  e: new mh(),
  c: new hh(),
  i: new gh(),
  a: new _h(),
  b: new yh(),
  B: new vh(),
  h: new bh(),
  H: new Sh(),
  K: new kh(),
  k: new Mh(),
  m: new wh(),
  s: new Ch(),
  S: new Ph(),
  X: new Th(),
  x: new Nh(),
  t: new Dh(),
  T: new Ah()
}, xh = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Eh = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Bh = /^'([^]*?)'?$/, Oh = /''/g, Gh = /\S/, Lh = /[a-zA-Z]/;
function Mr(a, r, n, t) {
  var e, i, o, s, l, u, c, d, p, m, f, y, v, P, k, w, C, S;
  x(3, arguments);
  var b = String(a), T = String(r), D = Ba(), A = (e = (i = t == null ? void 0 : t.locale) !== null && i !== void 0 ? i : D.locale) !== null && e !== void 0 ? e : et;
  if (!A.match)
    throw new RangeError("locale must contain match property");
  var I = J((o = (s = (l = (u = t == null ? void 0 : t.firstWeekContainsDate) !== null && u !== void 0 ? u : t == null || (c = t.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : D.firstWeekContainsDate) !== null && s !== void 0 ? s : (p = D.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(I >= 1 && I <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var K = J((f = (y = (v = (P = t == null ? void 0 : t.weekStartsOn) !== null && P !== void 0 ? P : t == null || (k = t.locale) === null || k === void 0 || (w = k.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && v !== void 0 ? v : D.weekStartsOn) !== null && y !== void 0 ? y : (C = D.locale) === null || C === void 0 || (S = C.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(K >= 0 && K <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (T === "")
    return b === "" ? O(n) : /* @__PURE__ */ new Date(NaN);
  var Z = {
    firstWeekContainsDate: I,
    weekStartsOn: K,
    locale: A
  }, Y = [new Wm()], z = T.match(Eh).map(function(oe) {
    var re = oe[0];
    if (re in Ur) {
      var Oe = Ur[re];
      return Oe(oe, A.formatLong);
    }
    return oe;
  }).join("").match(xh), H = [], U = _i(z), B;
  try {
    var R = function() {
      var re = B.value;
      !(t != null && t.useAdditionalWeekYearTokens) && Ys(re) && Wt(re, T, a), !(t != null && t.useAdditionalDayOfYearTokens) && Vs(re) && Wt(re, T, a);
      var Oe = re[0], X = Ih[Oe];
      if (X) {
        var ce = X.incompatibleTokens;
        if (Array.isArray(ce)) {
          var Ge = H.find(function(ca) {
            return ce.includes(ca.token) || ca.token === Oe;
          });
          if (Ge)
            throw new RangeError("The format string mustn't contain `".concat(Ge.fullToken, "` and `").concat(re, "` at the same time"));
        } else if (X.incompatibleTokens === "*" && H.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(re, "` and any other token at the same time"));
        H.push({
          token: Oe,
          fullToken: re
        });
        var ua = X.run(b, re, A.match, Z);
        if (!ua)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        Y.push(ua.setter), b = ua.rest;
      } else {
        if (Oe.match(Lh))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Oe + "`");
        if (re === "''" ? re = "'" : Oe === "'" && (re = Rh(re)), b.indexOf(re) === 0)
          b = b.slice(re.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (U.s(); !(B = U.n()).done; ) {
      var W = R();
      if (Ye(W) === "object") return W.v;
    }
  } catch (oe) {
    U.e(oe);
  } finally {
    U.f();
  }
  if (b.length > 0 && Gh.test(b))
    return /* @__PURE__ */ new Date(NaN);
  var j = Y.map(function(oe) {
    return oe.priority;
  }).sort(function(oe, re) {
    return re - oe;
  }).filter(function(oe, re, Oe) {
    return Oe.indexOf(oe) === re;
  }).map(function(oe) {
    return Y.filter(function(re) {
      return re.priority === oe;
    }).sort(function(re, Oe) {
      return Oe.subPriority - re.subPriority;
    });
  }).map(function(oe) {
    return oe[0];
  }), q = O(n);
  if (isNaN(q.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var te = Ks(q, Yt(q)), pe = {}, me = _i(j), _e;
  try {
    for (me.s(); !(_e = me.n()).done; ) {
      var xe = _e.value;
      if (!xe.validate(te, Z))
        return /* @__PURE__ */ new Date(NaN);
      var Ee = xe.set(te, pe, Z);
      Array.isArray(Ee) ? (te = Ee[0], zm(pe, Ee[1])) : te = Ee;
    }
  } catch (oe) {
    me.e(oe);
  } finally {
    me.f();
  }
  return te;
}
function Rh(a) {
  return a.match(Bh)[1].replace(Oh, "'");
}
function Fh(a, r) {
  var n;
  x(1, arguments);
  var t = J((n = void 0) !== null && n !== void 0 ? n : 2);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof a == "string" || Object.prototype.toString.call(a) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var e = zh(a), i;
  if (e.date) {
    var o = jh(e.date, t);
    i = Vh(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), l = 0, u;
  if (e.time && (l = Yh(e.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (e.timezone) {
    if (u = Wh(e.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var c = new Date(s + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()), d.setHours(c.getUTCHours(), c.getUTCMinutes(), c.getUTCSeconds(), c.getUTCMilliseconds()), d;
  }
  return new Date(s + l + u);
}
var xt = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Kh = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Hh = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Uh = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function zh(a) {
  var r = {}, n = a.split(xt.dateTimeDelimiter), t;
  if (n.length > 2)
    return r;
  if (/:/.test(n[0]) ? t = n[0] : (r.date = n[0], t = n[1], xt.timeZoneDelimiter.test(r.date) && (r.date = a.split(xt.timeZoneDelimiter)[0], t = a.substr(r.date.length, a.length))), t) {
    var e = xt.timezone.exec(t);
    e ? (r.time = t.replace(e[1], ""), r.timezone = e[1]) : r.time = t;
  }
  return r;
}
function jh(a, r) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"), t = a.match(n);
  if (!t) return {
    year: NaN,
    restDateString: ""
  };
  var e = t[1] ? parseInt(t[1]) : null, i = t[2] ? parseInt(t[2]) : null;
  return {
    year: i === null ? e : i * 100,
    restDateString: a.slice((t[1] || t[2]).length)
  };
}
function Vh(a, r) {
  if (r === null) return /* @__PURE__ */ new Date(NaN);
  var n = a.match(Kh);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var t = !!n[4], e = st(n[1]), i = st(n[2]) - 1, o = st(n[3]), s = st(n[4]), l = st(n[5]) - 1;
  if (t)
    return Qh(r, s, l) ? Zh(r, s, l) : /* @__PURE__ */ new Date(NaN);
  var u = /* @__PURE__ */ new Date(0);
  return !$h(r, i, o) || !qh(r, e) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(r, i, Math.max(e, o)), u);
}
function st(a) {
  return a ? parseInt(a) : 1;
}
function Yh(a) {
  var r = a.match(Hh);
  if (!r) return NaN;
  var n = wr(r[1]), t = wr(r[2]), e = wr(r[3]);
  return Xh(n, t, e) ? n * yn + t * _n + e * 1e3 : NaN;
}
function wr(a) {
  return a && parseFloat(a.replace(",", ".")) || 0;
}
function Wh(a) {
  if (a === "Z") return 0;
  var r = a.match(Uh);
  if (!r) return 0;
  var n = r[1] === "+" ? -1 : 1, t = parseInt(r[2]), e = r[3] && parseInt(r[3]) || 0;
  return ef(t, e) ? n * (t * yn + e * _n) : NaN;
}
function Zh(a, r, n) {
  var t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(a, 0, 4);
  var e = t.getUTCDay() || 7, i = (r - 1) * 7 + n + 1 - e;
  return t.setUTCDate(t.getUTCDate() + i), t;
}
var Jh = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function tl(a) {
  return a % 400 === 0 || a % 4 === 0 && a % 100 !== 0;
}
function $h(a, r, n) {
  return r >= 0 && r <= 11 && n >= 1 && n <= (Jh[r] || (tl(a) ? 29 : 28));
}
function qh(a, r) {
  return r >= 1 && r <= (tl(a) ? 366 : 365);
}
function Qh(a, r, n) {
  return r >= 1 && r <= 53 && n >= 0 && n <= 6;
}
function Xh(a, r, n) {
  return a === 24 ? r === 0 && n === 0 : n >= 0 && n < 60 && r >= 0 && r < 60 && a >= 0 && a < 25;
}
function ef(a, r) {
  return r >= 0 && r <= 59;
}
function af(a, r) {
  a.prototype = Object.create(r.prototype), a.prototype.constructor = a, Zr(a, r);
}
function Zr(a, r) {
  return Zr = Object.setPrototypeOf || function(t, e) {
    return t.__proto__ = e, t;
  }, Zr(a, r);
}
function tf(a, r) {
  if (a == null) return {};
  var n = {}, t = Object.keys(a), e, i;
  for (i = 0; i < t.length; i++)
    e = t[i], !(r.indexOf(e) >= 0) && (n[e] = a[e]);
  return n;
}
function yi(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function rf(a, r, n) {
  return a === r ? !0 : a.correspondingElement ? a.correspondingElement.classList.contains(n) : a.classList.contains(n);
}
function nf(a, r, n) {
  if (a === r)
    return !0;
  for (; a.parentNode || a.host; ) {
    if (a.parentNode && rf(a, r, n))
      return !0;
    a = a.parentNode || a.host;
  }
  return a;
}
function of(a) {
  return document.documentElement.clientWidth <= a.clientX || document.documentElement.clientHeight <= a.clientY;
}
var sf = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var r = !1, n = Object.defineProperty({}, "passive", {
      get: function() {
        r = !0;
      }
    }), t = function() {
    };
    return window.addEventListener("testPassiveEventSupport", t, n), window.removeEventListener("testPassiveEventSupport", t, n), r;
  }
};
function lf(a) {
  return a === void 0 && (a = 0), function() {
    return ++a;
  };
}
var uf = lf(), Jr, Et = {}, Cr = {}, cf = ["touchstart", "touchmove"], df = "ignore-react-onclickoutside";
function vi(a, r) {
  var n = {}, t = cf.indexOf(r) !== -1;
  return t && Jr && (n.passive = !a.props.preventDefault), n;
}
function ur(a, r) {
  var n, t, e = a.displayName || a.name || "Component";
  return t = n = /* @__PURE__ */ (function(i) {
    af(o, i);
    function o(l) {
      var u;
      return u = i.call(this, l) || this, u.__outsideClickHandler = function(c) {
        if (typeof u.__clickOutsideHandlerProp == "function") {
          u.__clickOutsideHandlerProp(c);
          return;
        }
        var d = u.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(c);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(c);
          return;
        }
        throw new Error("WrappedComponent: " + e + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, u.__getComponentNode = function() {
        var c = u.getInstance();
        return typeof c.setClickOutsideRef == "function" ? c.setClickOutsideRef() : cu(c);
      }, u.enableOnClickOutside = function() {
        if (!(typeof document > "u" || Cr[u._uid])) {
          typeof Jr > "u" && (Jr = sf()), Cr[u._uid] = !0;
          var c = u.props.eventTypes;
          c.forEach || (c = [c]), Et[u._uid] = function(d) {
            if (u.componentNode !== null && !(u.initTimeStamp > d.timeStamp) && (u.props.preventDefault && d.preventDefault(), u.props.stopPropagation && d.stopPropagation(), !(u.props.excludeScrollbar && of(d)))) {
              var p = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              nf(p, u.componentNode, u.props.outsideClickIgnoreClass) === document && u.__outsideClickHandler(d);
            }
          }, c.forEach(function(d) {
            document.addEventListener(d, Et[u._uid], vi(yi(u), d));
          });
        }
      }, u.disableOnClickOutside = function() {
        delete Cr[u._uid];
        var c = Et[u._uid];
        if (c && typeof document < "u") {
          var d = u.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(p) {
            return document.removeEventListener(p, c, vi(yi(u), p));
          }), delete Et[u._uid];
        }
      }, u.getRef = function(c) {
        return u.instanceRef = c;
      }, u._uid = uf(), u.initTimeStamp = performance.now(), u;
    }
    var s = o.prototype;
    return s.getInstance = function() {
      if (a.prototype && !a.prototype.isReactComponent)
        return this;
      var u = this.instanceRef;
      return u.getInstance ? u.getInstance() : u;
    }, s.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var u = this.props;
      u.excludeScrollbar;
      var c = tf(u, ["excludeScrollbar"]);
      return a.prototype && a.prototype.isReactComponent ? c.ref = this.getRef : c.wrappedRef = this.getRef, c.disableOnClickOutside = this.disableOnClickOutside, c.enableOnClickOutside = this.enableOnClickOutside, jl(a, c);
    }, o;
  })(Vl), n.displayName = "OnClickOutside(" + e + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: df,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return a.getClass ? a.getClass() : a;
  }, t;
}
var rl = he.createContext(), nl = he.createContext();
function pf(a) {
  var r = a.children, n = he.useState(null), t = n[0], e = n[1], i = he.useRef(!1);
  he.useEffect(function() {
    return function() {
      i.current = !0;
    };
  }, []);
  var o = he.useCallback(function(s) {
    i.current || e(s);
  }, []);
  return /* @__PURE__ */ he.createElement(rl.Provider, {
    value: t
  }, /* @__PURE__ */ he.createElement(nl.Provider, {
    value: o
  }, r));
}
var il = function(r) {
  return Array.isArray(r) ? r[0] : r;
}, ol = function(r) {
  if (typeof r == "function") {
    for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), e = 1; e < n; e++)
      t[e - 1] = arguments[e];
    return r.apply(void 0, t);
  }
}, $r = function(r, n) {
  if (typeof r == "function")
    return ol(r, n);
  r != null && (r.current = n);
}, bi = function(r) {
  return r.reduce(function(n, t) {
    var e = t[0], i = t[1];
    return n[e] = i, n;
  }, {});
}, Si = typeof window < "u" && window.document && window.document.createElement ? he.useLayoutEffect : he.useEffect, He = "top", We = "bottom", Ze = "right", Ue = "left", Sn = "auto", Nt = [He, We, Ze, Ue], Za = "start", Mt = "end", mf = "clippingParents", sl = "viewport", lt = "popper", hf = "reference", ki = /* @__PURE__ */ Nt.reduce(function(a, r) {
  return a.concat([r + "-" + Za, r + "-" + Mt]);
}, []), ll = /* @__PURE__ */ [].concat(Nt, [Sn]).reduce(function(a, r) {
  return a.concat([r, r + "-" + Za, r + "-" + Mt]);
}, []), ff = "beforeRead", gf = "read", _f = "afterRead", yf = "beforeMain", vf = "main", bf = "afterMain", Sf = "beforeWrite", kf = "write", Mf = "afterWrite", wf = [ff, gf, _f, yf, vf, bf, Sf, kf, Mf];
function la(a) {
  return a ? (a.nodeName || "").toLowerCase() : null;
}
function je(a) {
  if (a == null)
    return window;
  if (a.toString() !== "[object Window]") {
    var r = a.ownerDocument;
    return r && r.defaultView || window;
  }
  return a;
}
function Ia(a) {
  var r = je(a).Element;
  return a instanceof r || a instanceof Element;
}
function Ve(a) {
  var r = je(a).HTMLElement;
  return a instanceof r || a instanceof HTMLElement;
}
function kn(a) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = je(a).ShadowRoot;
  return a instanceof r || a instanceof ShadowRoot;
}
function Cf(a) {
  var r = a.state;
  Object.keys(r.elements).forEach(function(n) {
    var t = r.styles[n] || {}, e = r.attributes[n] || {}, i = r.elements[n];
    !Ve(i) || !la(i) || (Object.assign(i.style, t), Object.keys(e).forEach(function(o) {
      var s = e[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function Pf(a) {
  var r = a.state, n = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow), function() {
    Object.keys(r.elements).forEach(function(t) {
      var e = r.elements[t], i = r.attributes[t] || {}, o = Object.keys(r.styles.hasOwnProperty(t) ? r.styles[t] : n[t]), s = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Ve(e) || !la(e) || (Object.assign(e.style, s), Object.keys(i).forEach(function(l) {
        e.removeAttribute(l);
      }));
    });
  };
}
const Tf = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Cf,
  effect: Pf,
  requires: ["computeStyles"]
};
function oa(a) {
  return a.split("-")[0];
}
var Ca = Math.max, er = Math.min, Ja = Math.round;
function qr() {
  var a = navigator.userAgentData;
  return a != null && a.brands && Array.isArray(a.brands) ? a.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function ul() {
  return !/^((?!chrome|android).)*safari/i.test(qr());
}
function $a(a, r, n) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  var t = a.getBoundingClientRect(), e = 1, i = 1;
  r && Ve(a) && (e = a.offsetWidth > 0 && Ja(t.width) / a.offsetWidth || 1, i = a.offsetHeight > 0 && Ja(t.height) / a.offsetHeight || 1);
  var o = Ia(a) ? je(a) : window, s = o.visualViewport, l = !ul() && n, u = (t.left + (l && s ? s.offsetLeft : 0)) / e, c = (t.top + (l && s ? s.offsetTop : 0)) / i, d = t.width / e, p = t.height / i;
  return {
    width: d,
    height: p,
    top: c,
    right: u + d,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function Mn(a) {
  var r = $a(a), n = a.offsetWidth, t = a.offsetHeight;
  return Math.abs(r.width - n) <= 1 && (n = r.width), Math.abs(r.height - t) <= 1 && (t = r.height), {
    x: a.offsetLeft,
    y: a.offsetTop,
    width: n,
    height: t
  };
}
function cl(a, r) {
  var n = r.getRootNode && r.getRootNode();
  if (a.contains(r))
    return !0;
  if (n && kn(n)) {
    var t = r;
    do {
      if (t && a.isSameNode(t))
        return !0;
      t = t.parentNode || t.host;
    } while (t);
  }
  return !1;
}
function pa(a) {
  return je(a).getComputedStyle(a);
}
function Nf(a) {
  return ["table", "td", "th"].indexOf(la(a)) >= 0;
}
function ba(a) {
  return ((Ia(a) ? a.ownerDocument : (
    // $FlowFixMe[prop-missing]
    a.document
  )) || window.document).documentElement;
}
function cr(a) {
  return la(a) === "html" ? a : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    a.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    a.parentNode || // DOM Element detected
    (kn(a) ? a.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ba(a)
  );
}
function Mi(a) {
  return !Ve(a) || // https://github.com/popperjs/popper-core/issues/837
  pa(a).position === "fixed" ? null : a.offsetParent;
}
function Df(a) {
  var r = /firefox/i.test(qr()), n = /Trident/i.test(qr());
  if (n && Ve(a)) {
    var t = pa(a);
    if (t.position === "fixed")
      return null;
  }
  var e = cr(a);
  for (kn(e) && (e = e.host); Ve(e) && ["html", "body"].indexOf(la(e)) < 0; ) {
    var i = pa(e);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || r && i.willChange === "filter" || r && i.filter && i.filter !== "none")
      return e;
    e = e.parentNode;
  }
  return null;
}
function Dt(a) {
  for (var r = je(a), n = Mi(a); n && Nf(n) && pa(n).position === "static"; )
    n = Mi(n);
  return n && (la(n) === "html" || la(n) === "body" && pa(n).position === "static") ? r : n || Df(a) || r;
}
function wn(a) {
  return ["top", "bottom"].indexOf(a) >= 0 ? "x" : "y";
}
function ht(a, r, n) {
  return Ca(a, er(r, n));
}
function Af(a, r, n) {
  var t = ht(a, r, n);
  return t > n ? n : t;
}
function dl() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function pl(a) {
  return Object.assign({}, dl(), a);
}
function ml(a, r) {
  return r.reduce(function(n, t) {
    return n[t] = a, n;
  }, {});
}
var If = function(r, n) {
  return r = typeof r == "function" ? r(Object.assign({}, n.rects, {
    placement: n.placement
  })) : r, pl(typeof r != "number" ? r : ml(r, Nt));
};
function xf(a) {
  var r, n = a.state, t = a.name, e = a.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = oa(n.placement), l = wn(s), u = [Ue, Ze].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!i || !o)) {
    var d = If(e.padding, n), p = Mn(i), m = l === "y" ? He : Ue, f = l === "y" ? We : Ze, y = n.rects.reference[c] + n.rects.reference[l] - o[l] - n.rects.popper[c], v = o[l] - n.rects.reference[l], P = Dt(i), k = P ? l === "y" ? P.clientHeight || 0 : P.clientWidth || 0 : 0, w = y / 2 - v / 2, C = d[m], S = k - p[c] - d[f], b = k / 2 - p[c] / 2 + w, T = ht(C, b, S), D = l;
    n.modifiersData[t] = (r = {}, r[D] = T, r.centerOffset = T - b, r);
  }
}
function Ef(a) {
  var r = a.state, n = a.options, t = n.element, e = t === void 0 ? "[data-popper-arrow]" : t;
  e != null && (typeof e == "string" && (e = r.elements.popper.querySelector(e), !e) || cl(r.elements.popper, e) && (r.elements.arrow = e));
}
const Bf = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: xf,
  effect: Ef,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function qa(a) {
  return a.split("-")[1];
}
var Of = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Gf(a, r) {
  var n = a.x, t = a.y, e = r.devicePixelRatio || 1;
  return {
    x: Ja(n * e) / e || 0,
    y: Ja(t * e) / e || 0
  };
}
function wi(a) {
  var r, n = a.popper, t = a.popperRect, e = a.placement, i = a.variation, o = a.offsets, s = a.position, l = a.gpuAcceleration, u = a.adaptive, c = a.roundOffsets, d = a.isFixed, p = o.x, m = p === void 0 ? 0 : p, f = o.y, y = f === void 0 ? 0 : f, v = typeof c == "function" ? c({
    x: m,
    y
  }) : {
    x: m,
    y
  };
  m = v.x, y = v.y;
  var P = o.hasOwnProperty("x"), k = o.hasOwnProperty("y"), w = Ue, C = He, S = window;
  if (u) {
    var b = Dt(n), T = "clientHeight", D = "clientWidth";
    if (b === je(n) && (b = ba(n), pa(b).position !== "static" && s === "absolute" && (T = "scrollHeight", D = "scrollWidth")), b = b, e === He || (e === Ue || e === Ze) && i === Mt) {
      C = We;
      var A = d && b === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        b[T]
      );
      y -= A - t.height, y *= l ? 1 : -1;
    }
    if (e === Ue || (e === He || e === We) && i === Mt) {
      w = Ze;
      var I = d && b === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        b[D]
      );
      m -= I - t.width, m *= l ? 1 : -1;
    }
  }
  var K = Object.assign({
    position: s
  }, u && Of), Z = c === !0 ? Gf({
    x: m,
    y
  }, je(n)) : {
    x: m,
    y
  };
  if (m = Z.x, y = Z.y, l) {
    var Y;
    return Object.assign({}, K, (Y = {}, Y[C] = k ? "0" : "", Y[w] = P ? "0" : "", Y.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + y + "px)" : "translate3d(" + m + "px, " + y + "px, 0)", Y));
  }
  return Object.assign({}, K, (r = {}, r[C] = k ? y + "px" : "", r[w] = P ? m + "px" : "", r.transform = "", r));
}
function Lf(a) {
  var r = a.state, n = a.options, t = n.gpuAcceleration, e = t === void 0 ? !0 : t, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: oa(r.placement),
    variation: qa(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: e,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, wi(Object.assign({}, u, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, wi(Object.assign({}, u, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const Rf = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Lf,
  data: {}
};
var Bt = {
  passive: !0
};
function Ff(a) {
  var r = a.state, n = a.instance, t = a.options, e = t.scroll, i = e === void 0 ? !0 : e, o = t.resize, s = o === void 0 ? !0 : o, l = je(r.elements.popper), u = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, Bt);
  }), s && l.addEventListener("resize", n.update, Bt), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, Bt);
    }), s && l.removeEventListener("resize", n.update, Bt);
  };
}
const Kf = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Ff,
  data: {}
};
var Hf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Rt(a) {
  return a.replace(/left|right|bottom|top/g, function(r) {
    return Hf[r];
  });
}
var Uf = {
  start: "end",
  end: "start"
};
function Ci(a) {
  return a.replace(/start|end/g, function(r) {
    return Uf[r];
  });
}
function Cn(a) {
  var r = je(a), n = r.pageXOffset, t = r.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: t
  };
}
function Pn(a) {
  return $a(ba(a)).left + Cn(a).scrollLeft;
}
function zf(a, r) {
  var n = je(a), t = ba(a), e = n.visualViewport, i = t.clientWidth, o = t.clientHeight, s = 0, l = 0;
  if (e) {
    i = e.width, o = e.height;
    var u = ul();
    (u || !u && r === "fixed") && (s = e.offsetLeft, l = e.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Pn(a),
    y: l
  };
}
function jf(a) {
  var r, n = ba(a), t = Cn(a), e = (r = a.ownerDocument) == null ? void 0 : r.body, i = Ca(n.scrollWidth, n.clientWidth, e ? e.scrollWidth : 0, e ? e.clientWidth : 0), o = Ca(n.scrollHeight, n.clientHeight, e ? e.scrollHeight : 0, e ? e.clientHeight : 0), s = -t.scrollLeft + Pn(a), l = -t.scrollTop;
  return pa(e || n).direction === "rtl" && (s += Ca(n.clientWidth, e ? e.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function Tn(a) {
  var r = pa(a), n = r.overflow, t = r.overflowX, e = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + e + t);
}
function hl(a) {
  return ["html", "body", "#document"].indexOf(la(a)) >= 0 ? a.ownerDocument.body : Ve(a) && Tn(a) ? a : hl(cr(a));
}
function ft(a, r) {
  var n;
  r === void 0 && (r = []);
  var t = hl(a), e = t === ((n = a.ownerDocument) == null ? void 0 : n.body), i = je(t), o = e ? [i].concat(i.visualViewport || [], Tn(t) ? t : []) : t, s = r.concat(o);
  return e ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(ft(cr(o)))
  );
}
function Qr(a) {
  return Object.assign({}, a, {
    left: a.x,
    top: a.y,
    right: a.x + a.width,
    bottom: a.y + a.height
  });
}
function Vf(a, r) {
  var n = $a(a, !1, r === "fixed");
  return n.top = n.top + a.clientTop, n.left = n.left + a.clientLeft, n.bottom = n.top + a.clientHeight, n.right = n.left + a.clientWidth, n.width = a.clientWidth, n.height = a.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Pi(a, r, n) {
  return r === sl ? Qr(zf(a, n)) : Ia(r) ? Vf(r, n) : Qr(jf(ba(a)));
}
function Yf(a) {
  var r = ft(cr(a)), n = ["absolute", "fixed"].indexOf(pa(a).position) >= 0, t = n && Ve(a) ? Dt(a) : a;
  return Ia(t) ? r.filter(function(e) {
    return Ia(e) && cl(e, t) && la(e) !== "body";
  }) : [];
}
function Wf(a, r, n, t) {
  var e = r === "clippingParents" ? Yf(a) : [].concat(r), i = [].concat(e, [n]), o = i[0], s = i.reduce(function(l, u) {
    var c = Pi(a, u, t);
    return l.top = Ca(c.top, l.top), l.right = er(c.right, l.right), l.bottom = er(c.bottom, l.bottom), l.left = Ca(c.left, l.left), l;
  }, Pi(a, o, t));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function fl(a) {
  var r = a.reference, n = a.element, t = a.placement, e = t ? oa(t) : null, i = t ? qa(t) : null, o = r.x + r.width / 2 - n.width / 2, s = r.y + r.height / 2 - n.height / 2, l;
  switch (e) {
    case He:
      l = {
        x: o,
        y: r.y - n.height
      };
      break;
    case We:
      l = {
        x: o,
        y: r.y + r.height
      };
      break;
    case Ze:
      l = {
        x: r.x + r.width,
        y: s
      };
      break;
    case Ue:
      l = {
        x: r.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: r.x,
        y: r.y
      };
  }
  var u = e ? wn(e) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case Za:
        l[u] = l[u] - (r[c] / 2 - n[c] / 2);
        break;
      case Mt:
        l[u] = l[u] + (r[c] / 2 - n[c] / 2);
        break;
    }
  }
  return l;
}
function wt(a, r) {
  r === void 0 && (r = {});
  var n = r, t = n.placement, e = t === void 0 ? a.placement : t, i = n.strategy, o = i === void 0 ? a.strategy : i, s = n.boundary, l = s === void 0 ? mf : s, u = n.rootBoundary, c = u === void 0 ? sl : u, d = n.elementContext, p = d === void 0 ? lt : d, m = n.altBoundary, f = m === void 0 ? !1 : m, y = n.padding, v = y === void 0 ? 0 : y, P = pl(typeof v != "number" ? v : ml(v, Nt)), k = p === lt ? hf : lt, w = a.rects.popper, C = a.elements[f ? k : p], S = Wf(Ia(C) ? C : C.contextElement || ba(a.elements.popper), l, c, o), b = $a(a.elements.reference), T = fl({
    reference: b,
    element: w,
    placement: e
  }), D = Qr(Object.assign({}, w, T)), A = p === lt ? D : b, I = {
    top: S.top - A.top + P.top,
    bottom: A.bottom - S.bottom + P.bottom,
    left: S.left - A.left + P.left,
    right: A.right - S.right + P.right
  }, K = a.modifiersData.offset;
  if (p === lt && K) {
    var Z = K[e];
    Object.keys(I).forEach(function(Y) {
      var z = [Ze, We].indexOf(Y) >= 0 ? 1 : -1, H = [He, We].indexOf(Y) >= 0 ? "y" : "x";
      I[Y] += Z[H] * z;
    });
  }
  return I;
}
function Zf(a, r) {
  r === void 0 && (r = {});
  var n = r, t = n.placement, e = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? ll : l, c = qa(t), d = c ? s ? ki : ki.filter(function(f) {
    return qa(f) === c;
  }) : Nt, p = d.filter(function(f) {
    return u.indexOf(f) >= 0;
  });
  p.length === 0 && (p = d);
  var m = p.reduce(function(f, y) {
    return f[y] = wt(a, {
      placement: y,
      boundary: e,
      rootBoundary: i,
      padding: o
    })[oa(y)], f;
  }, {});
  return Object.keys(m).sort(function(f, y) {
    return m[f] - m[y];
  });
}
function Jf(a) {
  if (oa(a) === Sn)
    return [];
  var r = Rt(a);
  return [Ci(a), r, Ci(r)];
}
function $f(a) {
  var r = a.state, n = a.options, t = a.name;
  if (!r.modifiersData[t]._skip) {
    for (var e = n.mainAxis, i = e === void 0 ? !0 : e, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, u = n.padding, c = n.boundary, d = n.rootBoundary, p = n.altBoundary, m = n.flipVariations, f = m === void 0 ? !0 : m, y = n.allowedAutoPlacements, v = r.options.placement, P = oa(v), k = P === v, w = l || (k || !f ? [Rt(v)] : Jf(v)), C = [v].concat(w).reduce(function(me, _e) {
      return me.concat(oa(_e) === Sn ? Zf(r, {
        placement: _e,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: f,
        allowedAutoPlacements: y
      }) : _e);
    }, []), S = r.rects.reference, b = r.rects.popper, T = /* @__PURE__ */ new Map(), D = !0, A = C[0], I = 0; I < C.length; I++) {
      var K = C[I], Z = oa(K), Y = qa(K) === Za, z = [He, We].indexOf(Z) >= 0, H = z ? "width" : "height", U = wt(r, {
        placement: K,
        boundary: c,
        rootBoundary: d,
        altBoundary: p,
        padding: u
      }), B = z ? Y ? Ze : Ue : Y ? We : He;
      S[H] > b[H] && (B = Rt(B));
      var R = Rt(B), W = [];
      if (i && W.push(U[Z] <= 0), s && W.push(U[B] <= 0, U[R] <= 0), W.every(function(me) {
        return me;
      })) {
        A = K, D = !1;
        break;
      }
      T.set(K, W);
    }
    if (D)
      for (var j = f ? 3 : 1, q = function(_e) {
        var xe = C.find(function(Ee) {
          var oe = T.get(Ee);
          if (oe)
            return oe.slice(0, _e).every(function(re) {
              return re;
            });
        });
        if (xe)
          return A = xe, "break";
      }, te = j; te > 0; te--) {
        var pe = q(te);
        if (pe === "break") break;
      }
    r.placement !== A && (r.modifiersData[t]._skip = !0, r.placement = A, r.reset = !0);
  }
}
const qf = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $f,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ti(a, r, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: a.top - r.height - n.y,
    right: a.right - r.width + n.x,
    bottom: a.bottom - r.height + n.y,
    left: a.left - r.width - n.x
  };
}
function Ni(a) {
  return [He, Ze, We, Ue].some(function(r) {
    return a[r] >= 0;
  });
}
function Qf(a) {
  var r = a.state, n = a.name, t = r.rects.reference, e = r.rects.popper, i = r.modifiersData.preventOverflow, o = wt(r, {
    elementContext: "reference"
  }), s = wt(r, {
    altBoundary: !0
  }), l = Ti(o, t), u = Ti(s, e, i), c = Ni(l), d = Ni(u);
  r.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const Xf = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Qf
};
function eg(a, r, n) {
  var t = oa(a), e = [Ue, He].indexOf(t) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, r, {
    placement: a
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * e, [Ue, Ze].indexOf(t) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function ag(a) {
  var r = a.state, n = a.options, t = a.name, e = n.offset, i = e === void 0 ? [0, 0] : e, o = ll.reduce(function(c, d) {
    return c[d] = eg(d, r.rects, i), c;
  }, {}), s = o[r.placement], l = s.x, u = s.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += l, r.modifiersData.popperOffsets.y += u), r.modifiersData[t] = o;
}
const tg = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: ag
};
function rg(a) {
  var r = a.state, n = a.name;
  r.modifiersData[n] = fl({
    reference: r.rects.reference,
    element: r.rects.popper,
    placement: r.placement
  });
}
const ng = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: rg,
  data: {}
};
function ig(a) {
  return a === "x" ? "y" : "x";
}
function og(a) {
  var r = a.state, n = a.options, t = a.name, e = n.mainAxis, i = e === void 0 ? !0 : e, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, u = n.rootBoundary, c = n.altBoundary, d = n.padding, p = n.tether, m = p === void 0 ? !0 : p, f = n.tetherOffset, y = f === void 0 ? 0 : f, v = wt(r, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), P = oa(r.placement), k = qa(r.placement), w = !k, C = wn(P), S = ig(C), b = r.modifiersData.popperOffsets, T = r.rects.reference, D = r.rects.popper, A = typeof y == "function" ? y(Object.assign({}, r.rects, {
    placement: r.placement
  })) : y, I = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), K = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, Z = {
    x: 0,
    y: 0
  };
  if (b) {
    if (i) {
      var Y, z = C === "y" ? He : Ue, H = C === "y" ? We : Ze, U = C === "y" ? "height" : "width", B = b[C], R = B + v[z], W = B - v[H], j = m ? -D[U] / 2 : 0, q = k === Za ? T[U] : D[U], te = k === Za ? -D[U] : -T[U], pe = r.elements.arrow, me = m && pe ? Mn(pe) : {
        width: 0,
        height: 0
      }, _e = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : dl(), xe = _e[z], Ee = _e[H], oe = ht(0, T[U], me[U]), re = w ? T[U] / 2 - j - oe - xe - I.mainAxis : q - oe - xe - I.mainAxis, Oe = w ? -T[U] / 2 + j + oe + Ee + I.mainAxis : te + oe + Ee + I.mainAxis, X = r.elements.arrow && Dt(r.elements.arrow), ce = X ? C === "y" ? X.clientTop || 0 : X.clientLeft || 0 : 0, Ge = (Y = K == null ? void 0 : K[C]) != null ? Y : 0, ua = B + re - Ge - ce, ca = B + Oe - Ge, tt = ht(m ? er(R, ua) : R, B, m ? Ca(W, ca) : W);
      b[C] = tt, Z[C] = tt - B;
    }
    if (s) {
      var En, El = C === "x" ? He : Ue, Bl = C === "x" ? We : Ze, Sa = b[S], At = S === "y" ? "height" : "width", Bn = Sa + v[El], On = Sa - v[Bl], gr = [He, Ue].indexOf(P) !== -1, Gn = (En = K == null ? void 0 : K[S]) != null ? En : 0, Ln = gr ? Bn : Sa - T[At] - D[At] - Gn + I.altAxis, Rn = gr ? Sa + T[At] + D[At] - Gn - I.altAxis : On, Fn = m && gr ? Af(Ln, Sa, Rn) : ht(m ? Ln : Bn, Sa, m ? Rn : On);
      b[S] = Fn, Z[S] = Fn - Sa;
    }
    r.modifiersData[t] = Z;
  }
}
const sg = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: og,
  requiresIfExists: ["offset"]
};
function lg(a) {
  return {
    scrollLeft: a.scrollLeft,
    scrollTop: a.scrollTop
  };
}
function ug(a) {
  return a === je(a) || !Ve(a) ? Cn(a) : lg(a);
}
function cg(a) {
  var r = a.getBoundingClientRect(), n = Ja(r.width) / a.offsetWidth || 1, t = Ja(r.height) / a.offsetHeight || 1;
  return n !== 1 || t !== 1;
}
function dg(a, r, n) {
  n === void 0 && (n = !1);
  var t = Ve(r), e = Ve(r) && cg(r), i = ba(r), o = $a(a, e, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (t || !t && !n) && ((la(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Tn(i)) && (s = ug(r)), Ve(r) ? (l = $a(r, !0), l.x += r.clientLeft, l.y += r.clientTop) : i && (l.x = Pn(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function pg(a) {
  var r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), t = [];
  a.forEach(function(i) {
    r.set(i.name, i);
  });
  function e(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = r.get(s);
        l && e(l);
      }
    }), t.push(i);
  }
  return a.forEach(function(i) {
    n.has(i.name) || e(i);
  }), t;
}
function mg(a) {
  var r = pg(a);
  return wf.reduce(function(n, t) {
    return n.concat(r.filter(function(e) {
      return e.phase === t;
    }));
  }, []);
}
function hg(a) {
  var r;
  return function() {
    return r || (r = new Promise(function(n) {
      Promise.resolve().then(function() {
        r = void 0, n(a());
      });
    })), r;
  };
}
function fg(a) {
  var r = a.reduce(function(n, t) {
    var e = n[t.name];
    return n[t.name] = e ? Object.assign({}, e, t, {
      options: Object.assign({}, e.options, t.options),
      data: Object.assign({}, e.data, t.data)
    }) : t, n;
  }, {});
  return Object.keys(r).map(function(n) {
    return r[n];
  });
}
var Di = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ai() {
  for (var a = arguments.length, r = new Array(a), n = 0; n < a; n++)
    r[n] = arguments[n];
  return !r.some(function(t) {
    return !(t && typeof t.getBoundingClientRect == "function");
  });
}
function gg(a) {
  a === void 0 && (a = {});
  var r = a, n = r.defaultModifiers, t = n === void 0 ? [] : n, e = r.defaultOptions, i = e === void 0 ? Di : e;
  return function(s, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Di, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, m = {
      state: c,
      setOptions: function(P) {
        var k = typeof P == "function" ? P(c.options) : P;
        y(), c.options = Object.assign({}, i, c.options, k), c.scrollParents = {
          reference: Ia(s) ? ft(s) : s.contextElement ? ft(s.contextElement) : [],
          popper: ft(l)
        };
        var w = mg(fg([].concat(t, c.options.modifiers)));
        return c.orderedModifiers = w.filter(function(C) {
          return C.enabled;
        }), f(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var P = c.elements, k = P.reference, w = P.popper;
          if (Ai(k, w)) {
            c.rects = {
              reference: dg(k, Dt(w), c.options.strategy === "fixed"),
              popper: Mn(w)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(I) {
              return c.modifiersData[I.name] = Object.assign({}, I.data);
            });
            for (var C = 0; C < c.orderedModifiers.length; C++) {
              if (c.reset === !0) {
                c.reset = !1, C = -1;
                continue;
              }
              var S = c.orderedModifiers[C], b = S.fn, T = S.options, D = T === void 0 ? {} : T, A = S.name;
              typeof b == "function" && (c = b({
                state: c,
                options: D,
                name: A,
                instance: m
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: hg(function() {
        return new Promise(function(v) {
          m.forceUpdate(), v(c);
        });
      }),
      destroy: function() {
        y(), p = !0;
      }
    };
    if (!Ai(s, l))
      return m;
    m.setOptions(u).then(function(v) {
      !p && u.onFirstUpdate && u.onFirstUpdate(v);
    });
    function f() {
      c.orderedModifiers.forEach(function(v) {
        var P = v.name, k = v.options, w = k === void 0 ? {} : k, C = v.effect;
        if (typeof C == "function") {
          var S = C({
            state: c,
            name: P,
            instance: m,
            options: w
          }), b = function() {
          };
          d.push(S || b);
        }
      });
    }
    function y() {
      d.forEach(function(v) {
        return v();
      }), d = [];
    }
    return m;
  };
}
var _g = [Kf, ng, Rf, Tf, tg, qf, sg, Bf, Xf], yg = /* @__PURE__ */ gg({
  defaultModifiers: _g
}), Pr, Ii;
function vg() {
  if (Ii) return Pr;
  Ii = 1;
  var a = typeof Element < "u", r = typeof Map == "function", n = typeof Set == "function", t = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function e(i, o) {
    if (i === o) return !0;
    if (i && o && typeof i == "object" && typeof o == "object") {
      if (i.constructor !== o.constructor) return !1;
      var s, l, u;
      if (Array.isArray(i)) {
        if (s = i.length, s != o.length) return !1;
        for (l = s; l-- !== 0; )
          if (!e(i[l], o[l])) return !1;
        return !0;
      }
      var c;
      if (r && i instanceof Map && o instanceof Map) {
        if (i.size !== o.size) return !1;
        for (c = i.entries(); !(l = c.next()).done; )
          if (!o.has(l.value[0])) return !1;
        for (c = i.entries(); !(l = c.next()).done; )
          if (!e(l.value[1], o.get(l.value[0]))) return !1;
        return !0;
      }
      if (n && i instanceof Set && o instanceof Set) {
        if (i.size !== o.size) return !1;
        for (c = i.entries(); !(l = c.next()).done; )
          if (!o.has(l.value[0])) return !1;
        return !0;
      }
      if (t && ArrayBuffer.isView(i) && ArrayBuffer.isView(o)) {
        if (s = i.length, s != o.length) return !1;
        for (l = s; l-- !== 0; )
          if (i[l] !== o[l]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === o.source && i.flags === o.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof o.valueOf == "function") return i.valueOf() === o.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof o.toString == "function") return i.toString() === o.toString();
      if (u = Object.keys(i), s = u.length, s !== Object.keys(o).length) return !1;
      for (l = s; l-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(o, u[l])) return !1;
      if (a && i instanceof Element) return !1;
      for (l = s; l-- !== 0; )
        if (!((u[l] === "_owner" || u[l] === "__v" || u[l] === "__o") && i.$$typeof) && !e(i[u[l]], o[u[l]]))
          return !1;
      return !0;
    }
    return i !== i && o !== o;
  }
  return Pr = function(o, s) {
    try {
      return e(o, s);
    } catch (l) {
      if ((l.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw l;
    }
  }, Pr;
}
var bg = vg();
const Sg = /* @__PURE__ */ ir(bg);
var kg = [], Mg = function(r, n, t) {
  t === void 0 && (t = {});
  var e = he.useRef(null), i = {
    onFirstUpdate: t.onFirstUpdate,
    placement: t.placement || "bottom",
    strategy: t.strategy || "absolute",
    modifiers: t.modifiers || kg
  }, o = he.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = o[0], l = o[1], u = he.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(m) {
        var f = m.state, y = Object.keys(f.elements);
        lu.flushSync(function() {
          l({
            styles: bi(y.map(function(v) {
              return [v, f.styles[v] || {}];
            })),
            attributes: bi(y.map(function(v) {
              return [v, f.attributes[v]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = he.useMemo(function() {
    var p = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return Sg(e.current, p) ? e.current || p : (e.current = p, p);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, u]), d = he.useRef();
  return Si(function() {
    d.current && d.current.setOptions(c);
  }, [c]), Si(function() {
    if (!(r == null || n == null)) {
      var p = t.createPopper || yg, m = p(r, n, c);
      return d.current = m, function() {
        m.destroy(), d.current = null;
      };
    }
  }, [r, n, t.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
}, wg = function() {
}, Cg = function() {
  return Promise.resolve(null);
}, Pg = [];
function Tg(a) {
  var r = a.placement, n = r === void 0 ? "bottom" : r, t = a.strategy, e = t === void 0 ? "absolute" : t, i = a.modifiers, o = i === void 0 ? Pg : i, s = a.referenceElement, l = a.onFirstUpdate, u = a.innerRef, c = a.children, d = he.useContext(rl), p = he.useState(null), m = p[0], f = p[1], y = he.useState(null), v = y[0], P = y[1];
  he.useEffect(function() {
    $r(u, m);
  }, [u, m]);
  var k = he.useMemo(function() {
    return {
      placement: n,
      strategy: e,
      onFirstUpdate: l,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: v != null,
        options: {
          element: v
        }
      }])
    };
  }, [n, e, l, o, v]), w = Mg(s || d, m, k), C = w.state, S = w.styles, b = w.forceUpdate, T = w.update, D = he.useMemo(function() {
    return {
      ref: f,
      style: S.popper,
      placement: C ? C.placement : n,
      hasPopperEscaped: C && C.modifiersData.hide ? C.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: C && C.modifiersData.hide ? C.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: S.arrow,
        ref: P
      },
      forceUpdate: b || wg,
      update: T || Cg
    };
  }, [f, P, n, C, S, T, b]);
  return il(c)(D);
}
var Tr, xi;
function Ng() {
  if (xi) return Tr;
  xi = 1;
  var a = process.env.NODE_ENV !== "production", r = function() {
  };
  if (a) {
    var n = function(e, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var s = 1; s < o; s++)
        i[s - 1] = arguments[s];
      var l = 0, u = "Warning: " + e.replace(/%s/g, function() {
        return i[l++];
      });
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
    r = function(t, e, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var s = 2; s < o; s++)
        i[s - 2] = arguments[s];
      if (e === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      t || n.apply(null, [e].concat(i));
    };
  }
  return Tr = r, Tr;
}
var Dg = Ng();
const Ag = /* @__PURE__ */ ir(Dg);
function Ig(a) {
  var r = a.children, n = a.innerRef, t = he.useContext(nl), e = he.useCallback(function(i) {
    $r(n, i), ol(t, i);
  }, [n, t]);
  return he.useEffect(function() {
    return function() {
      return $r(n, null);
    };
  }, []), he.useEffect(function() {
    Ag(!!t, "`Reference` should not be used outside of a `Manager` component.");
  }, [t]), il(r)({
    ref: e
  });
}
function xg(a, r) {
  if (x(2, arguments), Ye(r) !== "object" || r === null)
    throw new RangeError("values parameter must be an object");
  var n = O(a);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.year != null && n.setFullYear(r.year), r.month != null && (n = Re(n, r.month)), r.date != null && n.setDate(J(r.date)), r.hours != null && n.setHours(J(r.hours)), r.minutes != null && n.setMinutes(J(r.minutes)), r.seconds != null && n.setSeconds(J(r.seconds)), r.milliseconds != null && n.setMilliseconds(J(r.milliseconds)), n);
}
function Ei(a, r) {
  var n = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(a);
    r && (t = t.filter((function(e) {
      return Object.getOwnPropertyDescriptor(a, e).enumerable;
    }))), n.push.apply(n, t);
  }
  return n;
}
function ar(a) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Ei(Object(n), !0).forEach((function(t) {
      h(a, t, n[t]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : Ei(Object(n)).forEach((function(t) {
      Object.defineProperty(a, t, Object.getOwnPropertyDescriptor(n, t));
    }));
  }
  return a;
}
function Xr(a) {
  return Xr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Xr(a);
}
function Te(a, r) {
  if (!(a instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function Bi(a, r) {
  for (var n = 0; n < r.length; n++) {
    var t = r[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(a, gl(t.key), t);
  }
}
function Ne(a, r, n) {
  return r && Bi(a.prototype, r), n && Bi(a, n), Object.defineProperty(a, "prototype", { writable: !1 }), a;
}
function h(a, r, n) {
  return (r = gl(r)) in a ? Object.defineProperty(a, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : a[r] = n, a;
}
function Qa() {
  return Qa = Object.assign ? Object.assign.bind() : function(a) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (a[t] = n[t]);
    }
    return a;
  }, Qa.apply(this, arguments);
}
function De(a, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(r && r.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), r && en(a, r);
}
function tr(a) {
  return tr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, tr(a);
}
function en(a, r) {
  return en = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, t) {
    return n.__proto__ = t, n;
  }, en(a, r);
}
function g(a) {
  if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function Ae(a) {
  var r = (function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
      }))), !0;
    } catch {
      return !1;
    }
  })();
  return function() {
    var n, t = tr(a);
    if (r) {
      var e = tr(this).constructor;
      n = Reflect.construct(t, arguments, e);
    } else n = t.apply(this, arguments);
    return (function(i, o) {
      if (o && (typeof o == "object" || typeof o == "function")) return o;
      if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return g(i);
    })(this, n);
  };
}
function Ct(a) {
  return (function(r) {
    if (Array.isArray(r)) return Nr(r);
  })(a) || (function(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
  })(a) || (function(r, n) {
    if (r) {
      if (typeof r == "string") return Nr(r, n);
      var t = Object.prototype.toString.call(r).slice(8, -1);
      if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Nr(r, n);
    }
  })(a) || (function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  })();
}
function Nr(a, r) {
  (r == null || r > a.length) && (r = a.length);
  for (var n = 0, t = new Array(r); n < r; n++) t[n] = a[n];
  return t;
}
function gl(a) {
  var r = (function(n, t) {
    if (typeof n != "object" || n === null) return n;
    var e = n[Symbol.toPrimitive];
    if (e !== void 0) {
      var i = e.call(n, t);
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(n);
  })(a, "string");
  return typeof r == "symbol" ? r : String(r);
}
var Oi = function(a, r) {
  switch (a) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    default:
      return r.date({ width: "full" });
  }
}, Gi = function(a, r) {
  switch (a) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    default:
      return r.time({ width: "full" });
  }
}, Eg = { p: Gi, P: function(a, r) {
  var n, t = a.match(/(P+)(p+)?/) || [], e = t[1], i = t[2];
  if (!i) return Oi(a, r);
  switch (e) {
    case "P":
      n = r.dateTime({ width: "short" });
      break;
    case "PP":
      n = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      n = r.dateTime({ width: "long" });
      break;
    default:
      n = r.dateTime({ width: "full" });
  }
  return n.replace("{{date}}", Oi(e, r)).replace("{{time}}", Gi(i, r));
} }, gt = 12, Bg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function fe(a) {
  var r = a ? typeof a == "string" || a instanceof String ? Fh(a) : O(a) : /* @__PURE__ */ new Date();
  return ha(r) ? r : null;
}
function ha(a, r) {
  return r = r || /* @__PURE__ */ new Date("1/1/1000"), vt(a) && !fa(a, r);
}
function ve(a, r, n) {
  if (n === "en") return di(a, r, { awareOfUnicodeTokens: !0 });
  var t = Ta(n);
  return n && !t && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), !t && Pa() && Ta(Pa()) && (t = Ta(Pa())), di(a, r, { locale: t || null, awareOfUnicodeTokens: !0 });
}
function Qe(a, r) {
  var n = r.dateFormat, t = r.locale;
  return a && ve(a, Array.isArray(n) ? n[0] : n, t) || "";
}
function Li(a, r) {
  var n = r.hour, t = n === void 0 ? 0 : n, e = r.minute, i = e === void 0 ? 0 : e, o = r.second;
  return Lt(Gt(Em(a, o === void 0 ? 0 : o), i), t);
}
function sa(a, r, n) {
  var t = Ta(r || Pa());
  return Zs(a, { locale: t, weekStartsOn: n });
}
function _a(a) {
  return Js(a);
}
function dt(a) {
  return $s(a);
}
function Ri(a) {
  return Vr(a);
}
function Fi() {
  return ia(fe());
}
function ga(a, r) {
  return a && r ? Hm(a, r) : !a && !r;
}
function Je(a, r) {
  return a && r ? Km(a, r) : !a && !r;
}
function rr(a, r) {
  return a && r ? Um(a, r) : !a && !r;
}
function ge(a, r) {
  return a && r ? Fm(a, r) : !a && !r;
}
function wa(a, r) {
  return a && r ? Rm(a, r) : !a && !r;
}
function Ft(a, r, n) {
  var t, e = ia(r), i = Yr(n);
  try {
    t = kt(a, { start: e, end: i });
  } catch {
    t = !1;
  }
  return t;
}
function Pa() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Ta(a) {
  if (typeof a == "string") {
    var r = typeof window < "u" ? window : globalThis;
    return r.__localeData__ ? r.__localeData__[a] : null;
  }
  return a;
}
function Nn(a, r) {
  return ve(Re(fe(), a), "LLLL", r);
}
function _l(a, r) {
  return ve(Re(fe(), a), "LLL", r);
}
function dr(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.excludeDateIntervals, o = r.includeDates, s = r.includeDateIntervals, l = r.filterDate;
  return pr(a, { minDate: n, maxDate: t }) || e && e.some((function(u) {
    return ge(a, u);
  })) || i && i.some((function(u) {
    var c = u.start, d = u.end;
    return kt(a, { start: c, end: d });
  })) || o && !o.some((function(u) {
    return ge(a, u);
  })) || s && !s.some((function(u) {
    var c = u.start, d = u.end;
    return kt(a, { start: c, end: d });
  })) || l && !l(fe(a)) || !1;
}
function Dn(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.excludeDates, t = r.excludeDateIntervals;
  return t && t.length > 0 ? t.some((function(e) {
    var i = e.start, o = e.end;
    return kt(a, { start: i, end: o });
  })) : n && n.some((function(e) {
    return ge(a, e);
  })) || !1;
}
function yl(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.includeDates, o = r.filterDate;
  return pr(a, { minDate: Js(n), maxDate: Gm(t) }) || e && e.some((function(s) {
    return Je(a, s);
  })) || i && !i.some((function(s) {
    return Je(a, s);
  })) || o && !o(fe(a)) || !1;
}
function Dr(a, r, n, t) {
  var e = $(a), i = Be(a), o = $(r), s = Be(r), l = $(t);
  return e === o && e === l ? i <= n && n <= s : e < o ? l === e && i <= n || l === o && s >= n || l < o && l > e : void 0;
}
function Og(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.includeDates, o = r.filterDate;
  return pr(a, { minDate: n, maxDate: t }) || e && e.some((function(s) {
    return rr(a, s);
  })) || i && !i.some((function(s) {
    return rr(a, s);
  })) || o && !o(fe(a)) || !1;
}
function Ar(a, r, n) {
  if (!vt(r) || !vt(n)) return !1;
  var t = $(r), e = $(n);
  return t <= a && e >= a;
}
function vl(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate, e = r.excludeDates, i = r.includeDates, o = r.filterDate, s = new Date(a, 0, 1);
  return pr(s, { minDate: $s(n), maxDate: Lm(t) }) || e && e.some((function(l) {
    return ga(s, l);
  })) || i && !i.some((function(l) {
    return ga(s, l);
  })) || o && !o(fe(s)) || !1;
}
function Ir(a, r, n, t) {
  var e = $(a), i = Fa(a), o = $(r), s = Fa(r), l = $(t);
  return e === o && e === l ? i <= n && n <= s : e < o ? l === e && i <= n || l === o && s >= n || l < o && l > e : void 0;
}
function pr(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.maxDate;
  return n && St(a, n) < 0 || t && St(a, t) > 0;
}
function Ki(a, r) {
  return r.some((function(n) {
    return na(n) === na(a) && ra(n) === ra(a);
  }));
}
function Hi(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.excludeTimes, t = r.includeTimes, e = r.filterTime;
  return n && Ki(a, n) || t && !Ki(a, t) || e && !e(a) || !1;
}
function Ui(a, r) {
  var n = r.minTime, t = r.maxTime;
  if (!n || !t) throw new Error("Both minTime and maxTime props required");
  var e, i = fe(), o = Lt(Gt(i, ra(a)), na(a)), s = Lt(Gt(i, ra(n)), na(n)), l = Lt(Gt(i, ra(t)), na(t));
  try {
    e = !kt(o, { start: s, end: l });
  } catch {
    e = !1;
  }
  return e;
}
function zi(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.includeDates, e = Wa(a, 1);
  return n && $t(n, e) > 0 || t && t.every((function(i) {
    return $t(i, e) > 0;
  })) || !1;
}
function ji(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.maxDate, t = r.includeDates, e = qe(a, 1);
  return n && $t(e, n) > 0 || t && t.every((function(i) {
    return $t(e, i) > 0;
  })) || !1;
}
function Vi(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, t = r.includeDates, e = bt(a, 1);
  return n && qt(n, e) > 0 || t && t.every((function(i) {
    return qt(i, e) > 0;
  })) || !1;
}
function Yi(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.maxDate, t = r.includeDates, e = Ya(a, 1);
  return n && qt(e, n) > 0 || t && t.every((function(i) {
    return qt(e, i) > 0;
  })) || !1;
}
function bl(a) {
  var r = a.minDate, n = a.includeDates;
  if (n && r) {
    var t = n.filter((function(e) {
      return St(e, r) >= 0;
    }));
    return fi(t);
  }
  return n ? fi(n) : r;
}
function Sl(a) {
  var r = a.maxDate, n = a.includeDates;
  if (n && r) {
    var t = n.filter((function(e) {
      return St(e, r) <= 0;
    }));
    return gi(t);
  }
  return n ? gi(n) : r;
}
function Wi() {
  for (var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), t = 0, e = a.length; t < e; t++) {
    var i = a[t];
    if (lr(i)) {
      var o = ve(i, "MM.dd.yyyy"), s = n.get(o) || [];
      s.includes(r) || (s.push(r), n.set(o, s));
    } else if (Xr(i) === "object") {
      var l = Object.keys(i), u = l[0], c = i[l[0]];
      if (typeof u == "string" && c.constructor === Array) for (var d = 0, p = c.length; d < p; d++) {
        var m = ve(c[d], "MM.dd.yyyy"), f = n.get(m) || [];
        f.includes(u) || (f.push(u), n.set(m, f));
      }
    }
  }
  return n;
}
function Gg() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", n = /* @__PURE__ */ new Map();
  return a.forEach((function(t) {
    var e = t.date, i = t.holidayName;
    if (lr(e)) {
      var o = ve(e, "MM.dd.yyyy"), s = n.get(o) || {};
      if (!("className" in s) || s.className !== r || (l = s.holidayNames, u = [i], l.length !== u.length || !l.every((function(d, p) {
        return d === u[p];
      })))) {
        var l, u;
        s.className = r;
        var c = s.holidayNames;
        s.holidayNames = c ? [].concat(Ct(c), [i]) : [i], n.set(o, s);
      }
    }
  })), n;
}
function Lg(a, r, n, t, e) {
  for (var i = e.length, o = [], s = 0; s < i; s++) {
    var l = zr(Cm(a, na(e[s])), ra(e[s])), u = zr(a, (n + 1) * t);
    ya(l, r) && fa(l, u) && o.push(e[s]);
  }
  return o;
}
function Zi(a) {
  return a < 10 ? "0".concat(a) : "".concat(a);
}
function Ka(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gt, n = Math.ceil($(a) / r) * r;
  return { startPeriod: n - (r - 1), endPeriod: n };
}
function Ji(a) {
  var r = a.getSeconds(), n = a.getMilliseconds();
  return O(a.getTime() - 1e3 * r - n);
}
function Rg(a, r, n, t) {
  for (var e = [], i = 0; i < 2 * r + 1; i++) {
    var o = a + r - i, s = !0;
    n && (s = $(n) <= o), t && s && (s = $(t) >= o), s && e.push(o);
  }
  return e;
}
var Fg = ur((function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    Te(this, n), h(g(e = r.call(this, t)), "renderOptions", (function() {
      var l = e.props.year, u = e.state.yearsList.map((function(p) {
        return M.createElement("div", { className: l === p ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: p, onClick: e.onChange.bind(g(e), p), "aria-selected": l === p ? "true" : void 0 }, l === p ? M.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", p);
      })), c = e.props.minDate ? $(e.props.minDate) : null, d = e.props.maxDate ? $(e.props.maxDate) : null;
      return d && e.state.yearsList.find((function(p) {
        return p === d;
      })) || u.unshift(M.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: e.incrementYears }, M.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), c && e.state.yearsList.find((function(p) {
        return p === c;
      })) || u.push(M.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: e.decrementYears }, M.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), u;
    })), h(g(e), "onChange", (function(l) {
      e.props.onChange(l);
    })), h(g(e), "handleClickOutside", (function() {
      e.props.onCancel();
    })), h(g(e), "shiftYears", (function(l) {
      var u = e.state.yearsList.map((function(c) {
        return c + l;
      }));
      e.setState({ yearsList: u });
    })), h(g(e), "incrementYears", (function() {
      return e.shiftYears(1);
    })), h(g(e), "decrementYears", (function() {
      return e.shiftYears(-1);
    }));
    var i = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = i || (o ? 10 : 5);
    return e.state = { yearsList: Rg(e.props.year, s, e.props.minDate, e.props.maxDate) }, e.dropdownRef = Yl(), e;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    var t = this.dropdownRef.current;
    if (t) {
      var e = t.children ? Array.from(t.children) : null, i = e ? e.find((function(o) {
        return o.ariaSelected;
      })) : null;
      t.scrollTop = i ? i.offsetTop + (i.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var t = Ie({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return M.createElement("div", { className: t, ref: this.dropdownRef }, this.renderOptions());
  } }]), n;
})()), Kg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "state", { dropdownVisible: !1 }), h(g(t), "renderSelectOptions", (function() {
      for (var s = t.props.minDate ? $(t.props.minDate) : 1900, l = t.props.maxDate ? $(t.props.maxDate) : 2100, u = [], c = s; c <= l; c++) u.push(M.createElement("option", { key: c, value: c }, c));
      return u;
    })), h(g(t), "onSelectChange", (function(s) {
      t.onChange(s.target.value);
    })), h(g(t), "renderSelectMode", (function() {
      return M.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    })), h(g(t), "renderReadView", (function(s) {
      return M.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(l) {
        return t.toggleDropdown(l);
      } }, M.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), M.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year));
    })), h(g(t), "renderDropdown", (function() {
      return M.createElement(Fg, { key: "dropdown", year: t.props.year, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableYearDropdown: t.props.scrollableYearDropdown, yearDropdownItemNumber: t.props.yearDropdownItemNumber });
    })), h(g(t), "renderScrollMode", (function() {
      var s = t.state.dropdownVisible, l = [t.renderReadView(!s)];
      return s && l.unshift(t.renderDropdown()), l;
    })), h(g(t), "onChange", (function(s) {
      t.toggleDropdown(), s !== t.props.year && t.props.onChange(s);
    })), h(g(t), "toggleDropdown", (function(s) {
      t.setState({ dropdownVisible: !t.state.dropdownVisible }, (function() {
        t.props.adjustDateOnChange && t.handleYearChange(t.props.date, s);
      }));
    })), h(g(t), "handleYearChange", (function(s, l) {
      t.onSelect(s, l), t.setOpen();
    })), h(g(t), "onSelect", (function(s, l) {
      t.props.onSelect && t.props.onSelect(s, l);
    })), h(g(t), "setOpen", (function() {
      t.props.setOpen && t.props.setOpen(!0);
    })), t;
  }
  return Ne(n, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return M.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), n;
})(), Hg = ur((function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "isSelectedMonth", (function(s) {
      return t.props.month === s;
    })), h(g(t), "renderOptions", (function() {
      return t.props.monthNames.map((function(s, l) {
        return M.createElement("div", { className: t.isSelectedMonth(l) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: t.onChange.bind(g(t), l), "aria-selected": t.isSelectedMonth(l) ? "true" : void 0 }, t.isSelectedMonth(l) ? M.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      }));
    })), h(g(t), "onChange", (function(s) {
      return t.props.onChange(s);
    })), h(g(t), "handleClickOutside", (function() {
      return t.props.onCancel();
    })), t;
  }
  return Ne(n, [{ key: "render", value: function() {
    return M.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n;
})()), Ug = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "state", { dropdownVisible: !1 }), h(g(t), "renderSelectOptions", (function(s) {
      return s.map((function(l, u) {
        return M.createElement("option", { key: u, value: u }, l);
      }));
    })), h(g(t), "renderSelectMode", (function(s) {
      return M.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(l) {
        return t.onChange(l.target.value);
      } }, t.renderSelectOptions(s));
    })), h(g(t), "renderReadView", (function(s, l) {
      return M.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown }, M.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), M.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, l[t.props.month]));
    })), h(g(t), "renderDropdown", (function(s) {
      return M.createElement(Hg, { key: "dropdown", month: t.props.month, monthNames: s, onChange: t.onChange, onCancel: t.toggleDropdown });
    })), h(g(t), "renderScrollMode", (function(s) {
      var l = t.state.dropdownVisible, u = [t.renderReadView(!l, s)];
      return l && u.unshift(t.renderDropdown(s)), u;
    })), h(g(t), "onChange", (function(s) {
      t.toggleDropdown(), s !== t.props.month && t.props.onChange(s);
    })), h(g(t), "toggleDropdown", (function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    })), t;
  }
  return Ne(n, [{ key: "render", value: function() {
    var t, e = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
      return _l(o, e.props.locale);
    } : function(o) {
      return Nn(o, e.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode(i);
        break;
      case "select":
        t = this.renderSelectMode(i);
    }
    return M.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), n;
})();
function zg(a, r) {
  for (var n = [], t = _a(a), e = _a(r); !ya(t, e); ) n.push(fe(t)), t = qe(t, 1);
  return n;
}
var jg = ur((function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), h(g(e = r.call(this, t)), "renderOptions", (function() {
      return e.state.monthYearsList.map((function(i) {
        var o = jr(i), s = ga(e.props.date, i) && Je(e.props.date, i);
        return M.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: e.onChange.bind(g(e), o), "aria-selected": s ? "true" : void 0 }, s ? M.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", ve(i, e.props.dateFormat, e.props.locale));
      }));
    })), h(g(e), "onChange", (function(i) {
      return e.props.onChange(i);
    })), h(g(e), "handleClickOutside", (function() {
      e.props.onCancel();
    })), e.state = { monthYearsList: zg(e.props.minDate, e.props.maxDate) }, e;
  }
  return Ne(n, [{ key: "render", value: function() {
    var t = Ie({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return M.createElement("div", { className: t }, this.renderOptions());
  } }]), n;
})()), Vg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "state", { dropdownVisible: !1 }), h(g(t), "renderSelectOptions", (function() {
      for (var s = _a(t.props.minDate), l = _a(t.props.maxDate), u = []; !ya(s, l); ) {
        var c = jr(s);
        u.push(M.createElement("option", { key: c, value: c }, ve(s, t.props.dateFormat, t.props.locale))), s = qe(s, 1);
      }
      return u;
    })), h(g(t), "onSelectChange", (function(s) {
      t.onChange(s.target.value);
    })), h(g(t), "renderSelectMode", (function() {
      return M.createElement("select", { value: jr(_a(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    })), h(g(t), "renderReadView", (function(s) {
      var l = ve(t.props.date, t.props.dateFormat, t.props.locale);
      return M.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(u) {
        return t.toggleDropdown(u);
      } }, M.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), M.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, l));
    })), h(g(t), "renderDropdown", (function() {
      return M.createElement(jg, { key: "dropdown", date: t.props.date, dateFormat: t.props.dateFormat, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown, locale: t.props.locale });
    })), h(g(t), "renderScrollMode", (function() {
      var s = t.state.dropdownVisible, l = [t.renderReadView(!s)];
      return s && l.unshift(t.renderDropdown()), l;
    })), h(g(t), "onChange", (function(s) {
      t.toggleDropdown();
      var l = fe(parseInt(s));
      ga(t.props.date, l) && Je(t.props.date, l) || t.props.onChange(l);
    })), h(g(t), "toggleDropdown", (function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    })), t;
  }
  return Ne(n, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return M.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), n;
})(), Yg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "dayEl", M.createRef()), h(g(t), "handleClick", (function(s) {
      !t.isDisabled() && t.props.onClick && t.props.onClick(s);
    })), h(g(t), "handleMouseEnter", (function(s) {
      !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(s);
    })), h(g(t), "handleOnKeyDown", (function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), t.props.handleOnKeyDown(s);
    })), h(g(t), "isSameDay", (function(s) {
      return ge(t.props.day, s);
    })), h(g(t), "isKeyboardSelected", (function() {
      return !t.props.disabledKeyboardNavigation && !(t.isSameDay(t.props.selected) || t.isSameWeek(t.props.selected)) && (t.isSameDay(t.props.preSelection) || t.isSameWeek(t.props.preSelection));
    })), h(g(t), "isDisabled", (function() {
      return dr(t.props.day, t.props);
    })), h(g(t), "isExcluded", (function() {
      return Dn(t.props.day, t.props);
    })), h(g(t), "isStartOfWeek", (function() {
      return ge(t.props.day, sa(t.props.day, t.props.locale, t.props.calendarStartDay));
    })), h(g(t), "isSameWeek", (function(s) {
      return t.props.showWeekPicker && ge(s, sa(t.props.day, t.props.locale, t.props.calendarStartDay));
    })), h(g(t), "getHighLightedClass", (function() {
      var s = t.props, l = s.day, u = s.highlightDates;
      if (!u) return !1;
      var c = ve(l, "MM.dd.yyyy");
      return u.get(c);
    })), h(g(t), "getHolidaysClass", (function() {
      var s = t.props, l = s.day, u = s.holidays;
      if (!u) return !1;
      var c = ve(l, "MM.dd.yyyy");
      return u.has(c) ? [u.get(c).className] : void 0;
    })), h(g(t), "isInRange", (function() {
      var s = t.props, l = s.day, u = s.startDate, c = s.endDate;
      return !(!u || !c) && Ft(l, u, c);
    })), h(g(t), "isInSelectingRange", (function() {
      var s, l = t.props, u = l.day, c = l.selectsStart, d = l.selectsEnd, p = l.selectsRange, m = l.selectsDisabledDaysInRange, f = l.startDate, y = l.endDate, v = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return !(!(c || d || p) || !v || !m && t.isDisabled()) && (c && y && (fa(v, y) || wa(v, y)) ? Ft(u, v, y) : (d && f && (ya(v, f) || wa(v, f)) || !(!p || !f || y || !ya(v, f) && !wa(v, f))) && Ft(u, f, v));
    })), h(g(t), "isSelectingRangeStart", (function() {
      var s;
      if (!t.isInSelectingRange()) return !1;
      var l = t.props, u = l.day, c = l.startDate, d = l.selectsStart, p = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return ge(u, d ? p : c);
    })), h(g(t), "isSelectingRangeEnd", (function() {
      var s;
      if (!t.isInSelectingRange()) return !1;
      var l = t.props, u = l.day, c = l.endDate, d = l.selectsEnd, p = l.selectsRange, m = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return ge(u, d || p ? m : c);
    })), h(g(t), "isRangeStart", (function() {
      var s = t.props, l = s.day, u = s.startDate, c = s.endDate;
      return !(!u || !c) && ge(u, l);
    })), h(g(t), "isRangeEnd", (function() {
      var s = t.props, l = s.day, u = s.startDate, c = s.endDate;
      return !(!u || !c) && ge(c, l);
    })), h(g(t), "isWeekend", (function() {
      var s = Nm(t.props.day);
      return s === 0 || s === 6;
    })), h(g(t), "isAfterMonth", (function() {
      return t.props.month !== void 0 && (t.props.month + 1) % 12 === Be(t.props.day);
    })), h(g(t), "isBeforeMonth", (function() {
      return t.props.month !== void 0 && (Be(t.props.day) + 1) % 12 === t.props.month;
    })), h(g(t), "isCurrentDay", (function() {
      return t.isSameDay(fe());
    })), h(g(t), "isSelected", (function() {
      return t.isSameDay(t.props.selected) || t.isSameWeek(t.props.selected);
    })), h(g(t), "getClassNames", (function(s) {
      var l, u = t.props.dayClassName ? t.props.dayClassName(s) : void 0;
      return Ie("react-datepicker__day", u, "react-datepicker__day--" + ve(t.props.day, "ddd", l), { "react-datepicker__day--disabled": t.isDisabled(), "react-datepicker__day--excluded": t.isExcluded(), "react-datepicker__day--selected": t.isSelected(), "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(), "react-datepicker__day--range-start": t.isRangeStart(), "react-datepicker__day--range-end": t.isRangeEnd(), "react-datepicker__day--in-range": t.isInRange(), "react-datepicker__day--in-selecting-range": t.isInSelectingRange(), "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(), "react-datepicker__day--today": t.isCurrentDay(), "react-datepicker__day--weekend": t.isWeekend(), "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth() }, t.getHighLightedClass("react-datepicker__day--highlighted"), t.getHolidaysClass());
    })), h(g(t), "getAriaLabel", (function() {
      var s = t.props, l = s.day, u = s.ariaLabelPrefixWhenEnabled, c = u === void 0 ? "Choose" : u, d = s.ariaLabelPrefixWhenDisabled, p = d === void 0 ? "Not available" : d, m = t.isDisabled() || t.isExcluded() ? p : c;
      return "".concat(m, " ").concat(ve(l, "PPPP", t.props.locale));
    })), h(g(t), "getTitle", (function() {
      var s = t.props, l = s.day, u = s.holidays, c = u === void 0 ? /* @__PURE__ */ new Map() : u, d = ve(l, "MM.dd.yyyy");
      return c.has(d) && c.get(d).holidayNames.length > 0 ? c.get(d).holidayNames.join(", ") : "";
    })), h(g(t), "getTabIndex", (function(s, l) {
      var u = s || t.props.selected, c = l || t.props.preSelection;
      return (!t.props.showWeekPicker || !t.props.showWeekNumber && t.isStartOfWeek()) && (t.isKeyboardSelected() || t.isSameDay(u) && ge(c, u)) ? 0 : -1;
    })), h(g(t), "handleFocusDay", (function() {
      var s, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = !1;
      t.getTabIndex() === 0 && !l.isInputFocused && t.isSameDay(t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (u = !0), t.props.inline && !t.props.shouldFocusDayInline && (u = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (u = !0), t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() && (u = !1), t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() && (u = !1)), u && ((s = t.dayEl.current) === null || s === void 0 || s.focus({ preventScroll: !0 }));
    })), h(g(t), "renderDayContents", (function() {
      return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(hi(t.props.day), t.props.day) : hi(t.props.day);
    })), h(g(t), "render", (function() {
      return M.createElement("div", { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.handleMouseEnter, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() }, t.renderDayContents(), t.getTitle() !== "" && M.createElement("span", { className: "holiday-overlay" }, t.getTitle()));
    })), t;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusDay(t);
  } }]), n;
})(), Wg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "weekNumberEl", M.createRef()), h(g(t), "handleClick", (function(s) {
      t.props.onClick && t.props.onClick(s);
    })), h(g(t), "handleOnKeyDown", (function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), t.props.handleOnKeyDown(s);
    })), h(g(t), "isKeyboardSelected", (function() {
      return !t.props.disabledKeyboardNavigation && !ge(t.props.date, t.props.selected) && ge(t.props.date, t.props.preSelection);
    })), h(g(t), "getTabIndex", (function() {
      return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || ge(t.props.date, t.props.selected) && ge(t.props.preSelection, t.props.selected)) ? 0 : -1;
    })), h(g(t), "handleFocusWeekNumber", (function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      t.getTabIndex() === 0 && !s.isInputFocused && ge(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), t.props.inline && !t.props.shouldFocusDayInline && (l = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (l = !0)), l && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
    })), t;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusWeekNumber(t);
  } }, { key: "render", value: function() {
    var t = this.props, e = t.weekNumber, i = t.ariaLabelPrefix, o = i === void 0 ? "week " : i, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!t.onClick, "react-datepicker__week-number--selected": ge(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return M.createElement("div", { ref: this.weekNumberEl, className: Ie(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, e);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), n;
})(), Zg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "handleDayClick", (function(s, l) {
      t.props.onDayClick && t.props.onDayClick(s, l);
    })), h(g(t), "handleDayMouseEnter", (function(s) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(s);
    })), h(g(t), "handleWeekClick", (function(s, l, u) {
      if (typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(s, l, u), t.props.showWeekPicker) {
        var c = sa(s, t.props.locale, t.props.calendarStartDay);
        t.handleDayClick(c, u);
      }
      t.props.shouldCloseOnSelect && t.props.setOpen(!1);
    })), h(g(t), "formatWeekNumber", (function(s) {
      return t.props.formatWeekNumber ? t.props.formatWeekNumber(s) : (function(l, u) {
        var c = Pa() && Ta(Pa());
        return xm(l, c ? { locale: c } : null);
      })(s);
    })), h(g(t), "renderDays", (function() {
      var s = sa(t.props.day, t.props.locale, t.props.calendarStartDay), l = [], u = t.formatWeekNumber(s);
      if (t.props.showWeekNumber) {
        var c = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(g(t), s, u) : void 0;
        l.push(M.createElement(Wg, { key: "W", weekNumber: u, date: s, onClick: c, selected: t.props.selected, preSelection: t.props.preSelection, ariaLabelPrefix: t.props.ariaLabelPrefix, showWeekPicker: t.props.showWeekPicker, showWeekNumber: t.props.showWeekNumber, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef }));
      }
      return l.concat([0, 1, 2, 3, 4, 5, 6].map((function(d) {
        var p = at(s, d);
        return M.createElement(Yg, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: p.valueOf(), day: p, month: t.props.month, onClick: t.handleDayClick.bind(g(t), p), onMouseEnter: t.handleDayMouseEnter.bind(g(t), p), minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, showWeekPicker: t.props.showWeekPicker, showWeekNumber: t.props.showWeekNumber, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, renderDayContents: t.props.renderDayContents, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart, locale: t.props.locale });
      })));
    })), h(g(t), "startOfWeek", (function() {
      return sa(t.props.day, t.props.locale, t.props.calendarStartDay);
    })), h(g(t), "isKeyboardSelected", (function() {
      return !t.props.disabledKeyboardNavigation && !ge(t.startOfWeek(), t.props.selected) && ge(t.startOfWeek(), t.props.preSelection);
    })), t;
  }
  return Ne(n, [{ key: "render", value: function() {
    var t = { "react-datepicker__week": !0, "react-datepicker__week--selected": ge(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return M.createElement("div", { className: Ie(t) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), n;
})(), kl = "two_columns", Ml = "three_columns", wl = "four_columns", xr = h(h(h({}, kl, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), Ml, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), wl, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function $i(a, r) {
  return a ? wl : r ? kl : Ml;
}
var Jg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "MONTH_REFS", Ct(Array(12)).map((function() {
      return M.createRef();
    }))), h(g(t), "QUARTER_REFS", Ct(Array(4)).map((function() {
      return M.createRef();
    }))), h(g(t), "isDisabled", (function(s) {
      return dr(s, t.props);
    })), h(g(t), "isExcluded", (function(s) {
      return Dn(s, t.props);
    })), h(g(t), "handleDayClick", (function(s, l) {
      t.props.onDayClick && t.props.onDayClick(s, l, t.props.orderInDisplay);
    })), h(g(t), "handleDayMouseEnter", (function(s) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(s);
    })), h(g(t), "handleMouseLeave", (function() {
      t.props.onMouseLeave && t.props.onMouseLeave();
    })), h(g(t), "isRangeStartMonth", (function(s) {
      var l = t.props, u = l.day, c = l.startDate, d = l.endDate;
      return !(!c || !d) && Je(Re(u, s), c);
    })), h(g(t), "isRangeStartQuarter", (function(s) {
      var l = t.props, u = l.day, c = l.startDate, d = l.endDate;
      return !(!c || !d) && rr(Ra(u, s), c);
    })), h(g(t), "isRangeEndMonth", (function(s) {
      var l = t.props, u = l.day, c = l.startDate, d = l.endDate;
      return !(!c || !d) && Je(Re(u, s), d);
    })), h(g(t), "isRangeEndQuarter", (function(s) {
      var l = t.props, u = l.day, c = l.startDate, d = l.endDate;
      return !(!c || !d) && rr(Ra(u, s), d);
    })), h(g(t), "isInSelectingRangeMonth", (function(s) {
      var l, u = t.props, c = u.day, d = u.selectsStart, p = u.selectsEnd, m = u.selectsRange, f = u.startDate, y = u.endDate, v = (l = t.props.selectingDate) !== null && l !== void 0 ? l : t.props.preSelection;
      return !(!(d || p || m) || !v) && (d && y ? Dr(v, y, s, c) : (p && f || !(!m || !f || y)) && Dr(f, v, s, c));
    })), h(g(t), "isSelectingMonthRangeStart", (function(s) {
      var l;
      if (!t.isInSelectingRangeMonth(s)) return !1;
      var u = t.props, c = u.day, d = u.startDate, p = u.selectsStart, m = Re(c, s), f = (l = t.props.selectingDate) !== null && l !== void 0 ? l : t.props.preSelection;
      return Je(m, p ? f : d);
    })), h(g(t), "isSelectingMonthRangeEnd", (function(s) {
      var l;
      if (!t.isInSelectingRangeMonth(s)) return !1;
      var u = t.props, c = u.day, d = u.endDate, p = u.selectsEnd, m = u.selectsRange, f = Re(c, s), y = (l = t.props.selectingDate) !== null && l !== void 0 ? l : t.props.preSelection;
      return Je(f, p || m ? y : d);
    })), h(g(t), "isInSelectingRangeQuarter", (function(s) {
      var l, u = t.props, c = u.day, d = u.selectsStart, p = u.selectsEnd, m = u.selectsRange, f = u.startDate, y = u.endDate, v = (l = t.props.selectingDate) !== null && l !== void 0 ? l : t.props.preSelection;
      return !(!(d || p || m) || !v) && (d && y ? Ir(v, y, s, c) : (p && f || !(!m || !f || y)) && Ir(f, v, s, c));
    })), h(g(t), "isWeekInMonth", (function(s) {
      var l = t.props.day, u = at(s, 6);
      return Je(s, l) || Je(u, l);
    })), h(g(t), "isCurrentMonth", (function(s, l) {
      return $(s) === $(fe()) && l === Be(fe());
    })), h(g(t), "isCurrentQuarter", (function(s, l) {
      return $(s) === $(fe()) && l === Fa(fe());
    })), h(g(t), "isSelectedMonth", (function(s, l, u) {
      return Be(u) === l && $(s) === $(u);
    })), h(g(t), "isSelectedQuarter", (function(s, l, u) {
      return Fa(s) === l && $(s) === $(u);
    })), h(g(t), "renderWeeks", (function() {
      for (var s = [], l = t.props.fixedHeight, u = 0, c = !1, d = sa(_a(t.props.day), t.props.locale, t.props.calendarStartDay); s.push(M.createElement(Zg, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix, key: u, day: d, month: Be(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, onWeekSelect: t.props.onWeekSelect, formatWeekNumber: t.props.formatWeekNumber, locale: t.props.locale, minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, showWeekNumber: t.props.showWeekNumbers, showWeekPicker: t.props.showWeekPicker, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, setOpen: t.props.setOpen, shouldCloseOnSelect: t.props.shouldCloseOnSelect, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, renderDayContents: t.props.renderDayContents, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, calendarStartDay: t.props.calendarStartDay, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart })), !c; ) {
        u++, d = Zt(d, 1);
        var p = l && u >= 6, m = !l && !t.isWeekInMonth(d);
        if (p || m) {
          if (!t.props.peekNextMonth) break;
          c = !0;
        }
      }
      return s;
    })), h(g(t), "onMonthClick", (function(s, l) {
      t.handleDayClick(_a(Re(t.props.day, l)), s);
    })), h(g(t), "onMonthMouseEnter", (function(s) {
      t.handleDayMouseEnter(_a(Re(t.props.day, s)));
    })), h(g(t), "handleMonthNavigation", (function(s, l) {
      t.isDisabled(l) || t.isExcluded(l) || (t.props.setPreSelection(l), t.MONTH_REFS[s].current && t.MONTH_REFS[s].current.focus());
    })), h(g(t), "onMonthKeyDown", (function(s, l) {
      var u = t.props, c = u.selected, d = u.preSelection, p = u.disabledKeyboardNavigation, m = u.showTwoColumnMonthYearPicker, f = u.showFourColumnMonthYearPicker, y = u.setPreSelection, v = s.key;
      if (v !== "Tab" && s.preventDefault(), !p) {
        var P = $i(f, m), k = xr[P].verticalNavigationOffset, w = xr[P].grid;
        switch (v) {
          case "Enter":
            t.onMonthClick(s, l), y(c);
            break;
          case "ArrowRight":
            t.handleMonthNavigation(l === 11 ? 0 : l + 1, qe(d, 1));
            break;
          case "ArrowLeft":
            t.handleMonthNavigation(l === 0 ? 11 : l - 1, Wa(d, 1));
            break;
          case "ArrowUp":
            t.handleMonthNavigation(w[0].includes(l) ? l + 12 - k : l - k, Wa(d, k));
            break;
          case "ArrowDown":
            t.handleMonthNavigation(w[w.length - 1].includes(l) ? l - 12 + k : l + k, qe(d, k));
        }
      }
    })), h(g(t), "onQuarterClick", (function(s, l) {
      t.handleDayClick(Ri(Ra(t.props.day, l)), s);
    })), h(g(t), "onQuarterMouseEnter", (function(s) {
      t.handleDayMouseEnter(Ri(Ra(t.props.day, s)));
    })), h(g(t), "handleQuarterNavigation", (function(s, l) {
      t.isDisabled(l) || t.isExcluded(l) || (t.props.setPreSelection(l), t.QUARTER_REFS[s - 1].current && t.QUARTER_REFS[s - 1].current.focus());
    })), h(g(t), "onQuarterKeyDown", (function(s, l) {
      var u = s.key;
      if (!t.props.disabledKeyboardNavigation) switch (u) {
        case "Enter":
          t.onQuarterClick(s, l), t.props.setPreSelection(t.props.selected);
          break;
        case "ArrowRight":
          t.handleQuarterNavigation(l === 4 ? 1 : l + 1, Ws(t.props.preSelection, 1));
          break;
        case "ArrowLeft":
          t.handleQuarterNavigation(l === 1 ? 4 : l - 1, Tm(t.props.preSelection, 1));
      }
    })), h(g(t), "getMonthClassNames", (function(s) {
      var l = t.props, u = l.day, c = l.startDate, d = l.endDate, p = l.selected, m = l.minDate, f = l.maxDate, y = l.preSelection, v = l.monthClassName, P = l.excludeDates, k = l.includeDates, w = v ? v(Re(u, s)) : void 0, C = Re(u, s);
      return Ie("react-datepicker__month-text", "react-datepicker__month-".concat(s), w, { "react-datepicker__month-text--disabled": (m || f || P || k) && yl(C, t.props), "react-datepicker__month-text--selected": t.isSelectedMonth(u, s, p), "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && Be(y) === s, "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": Dr(c, d, s, u), "react-datepicker__month-text--range-start": t.isRangeStartMonth(s), "react-datepicker__month-text--range-end": t.isRangeEndMonth(s), "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(s), "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(s), "react-datepicker__month-text--today": t.isCurrentMonth(u, s) });
    })), h(g(t), "getTabIndex", (function(s) {
      var l = Be(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    })), h(g(t), "getQuarterTabIndex", (function(s) {
      var l = Fa(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    })), h(g(t), "getAriaLabel", (function(s) {
      var l = t.props, u = l.chooseDayAriaLabelPrefix, c = u === void 0 ? "Choose" : u, d = l.disabledDayAriaLabelPrefix, p = d === void 0 ? "Not available" : d, m = l.day, f = Re(m, s), y = t.isDisabled(f) || t.isExcluded(f) ? p : c;
      return "".concat(y, " ").concat(ve(f, "MMMM yyyy"));
    })), h(g(t), "getQuarterClassNames", (function(s) {
      var l = t.props, u = l.day, c = l.startDate, d = l.endDate, p = l.selected, m = l.minDate, f = l.maxDate, y = l.preSelection, v = l.disabledKeyboardNavigation;
      return Ie("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (m || f) && Og(Ra(u, s), t.props), "react-datepicker__quarter-text--selected": t.isSelectedQuarter(u, s, p), "react-datepicker__quarter-text--keyboard-selected": !v && Fa(y) === s, "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": Ir(c, d, s, u), "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(s) });
    })), h(g(t), "getMonthContent", (function(s) {
      var l = t.props, u = l.showFullMonthYearPicker, c = l.renderMonthContent, d = l.locale, p = l.day, m = _l(s, d), f = Nn(s, d);
      return c ? c(s, m, f, p) : u ? f : m;
    })), h(g(t), "getQuarterContent", (function(s) {
      var l = t.props, u = l.renderQuarterContent, c = (function(d, p) {
        return ve(Ra(fe(), d), "QQQ", p);
      })(s, l.locale);
      return u ? u(s, c) : c;
    })), h(g(t), "renderMonths", (function() {
      var s = t.props, l = s.showTwoColumnMonthYearPicker, u = s.showFourColumnMonthYearPicker, c = s.day, d = s.selected;
      return xr[$i(u, l)].grid.map((function(p, m) {
        return M.createElement("div", { className: "react-datepicker__month-wrapper", key: m }, p.map((function(f, y) {
          return M.createElement("div", { ref: t.MONTH_REFS[f], key: y, onClick: function(v) {
            t.onMonthClick(v, f);
          }, onKeyDown: function(v) {
            t.onMonthKeyDown(v, f);
          }, onMouseEnter: function() {
            return t.onMonthMouseEnter(f);
          }, tabIndex: t.getTabIndex(f), className: t.getMonthClassNames(f), role: "option", "aria-label": t.getAriaLabel(f), "aria-current": t.isCurrentMonth(c, f) ? "date" : void 0, "aria-selected": t.isSelectedMonth(c, f, d) }, t.getMonthContent(f));
        })));
      }));
    })), h(g(t), "renderQuarters", (function() {
      var s = t.props, l = s.day, u = s.selected;
      return M.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map((function(c, d) {
        return M.createElement("div", { key: d, ref: t.QUARTER_REFS[d], role: "option", onClick: function(p) {
          t.onQuarterClick(p, c);
        }, onKeyDown: function(p) {
          t.onQuarterKeyDown(p, c);
        }, onMouseEnter: function() {
          return t.onQuarterMouseEnter(c);
        }, className: t.getQuarterClassNames(c), "aria-selected": t.isSelectedQuarter(l, c, u), tabIndex: t.getQuarterTabIndex(c), "aria-current": t.isCurrentQuarter(l, c) ? "date" : void 0 }, t.getQuarterContent(c));
      })));
    })), h(g(t), "getClassNames", (function() {
      var s = t.props, l = s.selectingDate, u = s.selectsStart, c = s.selectsEnd, d = s.showMonthYearPicker, p = s.showQuarterYearPicker, m = s.showWeekPicker;
      return Ie("react-datepicker__month", { "react-datepicker__month--selecting-range": l && (u || c) }, { "react-datepicker__monthPicker": d }, { "react-datepicker__quarterPicker": p }, { "react-datepicker__weekPicker": m });
    })), t;
  }
  return Ne(n, [{ key: "render", value: function() {
    var t = this.props, e = t.showMonthYearPicker, i = t.showQuarterYearPicker, o = t.day, s = t.ariaLabelPrefix, l = s === void 0 ? "month " : s;
    return M.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(l, " ").concat(ve(o, "yyyy-MM")), role: "listbox" }, e ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
  } }]), n;
})(), Cl = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    var t;
    Te(this, n);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
    return h(g(t = r.call.apply(r, [this].concat(i))), "state", { height: null }), h(g(t), "scrollToTheSelectedTime", (function() {
      requestAnimationFrame((function() {
        t.list && (t.list.scrollTop = t.centerLi && n.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - t.header.clientHeight : t.list.clientHeight, t.centerLi));
      }));
    })), h(g(t), "handleClick", (function(s) {
      (t.props.minTime || t.props.maxTime) && Ui(s, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Hi(s, t.props) || t.props.onChange(s);
    })), h(g(t), "isSelectedTime", (function(s) {
      return t.props.selected && (l = t.props.selected, u = s, Ji(l).getTime() === Ji(u).getTime());
      var l, u;
    })), h(g(t), "isDisabledTime", (function(s) {
      return (t.props.minTime || t.props.maxTime) && Ui(s, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Hi(s, t.props);
    })), h(g(t), "liClasses", (function(s) {
      var l = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(s) : void 0];
      return t.isSelectedTime(s) && l.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(s) && l.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (60 * na(s) + ra(s)) % t.props.intervals != 0 && l.push("react-datepicker__time-list-item--injected"), l.join(" ");
    })), h(g(t), "handleOnKeyDown", (function(s, l) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key !== "ArrowUp" && s.key !== "ArrowLeft" || !s.target.previousSibling || (s.preventDefault(), s.target.previousSibling.focus()), s.key !== "ArrowDown" && s.key !== "ArrowRight" || !s.target.nextSibling || (s.preventDefault(), s.target.nextSibling.focus()), s.key === "Enter" && t.handleClick(l), t.props.handleOnKeyDown(s);
    })), h(g(t), "renderTimes", (function() {
      for (var s = [], l = t.props.format ? t.props.format : "p", u = t.props.intervals, c = t.props.selected || t.props.openToDate || fe(), d = ia(c), p = t.props.injectTimes && t.props.injectTimes.sort((function(w, C) {
        return w - C;
      })), m = 60 * (function(w) {
        var C = new Date(w.getFullYear(), w.getMonth(), w.getDate()), S = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 24);
        return Math.round((+S - +C) / 36e5);
      })(c), f = m / u, y = 0; y < f; y++) {
        var v = zr(d, y * u);
        if (s.push(v), p) {
          var P = Lg(d, v, y, u, p);
          s = s.concat(P);
        }
      }
      var k = s.reduce((function(w, C) {
        return C.getTime() <= c.getTime() ? C : w;
      }), s[0]);
      return s.map((function(w, C) {
        return M.createElement("li", { key: C, onClick: t.handleClick.bind(g(t), w), className: t.liClasses(w), ref: function(S) {
          w === k && (t.centerLi = S);
        }, onKeyDown: function(S) {
          t.handleOnKeyDown(S, w);
        }, tabIndex: w === k ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(w) ? "true" : void 0, "aria-disabled": t.isDisabledTime(w) ? "true" : void 0 }, ve(w, l, t.props.locale));
      }));
    })), t;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var t = this, e = this.state.height;
    return M.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, M.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(i) {
      t.header = i;
    } }, M.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), M.createElement("div", { className: "react-datepicker__time" }, M.createElement("div", { className: "react-datepicker__time-box" }, M.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
      t.list = i;
    }, style: e ? { height: e } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n;
})();
h(Cl, "calcCenterPosition", (function(a, r) {
  return r.offsetTop - (a / 2 - r.clientHeight / 2);
}));
var $g = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), h(g(e = r.call(this, t)), "YEAR_REFS", Ct(Array(e.props.yearItemNumber)).map((function() {
      return M.createRef();
    }))), h(g(e), "isDisabled", (function(i) {
      return dr(i, e.props);
    })), h(g(e), "isExcluded", (function(i) {
      return Dn(i, e.props);
    })), h(g(e), "selectingDate", (function() {
      var i;
      return (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
    })), h(g(e), "updateFocusOnPaginate", (function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(g(e));
      window.requestAnimationFrame(o);
    })), h(g(e), "handleYearClick", (function(i, o) {
      e.props.onDayClick && e.props.onDayClick(i, o);
    })), h(g(e), "handleYearNavigation", (function(i, o) {
      var s = e.props, l = s.date, u = s.yearItemNumber, c = Ka(l, u).startPeriod;
      e.isDisabled(o) || e.isExcluded(o) || (e.props.setPreSelection(o), i - c == -1 ? e.updateFocusOnPaginate(u - 1) : i - c === u ? e.updateFocusOnPaginate(0) : e.YEAR_REFS[i - c].current.focus());
    })), h(g(e), "isSameDay", (function(i, o) {
      return ge(i, o);
    })), h(g(e), "isCurrentYear", (function(i) {
      return i === $(fe());
    })), h(g(e), "isRangeStart", (function(i) {
      return e.props.startDate && e.props.endDate && ga(da(fe(), i), e.props.startDate);
    })), h(g(e), "isRangeEnd", (function(i) {
      return e.props.startDate && e.props.endDate && ga(da(fe(), i), e.props.endDate);
    })), h(g(e), "isInRange", (function(i) {
      return Ar(i, e.props.startDate, e.props.endDate);
    })), h(g(e), "isInSelectingRange", (function(i) {
      var o = e.props, s = o.selectsStart, l = o.selectsEnd, u = o.selectsRange, c = o.startDate, d = o.endDate;
      return !(!(s || l || u) || !e.selectingDate()) && (s && d ? Ar(i, e.selectingDate(), d) : (l && c || !(!u || !c || d)) && Ar(i, c, e.selectingDate()));
    })), h(g(e), "isSelectingRangeStart", (function(i) {
      if (!e.isInSelectingRange(i)) return !1;
      var o = e.props, s = o.startDate, l = o.selectsStart, u = da(fe(), i);
      return ga(u, l ? e.selectingDate() : s);
    })), h(g(e), "isSelectingRangeEnd", (function(i) {
      if (!e.isInSelectingRange(i)) return !1;
      var o = e.props, s = o.endDate, l = o.selectsEnd, u = o.selectsRange, c = da(fe(), i);
      return ga(c, l || u ? e.selectingDate() : s);
    })), h(g(e), "isKeyboardSelected", (function(i) {
      var o = dt(da(e.props.date, i));
      return !e.props.disabledKeyboardNavigation && !e.props.inline && !ge(o, dt(e.props.selected)) && ge(o, dt(e.props.preSelection));
    })), h(g(e), "onYearClick", (function(i, o) {
      var s = e.props.date;
      e.handleYearClick(dt(da(s, o)), i);
    })), h(g(e), "onYearKeyDown", (function(i, o) {
      var s = i.key;
      if (!e.props.disabledKeyboardNavigation) switch (s) {
        case "Enter":
          e.onYearClick(i, o), e.props.setPreSelection(e.props.selected);
          break;
        case "ArrowRight":
          e.handleYearNavigation(o + 1, Ya(e.props.preSelection, 1));
          break;
        case "ArrowLeft":
          e.handleYearNavigation(o - 1, bt(e.props.preSelection, 1));
      }
    })), h(g(e), "getYearClassNames", (function(i) {
      var o = e.props, s = o.minDate, l = o.maxDate, u = o.selected, c = o.excludeDates, d = o.includeDates, p = o.filterDate;
      return Ie("react-datepicker__year-text", { "react-datepicker__year-text--selected": i === $(u), "react-datepicker__year-text--disabled": (s || l || c || d || p) && vl(i, e.props), "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(i), "react-datepicker__year-text--range-start": e.isRangeStart(i), "react-datepicker__year-text--range-end": e.isRangeEnd(i), "react-datepicker__year-text--in-range": e.isInRange(i), "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(i), "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(i), "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(i), "react-datepicker__year-text--today": e.isCurrentYear(i) });
    })), h(g(e), "getYearTabIndex", (function(i) {
      return e.props.disabledKeyboardNavigation ? "-1" : i === $(e.props.preSelection) ? "0" : "-1";
    })), h(g(e), "getYearContainerClassNames", (function() {
      var i = e.props, o = i.selectingDate, s = i.selectsStart, l = i.selectsEnd, u = i.selectsRange;
      return Ie("react-datepicker__year", { "react-datepicker__year--selecting-range": o && (s || l || u) });
    })), h(g(e), "getYearContent", (function(i) {
      return e.props.renderYearContent ? e.props.renderYearContent(i) : i;
    })), e;
  }
  return Ne(n, [{ key: "render", value: function() {
    for (var t = this, e = [], i = this.props, o = i.date, s = i.yearItemNumber, l = i.onYearMouseEnter, u = i.onYearMouseLeave, c = Ka(o, s), d = c.startPeriod, p = c.endPeriod, m = function(y) {
      e.push(M.createElement("div", { ref: t.YEAR_REFS[y - d], onClick: function(v) {
        t.onYearClick(v, y);
      }, onKeyDown: function(v) {
        t.onYearKeyDown(v, y);
      }, tabIndex: t.getYearTabIndex(y), className: t.getYearClassNames(y), onMouseEnter: function(v) {
        return l(v, y);
      }, onMouseLeave: function(v) {
        return u(v, y);
      }, key: y, "aria-current": t.isCurrentYear(y) ? "date" : void 0 }, t.getYearContent(y)));
    }, f = d; f <= p; f++) m(f);
    return M.createElement("div", { className: this.getYearContainerClassNames() }, M.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, e));
  } }]), n;
})(), qg = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), h(g(e = r.call(this, t)), "onTimeChange", (function(i) {
      e.setState({ time: i });
      var o = e.props.date, s = o instanceof Date && !isNaN(o) ? o : /* @__PURE__ */ new Date();
      s.setHours(i.split(":")[0]), s.setMinutes(i.split(":")[1]), e.props.onChange(s);
    })), h(g(e), "renderTimeInput", (function() {
      var i = e.state.time, o = e.props, s = o.date, l = o.timeString, u = o.customTimeInput;
      return u ? M.cloneElement(u, { date: s, value: i, onChange: e.onTimeChange }) : M.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: i, onChange: function(c) {
        e.onTimeChange(c.target.value || l);
      } });
    })), e.state = { time: e.props.timeString }, e;
  }
  return Ne(n, [{ key: "render", value: function() {
    return M.createElement("div", { className: "react-datepicker__input-time-container" }, M.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), M.createElement("div", { className: "react-datepicker-time__input-container" }, M.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(t, e) {
    return t.timeString !== e.time ? { time: t.timeString } : null;
  } }]), n;
})();
function Qg(a) {
  var r = a.className, n = a.children, t = a.showPopperArrow, e = a.arrowProps, i = e === void 0 ? {} : e;
  return M.createElement("div", { className: r }, t && M.createElement("div", Qa({ className: "react-datepicker__triangle" }, i)), n);
}
var Xg = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], e_ = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), h(g(e = r.call(this, t)), "handleClickOutside", (function(i) {
      e.props.onClickOutside(i);
    })), h(g(e), "setClickOutsideRef", (function() {
      return e.containerRef.current;
    })), h(g(e), "handleDropdownFocus", (function(i) {
      (function() {
        var o = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return Xg.some((function(s) {
          return o.indexOf(s) >= 0;
        }));
      })(i.target) && e.props.onDropdownFocus();
    })), h(g(e), "getDateInView", (function() {
      var i = e.props, o = i.preSelection, s = i.selected, l = i.openToDate, u = bl(e.props), c = Sl(e.props), d = fe(), p = l || s || o;
      return p || (u && fa(d, u) ? u : c && ya(d, c) ? c : d);
    })), h(g(e), "increaseMonth", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: qe(o, 1) };
      }), (function() {
        return e.handleMonthChange(e.state.date);
      }));
    })), h(g(e), "decreaseMonth", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: Wa(o, 1) };
      }), (function() {
        return e.handleMonthChange(e.state.date);
      }));
    })), h(g(e), "handleDayClick", (function(i, o, s) {
      e.props.onSelect(i, o, s), e.props.setPreSelection && e.props.setPreSelection(i);
    })), h(g(e), "handleDayMouseEnter", (function(i) {
      e.setState({ selectingDate: i }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(i);
    })), h(g(e), "handleMonthMouseLeave", (function() {
      e.setState({ selectingDate: null }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
    })), h(g(e), "handleYearMouseEnter", (function(i, o) {
      e.setState({ selectingDate: da(fe(), o) }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(i, o);
    })), h(g(e), "handleYearMouseLeave", (function(i, o) {
      e.props.onYearMouseLeave && e.props.onYearMouseLeave(i, o);
    })), h(g(e), "handleYearChange", (function(i) {
      e.props.onYearChange && (e.props.onYearChange(i), e.setState({ isRenderAriaLiveMessage: !0 })), e.props.adjustDateOnChange && (e.props.onSelect && e.props.onSelect(i), e.props.setOpen && e.props.setOpen(!0)), e.props.setPreSelection && e.props.setPreSelection(i);
    })), h(g(e), "handleMonthChange", (function(i) {
      e.handleCustomMonthChange(i), e.props.adjustDateOnChange && (e.props.onSelect && e.props.onSelect(i), e.props.setOpen && e.props.setOpen(!0)), e.props.setPreSelection && e.props.setPreSelection(i);
    })), h(g(e), "handleCustomMonthChange", (function(i) {
      e.props.onMonthChange && (e.props.onMonthChange(i), e.setState({ isRenderAriaLiveMessage: !0 }));
    })), h(g(e), "handleMonthYearChange", (function(i) {
      e.handleYearChange(i), e.handleMonthChange(i);
    })), h(g(e), "changeYear", (function(i) {
      e.setState((function(o) {
        var s = o.date;
        return { date: da(s, i) };
      }), (function() {
        return e.handleYearChange(e.state.date);
      }));
    })), h(g(e), "changeMonth", (function(i) {
      e.setState((function(o) {
        var s = o.date;
        return { date: Re(s, i) };
      }), (function() {
        return e.handleMonthChange(e.state.date);
      }));
    })), h(g(e), "changeMonthYear", (function(i) {
      e.setState((function(o) {
        var s = o.date;
        return { date: da(Re(s, Be(i)), $(i)) };
      }), (function() {
        return e.handleMonthYearChange(e.state.date);
      }));
    })), h(g(e), "header", (function() {
      var i = sa(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.state.date, e.props.locale, e.props.calendarStartDay), o = [];
      return e.props.showWeekNumbers && o.push(M.createElement("div", { key: "W", className: "react-datepicker__day-name" }, e.props.weekLabel || "#")), o.concat([0, 1, 2, 3, 4, 5, 6].map((function(s) {
        var l = at(i, s), u = e.formatWeekday(l, e.props.locale), c = e.props.weekDayClassName ? e.props.weekDayClassName(l) : void 0;
        return M.createElement("div", { key: s, className: Ie("react-datepicker__day-name", c) }, u);
      })));
    })), h(g(e), "formatWeekday", (function(i, o) {
      return e.props.formatWeekDay ? (function(s, l, u) {
        return l(ve(s, "EEEE", u));
      })(i, e.props.formatWeekDay, o) : e.props.useWeekdaysShort ? (function(s, l) {
        return ve(s, "EEE", l);
      })(i, o) : (function(s, l) {
        return ve(s, "EEEEEE", l);
      })(i, o);
    })), h(g(e), "decreaseYear", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: bt(o, e.props.showYearPicker ? e.props.yearItemNumber : 1) };
      }), (function() {
        return e.handleYearChange(e.state.date);
      }));
    })), h(g(e), "clearSelectingDate", (function() {
      e.setState({ selectingDate: null });
    })), h(g(e), "renderPreviousButton", (function() {
      if (!e.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case e.props.showMonthYearPicker:
            i = Vi(e.state.date, e.props);
            break;
          case e.props.showYearPicker:
            i = (function(P) {
              var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = k.minDate, C = k.yearItemNumber, S = C === void 0 ? gt : C, b = Ka(dt(bt(P, S)), S).endPeriod, T = w && $(w);
              return T && T > b || !1;
            })(e.state.date, e.props);
            break;
          default:
            i = zi(e.state.date, e.props);
        }
        if ((e.props.forceShowMonthNavigation || e.props.showDisabledMonthNavigation || !i) && !e.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = e.decreaseMonth;
          (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (s = e.decreaseYear), i && e.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--previous--disabled"), s = null);
          var l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, c = u.previousMonthButtonLabel, d = u.previousYearButtonLabel, p = e.props, m = p.previousMonthAriaLabel, f = m === void 0 ? typeof c == "string" ? c : "Previous Month" : m, y = p.previousYearAriaLabel, v = y === void 0 ? typeof d == "string" ? d : "Previous Year" : y;
          return M.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: e.props.handleOnKeyDown, "aria-label": l ? v : f }, M.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, l ? e.props.previousYearButtonLabel : e.props.previousMonthButtonLabel));
        }
      }
    })), h(g(e), "increaseYear", (function() {
      e.setState((function(i) {
        var o = i.date;
        return { date: Ya(o, e.props.showYearPicker ? e.props.yearItemNumber : 1) };
      }), (function() {
        return e.handleYearChange(e.state.date);
      }));
    })), h(g(e), "renderNextButton", (function() {
      if (!e.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case e.props.showMonthYearPicker:
            i = Yi(e.state.date, e.props);
            break;
          case e.props.showYearPicker:
            i = (function(P) {
              var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = k.maxDate, C = k.yearItemNumber, S = C === void 0 ? gt : C, b = Ka(Ya(P, S), S).startPeriod, T = w && $(w);
              return T && T < b || !1;
            })(e.state.date, e.props);
            break;
          default:
            i = ji(e.state.date, e.props);
        }
        if ((e.props.forceShowMonthNavigation || e.props.showDisabledMonthNavigation || !i) && !e.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          e.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var s = e.increaseMonth;
          (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (s = e.increaseYear), i && e.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), s = null);
          var l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, c = u.nextMonthButtonLabel, d = u.nextYearButtonLabel, p = e.props, m = p.nextMonthAriaLabel, f = m === void 0 ? typeof c == "string" ? c : "Next Month" : m, y = p.nextYearAriaLabel, v = y === void 0 ? typeof d == "string" ? d : "Next Year" : y;
          return M.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: e.props.handleOnKeyDown, "aria-label": l ? v : f }, M.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, l ? e.props.nextYearButtonLabel : e.props.nextMonthButtonLabel));
        }
      }
    })), h(g(e), "renderCurrentMonth", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.state.date, o = ["react-datepicker__current-month"];
      return e.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), M.createElement("div", { className: o.join(" ") }, ve(i, e.props.dateFormat, e.props.locale));
    })), h(g(e), "renderYearDropdown", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (e.props.showYearDropdown && !i) return M.createElement(Kg, { adjustDateOnChange: e.props.adjustDateOnChange, date: e.state.date, onSelect: e.props.onSelect, setOpen: e.props.setOpen, dropdownMode: e.props.dropdownMode, onChange: e.changeYear, minDate: e.props.minDate, maxDate: e.props.maxDate, year: $(e.state.date), scrollableYearDropdown: e.props.scrollableYearDropdown, yearDropdownItemNumber: e.props.yearDropdownItemNumber });
    })), h(g(e), "renderMonthDropdown", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (e.props.showMonthDropdown && !i) return M.createElement(Ug, { dropdownMode: e.props.dropdownMode, locale: e.props.locale, onChange: e.changeMonth, month: Be(e.state.date), useShortMonthInDropdown: e.props.useShortMonthInDropdown });
    })), h(g(e), "renderMonthYearDropdown", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (e.props.showMonthYearDropdown && !i) return M.createElement(Vg, { dropdownMode: e.props.dropdownMode, locale: e.props.locale, dateFormat: e.props.dateFormat, onChange: e.changeMonthYear, minDate: e.props.minDate, maxDate: e.props.maxDate, date: e.state.date, scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown });
    })), h(g(e), "handleTodayButtonClick", (function(i) {
      e.props.onSelect(Fi(), i), e.props.setPreSelection && e.props.setPreSelection(Fi());
    })), h(g(e), "renderTodayButton", (function() {
      if (e.props.todayButton && !e.props.showTimeSelectOnly) return M.createElement("div", { className: "react-datepicker__today-button", onClick: function(i) {
        return e.handleTodayButtonClick(i);
      } }, e.props.todayButton);
    })), h(g(e), "renderDefaultHeader", (function(i) {
      var o = i.monthDate, s = i.i;
      return M.createElement("div", { className: "react-datepicker__header ".concat(e.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, e.renderCurrentMonth(o), M.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode), onFocus: e.handleDropdownFocus }, e.renderMonthDropdown(s !== 0), e.renderMonthYearDropdown(s !== 0), e.renderYearDropdown(s !== 0)), M.createElement("div", { className: "react-datepicker__day-names" }, e.header(o)));
    })), h(g(e), "renderCustomHeader", (function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, s = i.i;
      if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly) return null;
      var l = zi(e.state.date, e.props), u = ji(e.state.date, e.props), c = Vi(e.state.date, e.props), d = Yi(e.state.date, e.props), p = !e.props.showMonthYearPicker && !e.props.showQuarterYearPicker && !e.props.showYearPicker;
      return M.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: e.props.onDropdownFocus }, e.props.renderCustomHeader(ar(ar({}, e.state), {}, { customHeaderCount: s, monthDate: o, changeMonth: e.changeMonth, changeYear: e.changeYear, decreaseMonth: e.decreaseMonth, increaseMonth: e.increaseMonth, decreaseYear: e.decreaseYear, increaseYear: e.increaseYear, prevMonthButtonDisabled: l, nextMonthButtonDisabled: u, prevYearButtonDisabled: c, nextYearButtonDisabled: d })), p && M.createElement("div", { className: "react-datepicker__day-names" }, e.header(o)));
    })), h(g(e), "renderYearHeader", (function() {
      var i = e.state.date, o = e.props, s = o.showYearPicker, l = Ka(i, o.yearItemNumber), u = l.startPeriod, c = l.endPeriod;
      return M.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(u, " - ").concat(c) : $(i));
    })), h(g(e), "renderHeader", (function(i) {
      switch (!0) {
        case e.props.renderCustomHeader !== void 0:
          return e.renderCustomHeader(i);
        case (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker):
          return e.renderYearHeader(i);
        default:
          return e.renderDefaultHeader(i);
      }
    })), h(g(e), "renderMonths", (function() {
      var i;
      if (!e.props.showTimeSelectOnly && !e.props.showYearPicker) {
        for (var o = [], s = e.props.showPreviousMonths ? e.props.monthsShown - 1 : 0, l = Wa(e.state.date, s), u = (i = e.props.monthSelectedIn) !== null && i !== void 0 ? i : s, c = 0; c < e.props.monthsShown; ++c) {
          var d = qe(l, c - u + s), p = "month-".concat(c), m = c < e.props.monthsShown - 1, f = c > 0;
          o.push(M.createElement("div", { key: p, ref: function(y) {
            e.monthContainer = y;
          }, className: "react-datepicker__month-container" }, e.renderHeader({ monthDate: d, i: c }), M.createElement(Jg, { chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: e.props.weekAriaLabelPrefix, ariaLabelPrefix: e.props.monthAriaLabelPrefix, onChange: e.changeMonthYear, day: d, dayClassName: e.props.dayClassName, calendarStartDay: e.props.calendarStartDay, monthClassName: e.props.monthClassName, onDayClick: e.handleDayClick, handleOnKeyDown: e.props.handleOnDayKeyDown, onDayMouseEnter: e.handleDayMouseEnter, onMouseLeave: e.handleMonthMouseLeave, onWeekSelect: e.props.onWeekSelect, orderInDisplay: c, formatWeekNumber: e.props.formatWeekNumber, locale: e.props.locale, minDate: e.props.minDate, maxDate: e.props.maxDate, excludeDates: e.props.excludeDates, excludeDateIntervals: e.props.excludeDateIntervals, highlightDates: e.props.highlightDates, holidays: e.props.holidays, selectingDate: e.state.selectingDate, includeDates: e.props.includeDates, includeDateIntervals: e.props.includeDateIntervals, inline: e.props.inline, shouldFocusDayInline: e.props.shouldFocusDayInline, fixedHeight: e.props.fixedHeight, filterDate: e.props.filterDate, preSelection: e.props.preSelection, setPreSelection: e.props.setPreSelection, selected: e.props.selected, selectsStart: e.props.selectsStart, selectsEnd: e.props.selectsEnd, selectsRange: e.props.selectsRange, selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange, showWeekNumbers: e.props.showWeekNumbers, startDate: e.props.startDate, endDate: e.props.endDate, peekNextMonth: e.props.peekNextMonth, setOpen: e.props.setOpen, shouldCloseOnSelect: e.props.shouldCloseOnSelect, renderDayContents: e.props.renderDayContents, renderMonthContent: e.props.renderMonthContent, renderQuarterContent: e.props.renderQuarterContent, renderYearContent: e.props.renderYearContent, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, showMonthYearPicker: e.props.showMonthYearPicker, showFullMonthYearPicker: e.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: e.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: e.props.showFourColumnMonthYearPicker, showYearPicker: e.props.showYearPicker, showQuarterYearPicker: e.props.showQuarterYearPicker, showWeekPicker: e.props.showWeekPicker, isInputFocused: e.props.isInputFocused, containerRef: e.containerRef, monthShowsDuplicateDaysEnd: m, monthShowsDuplicateDaysStart: f })));
        }
        return o;
      }
    })), h(g(e), "renderYears", (function() {
      if (!e.props.showTimeSelectOnly) return e.props.showYearPicker ? M.createElement("div", { className: "react-datepicker__year--container" }, e.renderHeader(), M.createElement($g, Qa({ onDayClick: e.handleDayClick, selectingDate: e.state.selectingDate, clearSelectingDate: e.clearSelectingDate, date: e.state.date }, e.props, { onYearMouseEnter: e.handleYearMouseEnter, onYearMouseLeave: e.handleYearMouseLeave }))) : void 0;
    })), h(g(e), "renderTimeSection", (function() {
      if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly)) return M.createElement(Cl, { selected: e.props.selected, openToDate: e.props.openToDate, onChange: e.props.onTimeChange, timeClassName: e.props.timeClassName, format: e.props.timeFormat, includeTimes: e.props.includeTimes, intervals: e.props.timeIntervals, minTime: e.props.minTime, maxTime: e.props.maxTime, excludeTimes: e.props.excludeTimes, filterTime: e.props.filterTime, timeCaption: e.props.timeCaption, todayButton: e.props.todayButton, showMonthDropdown: e.props.showMonthDropdown, showMonthYearDropdown: e.props.showMonthYearDropdown, showYearDropdown: e.props.showYearDropdown, withPortal: e.props.withPortal, monthRef: e.state.monthContainer, injectTimes: e.props.injectTimes, locale: e.props.locale, handleOnKeyDown: e.props.handleOnKeyDown, showTimeSelectOnly: e.props.showTimeSelectOnly });
    })), h(g(e), "renderInputTimeSection", (function() {
      var i = new Date(e.props.selected), o = ha(i) && e.props.selected ? "".concat(Zi(i.getHours()), ":").concat(Zi(i.getMinutes())) : "";
      if (e.props.showTimeInput) return M.createElement(qg, { date: i, timeString: o, timeInputLabel: e.props.timeInputLabel, onChange: e.props.onTimeChange, customTimeInput: e.props.customTimeInput });
    })), h(g(e), "renderAriaLiveRegion", (function() {
      var i, o = Ka(e.state.date, e.props.yearItemNumber), s = o.startPeriod, l = o.endPeriod;
      return i = e.props.showYearPicker ? "".concat(s, " - ").concat(l) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? $(e.state.date) : "".concat(Nn(Be(e.state.date), e.props.locale), " ").concat($(e.state.date)), M.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, e.state.isRenderAriaLiveMessage && i);
    })), h(g(e), "renderChildren", (function() {
      if (e.props.children) return M.createElement("div", { className: "react-datepicker__children-container" }, e.props.children);
    })), e.containerRef = M.createRef(), e.state = { date: e.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, e;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    var t = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void t.setState({ monthContainer: t.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(t) {
    var e = this;
    if (!this.props.preSelection || ge(this.props.preSelection, t.preSelection) && this.props.monthSelectedIn === t.monthSelectedIn) this.props.openToDate && !ge(this.props.openToDate, t.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var i = !Je(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, (function() {
        return i && e.handleCustomMonthChange(e.state.date);
      }));
    }
  } }, { key: "render", value: function() {
    var t = this.props.container || Qg;
    return M.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, M.createElement(t, { className: Ie("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: gt };
  } }]), n;
})(), a_ = function(a) {
  var r = a.icon, n = a.className, t = n === void 0 ? "" : n, e = a.onClick, i = "react-datepicker__calendar-icon";
  return M.isValidElement(r) ? M.cloneElement(r, { className: "".concat(r.props.className || "", " ").concat(i, " ").concat(t), onClick: function(o) {
    typeof r.props.onClick == "function" && r.props.onClick(o), typeof e == "function" && e(o);
  } }) : typeof r == "string" ? M.createElement("i", { className: "".concat(i, " ").concat(r, " ").concat(t), "aria-hidden": "true", onClick: e }) : M.createElement("svg", { className: "".concat(i, " ").concat(t), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: e }, M.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, Pl = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), (e = r.call(this, t)).el = document.createElement("div"), e;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return uu.createPortal(this.props.children, this.el);
  } }]), n;
})(), t_ = function(a) {
  return !a.disabled && a.tabIndex !== -1;
}, Tl = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), h(g(e = r.call(this, t)), "getTabChildren", (function() {
      return Array.prototype.slice.call(e.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(t_);
    })), h(g(e), "handleFocusStart", (function() {
      var i = e.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    })), h(g(e), "handleFocusEnd", (function() {
      var i = e.getTabChildren();
      i && i.length > 1 && i[0].focus();
    })), e.tabLoopRef = M.createRef(), e;
  }
  return Ne(n, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? M.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, M.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, M.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), n;
})(), r_ = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n() {
    return Te(this, n), r.apply(this, arguments);
  }
  return Ne(n, [{ key: "render", value: function() {
    var t, e = this.props, i = e.className, o = e.wrapperClassName, s = e.hidePopper, l = e.popperComponent, u = e.popperModifiers, c = e.popperPlacement, d = e.popperProps, p = e.targetComponent, m = e.enableTabLoop, f = e.popperOnKeyDown, y = e.portalId, v = e.portalHost;
    if (!s) {
      var P = Ie("react-datepicker-popper", i);
      t = M.createElement(Tg, Qa({ modifiers: u, placement: c }, d), (function(w) {
        var C = w.ref, S = w.style, b = w.placement, T = w.arrowProps;
        return M.createElement(Tl, { enableTabLoop: m }, M.createElement("div", { ref: C, style: S, className: P, "data-placement": b, onKeyDown: f }, M.cloneElement(l, { arrowProps: T })));
      }));
    }
    this.props.popperContainer && (t = M.createElement(this.props.popperContainer, {}, t)), y && !s && (t = M.createElement(Pl, { portalId: y, portalHost: v }, t));
    var k = Ie("react-datepicker-wrapper", o);
    return M.createElement(pf, { className: "react-datepicker-manager" }, M.createElement(Ig, null, (function(w) {
      var C = w.ref;
      return M.createElement("div", { ref: C, className: k }, p);
    })), t);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), n;
})(), qi = "react-datepicker-ignore-onclickoutside", n_ = ur(e_), Er = "Date input not valid.", mr = (function(a) {
  De(n, M.Component);
  var r = Ae(n);
  function n(t) {
    var e;
    return Te(this, n), h(g(e = r.call(this, t)), "getPreSelection", (function() {
      return e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : fe();
    })), h(g(e), "modifyHolidays", (function() {
      var i;
      return (i = e.props.holidays) === null || i === void 0 ? void 0 : i.reduce((function(o, s) {
        var l = new Date(s.date);
        return vt(l) ? [].concat(Ct(o), [ar(ar({}, s), {}, { date: l })]) : o;
      }), []);
    })), h(g(e), "calcInitialState", (function() {
      var i, o = e.getPreSelection(), s = bl(e.props), l = Sl(e.props), u = s && fa(o, ia(s)) ? s : l && ya(o, Yr(l)) ? l : o;
      return { open: e.props.startOpen || !1, preventFocus: !1, preSelection: (i = e.props.selectsRange ? e.props.startDate : e.props.selected) !== null && i !== void 0 ? i : u, highlightDates: Wi(e.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    })), h(g(e), "clearPreventFocusTimeout", (function() {
      e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
    })), h(g(e), "setFocus", (function() {
      e.input && e.input.focus && e.input.focus({ preventScroll: !0 });
    })), h(g(e), "setBlur", (function() {
      e.input && e.input.blur && e.input.blur(), e.cancelFocusInput();
    })), h(g(e), "setOpen", (function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      e.setState({ open: i, preSelection: i && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection, lastPreSelectChange: Br }, (function() {
        i || e.setState((function(s) {
          return { focused: !!o && s.focused };
        }), (function() {
          !o && e.setBlur(), e.setState({ inputValue: null });
        }));
      }));
    })), h(g(e), "inputOk", (function() {
      return lr(e.state.preSelection);
    })), h(g(e), "isCalendarOpen", (function() {
      return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
    })), h(g(e), "handleFocus", (function(i) {
      e.state.preventFocus || (e.props.onFocus(i), e.props.preventOpenOnFocus || e.props.readOnly || e.setOpen(!0)), e.setState({ focused: !0 });
    })), h(g(e), "sendFocusBackToInput", (function() {
      e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({ preventFocus: !0 }, (function() {
        e.preventFocusTimeout = setTimeout((function() {
          e.setFocus(), e.setState({ preventFocus: !1 });
        }));
      }));
    })), h(g(e), "cancelFocusInput", (function() {
      clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = null;
    })), h(g(e), "deferFocusInput", (function() {
      e.cancelFocusInput(), e.inputFocusTimeout = setTimeout((function() {
        return e.setFocus();
      }), 1);
    })), h(g(e), "handleDropdownFocus", (function() {
      e.cancelFocusInput();
    })), h(g(e), "handleBlur", (function(i) {
      (!e.state.open || e.props.withPortal || e.props.showTimeInput) && e.props.onBlur(i), e.setState({ focused: !1 });
    })), h(g(e), "handleCalendarClickOutside", (function(i) {
      e.props.inline || e.setOpen(!1), e.props.onClickOutside(i), e.props.withPortal && i.preventDefault();
    })), h(g(e), "handleChange", (function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) o[s] = arguments[s];
      var l = o[0];
      if (!e.props.onChangeRaw || (e.props.onChangeRaw.apply(g(e), o), typeof l.isDefaultPrevented == "function" && !l.isDefaultPrevented())) {
        e.setState({ inputValue: l.target.value, lastPreSelectChange: i_ });
        var u, c, d, p, m, f, y, v, P = (u = l.target.value, c = e.props.dateFormat, d = e.props.locale, p = e.props.strictParsing, m = e.props.minDate, f = null, y = Ta(d) || Ta(Pa()), v = !0, Array.isArray(c) ? (c.forEach((function(k) {
          var w = Mr(u, k, /* @__PURE__ */ new Date(), { locale: y });
          p && (v = ha(w, m) && u === ve(w, k, d)), ha(w, m) && v && (f = w);
        })), f) : (f = Mr(u, c, /* @__PURE__ */ new Date(), { locale: y }), p ? v = ha(f) && u === ve(f, c, d) : ha(f) || (c = c.match(Bg).map((function(k) {
          var w = k[0];
          return w === "p" || w === "P" ? y ? (0, Eg[w])(k, y.formatLong) : w : k;
        })).join(""), u.length > 0 && (f = Mr(u, c.slice(0, u.length), /* @__PURE__ */ new Date())), ha(f) || (f = new Date(u))), ha(f) && v ? f : null));
        e.props.showTimeSelectOnly && e.props.selected && P && !ge(P, e.props.selected) && (P = xg(e.props.selected, { hours: na(P), minutes: ra(P), seconds: mi(P) })), !P && l.target.value || (e.props.showWeekPicker && (P = sa(P, e.props.locale, e.props.calendarStartDay)), e.setSelected(P, l, !0));
      }
    })), h(g(e), "handleSelect", (function(i, o, s) {
      if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && e.sendFocusBackToInput(), e.props.onChangeRaw && e.props.onChangeRaw(o), e.props.showWeekPicker && (i = sa(i, e.props.locale, e.props.calendarStartDay)), e.setSelected(i, o, !1, s), e.props.showDateSelect && e.setState({ isRenderAriaLiveMessage: !0 }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect) e.setPreSelection(i);
      else if (!e.props.inline) {
        e.props.selectsRange || e.setOpen(!1);
        var l = e.props, u = l.startDate, c = l.endDate;
        !u || c || fa(i, u) || e.setOpen(!1);
      }
    })), h(g(e), "setSelected", (function(i, o, s, l) {
      var u = i;
      if (e.props.showYearPicker) {
        if (u !== null && vl($(u), e.props)) return;
      } else if (e.props.showMonthYearPicker) {
        if (u !== null && yl(u, e.props)) return;
      } else if (u !== null && dr(u, e.props)) return;
      var c = e.props, d = c.onChange, p = c.selectsRange, m = c.startDate, f = c.endDate;
      if (!wa(e.props.selected, u) || e.props.allowSameDay || p) if (u !== null && (!e.props.selected || s && (e.props.showTimeSelect || e.props.showTimeSelectOnly || e.props.showTimeInput) || (u = Li(u, { hour: na(e.props.selected), minute: ra(e.props.selected), second: mi(e.props.selected) })), e.props.inline || e.setState({ preSelection: u }), e.props.focusSelectedMonth || e.setState({ monthSelectedIn: l })), p) {
        var y = m && !f, v = m && f;
        !m && !f ? d([u, null], o) : y && (fa(u, m) ? d([u, null], o) : d([m, u], o)), v && d([u, null], o);
      } else d(u, o);
      s || (e.props.onSelect(u, o), e.setState({ inputValue: null }));
    })), h(g(e), "setPreSelection", (function(i) {
      var o = e.props.minDate !== void 0, s = e.props.maxDate !== void 0, l = !0;
      if (i) {
        e.props.showWeekPicker && (i = sa(i, e.props.locale, e.props.calendarStartDay));
        var u = ia(i);
        if (o && s) l = Ft(i, e.props.minDate, e.props.maxDate);
        else if (o) {
          var c = ia(e.props.minDate);
          l = ya(i, c) || wa(u, c);
        } else if (s) {
          var d = Yr(e.props.maxDate);
          l = fa(i, d) || wa(u, d);
        }
      }
      l && e.setState({ preSelection: i });
    })), h(g(e), "toggleCalendar", (function() {
      e.setOpen(!e.state.open);
    })), h(g(e), "handleTimeChange", (function(i) {
      var o = e.props.selected ? e.props.selected : e.getPreSelection(), s = e.props.selected ? i : Li(o, { hour: na(i), minute: ra(i) });
      e.setState({ preSelection: s }), e.props.onChange(s), e.props.shouldCloseOnSelect && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), e.setState({ inputValue: null });
    })), h(g(e), "onInputClick", (function() {
      e.props.disabled || e.props.readOnly || e.setOpen(!0), e.props.onInputClick();
    })), h(g(e), "onInputKeyDown", (function(i) {
      e.props.onKeyDown(i);
      var o = i.key;
      if (e.state.open || e.props.inline || e.props.preventOpenOnFocus) {
        if (e.state.open) {
          if (o === "ArrowDown" || o === "ArrowUp") {
            i.preventDefault();
            var s = e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', l = e.calendar.componentNode && e.calendar.componentNode.querySelector(s);
            return void (l && l.focus({ preventScroll: !0 }));
          }
          var u = fe(e.state.preSelection);
          o === "Enter" ? (i.preventDefault(), e.inputOk() && e.state.lastPreSelectChange === Br ? (e.handleSelect(u, i), !e.props.shouldCloseOnSelect && e.setPreSelection(u)) : e.setOpen(!1)) : o === "Escape" ? (i.preventDefault(), e.sendFocusBackToInput(), e.setOpen(!1)) : o === "Tab" && e.setOpen(!1), e.inputOk() || e.props.onInputError({ code: 1, msg: Er });
        }
      } else o !== "ArrowDown" && o !== "ArrowUp" && o !== "Enter" || e.onInputClick();
    })), h(g(e), "onPortalKeyDown", (function(i) {
      i.key === "Escape" && (i.preventDefault(), e.setState({ preventFocus: !0 }, (function() {
        e.setOpen(!1), setTimeout((function() {
          e.setFocus(), e.setState({ preventFocus: !1 });
        }));
      })));
    })), h(g(e), "onDayKeyDown", (function(i) {
      e.props.onKeyDown(i);
      var o = i.key, s = fe(e.state.preSelection);
      if (o === "Enter") i.preventDefault(), e.handleSelect(s, i), !e.props.shouldCloseOnSelect && e.setPreSelection(s);
      else if (o === "Escape") i.preventDefault(), e.setOpen(!1), e.inputOk() || e.props.onInputError({ code: 1, msg: Er });
      else if (!e.props.disabledKeyboardNavigation) {
        var l;
        switch (o) {
          case "ArrowLeft":
            l = e.props.showWeekPicker ? pi(s, 1) : Pm(s, 1);
            break;
          case "ArrowRight":
            l = e.props.showWeekPicker ? Zt(s, 1) : at(s, 1);
            break;
          case "ArrowUp":
            l = pi(s, 1);
            break;
          case "ArrowDown":
            l = Zt(s, 1);
            break;
          case "PageUp":
            l = Wa(s, 1);
            break;
          case "PageDown":
            l = qe(s, 1);
            break;
          case "Home":
            l = bt(s, 1);
            break;
          case "End":
            l = Ya(s, 1);
            break;
          default:
            l = null;
        }
        if (!l) return void (e.props.onInputError && e.props.onInputError({ code: 1, msg: Er }));
        if (i.preventDefault(), e.setState({ lastPreSelectChange: Br }), e.props.adjustDateOnChange && e.setSelected(l), e.setPreSelection(l), e.props.inline) {
          var u = Be(s), c = Be(l), d = $(s), p = $(l);
          u !== c || d !== p ? e.setState({ shouldFocusDayInline: !0 }) : e.setState({ shouldFocusDayInline: !1 });
        }
      }
    })), h(g(e), "onPopperKeyDown", (function(i) {
      i.key === "Escape" && (i.preventDefault(), e.sendFocusBackToInput());
    })), h(g(e), "onClearClick", (function(i) {
      i && i.preventDefault && i.preventDefault(), e.sendFocusBackToInput(), e.props.selectsRange ? e.props.onChange([null, null], i) : e.props.onChange(null, i), e.setState({ inputValue: null });
    })), h(g(e), "clear", (function() {
      e.onClearClick();
    })), h(g(e), "onScroll", (function(i) {
      typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? i.target !== document && i.target !== document.documentElement && i.target !== document.body || e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(i) && e.setOpen(!1);
    })), h(g(e), "renderCalendar", (function() {
      return e.props.inline || e.isCalendarOpen() ? M.createElement(n_, { ref: function(i) {
        e.calendar = i;
      }, locale: e.props.locale, calendarStartDay: e.props.calendarStartDay, chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: e.props.weekAriaLabelPrefix, monthAriaLabelPrefix: e.props.monthAriaLabelPrefix, adjustDateOnChange: e.props.adjustDateOnChange, setOpen: e.setOpen, shouldCloseOnSelect: e.props.shouldCloseOnSelect, dateFormat: e.props.dateFormatCalendar, useWeekdaysShort: e.props.useWeekdaysShort, formatWeekDay: e.props.formatWeekDay, dropdownMode: e.props.dropdownMode, selected: e.props.selected, preSelection: e.state.preSelection, onSelect: e.handleSelect, onWeekSelect: e.props.onWeekSelect, openToDate: e.props.openToDate, minDate: e.props.minDate, maxDate: e.props.maxDate, selectsStart: e.props.selectsStart, selectsEnd: e.props.selectsEnd, selectsRange: e.props.selectsRange, startDate: e.props.startDate, endDate: e.props.endDate, excludeDates: e.props.excludeDates, excludeDateIntervals: e.props.excludeDateIntervals, filterDate: e.props.filterDate, onClickOutside: e.handleCalendarClickOutside, formatWeekNumber: e.props.formatWeekNumber, highlightDates: e.state.highlightDates, holidays: Gg(e.modifyHolidays()), includeDates: e.props.includeDates, includeDateIntervals: e.props.includeDateIntervals, includeTimes: e.props.includeTimes, injectTimes: e.props.injectTimes, inline: e.props.inline, shouldFocusDayInline: e.state.shouldFocusDayInline, peekNextMonth: e.props.peekNextMonth, showMonthDropdown: e.props.showMonthDropdown, showPreviousMonths: e.props.showPreviousMonths, useShortMonthInDropdown: e.props.useShortMonthInDropdown, showMonthYearDropdown: e.props.showMonthYearDropdown, showWeekNumbers: e.props.showWeekNumbers, showYearDropdown: e.props.showYearDropdown, withPortal: e.props.withPortal, forceShowMonthNavigation: e.props.forceShowMonthNavigation, showDisabledMonthNavigation: e.props.showDisabledMonthNavigation, scrollableYearDropdown: e.props.scrollableYearDropdown, scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown, todayButton: e.props.todayButton, weekLabel: e.props.weekLabel, outsideClickIgnoreClass: qi, fixedHeight: e.props.fixedHeight, monthsShown: e.props.monthsShown, monthSelectedIn: e.state.monthSelectedIn, onDropdownFocus: e.handleDropdownFocus, onMonthChange: e.props.onMonthChange, onYearChange: e.props.onYearChange, dayClassName: e.props.dayClassName, weekDayClassName: e.props.weekDayClassName, monthClassName: e.props.monthClassName, timeClassName: e.props.timeClassName, showDateSelect: e.props.showDateSelect, showTimeSelect: e.props.showTimeSelect, showTimeSelectOnly: e.props.showTimeSelectOnly, onTimeChange: e.handleTimeChange, timeFormat: e.props.timeFormat, timeIntervals: e.props.timeIntervals, minTime: e.props.minTime, maxTime: e.props.maxTime, excludeTimes: e.props.excludeTimes, filterTime: e.props.filterTime, timeCaption: e.props.timeCaption, className: e.props.calendarClassName, container: e.props.calendarContainer, yearItemNumber: e.props.yearItemNumber, yearDropdownItemNumber: e.props.yearDropdownItemNumber, previousMonthAriaLabel: e.props.previousMonthAriaLabel, previousMonthButtonLabel: e.props.previousMonthButtonLabel, nextMonthAriaLabel: e.props.nextMonthAriaLabel, nextMonthButtonLabel: e.props.nextMonthButtonLabel, previousYearAriaLabel: e.props.previousYearAriaLabel, previousYearButtonLabel: e.props.previousYearButtonLabel, nextYearAriaLabel: e.props.nextYearAriaLabel, nextYearButtonLabel: e.props.nextYearButtonLabel, timeInputLabel: e.props.timeInputLabel, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, renderCustomHeader: e.props.renderCustomHeader, popperProps: e.props.popperProps, renderDayContents: e.props.renderDayContents, renderMonthContent: e.props.renderMonthContent, renderQuarterContent: e.props.renderQuarterContent, renderYearContent: e.props.renderYearContent, onDayMouseEnter: e.props.onDayMouseEnter, onMonthMouseLeave: e.props.onMonthMouseLeave, onYearMouseEnter: e.props.onYearMouseEnter, onYearMouseLeave: e.props.onYearMouseLeave, selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange, showTimeInput: e.props.showTimeInput, showMonthYearPicker: e.props.showMonthYearPicker, showFullMonthYearPicker: e.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: e.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: e.props.showFourColumnMonthYearPicker, showYearPicker: e.props.showYearPicker, showQuarterYearPicker: e.props.showQuarterYearPicker, showWeekPicker: e.props.showWeekPicker, showPopperArrow: e.props.showPopperArrow, excludeScrollbar: e.props.excludeScrollbar, handleOnKeyDown: e.props.onKeyDown, handleOnDayKeyDown: e.onDayKeyDown, isInputFocused: e.state.focused, customTimeInput: e.props.customTimeInput, setPreSelection: e.setPreSelection }, e.props.children) : null;
    })), h(g(e), "renderAriaLiveRegion", (function() {
      var i, o = e.props, s = o.dateFormat, l = o.locale, u = e.props.showTimeInput || e.props.showTimeSelect ? "PPPPp" : "PPPP";
      return i = e.props.selectsRange ? "Selected start date: ".concat(Qe(e.props.startDate, { dateFormat: u, locale: l }), ". ").concat(e.props.endDate ? "End date: " + Qe(e.props.endDate, { dateFormat: u, locale: l }) : "") : e.props.showTimeSelectOnly ? "Selected time: ".concat(Qe(e.props.selected, { dateFormat: s, locale: l })) : e.props.showYearPicker ? "Selected year: ".concat(Qe(e.props.selected, { dateFormat: "yyyy", locale: l })) : e.props.showMonthYearPicker ? "Selected month: ".concat(Qe(e.props.selected, { dateFormat: "MMMM yyyy", locale: l })) : e.props.showQuarterYearPicker ? "Selected quarter: ".concat(Qe(e.props.selected, { dateFormat: "yyyy, QQQ", locale: l })) : "Selected date: ".concat(Qe(e.props.selected, { dateFormat: u, locale: l })), M.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, i);
    })), h(g(e), "renderDateInput", (function() {
      var i, o = Ie(e.props.className, h({}, qi, e.state.open)), s = e.props.customInput || M.createElement("input", { type: "text" }), l = e.props.customInputRef || "ref", u = typeof e.props.value == "string" ? e.props.value : typeof e.state.inputValue == "string" ? e.state.inputValue : e.props.selectsRange ? (function(c, d, p) {
        if (!c) return "";
        var m = Qe(c, p), f = d ? Qe(d, p) : "";
        return "".concat(m, " - ").concat(f);
      })(e.props.startDate, e.props.endDate, e.props) : Qe(e.props.selected, e.props);
      return M.cloneElement(s, (h(h(h(h(h(h(h(h(h(h(i = {}, l, (function(c) {
        e.input = c;
      })), "value", u), "onBlur", e.handleBlur), "onChange", e.handleChange), "onClick", e.onInputClick), "onFocus", e.handleFocus), "onKeyDown", e.onInputKeyDown), "id", e.props.id), "name", e.props.name), "form", e.props.form), h(h(h(h(h(h(h(h(h(h(i, "autoFocus", e.props.autoFocus), "placeholder", e.props.placeholderText), "disabled", e.props.disabled), "autoComplete", e.props.autoComplete), "className", Ie(s.props.className, o)), "title", e.props.title), "readOnly", e.props.readOnly), "required", e.props.required), "tabIndex", e.props.tabIndex), "aria-describedby", e.props.ariaDescribedBy), h(h(h(i, "aria-invalid", e.props.ariaInvalid), "aria-labelledby", e.props.ariaLabelledBy), "aria-required", e.props.ariaRequired)));
    })), h(g(e), "renderClearButton", (function() {
      var i = e.props, o = i.isClearable, s = i.disabled, l = i.selected, u = i.startDate, c = i.endDate, d = i.clearButtonTitle, p = i.clearButtonClassName, m = p === void 0 ? "" : p, f = i.ariaLabelClose, y = f === void 0 ? "Close" : f;
      return !o || l == null && u == null && c == null ? null : M.createElement("button", { type: "button", className: Ie("react-datepicker__close-icon", m, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": y, onClick: e.onClearClick, title: d, tabIndex: -1 });
    })), e.state = e.calcInitialState(), e.preventFocusTimeout = null, e;
  }
  return Ne(n, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(t, e) {
    var i, o;
    t.inline && (i = t.selected, o = this.props.selected, i && o ? Be(i) !== Be(o) || $(i) !== $(o) : i !== o) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: Wi(this.props.highlightDates) }), e.focused || wa(t.selected, this.props.selected) || this.setState({ inputValue: null }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), e.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var t = this.props, e = t.showIcon, i = t.icon, o = t.calendarIconClassname, s = t.toggleCalendarOnIconClick, l = this.state.open;
    return M.createElement("div", { className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "") }, e && M.createElement(a_, Qa({ icon: i, className: "".concat(o, " ").concat(l && "react-datepicker-ignore-onclickoutside") }, s ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var t = this.renderCalendar();
    if (this.props.inline) return t;
    if (this.props.withPortal) {
      var e = this.state.open ? M.createElement(Tl, { enableTabLoop: this.props.enableTabLoop }, M.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)) : null;
      return this.state.open && this.props.portalId && (e = M.createElement(Pl, { portalId: this.props.portalId, portalHost: this.props.portalHost }, e)), M.createElement("div", null, this.renderInputContainer(), e);
    }
    return M.createElement(r_, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: t, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: gt, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), n;
})(), i_ = "input", Br = "navigate";
const o_ = (a) => {
  const r = new Date(0, 0, 0, 0, 0), { hours: n, minutes: t, seconds: e } = l_(a);
  return r.setHours(Number(n)), r.setMinutes(Number(t)), r.setSeconds(Number(e)), r;
}, Qi = (a) => {
  const r = a.getHours(), n = a.getMinutes(), t = a.getSeconds();
  return r * 3600 + n * 60 + t;
}, s_ = (a) => {
  const r = Math.floor(a / 3600), n = Math.floor(a % 3600 / 60);
  return {
    hours: r < 10 ? `0${r}` : String(r),
    minutes: n < 10 ? `0${n}` : String(n)
  };
}, l_ = (a) => {
  const { hours: r, minutes: n } = s_(a), t = a % 60;
  return {
    hours: r,
    minutes: n,
    seconds: t < 10 ? `0${t}` : String(t)
  };
}, hr = Pt(function({
  error: r,
  label: n,
  labelClassName: t,
  labelRightElement: e,
  htmlFor: i,
  nativeLabelProps: o,
  value: s,
  onChange: l,
  onFocus: u,
  maxLength: c,
  placeholder: d,
  isPreFetching: p,
  required: m,
  description: f,
  className: y,
  addonBefore: v,
  addonAfter: P,
  inputClassName: k,
  success: w,
  addonAfterClassName: C,
  addonBeforeClassName: S,
  statusIcon: b,
  statusIconClassName: T,
  labelContentWrapperClassName: D,
  errorAndDescriptionClassName: A,
  descriptionClassName: I,
  errorClassName: K,
  ...Z
}, Y) {
  const z = N(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    p ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), H = N(dn, b && "pr-9");
  return /* @__PURE__ */ G(
    "label",
    {
      className: N("flex flex-col gap-1 text-sm font-medium", y),
      ...o,
      children: [
        /* @__PURE__ */ _(
          xa,
          {
            label: n,
            labelClassName: t,
            labelRightElement: e,
            required: m
          }
        ),
        /* @__PURE__ */ G(
          "div",
          {
            className: N(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              p && "animate-pulse",
              D
            ),
            children: [
              v && /* @__PURE__ */ _(
                "div",
                {
                  className: N(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    z,
                    S
                  ),
                  children: v
                }
              ),
              /* @__PURE__ */ _(
                "input",
                {
                  ref: Y,
                  className: N(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    H,
                    r ? "border-danger" : w ? "border-green" : "border-text-secondary/30",
                    p ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    v && "rounded-l-none",
                    P && "rounded-r-none",
                    k
                  ),
                  type: Z.type || "text",
                  value: s,
                  onChange: l,
                  onFocus: u,
                  maxLength: c,
                  placeholder: d,
                  spellCheck: !1,
                  disabled: Z.disabled || p,
                  ...Z
                }
              ),
              P && /* @__PURE__ */ _(
                "div",
                {
                  className: N(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    z,
                    C
                  ),
                  children: P
                }
              ),
              b && /* @__PURE__ */ _(
                "div",
                {
                  className: N(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    T
                  ),
                  children: b
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _(
          va,
          {
            description: f,
            error: r,
            className: A,
            descriptionClassName: I,
            errorClassName: K
          }
        )
      ]
    }
  );
});
function Ay({
  inputRef: a,
  label: r,
  labelClassName: n,
  required: t,
  value: e,
  onChange: i,
  onFocus: o,
  maxLength: s,
  error: l,
  placeholder: u,
  onClear: c,
  description: d,
  testAttributePostfix: p,
  isPreFetching: m,
  searchIconClassName: f,
  closeIconClassName: y,
  errorAndDescriptionClassName: v,
  descriptionClassName: P,
  errorClassName: k,
  showSearchIcon: w,
  ...C
}) {
  return /* @__PURE__ */ G("label", { className: `${C.className} relative flex flex-col gap-1 text-sm font-medium`, children: [
    /* @__PURE__ */ _(xa, { label: r, labelClassName: n, required: t }),
    (e === "" || w) && /* @__PURE__ */ _(
      Xl,
      {
        className: N(
          "z-1 absolute right-4 h-[21px] w-[21px] translate-y-1/2 scale-75",
          r && "top-[24px]",
          f
        )
      }
    ),
    e !== "" && /* @__PURE__ */ _(
      Tt,
      {
        onClick: c,
        className: N(
          "z-1 fill-text-primary absolute right-2 h-[21px] w-[21px] translate-y-1/2 scale-75 cursor-pointer",
          r && "top-[24px]",
          y
        )
      }
    ),
    /* @__PURE__ */ _(
      "input",
      {
        ref: a,
        className: `text-text-primary main-transition-colors bg-background-secondary relative w-full rounded-lg border ${l ? "border-danger" : "border-text-secondary/30"} focus:border-brand-primary placeholder:text-text-tertiary/70 py-2.5 pl-4 pr-8 focus:outline-hidden ${m ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 animate-pulse text-transparent" : "disabled:bg-background-tertiary/40"} ${C.inputClassName || ""}`,
        onKeyDown: (S) => C.type === "number" && ["e", "E", "+", "-"].includes(S.key) && S.preventDefault(),
        type: C.type || "text",
        disabled: C.disabled || m,
        value: e,
        onChange: i,
        onFocus: o,
        maxLength: s,
        placeholder: u || F.t("public_pages_purchase.input.search"),
        spellCheck: !1,
        ...Rr(!!p, `${p}`)
      }
    ),
    /* @__PURE__ */ _(
      va,
      {
        description: d,
        error: l,
        className: v,
        descriptionClassName: P,
        errorClassName: k
      }
    )
  ] });
}
const Iy = ({
  onChange: a,
  value: r = "",
  addonBefore: n,
  withCopyButton: t,
  buttonClassName: e,
  linkIconClassName: i,
  scheme: o = "https://",
  ...s
}) => {
  const l = r.replace(o, "");
  return /* @__PURE__ */ _(
    hr,
    {
      type: "url",
      addonBefore: n || o,
      value: l,
      onChange: ({ target: { value: c } }) => {
        if (!c || c === o) return a("");
        a(o + c.replace(o, ""));
      },
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: t && /* @__PURE__ */ _(
        "button",
        {
          type: "button",
          onClick: async (c) => {
            c.preventDefault(), await mp(r, F.t("public_pages_purchase.copy_clipboard"));
          },
          className: N(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            e
          ),
          children: /* @__PURE__ */ _(
            eu,
            {
              className: N(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                i
              )
            }
          )
        }
      ),
      ...s
    }
  );
}, xy = ({
  value: a,
  onChange: r,
  type: n = "float",
  toFixed: t = 2,
  max: e,
  min: i,
  onBlur: o,
  ...s
}) => {
  const [l, u] = ue(a.toString());
  return Pe(() => {
    u(a.toString());
  }, [a]), /* @__PURE__ */ _(
    hr,
    {
      value: l,
      onChange: (p) => {
        const m = p.target.value;
        if (n === "integer")
          /^[0-9]*$/.test(m) && u(m);
        else {
          const f = m.replace(",", "."), y = new RegExp(`^-?\\d*(\\.\\d{0,${t}})?$`);
          f.match(y) !== null && u(f);
        }
      },
      onBlur: (p) => {
        let m;
        n === "integer" ? m = parseInt(l, 10) || 0 : m = parseFloat(l) || 0, e !== void 0 && (m = Math.min(m, e)), i !== void 0 && (m = Math.max(m, i)), n === "integer" && (m = Math.max(0, m)), r(m), u(n === "integer" ? m.toString() : m.toFixed(t)), o == null || o(p, m);
      },
      min: n === "integer" ? "0" : void 0,
      type: "text",
      ...s
    }
  );
}, u_ = "react-international-phone-", Nl = (...a) => a.filter((r) => !!r).join(" ").trim(), c_ = (...a) => Nl(...a).split(" ").map((r) => `${u_}${r}`).join(" "), Ke = ({ addPrefix: a, rawClassNames: r }) => Nl(c_(...a), ...r), Xe = (a) => a.replace(/\D/g, ""), Xi = 35, d_ = ({
  value: a,
  mask: r,
  maskSymbol: n,
  allowMoreDigitsThanMaskAllows: t,
  offset: e = 0,
  trimNonMaskCharsLeftover: i = !1
}) => {
  if (a.length < e) return a;
  const o = a.slice(0, e), s = a.slice(e);
  let l = o, u = 0;
  for (const d of r.split("")) {
    if (u >= s.length) {
      if (!i && d !== n) {
        l += d;
        continue;
      }
      break;
    }
    d === n ? (l += s[u], u += 1) : l += d;
  }
  let c = Xe(l);
  return t && c.length < a.length && (l += a.slice(c.length), c = Xe(l)), c.length >= Xi && (l = l.slice(0, -(c.length - Xi) || void 0)), l;
}, p_ = (a, r) => {
  const n = a.style.display;
  n !== "block" && (a.style.display = "block");
  const t = a.getBoundingClientRect(), e = r.getBoundingClientRect(), i = e.top - t.top, o = t.bottom - e.bottom;
  i >= 0 && o >= 0 || (Math.abs(i) < Math.abs(o) ? a.scrollTop += i : a.scrollTop -= o), a.style.display = n;
}, $e = (a) => {
  const [r, n, t, e, i, o, s] = a;
  return {
    name: r,
    regions: n,
    iso2: t,
    dialCode: e,
    format: i,
    priority: o,
    areaCodes: s
  };
}, m_ = (a) => `Field "${a}" is not supported`, Ha = ({
  value: a,
  field: r,
  countries: n,
  defaultCountry: t
}) => {
  if (["regions", "priority"].includes(r))
    throw new Error(m_(r));
  const e = n.find((i) => {
    const o = $e(i);
    return a === o[r];
  }) || n.find((i) => {
    const o = $e(i);
    return t.toLocaleLowerCase() === o[r];
  });
  if (e)
    return $e(e);
}, eo = ({
  phone: a,
  countries: r,
  currentCountryIso2: n,
  defaultCountry: t
}) => {
  var l;
  const e = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!a)
    return e;
  const i = Xe(a);
  if (!i)
    return e;
  let o = e;
  const s = ({
    country: u,
    fullDialCodeMatch: c,
    areaCodeMatch: d
  }) => {
    var f, y;
    const p = u.dialCode === ((f = o.country) == null ? void 0 : f.dialCode), m = (u.priority ?? 0) < (((y = o.country) == null ? void 0 : y.priority) ?? 0);
    (!p || m) && (o = { country: u, fullDialCodeMatch: c, areaCodeMatch: d });
  };
  for (const u of r) {
    const c = $e(u), { dialCode: d, areaCodes: p } = c;
    if (i.startsWith(d)) {
      const m = o.country ? Number(d) >= Number(o.country.dialCode) : !0;
      if (p) {
        const f = i.substring(d.length);
        for (const y of p)
          if (f.startsWith(y))
            return {
              country: c,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (m || d === i || !o.fullDialCodeMatch) && s({
        country: c,
        fullDialCodeMatch: !0,
        areaCodeMatch: p ? !p : void 0
      });
    }
    o.fullDialCodeMatch || i.length < d.length && d.startsWith(i) && (!o.country || Number(d) <= Number(o.country.dialCode)) && s({ country: c, fullDialCodeMatch: !1 });
  }
  if (n) {
    const u = Ha({
      value: n,
      field: "iso2",
      countries: r,
      defaultCountry: t
    });
    !!o && !!u && // different countries with same dial code
    ((l = o.country) == null ? void 0 : l.dialCode) === u.dialCode && o.country !== u && // full dial code match (without area code)
    o.fullDialCodeMatch && !o.areaCodeMatch && (o = {
      country: u,
      areaCodeMatch: u != null && u.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return o;
}, h_ = ({
  phone: a,
  dialCode: r,
  prefix: n = "+",
  charAfterDialCode: t = " "
}) => {
  if (!a || !r)
    return a;
  let e = a;
  return e.startsWith(n) && (e = e.replace(n, "")), e.startsWith(r) ? (e = e.replace(r, ""), e.startsWith(t) && (e = e.replace(t, "")), e) : a;
}, ao = ({
  phone: a,
  dialCode: r,
  prefix: n = "+",
  charAfterDialCode: t = " "
}) => `${n}${r}${t}${h_({
  phone: a,
  dialCode: r,
  charAfterDialCode: t,
  prefix: n
})}`, f_ = (a, r) => {
  const n = r.disableDialCodeAndPrefix ? !1 : r.forceDialCode, t = r.disableDialCodeAndPrefix ? !1 : r.insertDialCodeOnEmpty;
  let e = a;
  const i = (u) => r.trimNonDigitsEnd ? u.trim() : u;
  if (!e)
    return t && !e.length || n ? i(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`) : i(e);
  if (e = Xe(e), e === r.dialCode && !r.disableDialCodeAndPrefix)
    return i(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
  if (r.dialCode.startsWith(e) && !r.disableDialCodeAndPrefix)
    return i(n ? `${r.prefix}${r.dialCode}${r.charAfterDialCode}` : `${r.prefix}${e}`);
  if (!e.startsWith(r.dialCode) && !r.disableDialCodeAndPrefix) {
    if (n)
      return i(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
    if (e.length < r.dialCode.length)
      return i(`${r.prefix}${e}`);
  }
  const o = () => {
    let u = r.dialCode.length;
    r.disableDialCodeAndPrefix && (u = 0);
    const c = e.slice(0, u), d = e.slice(u);
    return {
      phoneLeftSide: c,
      phoneRightSide: d
    };
  };
  let { phoneLeftSide: s, phoneRightSide: l } = o();
  return s = `${r.prefix}${s}${r.charAfterDialCode}`, l = d_({
    value: l,
    mask: r.mask,
    maskSymbol: r.maskChar,
    allowMoreDigitsThanMaskAllows: r.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: r.trimNonDigitsEnd
  }), r.disableDialCodeAndPrefix && (s = ""), i(`${s}${l}`);
}, ut = (a) => /\d/.test(a), g_ = ({
  phoneBeforeInput: a,
  phoneAfterInput: r,
  phoneAfterFormatted: n,
  cursorPositionAfterInput: t,
  leftOffset: e = 0,
  deletion: i
}) => {
  if (t < e)
    return e;
  if (!a)
    return n.length;
  const o = i === "backward";
  if (t === 0 && r.length > 0 && n.length > 0) {
    if (o) return 0;
    for (let d = 0; d < n.length; d += 1)
      if (ut(n[d]))
        return d;
    return n.length;
  }
  if (r.length < a.length && r.length === 1)
    return n.length;
  let s = null;
  for (let d = t - 1; d >= 0; d -= 1)
    if (ut(r[d])) {
      s = d;
      break;
    }
  if (s === null)
    return t !== 0 ? t : n.length;
  let l = 0;
  for (let d = 0; d < s; d += 1)
    ut(r[d]) && (l += 1);
  o && (l -= 1);
  let u = 0, c = 0;
  for (let d = 0; d < n.length && (u += 1, ut(n[d]) && (c += 1), c !== l + 1); d += 1)
    ;
  for (; !ut(n[u]) && u < n.length; )
    u += 1;
  return o && (u += 1), u;
}, An = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
  ["Faroe Islands", ["europe"], "fo", "298"]
], an = "fr", __ = ".", y_ = {
  defaultCountry: an,
  initialCountry: an,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: An,
  dontShowDialCodePrefillOnFocus: !1
}, v_ = (a, r) => {
  const n = parseInt(a, 16);
  return Number(n + r).toString(16);
}, b_ = "abcdefghijklmnopqrstuvwxyz", S_ = "1f1e6", to = b_.split("").reduce((a, r, n) => ({
  ...a,
  // construct alphabet by incrementing A letter codepoint value
  [r]: v_(S_, n)
}), {}), k_ = (a) => [to[a[0]], to[a[1]]].join("-"), Dl = ({
  iso2: a,
  size: r = "24px",
  protocol: n = "https",
  disableLazyLoading: t,
  className: e,
  ...i
}) => {
  if (!a)
    return /* @__PURE__ */ _("img", { width: r, height: r, ...i });
  const o = k_(a), s = `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${o}.svg`;
  return /* @__PURE__ */ _(
    "img",
    {
      alt: a,
      className: Ke({
        addPrefix: ["flag-emoji"],
        rawClassNames: [e]
      }),
      src: s,
      width: r,
      height: r,
      draggable: !1,
      "data-country": a,
      loading: t ? void 0 : "lazy",
      ...i
    }
  );
}, Al = ({
  show: a,
  dialCodePrefix: r = "+",
  selectedCountry: n,
  countries: t = An,
  onSelect: e,
  onClose: i,
  searchInputPlaceholder: o,
  ...s
}) => {
  const l = Ce(null), u = Ce(null), c = Ce(), [d, p] = ue(""), m = Xa(() => {
    if (d) {
      const b = d.toLowerCase();
      return t.filter(([T]) => T.toLowerCase().includes(b));
    } else
      return t;
  }, [t, d]), f = za(
    (b) => m.findIndex((T) => $e(T).iso2 === b),
    [m]
  ), [y, v] = ue(f(n)), P = () => {
    c.current !== n && v(f(n));
  }, k = za(
    (b) => {
      v(f(b.iso2)), e == null || e(b);
    },
    [e, f]
  ), w = (b) => {
    const T = m.length - 1, D = (A) => b === "prev" ? A - 1 : b === "next" ? A + 1 : b === "last" ? T : 0;
    v((A) => {
      const I = D(A);
      return I < 0 ? 0 : I > T ? T : I;
    });
  }, C = (b) => {
    if (b.stopPropagation(), b.key === "Enter") {
      const T = $e(m[y]);
      k(T);
      return;
    }
    if (b.key === "Escape") {
      i == null || i();
      return;
    }
    if (b.key === "ArrowUp") {
      b.preventDefault(), w("prev");
      return;
    }
    if (b.key === "ArrowDown") {
      b.preventDefault(), w("next");
      return;
    }
    if (b.key === "PageUp") {
      b.preventDefault(), w("first");
      return;
    }
    if (b.key === "PageDown") {
      b.preventDefault(), w("last");
      return;
    }
    b.key === " " && b.preventDefault();
  }, S = za(() => {
    if (!u.current || y === void 0 || !m[y])
      return;
    const b = $e(m[y]).iso2;
    if (b === c.current) return;
    const T = u.current.querySelector(`[data-country="${b}"]`);
    T && (p_(u.current, T), c.current = b);
  }, [y, m]);
  return Pe(() => {
    S();
  }, [y, S]), Pe(() => {
    l.current && (a ? Promise.resolve().then(() => {
      var b;
      return (b = l.current) == null ? void 0 : b.focus();
    }) : P());
  }, [a]), Pe(() => {
    P();
  }, [n]), /* @__PURE__ */ G(
    "div",
    {
      className: Ke({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [s.className]
      }),
      style: { display: a ? "block" : "none", ...s.style },
      tabIndex: -1,
      "aria-activedescendant": `${m[y] && $e(m[y]).iso2}-option`,
      onBlur: i,
      children: [
        /* @__PURE__ */ _(
          "input",
          {
            ref: l,
            className: Ke({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [s.searchInputClassName]
            }),
            placeholder: o || "",
            style: s.searchInputStyle,
            type: "text",
            value: d,
            onChange: (b) => p(b.target.value),
            onKeyDown: C
          }
        ),
        d && /* @__PURE__ */ _(
          Tt,
          {
            onClick: () => p(""),
            className: Ke({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [s.clearSearchInputClassName]
            }),
            style: s.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ _(
          "ul",
          {
            ref: u,
            role: "listbox",
            className: Ke({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [s.listClassName]
            }),
            style: s.listStyle,
            children: m.map((b, T) => {
              const D = $e(b), A = D.iso2 === n, I = T === y;
              return /* @__PURE__ */ G(
                "li",
                {
                  "data-country": D.iso2,
                  "data-focused": I,
                  role: "option",
                  "aria-selected": A,
                  "aria-label": `${D.name} ${r}${D.dialCode}`,
                  id: `${D.iso2}-option`,
                  className: Ke({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      A && "country-selector-dropdown__list-item--selected",
                      I && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [s.listItemClassName]
                  }),
                  onClick: () => k(D),
                  style: s.listItemStyle,
                  children: [
                    /* @__PURE__ */ _(
                      Dl,
                      {
                        iso2: D.iso2,
                        className: Ke({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [s.listItemFlagClassName]
                        }),
                        style: s.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ _(
                      "span",
                      {
                        className: Ke({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [s.listItemCountryNameClassName]
                        }),
                        style: s.listItemCountryNameStyle,
                        children: D.name
                      }
                    ),
                    /* @__PURE__ */ G(
                      "span",
                      {
                        className: Ke({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [s.listItemDialCodeClassName]
                        }),
                        style: s.listItemDialCodeStyle,
                        children: [
                          r,
                          D.dialCode
                        ]
                      }
                    )
                  ]
                },
                D.iso2
              );
            })
          }
        )
      ]
    }
  );
}, M_ = ({
  selectedCountry: a,
  onSelect: r,
  disabled: n,
  hideDropdown: t,
  defaultCountry: e = an,
  countries: i = An,
  renderButtonWrapper: o,
  ...s
}) => {
  const [l, u] = ue(!1), c = Xa(() => {
    if (a)
      return Ha({
        value: a,
        field: "iso2",
        countries: i,
        defaultCountry: e
      });
  }, [i, e, a]), d = Ce(null), p = (f) => {
    f.key && ["ArrowUp", "ArrowDown"].includes(f.key) && (f.preventDefault(), u(!0));
  }, m = () => {
    const f = {
      title: c == null ? void 0 : c.name,
      onClick: () => u((v) => !v),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (v) => v.preventDefault(),
      onKeyDown: p,
      disabled: t || n,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": l
    }, y = /* @__PURE__ */ G(
      "div",
      {
        className: Ke({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [s.buttonContentWrapperClassName]
        }),
        style: s.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ _(
            Dl,
            {
              iso2: a,
              className: Ke({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  n && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [s.flagClassName]
              }),
              style: {
                visibility: a ? "visible" : "hidden",
                ...s.flagStyle
              }
            }
          ),
          !t && /* @__PURE__ */ _(
            "div",
            {
              className: Ke({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  n && "country-selector-button__dropdown-arrow--disabled",
                  l && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [s.dropdownArrowClassName]
              }),
              style: s.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return o ? o({
      children: y,
      rootProps: f
    }) : /* @__PURE__ */ _(
      "button",
      {
        ...f,
        type: "button",
        className: Ke({
          addPrefix: [
            "country-selector-button",
            l && "country-selector-button--active",
            n && "country-selector-button--disabled",
            t && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [s.buttonClassName]
        }),
        "data-country": a,
        style: s.buttonStyle,
        children: y
      }
    );
  };
  return /* @__PURE__ */ G(
    "div",
    {
      className: Ke({
        addPrefix: ["country-selector"],
        rawClassNames: [s.className]
      }),
      style: s.style,
      ref: d,
      children: [
        m(),
        /* @__PURE__ */ _(
          Al,
          {
            show: l,
            countries: i,
            onSelect: (f) => {
              u(!1), r == null || r(f);
            },
            selectedCountry: a,
            onClose: () => {
              u(!1);
            },
            ...s.dropdownStyleProps
          }
        )
      ]
    }
  );
}, w_ = () => {
  const a = Ce(), r = Ce(Date.now());
  return {
    check: () => {
      const t = Date.now(), e = a.current ? t - r.current : void 0;
      return a.current = r.current, r.current = t, e;
    }
  };
}, C_ = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function P_(a, r) {
  const { size: n, overrideLastItemDebounceMS: t, onChange: e } = {
    ...C_,
    ...r
  }, [i, o] = ue(a), [s, l] = ue([i]), [u, c] = ue(0), d = w_();
  return [i, (y, v) => {
    if (
      // compare entries if passed value is object
      typeof y == "object" && Object.entries(y).toString() === Object.entries(i).toString() || y === i
    )
      return;
    const P = t > 0, k = d.check(), w = P && k !== void 0 ? k > t : !0;
    if (
      // use value of config.overrideLastItem if passed
      (v == null ? void 0 : v.overrideLastItem) !== void 0 ? v.overrideLastItem : !w
    )
      l((S) => [...S.slice(0, u), y]);
    else {
      const S = s.length >= n;
      l((b) => [...b.slice(S ? 1 : 0, u + 1), y]), S || c((b) => b + 1);
    }
    o(y), e == null || e(y);
  }, () => {
    if (u <= 0)
      return { success: !1 };
    const y = s[u - 1];
    return o(y), c((v) => v - 1), e == null || e(y), { success: !0, value: y };
  }, () => {
    if (u + 1 >= s.length)
      return { success: !1 };
    const y = s[u + 1];
    return o(y), c((v) => v + 1), e == null || e(y), { success: !0, value: y };
  }];
}
const T_ = __, Fe = y_, N_ = ({
  defaultCountry: a = Fe.defaultCountry,
  initialCountry: r = Fe.initialCountry,
  value: n = Fe.value,
  countries: t = Fe.countries,
  prefix: e = Fe.prefix,
  defaultMask: i = Fe.defaultMask,
  allowMoreDigitsThanMaskAllows: o = Fe.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: s = Fe.charAfterDialCode,
  historySaveDebounceMS: l = Fe.historySaveDebounceMS,
  disableCountryGuess: u = Fe.disableCountryGuess,
  disableDialCodePrefill: c = Fe.disableDialCodePrefill,
  forceDialCode: d = Fe.forceDialCode,
  disableDialCodeAndPrefix: p = Fe.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: m = Fe.dontShowDialCodePrefillOnFocus,
  onChange: f
}) => {
  const y = n || "", v = p ? !1 : !u, P = Ce(null), k = ({
    value: B,
    country: R,
    trimNonDigitsEnd: W,
    insertDialCodeOnEmpty: j,
    forceDisableCountryGuess: q
  }) => {
    const pe = !q && v ? eo({
      phone: B,
      countries: t,
      currentCountryIso2: R.iso2,
      defaultCountry: a
    }) : void 0, me = (pe == null ? void 0 : pe.country) ?? R;
    return { phone: me ? f_(B, {
      prefix: e,
      mask: me.format || i,
      maskChar: T_,
      dialCode: me.dialCode,
      allowMoreDigitsThanMaskAllows: o,
      trimNonDigitsEnd: W,
      charAfterDialCode: s,
      forceDialCode: d,
      insertDialCodeOnEmpty: j,
      disableDialCodeAndPrefix: p
    }) : B, countryGuessResult: pe, formatCountry: me };
  }, w = (B) => {
    typeof document < "u" && document.activeElement === P.current && Promise.resolve().then(() => {
      var R;
      (R = P.current) == null || R.setSelectionRange(B, B);
    });
  }, C = za(
    ({ phone: B, country: R }) => f == null ? void 0 : f({
      phone: B,
      unformatedPhone: Xe(B),
      country: R,
      prefix: e
    }),
    [f, e]
  ), [{ phone: S, country: b }, T, D, A] = P_(
    () => {
      const R = eo({
        phone: y,
        countries: t,
        currentCountryIso2: r,
        defaultCountry: a
      }).country || Ha({
        value: r,
        field: "iso2",
        countries: t,
        defaultCountry: a
      });
      R || console.error(
        `[react-international-phone]: can not find a country with "${a}" iso2 code`
      );
      const W = R || // set "us" if user provided not valid country
      $e(t.find((q) => $e(q).iso2 === a)), j = k({
        value: y,
        country: W,
        insertDialCodeOnEmpty: m ? !c : !1
      }).phone;
      return w(j.length), {
        phone: j,
        country: W.iso2
      };
    },
    {
      overrideLastItemDebounceMS: l,
      onChange: C
    }
  ), I = Xa(() => Ha({
    value: b,
    field: "iso2",
    countries: t,
    defaultCountry: a
  }), [t, b, a]), K = za(() => {
    var B;
    m || (B = P == null ? void 0 : P.current) != null && B.value || C == null || C({
      phone: ao({
        phone: S,
        dialCode: I.dialCode,
        charAfterDialCode: s,
        prefix: e
      }),
      country: b
    });
  }, [
    s,
    b,
    I,
    C,
    S,
    e,
    m
  ]), Z = (B, {
    deletion: R,
    cursorPosition: W,
    insertDialCodeOnEmpty: j,
    inserted: q
  } = {}) => {
    var oe;
    let te = B, pe = W;
    d && !p && I && // dial code has been changed
    !Xe(B).startsWith(I.dialCode) && B && (q && B.startsWith(e) && // cursor position was set to 0 before the input
    B.length - (W ?? 0) === 0 ? te = B : (te = S, pe = 0));
    const { phone: me, countryGuessResult: _e } = k({
      value: te,
      country: I,
      trimNonDigitsEnd: R === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: j,
      forceDisableCountryGuess: d && !!R && Xe(te).length < I.dialCode.length
    });
    let xe = I;
    v && (_e != null && _e.country) && _e.country.name !== b && _e.fullDialCodeMatch && (xe = _e.country);
    const Ee = g_({
      cursorPositionAfterInput: pe ?? 0,
      phoneBeforeInput: S,
      phoneAfterInput: B,
      phoneAfterFormatted: me,
      leftOffset: d ? e.length + (((oe = I == null ? void 0 : I.dialCode) == null ? void 0 : oe.length) ?? 0) + s.length : 0,
      deletion: R
    });
    return T({
      phone: me,
      country: xe.iso2
    }), w(Ee), me;
  };
  Pe(() => {
    const B = P.current;
    if (!B) return;
    const R = (W) => {
      if (!W.key) return;
      const j = W.ctrlKey, q = W.shiftKey, te = W.key.toLowerCase() === "z";
      !j || !te || (q ? A() : D());
    };
    return B.addEventListener("keydown", R), () => {
      B.removeEventListener("keydown", R);
    };
  }, [P, D, A]);
  const Y = (B) => {
    B.preventDefault();
    const R = B.nativeEvent.inputType, W = () => {
      if ((R == null ? void 0 : R.toLocaleLowerCase().includes("delete")) ?? !1)
        return R != null && R.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, j = R == null ? void 0 : R.startsWith("insertFrom"), q = Z(B.target.value, {
      deletion: W(),
      inserted: j,
      cursorPosition: B.target.selectionStart ?? 0
    });
    return p && I ? ao({
      phone: q,
      dialCode: I.dialCode,
      charAfterDialCode: s,
      prefix: e
    }) : q;
  }, z = (B) => {
    const R = Ha({
      value: B,
      field: "iso2",
      countries: t,
      defaultCountry: a
    });
    if (!R) return;
    const W = p ? "" : `${e}${R.dialCode}${s}`;
    T({
      phone: W,
      country: R.iso2
    }), Promise.resolve().then(() => {
      var j;
      (j = P.current) == null || j.focus();
    });
  }, [H, U] = ue(!1);
  return Pe(() => {
    if (!H) {
      U(!0), y !== S && (C == null || C({ phone: S, country: b }));
      return;
    }
    Xe(y) !== Xe(S) && Z(Xe(y));
  }, [y]), Pe(() => {
    if (!S && r) {
      const B = Ha({
        value: r,
        field: "iso2",
        countries: t,
        defaultCountry: a
      });
      T({
        phone: S,
        country: (B == null ? void 0 : B.iso2) || a
      });
    }
  }, [r]), {
    phone: S,
    // Formatted phone string.
    country: b,
    // Current country iso code.
    setCountry: z,
    // Country setter.
    handlePhoneValueChange: Y,
    // Change handler for input component
    onFocus: K,
    inputRef: P
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
}, Ey = ({
  label: a,
  labelClassName: r,
  required: n,
  value: t,
  onChange: e,
  error: i,
  wrapperClassName: o,
  inputClassName: s,
  listClassName: l,
  searchInputClassName: u,
  clearSearchInputClassName: c,
  listItemClassName: d,
  listItemCountryNameClassName: p,
  countrySelectorDropdownClassName: m,
  countrySelectorClassName: f,
  buttonClassName: y,
  listboxButtonClassName: v,
  listboxOptionsClassName: P,
  initialCountry: k,
  ...w
}) => {
  const C = Ce(null), S = Ce(null), b = Ce(null), { country: T, setCountry: D, phone: A, handlePhoneValueChange: I, onFocus: K, inputRef: Z } = N_({
    value: t,
    onChange: ({ unformatedPhone: Y }) => e(Y),
    initialCountry: k == null ? void 0 : k.toLowerCase()
  });
  return /* @__PURE__ */ _("div", { className: o, children: /* @__PURE__ */ _(nn, { children: ({ open: Y }) => {
    var z;
    return /* @__PURE__ */ G(ze, { children: [
      /* @__PURE__ */ G("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ _(
          xa,
          {
            label: a,
            required: n,
            labelClassName: N("text-sm font-medium", r)
          }
        ),
        /* @__PURE__ */ G(
          "div",
          {
            ref: S,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ G(
                Kt,
                {
                  ref: b,
                  as: "div",
                  role: "button",
                  disabled: w.disabled,
                  className: N(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    v,
                    w.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ _(
                      M_,
                      {
                        className: N("flex", f),
                        buttonStyle: { border: "none" },
                        buttonClassName: N(
                          w.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          y
                        ),
                        hideDropdown: !0,
                        disabled: w.disabled,
                        selectedCountry: T,
                        defaultCountry: k == null ? void 0 : k.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ _(
                      go,
                      {
                        className: `transition-transform duration-300 ${Y && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ _(
                hr,
                {
                  ref: Z,
                  type: "tel",
                  placeholder: F.t("public_pages_purchase.input.phone_number"),
                  inputClassName: N(
                    "pl-16",
                    Y && "border-brand-primary",
                    s
                  ),
                  value: A,
                  onChange: I,
                  onFocus: K,
                  error: i,
                  ...w
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ _(
        on,
        {
          className: N("focus-visible:outline-hidden", P),
          children: /* @__PURE__ */ _(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: C,
              style: {
                width: `${(z = Z.current) == null ? void 0 : z.clientWidth}px`
              },
              children: /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
                Al,
                {
                  className: N(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    m
                  ),
                  listClassName: N(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    l
                  ),
                  searchInputClassName: N(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    u
                  ),
                  clearSearchInputClassName: N(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    c
                  ),
                  listItemClassName: N(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    d
                  ),
                  listItemCountryNameClassName: N(
                    "truncate",
                    p
                  ),
                  searchInputPlaceholder: F.t("public_pages_purchase.input.phone_search"),
                  show: Y,
                  selectedCountry: T,
                  onSelect: (H) => {
                    var U;
                    D(H.iso2), (U = b.current) == null || U.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
}, D_ = (a) => {
  const r = {
    h: "-",
    hh: "--",
    H: "-",
    HH: "--",
    m: "-",
    mm: "--",
    s: "-",
    ss: "--",
    a: "AM/PM"
  };
  return a.split(/([^\w])/g).map((n) => r[n] || n).join("");
}, Il = (a, r) => {
  const n = {
    d: "dd",
    // Day of the month, 2 digits with leading zero
    m: "MM",
    // Month, 2 digits with leading zero
    Y: "yyyy"
    // Year, 4 digits
  }, t = {
    h: "hh",
    // Hour in 12-hour format, 2 digits with leading zero
    H: "HH",
    // Hour in 24-hour format, 2 digits with leading zero
    i: "mm",
    // Minutes, 2 digits with leading zero
    s: "ss",
    // Seconds, 2 digits with leading zero
    A: "a"
    // AM/PM marker
  }, e = (s, l) => s.split(/([ :/])/).map(
    (u) => u.split("").map((c) => l[c] || c).join("")
  ).join(""), i = e(a, t), o = e(r, n);
  return {
    timeFormat: i,
    dateFormat: o
  };
}, By = ({
  seconds: a,
  onChangeSeconds: r,
  containerClassName: n,
  userDateFormat: t,
  userTimeFormat: e,
  classNameCustomInput: i,
  wrapperClassName: o,
  showTimeSelect: s = !0,
  showTimeSelectOnly: l = !0,
  timeIntervals: u = 15,
  ...c
}) => {
  const { timeFormat: d } = t && e ? Il(e, t) : { timeFormat: "HH:mm" };
  return (
    // react-datepicker create a popup component as sibling which can cause "jumping" if parent has flex property
    /* @__PURE__ */ _("div", { className: N("w-min", n), children: /* @__PURE__ */ _(
      mr,
      {
        disabled: c.disabled || c.isPreFetching,
        selected: typeof a == "number" ? o_(a) : null,
        onChange: (p) => {
          p && r(Qi(p));
        },
        showTimeSelect: s,
        showTimeSelectOnly: l,
        timeIntervals: u,
        timeCaption: F.t("public_pages_purchase.date_picker.time"),
        timeFormat: d,
        dateFormat: d,
        placeholderText: D_(d),
        customInput: /* @__PURE__ */ _(hr, { className: N("w-32", i), ...c }),
        timeClassName: (p) => a === Qi(p) ? "text-brand-primary" : "text-text-primary",
        wrapperClassName: N("time-only", o)
      }
    ) })
  );
};
var tn = /* @__PURE__ */ ((a) => (a.DateSince = "dateSince", a.DateTill = "dateTill", a))(tn || {}), _t = /* @__PURE__ */ ((a) => (a.Last30Days = "last_30_days", a.ThisMonth = "this_month", a.LastMonth = "last_month", a))(_t || {}), Na = /* @__PURE__ */ ((a) => (a.AllTime = "all_time", a.Last3Months = "last_3_months", a.EvaluationPeriod = "evaluation_period", a))(Na || {});
const fr = Pt(
  ({
    onClick: a,
    error: r,
    label: n,
    labelClassName: t,
    required: e,
    wrapperButtonInputClassName: i,
    buttonInputClassName: o,
    description: s,
    children: l,
    value: u
  }, c) => /* @__PURE__ */ G("div", { className: N("flex flex-col gap-1", i), children: [
    /* @__PURE__ */ _(xa, { label: n, labelClassName: t, required: e }),
    /* @__PURE__ */ G("button", { onClick: a, ref: c, type: "button", className: o, children: [
      l(u),
      /* @__PURE__ */ _(
        au,
        {
          className: N(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            u ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ _(va, { error: r, description: s })
  ] })
);
fr.displayName = "ButtonInput";
const In = ({
  date: a,
  prevMonthButtonDisabled: r,
  nextMonthButtonDisabled: n,
  increaseMonth: t,
  decreaseMonth: e,
  intlLocale: i
}) => /* @__PURE__ */ G("div", { className: "flex items-center justify-between px-2 py-2", children: [
  /* @__PURE__ */ _(
    "button",
    {
      onClick: e,
      disabled: r,
      type: "button",
      className: N(
        "group rounded-full outline-hidden  ",
        r && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ _(tu, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  ),
  /* @__PURE__ */ _("span", { className: "text-text-primary text-base", children: new Intl.DateTimeFormat(i, {
    month: "long",
    year: "numeric"
  }).format(a) }),
  /* @__PURE__ */ _(
    "button",
    {
      onClick: t,
      disabled: n,
      type: "button",
      className: N(
        "group rounded-full outline-hidden ",
        n && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ _(_o, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  )
] }), xn = (a, r) => {
  Pe(() => {
    (async () => {
      try {
        if (a) {
          let t;
          switch (a) {
            case Q.ENGLISH:
            case "en":
              t = await import("./index-zybSvIgq.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.FRENCH:
            case "fr":
              t = await import("./index-CTxt6b4N.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.SPANISH:
            case "es":
              t = await import("./index-C8SJD3xx.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.ITALIAN:
            case "it":
              t = await import("./index-VrUGlXbz.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.PORTUGUESE:
            case "pt":
              t = await import("./index-DJulXfnc.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.DEUTSCH:
            case "de":
              t = await import("./index-DH0hhHEI.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.DUTCH:
            case "nl":
              t = await import("./index-HfwniHlq.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.RUSSIAN:
            case "ru":
              t = await import("./index-9S_OeToi.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.JAPANESE:
            case "ja":
              t = await import("./index-Ur2y75zS.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.ARABIC:
            case "ar":
              t = await import("./index-CZ_HkuIb.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.TURKISH:
            case "tr":
              t = await import("./index-CHcNyAKI.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.CHINESE:
            case "zh":
              t = await import("./index-DCqYFo7S.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.SWEDISH:
            case "sv":
              t = await import("./index-COBzovPm.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.ROMANIAN:
            case "ro":
              t = await import("./index-Bwbh05L2.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.CZECH:
            case "cs":
              t = await import("./index-BcI5YY_3.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.HUNGARIAN:
            case "hu":
              t = await import("./index-B6C88t5A.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.SLOVAK:
            case "sk":
              t = await import("./index-D7SZwJpG.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.DANISH:
            case "da":
              t = await import("./index-jaR2hjIQ.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.INDONESIAN:
            case "id":
              t = await import("./index-4EcX5VSY.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.POLISH:
            case "pl":
              t = await import("./index-U1THAL0x.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.GREEK:
            case "el":
              t = await import("./index-CQvjR70S.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.SERBIAN:
            case "sr":
              t = await import("./index-D0_FBkOw.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.NORWEGIAN:
            case "no":
              t = await import("./index-CYWIcw61.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.THAI:
            case "th":
              t = await import("./index-D6hk8d8q.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.SLOVENIAN:
            case "sl":
              t = await import("./index-CSQX9sng.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.UKRAINIAN:
            case "uk":
              t = await import("./index-CCWQtOQ4.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.ALBANIA:
            case "sq":
              t = await import("./index-Cc3Y-KI4.mjs").then((e) => e.i).then((e) => e.default);
              break;
            case Q.HINDI:
            case "hi":
              t = await import("./index-CsmjTL5j.mjs").then((e) => e.i).then((e) => e.default);
              break;
            default:
              t = await import("./index-zybSvIgq.mjs").then((e) => e.i).then((e) => e.default);
              break;
          }
          t && r(t);
        } else {
          const t = await import("./index-zybSvIgq.mjs").then((e) => e.i).then((e) => e.default);
          r(t);
        }
      } catch (t) {
        console.error("Error loading locale:", t), r(et);
      }
    })();
  }, [a, r]);
}, Oy = ({
  value: a,
  onChange: r,
  error: n,
  label: t,
  required: e,
  placeholder: i,
  description: o,
  customProps: s,
  wrapperButtonInputClassName: l,
  labelClassName: u,
  timezone: c,
  intlLocale: d,
  disableApplyButton: p,
  userTimeFormat: m,
  userDateFormat: f,
  ...y
}) => {
  const [v, P] = ue(
    a && Se(a, c) || null
  ), [k, w] = ue(
    a && Se(a, c) || null
  ), [C, S] = ue(et), b = Ce(null);
  Pe(() => {
    a && !v && !k && c && (P(Se(a, c)), w(Se(a, c)));
  }, [a, c, v, k]), xn(d, S);
  const { timeFormat: T, dateFormat: D } = f && m ? Il(m, f) : { timeFormat: "HH:mm", dateFormat: "dd/MM/yyyy" };
  return /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
    mr,
    {
      ref: b,
      selected: v,
      showTimeSelect: !0,
      dayClassName: (A) => v && k && A.toDateString() === k.toDateString() && v.toDateString() !== k.toDateString() ? "text-brand-primary/50" : "",
      timeClassName: (A) => v && k && A.getTime() === k.getTime() && v.getTime() !== k.getTime() ? "text-brand-primary/50" : ".",
      shouldCloseOnSelect: !1,
      onCalendarClose: () => {
        P(k);
      },
      timeFormat: T,
      dateFormat: D,
      timeIntervals: 15,
      timeCaption: F.t("public_pages_purchase.date_picker.time"),
      timeInputLabel: F.t("public_pages_purchase.date_picker.time"),
      onChange: (A) => {
        A && P(A);
      },
      locale: C,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ _(
        fr,
        {
          error: n,
          label: t,
          required: e,
          wrapperButtonInputClassName: l,
          buttonInputClassName: `flex group justify-between min-w-[250px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${n ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          description: o,
          labelClassName: u,
          children: () => /* @__PURE__ */ _("span", { children: k ? new Intl.DateTimeFormat(d, {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "numeric",
            hour12: m === ct.hourMinuteAmPm || m === ct.hourMinuteSecondAmPm,
            minute: "numeric",
            second: m === ct.hourMinuteSecond || m === ct.hourMinuteSecondAmPm ? "numeric" : void 0
          }).format(k) : /* @__PURE__ */ _("span", { className: "text-text-tertiary/70", children: i }) })
        }
      ),
      renderCustomHeader: ({
        date: A,
        decreaseMonth: I,
        increaseMonth: K,
        prevMonthButtonDisabled: Z,
        nextMonthButtonDisabled: Y
      }) => /* @__PURE__ */ _(
        In,
        {
          date: A,
          decreaseMonth: I,
          increaseMonth: K,
          prevMonthButtonDisabled: Z,
          nextMonthButtonDisabled: Y,
          intlLocale: d
        }
      ),
      ...y,
      ...s,
      children: /* @__PURE__ */ G("div", { className: "flex w-full justify-center gap-5 sm:col-span-2", children: [
        /* @__PURE__ */ _(
          As,
          {
            disabled: !v || (p == null ? void 0 : p(v)),
            onClick: () => {
              var A;
              v && ((A = b.current) == null || A.setOpen(!1), w(v), r(Ma(v)));
            },
            width: "large",
            children: F.t("public_pages_purchase.date_picker.apply")
          }
        ),
        /* @__PURE__ */ _(
          Is,
          {
            onClick: () => {
              var A;
              (A = b.current) == null || A.setOpen(!1), w(null), r(null);
            },
            width: "large",
            children: F.t("public_pages_purchase.date_picker.clear")
          }
        )
      ] })
    }
  ) });
}, A_ = {
  [_t.Last30Days]: "public_pages_purchase.date_picker.last_30_days",
  [_t.ThisMonth]: "public_pages_purchase.date_picker.this_month",
  [_t.LastMonth]: "public_pages_purchase.date_picker.last_month"
}, I_ = {
  [Na.AllTime]: "public_pages_purchase.date_picker.all_time",
  [Na.Last3Months]: "public_pages_purchase.date_picker.last_3_months",
  [Na.EvaluationPeriod]: "public_pages_purchase.date_picker.last_pool_period"
}, x_ = (a) => F.t(A_[a]), E_ = (a) => F.t(I_[a]);
function ro(a, r) {
  var n = a.getFullYear() - r.getFullYear() || a.getMonth() - r.getMonth() || a.getDate() - r.getDate() || a.getHours() - r.getHours() || a.getMinutes() - r.getMinutes() || a.getSeconds() - r.getSeconds() || a.getMilliseconds() - r.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function B_(a, r) {
  x(2, arguments);
  var n = O(a), t = O(r), e = ro(n, t), i = Math.abs(St(n, t));
  n.setDate(n.getDate() - e * i);
  var o = +(ro(n, t) === -e), s = e * (i - o);
  return s === 0 ? 0 : s;
}
const O_ = (a, r, n) => (a && r && B_(r, a) > n && (a = new Date(r.getTime() - n * 24 * 60 * 60 * 1e3)), [a, r]), G_ = (a) => Object.values(Na).includes(
  a
), L_ = ({
  activeFilter: a,
  setDateRange: r,
  timezone: n,
  customFilters: t
}) => {
  var i;
  if (G_(a)) {
    const o = (i = t.find((s) => s.slug === a)) == null ? void 0 : i.handler;
    o && r(o());
  } else
    switch (a) {
      case "last_30_days": {
        const o = Se("", n);
        o.setHours(23, 59, 59, 999);
        const s = new Date(o);
        s.setDate(s.getDate() - 30), s.setHours(0, 0, 0, 0), r([s, o]);
        break;
      }
      case "this_month": {
        const o = Se("", n), s = o.getFullYear(), l = o.getMonth(), u = new Date(s, l, 1), c = new Date(s, l + 1, 0);
        r([u, c]);
        break;
      }
      case "last_month": {
        const o = Se("", n), s = o.getFullYear(), l = o.getMonth(), u = new Date(s, l - 1, 1), c = new Date(s, l, 0);
        r([u, c]);
        break;
      }
    }
}, R_ = (a, r) => {
  const n = Se("", r);
  return n.setHours(23, 59, 59, 999), [Se(a, r), n];
}, F_ = (a) => {
  const r = Se("", a);
  r.setHours(23, 59, 59, 999);
  const n = Se("", a);
  return n.setMonth(n.getMonth() - 3), n.setHours(0, 0, 0, 0), [n, r];
}, no = (a, r) => ({
  slug: Na.AllTime,
  handler: () => R_(a, r)
}), Gy = (a) => ({
  slug: Na.Last3Months,
  handler: () => F_(a)
}), K_ = (a) => (a.setHours(0, 0, 0, 0), a), xl = (a) => (a.setHours(23, 59, 59, 999), a), Ly = ({
  date: a,
  light: r,
  getDefaultDate: n,
  small: t,
  customFilters: e,
  filtersDisabled: i,
  onChange: o,
  placeholder: s,
  error: l,
  description: u,
  disabled: c,
  label: d,
  required: p,
  maxDate: m,
  minDate: f,
  wrapperButtonInputClassName: y,
  intlLocale: v,
  createdAt: P,
  timezone: k,
  dateFormat: w,
  customProps: C,
  labelClassName: S,
  maxInterval: b,
  showActionsSideBar: T = !0
}) => {
  const D = Ce(null), [A, I] = ue(et), K = Xa(
    () => (f && Ma(f)) ?? P,
    [f, P]
  ), Z = (X) => !v || !K || !X ? X : Ot(K) > Ot(X) ? K : X, [Y, z] = a, H = Z(a[0]), [U, B] = ue(), [R, W] = ue(), [j, q] = ue([
    H && Se(H, k) || null,
    z && Se(z, k) || null
  ]), [te, pe] = j, [me, _e] = ue(
    H && Se(H, k) || null
  ), [xe, Ee] = ue(
    z && Se(z, k) || null
  );
  Pe(() => {
    !k || !K || L_({
      activeFilter: R,
      timezone: k,
      setDateRange: q,
      customFilters: e || [no(K, k)]
    });
  }, [U, R, e, K]), xn(v, I), Pe(() => {
    if (H && z && k) {
      const X = Se(H, k), ce = Se(z, k);
      q([X, ce]), _e(X), Ee(ce);
    }
  }, [a, H, z, k]);
  const oe = /* @__PURE__ */ G("div", { className: "flex w-full flex-col gap-3 px-2 sm:flex-row sm:gap-5", children: [
    /* @__PURE__ */ G("div", { className: "flex w-fit sm:w-full", children: [
      /* @__PURE__ */ G("span", { className: "text-text-secondary pr-1", children: [
        F.t("public_pages_purchase.date_picker.from"),
        ":"
      ] }),
      /* @__PURE__ */ _("span", { className: "text-text-primary", children: te ? ni(te, { dateFormat: w }) : "-" })
    ] }),
    /* @__PURE__ */ G("div", { className: "flex w-fit sm:w-full sm:pl-2", children: [
      /* @__PURE__ */ G("span", { className: "text-text-secondary pr-1", children: [
        F.t("public_pages_purchase.date_picker.to"),
        ":"
      ] }),
      /* @__PURE__ */ _("span", { className: "text-text-primary", children: pe ? ni(pe, { dateFormat: w }) : "-" })
    ] })
  ] }), re = /* @__PURE__ */ G(ze, { children: [
    /* @__PURE__ */ _(
      Is,
      {
        disabled: c,
        onClick: () => {
          var X;
          if ((X = D.current) == null || X.setOpen(!1), n) {
            const [ce, Ge] = n(), ua = Z(ce) ?? void 0, ca = Se(ua, k), tt = Se(Ge, k);
            Ee(tt), _e(ca), o([
              Ma(ca),
              Ma(tt)
            ]);
          } else
            Ee(null), _e(null), o([null, null]);
          B(void 0);
        },
        className: "w-full",
        children: F.t("public_pages_purchase.date_picker.clear")
      }
    ),
    /* @__PURE__ */ _(
      As,
      {
        disabled: !j[0] || !j[1] || c,
        className: "w-full",
        onClick: () => {
          var Ge;
          const [X, ce] = j;
          X && ce ? (_e(X), Ee(ce), B(R), K_(X), xl(ce), o([Ma(X), Ma(ce)])) : o([null, null]), (Ge = D.current) == null || Ge.setOpen(!1);
        },
        children: F.t("public_pages_purchase.date_picker.apply")
      }
    )
  ] });
  return /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
    mr,
    {
      ref: D,
      shouldCloseOnSelect: !1,
      selectsRange: !0,
      monthsShown: 2,
      selected: te,
      startDate: te,
      className: "w-full",
      calendarClassName: "date-range-picker",
      popperClassName: "react-datepicker-bottom",
      onCalendarClose: () => {
        q([me, xe]), W(U);
      },
      calendarContainer: T ? (X) => /* @__PURE__ */ G(
        "div",
        {
          ...X,
          className: N(
            "flex flex-col justify-center gap-4 sm:flex-row sm:gap-5",
            X.className
          ),
          children: [
            /* @__PURE__ */ G("div", { className: "flex flex-col gap-4 md:mb-4", children: [
              /* @__PURE__ */ _("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: X.children }),
              oe
            ] }),
            /* @__PURE__ */ G("div", { className: "sm:border-text-secondary/30 flex w-full flex-col items-center justify-center gap-5 border-transparent sm:m-auto sm:border-t sm:p-2 md:w-fit md:border-l md:border-t-0 md:pl-5", children: [
              /* @__PURE__ */ G("ul", { className: "hidden w-1/2 gap-5 sm:flex sm:flex-col md:w-full", children: [
                Object.values(_t).map((ce) => /* @__PURE__ */ _("li", { children: /* @__PURE__ */ _(
                  ii,
                  {
                    className: "w-full",
                    disabled: !k || i || c,
                    onClick: () => {
                      W(ce);
                    },
                    selected: ce === R,
                    children: x_(ce)
                  }
                ) }, ce)),
                (e || [no(K, k)]).map(
                  (ce) => /* @__PURE__ */ _("li", { children: /* @__PURE__ */ _(
                    ii,
                    {
                      className: "w-full",
                      disabled: i || c,
                      onClick: () => {
                        W(ce.slug);
                      },
                      selected: ce.slug === R,
                      children: E_(ce.slug)
                    }
                  ) }, ce.slug)
                )
              ] }),
              /* @__PURE__ */ _("div", { className: "flex w-full justify-between gap-3 sm:w-1/2 md:w-full", children: re })
            ] })
          ]
        }
      ) : (X) => /* @__PURE__ */ G("div", { ...X, children: [
        /* @__PURE__ */ _("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: X.children }),
        oe,
        /* @__PURE__ */ _("div", { className: "flex w-full justify-center gap-3", children: re })
      ] }),
      endDate: pe,
      minDate: Ot(K, k),
      maxDate: m,
      dateFormat: "MMMM d, yyyy",
      onChange: (X) => {
        if (X) {
          W(void 0);
          const [ce, Ge] = X;
          q(b ? O_(ce, Ge, b) : [ce, Ge]);
        }
      },
      locale: A,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ _(
        fr,
        {
          buttonInputClassName: `flex group justify-between ${t ? "" : "min-w-[150px] lg:min-w-[200px]"} w-full py-2.5 px-4 text-sm font-medium ${r ? "text-[rgb(var(--text-tertiary))]" : "text-text-primary"} border ${l ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          wrapperButtonInputClassName: y,
          labelClassName: S,
          error: l,
          label: d,
          required: p,
          description: u,
          children: () => /* @__PURE__ */ _("span", { className: "text-start whitespace-nowrap", children: me && xe ? /* @__PURE__ */ G(ze, { children: [
            /* @__PURE__ */ _("span", { className: "hidden lg:inline", children: `${new Intl.DateTimeFormat(v, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(me)} - ${new Intl.DateTimeFormat(v, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(xe)}
              ` }),
            /* @__PURE__ */ _("span", { className: "inline lg:hidden", children: `${new Intl.DateTimeFormat(v, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(me)} - ${new Intl.DateTimeFormat(v, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(xe)}
              ` })
          ] }) : /* @__PURE__ */ _("span", { className: "text-text-tertiary/70", children: s || F.t("public_pages_purchase.date_picker.title_dates") }) })
        }
      ),
      renderCustomHeader: ({
        monthDate: X,
        decreaseMonth: ce,
        increaseMonth: Ge,
        prevMonthButtonDisabled: ua,
        nextMonthButtonDisabled: ca
      }) => /* @__PURE__ */ _(
        In,
        {
          date: X,
          decreaseMonth: ce,
          increaseMonth: Ge,
          prevMonthButtonDisabled: ua,
          nextMonthButtonDisabled: ca,
          intlLocale: v
        }
      ),
      ...C
    }
  ) });
}, Ry = ({
  mode: a = tn.DateSince,
  value: r,
  onChange: n,
  description: t,
  error: e,
  label: i,
  required: o,
  placeholder: s,
  maxDate: l,
  minDate: u,
  wrapperButtonInputClassName: c,
  disabled: d,
  timezone: p,
  intlLocale: m,
  createdAt: f,
  labelClassName: y,
  customProps: v
}) => {
  const [P, k] = ue(
    r && Se(r, p) || null
  ), [w, C] = ue(), [S, b] = ue(et), T = f && p ? Ot(f, p) : null;
  return xn(m, b), Pe(() => {
    if (!p) return;
    const D = r ? Se(r, p) : null;
    (!P || (D == null ? void 0 : D.toISOString()) !== P.toISOString()) && k(D);
  }, [r, p, P]), /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
    mr,
    {
      selected: P,
      dateFormat: "MMMM d, yyyy",
      onChange: (D) => {
        D && ((P ? D.toDateString() === P.toDateString() : !1) ? (k(null), n(null)) : (k(D), a === tn.DateTill && xl(D), n(Ma(D))));
      },
      onChangeRaw: (D) => {
        w === D.target.ariaLabel ? (k(null), n(null)) : C(D.target.ariaLabel);
      },
      locale: S,
      minDate: u || T,
      maxDate: l,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ _(
        fr,
        {
          description: t,
          buttonInputClassName: `flex group justify-between min-w-[200px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${d ? "bg-background-tertiary/40" : "bg-background-secondary focus:border-brand-primary"} ${e ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          error: e,
          label: i,
          required: o,
          wrapperButtonInputClassName: c,
          labelClassName: y,
          children: (D) => /* @__PURE__ */ _("span", { className: "text-start", children: D || /* @__PURE__ */ _("span", { className: "text-text-tertiary/70", children: s }) })
        }
      ),
      renderCustomHeader: ({
        date: D,
        decreaseMonth: A,
        increaseMonth: I,
        prevMonthButtonDisabled: K,
        nextMonthButtonDisabled: Z
      }) => /* @__PURE__ */ _(
        In,
        {
          date: D,
          decreaseMonth: A,
          increaseMonth: I,
          prevMonthButtonDisabled: K,
          nextMonthButtonDisabled: Z,
          intlLocale: m
        }
      ),
      disabled: d,
      ...v
    }
  ) });
}, io = ({
  children: a,
  isLast: r,
  className: n,
  isLink: t,
  onClick: e
}) => {
  const i = (o) => {
    e && (o.preventDefault(), e());
  };
  return /* @__PURE__ */ _(
    "h2",
    {
      className: N(
        "text-text-tertiary text-[18px] font-semibold leading-8 transition-colors md:truncate md:text-[20px]  lg:text-[22px]",
        n,
        (t || e) && "hover:text-text-primary cursor-pointer",
        r && "text-text-primary"
      ),
      onClick: i,
      children: a
    }
  );
}, Fy = ({
  data: a,
  isFetching: r,
  classnameBreadcrumbsItem: n,
  CustomBreadcrumbLinkItem: t
}) => {
  const e = Ce(null), i = Ce(null);
  return Wl(() => {
    e.current && i.current && e.current.scrollTo(i.current.offsetLeft, 0);
  }, [r]), /* @__PURE__ */ _(
    "ul",
    {
      ref: e,
      className: `
        md:overflow:hidden hide-scrollbar
        flex min-h-[42px] w-full flex-nowrap items-center gap-3 gap-y-0
        overflow-scroll whitespace-nowrap
        md:flex-wrap md:truncate 
        lg:flex-nowrap
      `,
      children: a.map((o, s) => {
        const l = s === a.length - 1;
        return /* @__PURE__ */ G(
          "li",
          {
            className: "flex flex-nowrap items-center gap-3 md:truncate",
            ref: l ? i : void 0,
            children: [
              s !== 0 && /* @__PURE__ */ _(_o, { height: "14", width: "10", fill: "rgb(var(--text-tertiary))" }),
              !o.isStatic && r ? /* @__PURE__ */ _(Ht, { small: !0, type: "dark" }) : o.href ? /* @__PURE__ */ _(
                io,
                {
                  isLast: l,
                  className: N(n),
                  isLink: !0,
                  onClick: o.onClick,
                  children: t ? /* @__PURE__ */ _(t, { href: o.href, children: o.caption }) : /* @__PURE__ */ _("a", { href: o.href, rel: "noreferrer", className: "outline-hidden", children: o.caption })
                }
              ) : /* @__PURE__ */ _(
                io,
                {
                  onClick: o.onClick,
                  className: N(n),
                  isLast: l,
                  children: o.caption
                }
              )
            ]
          },
          s
        );
      })
    }
  );
};
export {
  l_ as $,
  vy as A,
  Qc as B,
  q_ as C,
  Is as D,
  Rs as E,
  xa as F,
  oi as G,
  Os as H,
  un as I,
  cn as J,
  Bs as K,
  Ht as L,
  J_ as M,
  gy as N,
  pn as O,
  Q_ as P,
  sr as Q,
  My as R,
  _y as S,
  Sy as T,
  Gs as U,
  Cp as V,
  wp as W,
  Ty as X,
  Ny as Y,
  sn as Z,
  Dy as _,
  du as a,
  o_ as a0,
  Qi as a1,
  s_ as a2,
  By as a3,
  tn as a4,
  _t as a5,
  Na as a6,
  Oy as a7,
  Ly as a8,
  Ry as a9,
  oy as aA,
  ln as aB,
  sy as aC,
  ly as aD,
  Le as aE,
  cp as aF,
  uy as aG,
  dp as aH,
  Rr as aI,
  Ot as aJ,
  br as aK,
  Se as aL,
  Ma as aM,
  ni as aN,
  cy as aO,
  mp as aP,
  dy as aQ,
  py as aR,
  my as aS,
  hy as aT,
  Es as aU,
  Gy as aa,
  K_ as ab,
  xl as ac,
  io as ad,
  Fy as ae,
  hr as af,
  Ay as ag,
  Iy as ah,
  xy as ai,
  Ey as aj,
  ko as ak,
  Mo as al,
  $c as am,
  ye as an,
  ay as ao,
  $_ as ap,
  Fr as aq,
  ct as ar,
  Q as as,
  ny as at,
  Po as au,
  iy as av,
  Da as aw,
  ty as ax,
  Xc as ay,
  ry as az,
  va as b,
  X_ as c,
  ey as d,
  fy as e,
  ja as f,
  ir as g,
  yy as h,
  ii as i,
  As as j,
  Ea as k,
  gp as l,
  vp as m,
  yp as n,
  hp as o,
  fp as p,
  by as q,
  Sp as r,
  wy as s,
  Cy as t,
  ky as u,
  Py as v,
  Ls as w,
  Fs as x,
  hn as y,
  mn as z
};
